var _defs, _rect, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgPuntos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "img_puntos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 314,
    viewBox: "0 0 1920 314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_139",
    "data-name": "Rect\\xE1ngulo 139",
    width: 56.661,
    height: 36.558,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 40"
  }, /*#__PURE__*/React.createElement("image", {
    width: 61,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAoCAYAAABNefLBAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATHSURBVGhD5ZptTFtVGMf/99aurSBI1JVlLyjDhSGYwvig6ECMMjenkcESyUy2sWWbClu2iX6YTDJYmDNKglk0TEnmdDNu+BaHRKOTUQkucetCwHXQIS2dDGFCRwuUtfWc01O2yhgvXkYv/JrT+zxPz7nt/55znnt6WiH/xQUeCMDciChsLv4JM4BUkT67SWk1m3Di4DbqTnuYaA8pCkHEaX0l6k8dpaFpy87D5yEKZGjT4Q1mABXlBTBf+J3Z04mK2stYWFCD935tgkiHtsAfPsre3oJO2yD35I21y4nM0jPI/OQ0LrZ3s5g4WzvH18lDOBx2nCjL4Z486bG7sOd4M6L3VqOi0cqjXoTe7nZP6Wup6Ot3QhBJf5O5bRtQwAUFHk95Fqu37ONV5cNvRhtWHT6LS502HvEjVQwK1SIt0z9riyy9Aaeqq6CvPOR1ZACdt0nFdXikpHokwQzBQ6BGffVnOE6SGO1p+6ACTreC3MoU8AgKvLB6E55K38waBBp0GB/RW/HmyWZc6bbz6C3x3qcpcSlrkJyWxT1/Ko59hMYz1dwLHOicnZf/M1756txYBTOGetpH+VvP4Y9mk19Pu8jtXKXSYFNuEWISknnNqaGmoRsf6y2oMLaj19HPo+MidZhoyu6NiWTYDPiJdntIIf6yZenIXJfHa94ezlscOPiLGWVnLRMVeiM3F00XJ+8WrIeLCKWi3VQ0EcyEkzn/0GIdMtbkICIymreQnu/qrDCYbfi0oQPGyyMnpQlwc9GUbw8V4oeqL72iuVh6EdzsIpBCjrqYeCx/PguL45bwVhOn1mCGoaULlfVt+N7cRc4/i0w+UkQleXUo9UjByKIdvd34cO8GmFpbRxTtG/Jhd9+D2JiHER4+H/dHLiKtBcQnDL8QxqYWXO21w9bbh8aWdrRdscPcZce5jh5YnAIGiUi3oMQ1dpwC0T6Ktq+Etb3jlqK9MW57qO2N0VzgITbLCaS4hDvYOa4RYX2CCgOCGg4irI8UB/Fvl+hRz7Z1dzm3pg+jig4Jm43cvP3QqFQ8In/GNG5iEp5AcsoK7smfMU+WVevegC42nnvyZlwZImfXAURFLOSefBmXaMq2XaVkfqu5J0/GLTooOASv5uZzT56MWzQlNuEx5O0slG1Gn5BoSlxCErLXy3NLacKiKY8mP4OXN24llgCySGdH9svB0J6bQFZi3qPvrTxkZUdXd2wFR1d5rA71eXuykmN1yWtDRWL+9xmXPrkC2S9t4J48kOQypi1Px4GSMgRp7uSRwEaysXOfNhz5r+dDow7825mkEyZqUTTycrZzL3CRPEvQ79Elhfswj/R8oCK5aMoDkZHYv6cQGWlP80hgMSmiKcHBwcheuxZFO3YgLOQuHg0MJk20j8QlOnxQXISVS5N4ZOoZdbtISkwtFuS98z7+ujqAPqgwIKphhxL9goptG7loEVVkwaKEW7xhu0jaTzj6Htlk8E1VDb7WG1Bn+XvmiPZx4c8OlB47iS8aWmeOaB82uxOf/1iPOlMHaq09aLI5JRGtUc+CThuKe9VKJM4PRfyCUDw4JygwRP+XS539qDN2wvKPEzUXvf8eMNn6YWjrYjYlI2Yut66TlXg9lpGk5dYwmGhuzxSAfwH62eMak2StmAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1716",
    "data-name": "Trazado 1716",
    d: "M451.284,135.462l45.188.107-.136-47.654-45.085-.07Z",
    transform: "translate(-451.251 -87.846)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_426",
    "data-name": "Rect\\xE1ngulo 426",
    width: 45.236,
    height: 47.737,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-2",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 291"
  }, /*#__PURE__*/React.createElement("image", {
    width: 800,
    height: 291,
    xlinkHref: "data:image/jpeg;base64,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"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_97",
    "data-name": "Rect\\xE1ngulo 97",
    width: 1920,
    height: 314,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    transform: "translate(1658.251 100.483)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9",
    "data-name": "Elipse 9",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(93.749 87.517)",
    fill: "#002e0f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_11",
    "data-name": "Elipse 11",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(93.749 43.517)",
    fill: "#002e0f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_12",
    "data-name": "Elipse 12",
    cx: 13.5,
    cy: 14,
    rx: 13.5,
    ry: 14,
    transform: "translate(93.749 -0.483)",
    fill: "#002e0f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_10",
    "data-name": "Elipse 10",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(46.749 87.517)",
    fill: "#002e0f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_14",
    "data-name": "Elipse 14",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(46.749 43.517)",
    fill: "#002e0f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_13",
    "data-name": "Elipse 13",
    cx: 14,
    cy: 13.5,
    rx: 14,
    ry: 13.5,
    transform: "translate(-0.251 87.517)",
    fill: "#002e0f"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "img_logos",
    transform: "translate(218.812 65.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_640",
    "data-name": "Grupo 640",
    transform: "translate(0 1.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_310",
    "data-name": "Grupo 310",
    transform: "translate(137.869 30.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_309",
    "data-name": "Grupo 309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1469",
    "data-name": "Trazado 1469",
    d: "M145.127,70.137,144.8,62.5c1.186,1.47,2.362,2.859,3.215,3.785,2.823,3.076,7.672,11.433,31,3.989,13.261-4.227,33.78-17.638,51.727-39.591.026.275,1.135,5.924,2.49,12.778.859,4.34,1.812,9.144,2.658,13.378,1.253,6.335,2.253,11.375,2.267,11.519-.054,0-11.87,14.6-31.188,21.78-3.963,1.474-10.958,4.8-25.508,4.965-17.447.2-27.94-14.17-36.341-24.964",
    transform: "translate(-144.802 -30.681)",
    fill: "#0068b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_317",
    "data-name": "Grupo 317",
    transform: "translate(25.188 21.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_312",
    "data-name": "Grupo 312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_311",
    "data-name": "Grupo 311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1470",
    "data-name": "Trazado 1470",
    d: "M127.216,48.02a78.063,78.063,0,0,1,7.521,9.751l.069-.305c-4.477-6.251-7.7-12.068-14.631-18.633-8.889-8.4-20.2-12.27-26.208-13.871C55.19,13.78,25.346,34.453,25.188,34.538c1.317,3.76,2.618,7.517,3.928,11.273,6.509-4.78,15.7-8.83,21.891-11.039a96.667,96.667,0,0,1,18.135-4.316,125.052,125.052,0,0,1,16.173-.381,101.477,101.477,0,0,1,15.841,3.03,82.283,82.283,0,0,1,14.388,6.13,46.71,46.71,0,0,1,11.672,8.785",
    transform: "translate(-25.188 -21.646)",
    fill: "#3e4243",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_314",
    "data-name": "Grupo 314",
    transform: "translate(3.928 8.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_313",
    "data-name": "Grupo 313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1471",
    "data-name": "Trazado 1471",
    d: "M134.2,61.977l.787-3.693a78.173,78.173,0,0,0-7.525-9.751,46.586,46.586,0,0,0-11.671-8.785,81.966,81.966,0,0,0-14.386-6.13,101.51,101.51,0,0,0-15.842-3.031,125.224,125.224,0,0,0-16.174.38A96.722,96.722,0,0,0,51.25,35.285c-6.195,2.21-15.382,6.26-21.892,11.039Q31.471,52.35,33.564,58.4c4.12-3.007,17.424-12.312,29.521-15.829a69.038,69.038,0,0,1,39.955-.083A68.815,68.815,0,0,1,126.877,54.7a69.787,69.787,0,0,1,7.319,7.275",
    transform: "translate(-29.358 -30.483)",
    fill: "#ce0017",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_316",
    "data-name": "Grupo 316",
    transform: "translate(8.134 17.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_315",
    "data-name": "Grupo 315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1472",
    "data-name": "Trazado 1472",
    d: "M134.025,64.546l.43-2.009a69.586,69.586,0,0,0-7.318-7.274A68.772,68.772,0,0,0,103.3,43.044a69.038,69.038,0,0,0-39.955.082c-12.1,3.517-25.4,12.822-29.522,15.828,1.23,3.545,2.478,7.1,3.708,10.637C41.375,66.113,62.2,49.344,90.6,48.289c12.832-.466,25.4,2.268,33.091,7.269a55.5,55.5,0,0,1,10.338,8.988",
    transform: "translate(-33.822 -40.131)",
    fill: "#ffba00",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_319",
    "data-name": "Grupo 319",
    transform: "translate(133.544 58.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_318",
    "data-name": "Grupo 318",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_138",
    "data-name": "Rect\\xE1ngulo 138",
    width: 56.661,
    height: 36.128,
    fill: "url(#pattern)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_639",
    "data-name": "Grupo 639",
    transform: "translate(35.544 62.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_590",
    "data-name": "Grupo 590",
    transform: "translate(142.288 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_321",
    "data-name": "Grupo 321",
    transform: "translate(2.246 2.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_320",
    "data-name": "Grupo 320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1473",
    "data-name": "Trazado 1473",
    d: "M189.952,83.168c-1.509-5.431,2.089-11.927,8.078-14.609,5.968-2.691,12.385-.455,14.451,5.032s-1.465,11.984-8,14.621-13,.4-14.526-5.045",
    transform: "translate(-189.608 -67.42)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_323",
    "data-name": "Grupo 323",
    transform: "translate(2.151 2.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_322",
    "data-name": "Grupo 322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1474",
    "data-name": "Trazado 1474",
    d: "M199.015,89.417a10.892,10.892,0,0,1-4.821-1.063,8.063,8.063,0,0,1-4.346-5.165h0c-1.511-5.437,2.138-12.044,8.134-14.729a11.8,11.8,0,0,1,9.318-.343,9.432,9.432,0,0,1,5.27,5.432c2.085,5.5-1.531,12.117-8.059,14.752A14.766,14.766,0,0,1,199.015,89.417Zm-8.971-6.282a7.864,7.864,0,0,0,4.239,5.037,12.543,12.543,0,0,0,10.151-.059c6.427-2.592,9.991-9.093,7.945-14.491a9.232,9.232,0,0,0-5.157-5.315,11.592,11.592,0,0,0-9.158.34c-5.908,2.646-9.506,9.145-8.021,14.489Z",
    transform: "translate(-189.507 -67.318)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_325",
    "data-name": "Grupo 325",
    transform: "translate(7.966 21.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_324",
    "data-name": "Grupo 324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1475",
    "data-name": "Trazado 1475",
    d: "M196.716,88.882l-.211-.037.012-.045.014-.046-.009-.032-.01-.045-.017-.021-.019-.027-.041-.022-.026-.01-.013-.009-.039-.008-.047,0-.033,0-.044.009-.034.013-.017.018-.03.026-.009.011-.01.01-.015.032-.007.017,0,.019,0,.009.007.028.039.021.13.092.058.049.031.025.026.024.031.036.006.022,0,.024.019.024.008.032,0,.019,0,.038,0,.026,0,.028-.014.028-.007.024-.025.039-.03.028-.039.033-.04.033-.03.024-.044.016-.057.011-.046,0-.046,0-.048,0-.052-.015-.07-.008-.08-.037-.028-.02-.042-.021-.015-.019-.019-.03-.017-.023-.018-.025-.008-.031-.008-.029-.007-.03,0-.03.014-.039,0-.02.041-.073.2.057-.025.04.007.031-.006.028.007.025.017.021.017.024.039.01.028.02.05.011.038,0,.036.007.033-.012.023-.008.009-.007.02-.019.008-.012.017-.022.009-.02,0-.012-.015-.01-.008-.033-.03-.029-.044-.034-.057-.041L196.049,89l-.057-.034-.02-.038-.031-.028-.029-.03-.011-.041-.006-.029-.02-.032.013-.042,0-.037.024-.047.024-.045.026-.039.027-.032.039-.037.041-.026.053-.03.043-.015.056-.017.034-.006.057,0,.059.006.062.01.025.006.039.012.088.026.06.046.028.024.017.024.02.028.029.023.015.061,0,.036,0,.032-.017.081Z",
    transform: "translate(-195.68 -88.394)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_327",
    "data-name": "Grupo 327",
    transform: "translate(7.862 21.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_326",
    "data-name": "Grupo 326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1476",
    "data-name": "Trazado 1476",
    d: "M196.095,89.567l-.069,0-.154-.034-.192-.111-.1-.19-.011-.053.017-.077,0-.01.014-.053.081-.143.154.044-.02-.019-.032-.1-.024-.039.026-.087,0-.015.012-.04.115-.182.1-.082.119-.057.1-.026.071,0,.22.039.119.042.182.167.028.111-.009.091-.057.256-.277-.049.051.112.013.08-.048.194-.073.085-.142.111Zm-.265-.287.033.018-.061-.126,0-.031-.018-.006-.012.035Zm.5-.17.032.075-.011.041.022-.091-.046-.1-.3-.21-.021-.1.011-.086-.04.1.084.141.2.135.062.06Zm-.273.063.072.01.007,0-.107-.075-.013.023,0,.01,0,.012Zm.165-.468.174.129.024-.088L196.4,88.7l-.071-.029h-.03l-.021,0-.036.015Zm.408.053h0l.016-.1-.025-.036-.047-.056-.036-.028.065.1.026.1Zm-.1-.219.01.006Z",
    transform: "translate(-195.57 -88.286)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_329",
    "data-name": "Grupo 329",
    transform: "translate(7.205 21.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_328",
    "data-name": "Grupo 328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1477",
    "data-name": "Trazado 1477",
    d: "M195.715,88.133l-.658.935-.186-.084.671-.945Z",
    transform: "translate(-194.872 -88.04)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_331",
    "data-name": "Grupo 331",
    transform: "translate(7.051 21.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_330",
    "data-name": "Grupo 330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1478",
    "data-name": "Trazado 1478",
    d: "M195.083,89.187l-.375-.168L195.5,87.9l.352.19Z",
    transform: "translate(-194.708 -87.9)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_333",
    "data-name": "Grupo 333",
    transform: "translate(6.296 21.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_332",
    "data-name": "Grupo 332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1479",
    "data-name": "Trazado 1479",
    d: "M194.937,88.166l-.184-.085.022-.044L194.8,88l0-.045.007-.017,0-.015-.009-.038-.008-.029-.03-.032-.041-.025-.029-.02-.048-.014-.027-.008-.036,0-.033,0-.033.013-.027.024-.03.02-.009.015-.008.018-.007.017v.006l0,.019.006.023,0,.017.016.022.089.128.048.057.019.028.018.024.023.047v.106l0,.026-.006.032-.017.023,0,.033-.028.029-.018.022-.008.018-.018.017-.029.021-.041.025-.041.025-.013,0-.032.007-.045.007-.056.01-.038,0-.05-.009-.039-.021-.051-.017-.046-.035-.04-.025-.025-.02-.029-.03-.018-.025-.03-.023,0-.026-.009-.034-.006-.03-.007-.032,0-.034.006-.024,0-.036.015-.026.016-.036.024-.035.02-.022.175.1-.025.043-.007.022-.008.022-.008.019,0,.03.016.021.017.023.017.021.041.02.027.019.04.022.038,0h.034l.031-.012.023-.007.021-.018.008-.012.007-.024,0-.015.02-.021-.017-.029-.022-.036-.081-.089-.034-.05-.038-.055-.02-.036-.031-.035-.007-.031-.009-.039,0-.04,0-.034.024-.044.015-.035.024-.05.036-.043.028-.029.037-.035.041-.026.054-.021.042-.019.054-.016.049,0,.047,0,.024,0,.025.006.053.022.052.021.054.029.031.029.038.027.048.052.021.039.007.027.019.024,0,.041.008.032,0,.034,0,.037,0,.031-.037.068-.015.042Z",
    transform: "translate(-193.907 -87.559)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_335",
    "data-name": "Grupo 335",
    transform: "translate(6.193 20.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_334",
    "data-name": "Grupo 334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1480",
    "data-name": "Trazado 1480",
    d: "M194.311,88.736l-.154-.022-.217-.128-.107-.1-.036-.174.054-.2.116-.141.139.075-.021-.089.02-.133.144-.223.1-.075.192-.073.18.02.207.1.137.135.06.106,0,.064.008.035-.027.156-.134.224-.22-.1.011.023,0,.075v.052l-.037.162-.137.142-.115.067Zm-.014-.387h.021l.007-.012,0-.008-.074-.08-.025.05.025.018ZM194,88.3l.008.035.012-.073.051,0-.052-.029Zm.3-.329.253.354,0-.038v-.031l-.042-.064-.041-.047-.126-.192.089-.063-.1.024-.01-.053.008-.029-.039.106Zm-.17.286h0Zm.406-.369,0,0,.111.154.049-.12-.008-.026-.1-.045-.033,0-.04.031Zm.342-.088.031.124-.01.087.022-.09-.007-.03v-.017Zm-.418.077-.028.012h.057Zm.012-.006.025.015-.013-.021Zm-.04-.024.021.012.025,0Z",
    transform: "translate(-193.798 -87.45)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_337",
    "data-name": "Grupo 337",
    transform: "translate(5.224 20.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_336",
    "data-name": "Grupo 336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1481",
    "data-name": "Trazado 1481",
    d: "M193.975,87.059l-.7.691.228.177-.143.139-.587-.478.142-.138.219.174.688-.69Z",
    transform: "translate(-192.77 -86.936)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_339",
    "data-name": "Grupo 339",
    transform: "translate(5.071 20.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_338",
    "data-name": "Grupo 338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1482",
    "data-name": "Trazado 1482",
    d: "M193.353,88.195l-.746-.608.289-.279.217.173.688-.689.32.249-.7.691.228.178Z",
    transform: "translate(-192.607 -86.792)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_341",
    "data-name": "Grupo 341",
    transform: "translate(4.477 19.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_340",
    "data-name": "Grupo 340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1483",
    "data-name": "Trazado 1483",
    d: "M193.354,86.487l-.909.741-.469-.513.161-.129.331.378.2-.166-.32-.349.154-.123.324.348.242-.207-.355-.385.154-.128Z",
    transform: "translate(-191.976 -85.953)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_343",
    "data-name": "Grupo 343",
    transform: "translate(4.329 19.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_342",
    "data-name": "Grupo 342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1484",
    "data-name": "Trazado 1484",
    d: "M192.426,87.359l-.607-.665.321-.257.331.377.043-.036-.321-.349.313-.251.322.345.088-.075-.356-.385.311-.26.623.686Zm-.311-.642.015.015-.014-.016Z",
    transform: "translate(-191.819 -85.803)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_345",
    "data-name": "Grupo 345",
    transform: "translate(3.735 18.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_344",
    "data-name": "Grupo 344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1485",
    "data-name": "Trazado 1485",
    d: "M192.644,85.657l-.991.628-.151-.251.591-.574-.759.285-.145-.237,1-.627.081.15-.778.484.882-.335.084.165-.685.654.78-.5Z",
    transform: "translate(-191.189 -84.882)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_347",
    "data-name": "Grupo 347",
    transform: "translate(3.596 18.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_346",
    "data-name": "Grupo 346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1486",
    "data-name": "Trazado 1486",
    d: "M191.611,86.418l-.246-.409.3-.29-.382.143-.241-.395,1.177-.739.174.323.022-.008.075.148.016-.007-.013.013.078.153.008,0,.2.335Zm.011-.375.056.091.124-.078-.084-.107Zm-.3-.511.049.08.132-.049-.055-.109Z",
    transform: "translate(-191.041 -84.729)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_349",
    "data-name": "Grupo 349",
    transform: "translate(3.355 17.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_348",
    "data-name": "Grupo 348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1487",
    "data-name": "Trazado 1487",
    d: "M191.678,83.682l.077.189-.2.192.138.355.266-.049.078.2-1.176.178-.078-.182Zm-.281.539-.342.32.442-.086Z",
    transform: "translate(-190.785 -83.682)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_351",
    "data-name": "Grupo 351",
    transform: "translate(3.233 17.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_350",
    "data-name": "Grupo 350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1488",
    "data-name": "Trazado 1488",
    d: "M190.793,84.847l-.065-.151h-.008l.007-.006-.071-.162,1.051-1.038.16.394-.2.193.083.214.266-.048.155.394Zm1.1-.373-.039.007.039-.006Zm-.457-.425.077.181-.073-.186Z",
    transform: "translate(-190.656 -83.491)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_353",
    "data-name": "Grupo 353",
    transform: "translate(2.908 15.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_352",
    "data-name": "Grupo 352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1489",
    "data-name": "Trazado 1489",
    d: "M190.366,83.075l-.047-.351v-.115l-.007-.077.022-.058.009-.012,0-.028.021-.043.027-.037.036-.038.037-.041.049-.039.038-.035.063-.032.061-.024.061-.029.076-.024.06-.018.058-.018.053-.006.059,0,.056-.008.049.016.059.009.041.024.027.021.039.014.019.035.021.041.008.038.02.032.009.042,0,.059.059.361Zm.157-.252.728-.229-.023-.143-.016-.07-.008-.041-.016-.024-.017-.013-.029-.03-.024-.01-.024-.006h-.07l-.032,0-.045.01-.057.014-.062.018-.053.015-.055.021-.05.024-.029.023-.041.017-.018.027-.019.016-.029.025-.008.018,0,.028-.015.035-.008.023,0,.028.008.037.011.1Z",
    transform: "translate(-190.311 -82.045)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_355",
    "data-name": "Grupo 355",
    transform: "translate(2.806 15.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_354",
    "data-name": "Grupo 354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1490",
    "data-name": "Trazado 1490",
    d: "M190.274,83.2l-.062-.471-.009-.219.068-.172.116-.139.116-.1.187-.086.209-.066.073-.009.074,0,.06-.009.277.106.1.248,0,.078.073.435Zm.318-.611.012.092.527-.166-.069-.167-.045,0h-.023l-.353.143-.032.05Zm.495-.441.122.047.045.044-.018-.035-.149-.062-.034,0-.077,0-.081.021.081-.02Z",
    transform: "translate(-190.202 -81.935)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_357",
    "data-name": "Grupo 357",
    transform: "translate(2.823 14.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_356",
    "data-name": "Grupo 356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1491",
    "data-name": "Trazado 1491",
    d: "M191.318,81.5l-1.092.213-.007-.737.2-.041-.012.545.26-.06v-.5l.173-.037,0,.514.284-.061.006-.56.185-.038Z",
    transform: "translate(-190.22 -80.737)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_359",
    "data-name": "Grupo 359",
    transform: "translate(2.72 14.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_358",
    "data-name": "Grupo 358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1492",
    "data-name": "Trazado 1492",
    d: "M190.119,81.831l-.008-.942.4-.086-.012.543.054-.012v-.5l.376-.08,0,.513.083-.017.006-.561.386-.079.006.974Zm.612-.329-.065.014Z",
    transform: "translate(-190.111 -80.604)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_361",
    "data-name": "Grupo 361",
    transform: "translate(2.986 12.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_360",
    "data-name": "Grupo 360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1493",
    "data-name": "Trazado 1493",
    d: "M191.429,79.615l-1.035.017.032-.209.875-.016.1-.507.181-.006Z",
    transform: "translate(-190.394 -78.895)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_363",
    "data-name": "Grupo 363",
    transform: "translate(2.868 12.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_362",
    "data-name": "Grupo 362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1494",
    "data-name": "Trazado 1494",
    d: "M190.268,79.73l.062-.413.879-.017.1-.506.391-.011-.194.926Zm.238-.213v.006l.835-.021Z",
    transform: "translate(-190.268 -78.783)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_365",
    "data-name": "Grupo 365",
    transform: "translate(3.326 11.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_364",
    "data-name": "Grupo 364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1495",
    "data-name": "Trazado 1495",
    d: "M191.981,77.562l-.071.219-.266.074-.12.4.205.121-.082.219-.895-.506.085-.223Zm-.528.336-.429.1.347.178Z",
    transform: "translate(-190.754 -77.562)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_367",
    "data-name": "Grupo 367",
    transform: "translate(3.199 11.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_366",
    "data-name": "Grupo 366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1496",
    "data-name": "Trazado 1496",
    d: "M191.695,78.73l-1.075-.608.135-.353,1.373-.362-.144.447-.265.074-.08.267.21.123Zm-.822-.7.715.4.01-.027-.169-.1,0,.008-.555-.285Z",
    transform: "translate(-190.62 -77.407)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_369",
    "data-name": "Grupo 369",
    transform: "translate(4.022 10.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_368",
    "data-name": "Grupo 368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1497",
    "data-name": "Trazado 1497",
    d: "M192.442,76.541l-.95-.277.1-.2.95.27Z",
    transform: "translate(-191.493 -76.064)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_371",
    "data-name": "Grupo 371",
    transform: "translate(3.877 10.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_370",
    "data-name": "Grupo 370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1498",
    "data-name": "Trazado 1498",
    d: "M192.488,76.656l-1.149-.335.19-.384,1.147.327Zm-.859-.463.75.219.009-.02-.753-.214Z",
    transform: "translate(-191.339 -75.936)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_373",
    "data-name": "Grupo 373",
    transform: "translate(4.392 9.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_372",
    "data-name": "Grupo 372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1499",
    "data-name": "Trazado 1499",
    d: "M192.779,75.852l-.893-.369.105-.177.831-.162-.593-.242.1-.179.894.374-.1.184-.824.147.586.246Z",
    transform: "translate(-191.886 -74.723)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_375",
    "data-name": "Grupo 375",
    transform: "translate(4.245 8.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_374",
    "data-name": "Grupo 374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1500",
    "data-name": "Trazado 1500",
    d: "M192.813,75.972l-1.083-.447.188-.317.541-.106-.385-.157.205-.358,1.082.453-.184.325-.531.1.375.157Zm-.789-.546.7.291v0l-.7-.293Zm.342-.582.012.006-.012-.006Z",
    transform: "translate(-191.73 -74.586)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_377",
    "data-name": "Grupo 377",
    transform: "translate(5.117 7.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_376",
    "data-name": "Grupo 376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1501",
    "data-name": "Trazado 1501",
    d: "M193.682,74.467l-.68-.412-.2.266-.142-.082.549-.72.132.089-.188.267.668.408Z",
    transform: "translate(-192.655 -73.519)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_379",
    "data-name": "Grupo 379",
    transform: "translate(4.966 7.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_378",
    "data-name": "Grupo 378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1502",
    "data-name": "Trazado 1502",
    d: "M193.7,74.594l-.683-.414-.2.265-.319-.185.677-.887.3.2-.186.263.669.409Zm-.7-.661.644.39.015-.02-.642-.392Z",
    transform: "translate(-192.495 -73.373)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_381",
    "data-name": "Grupo 381",
    transform: "translate(5.985 6.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_380",
    "data-name": "Grupo 380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1503",
    "data-name": "Trazado 1503",
    d: "M194.3,73.675l-.718-.6.561-.611.126.1-.421.454.173.12.381-.406.126.1-.392.41.2.178.431-.479.127.1Z",
    transform: "translate(-193.577 -72.462)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_383",
    "data-name": "Grupo 383",
    transform: "translate(5.838 6.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_382",
    "data-name": "Grupo 382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1504",
    "data-name": "Trazado 1504",
    d: "M194.3,73.806l-.874-.732.7-.759.287.225-.415.449,0,0,.385-.411.285.23-.4.414.045.04.427-.474.288.23Zm-.58-.751.562.471.01-.01-.312-.28,0,0-.262-.181Z",
    transform: "translate(-193.421 -72.315)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_385",
    "data-name": "Grupo 385",
    transform: "translate(7.11 5.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_384",
    "data-name": "Grupo 384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1505",
    "data-name": "Trazado 1505",
    d: "M195.415,72.092l-.108-.114.362-.33.251.275-.01.048-.021.056-.021.047-.029.065-.041.058-.041.06-.055.052-.053.054-.062.049-.069.046-.03.013-.041.021-.061.015-.073.024h-.036l-.041.011h-.024l-.035-.01-.034-.008-.024-.011-.07-.018-.055-.035-.048-.047-.041-.044-.059-.049-.008-.031-.018-.029-.026-.06-.016-.061v-.044l-.008-.025.017-.072,0-.039,0-.026.01-.041.016-.029.031-.059.041-.053.041-.053.061-.06.076-.056.048-.029.027-.022.041-.018.039-.02.031-.012.032-.008h.131l.025.014.037.011.026.01.038.02-.155.176-.025-.011-.036-.011-.035,0h-.045l-.041.016-.041.017-.027.023-.046.033-.046.05-.017.021-.013.025L195,71.9l-.007.026-.012.03.006.026,0,.02,0,.038.021.027.008.028.007.033.019.027.036.057.058.058.024.018.026.012.041.019.024.012.034,0,.033,0,.032,0,.025,0,.029-.011.032-.008.032-.011.016-.019.057-.041.054-.057.047-.066.022-.055.022-.039L195.69,72l-.088-.082Z",
    transform: "translate(-194.771 -71.472)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_387",
    "data-name": "Grupo 387",
    transform: "translate(7.004 5.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_386",
    "data-name": "Grupo 386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1506",
    "data-name": "Trazado 1506",
    d: "M195.241,72.638l-.127-.023-.181-.077-.185-.168-.022-.065-.057-.163V72.1l-.01-.037.024-.1v-.02l.044-.14.029-.057.093-.121.07-.071.3-.178.059-.015.048,0h.065l.053,0,.264.128-.021.024.34.373-.069.221-.029.066-.09.134-.191.177-.156.091-.165.05h-.039Zm-.16-.245.138.041.023-.007-.077-.023-.108-.059-.07-.069-.083-.137-.03-.064v.043l.057.137Zm.179-.169.046,0,.031,0,.01,0,.042-.011-.235-.247.192-.175-.053-.021-.093.033-.1.1-.025.054,0,.02-.007.029.135.2Zm.374-.419.163.153,0-.011-.146-.16Zm-.345-.236.075,0h-.07Z",
    transform: "translate(-194.659 -71.363)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_389",
    "data-name": "Grupo 389",
    transform: "translate(8.16 5.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_388",
    "data-name": "Grupo 388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1507",
    "data-name": "Trazado 1507",
    d: "M196.413,71.712l-.527-.78.4-.281.062-.053.057-.038.059-.03.041-.014.045-.008.031-.008.057,0h.012l.011.009.04.016.038.02.018.023.04.025.025.053.01.042,0,.027.007.023-.008.054-.013.046-.015.027-.016.022-.04.058-.017.021-.038.03.089-.014.065,0,.026.009.058,0,.1.038.231.073-.238.166-.239-.078-.111-.038-.07,0-.036-.006-.041.01-.01.006-.032.01-.065.042-.024.032.215.323Zm-.108-.593.132-.089.1-.082.054-.053.024-.03,0-.021,0-.021,0-.039-.021-.037,0-.013-.025-.015-.014-.013-.013-.008h-.021l-.033.012-.023,0-.019.014-.141.088-.139.107Z",
    transform: "translate(-195.886 -70.501)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_391",
    "data-name": "Grupo 391",
    transform: "translate(8.02 4.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_390",
    "data-name": "Grupo 390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1508",
    "data-name": "Trazado 1508",
    d: "M196.378,71.847l-.641-.948.671-.466.154-.041.1.007.2.122.058.161,0,.024,0,.043-.039.145.066.009.1.038.423.132-.45.313-.386-.127-.081-.007-.043.014.221.333Zm-.36-.9.413.612.023-.016-.2-.3.008-.008-.218-.305Zm.733.133.238.079.025-.019-.256-.061Zm-.455-.146.025.036.185-.169-.015,0Zm.271-.337.1.06.046.093,0,.039.008-.048,0-.044v-.008l-.008-.028-.129-.066Z",
    transform: "translate(-195.737 -70.392)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_393",
    "data-name": "Grupo 393",
    transform: "translate(9.665 4.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_392",
    "data-name": "Grupo 392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1509",
    "data-name": "Trazado 1509",
    d: "M198.477,70.451l-.211.126-.176-.157-.392.2v.261l-.207.1-.008-1.08.219-.114Zm-.522-.152-.276-.249.016.394Z",
    transform: "translate(-197.483 -69.789)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_395",
    "data-name": "Grupo 395",
    transform: "translate(9.562 4.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_394",
    "data-name": "Grupo 394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1510",
    "data-name": "Trazado 1510",
    d: "M197.383,71.137l-.009-1.3.335-.174.935.8-.4.237-.18-.161-.275.141v.263Zm.2-.835,0,.512,0,0Zm.541.009.149.133.025-.015-.615-.527-.008,0,.45.4Z",
    transform: "translate(-197.374 -69.66)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_397",
    "data-name": "Grupo 397",
    transform: "translate(10.762 3.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_396",
    "data-name": "Grupo 396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1511",
    "data-name": "Trazado 1511",
    d: "M199.409,69.653l.218-.025-.01.043-.011.042v.077l-.038.068-.016.03-.025.031-.04.058-.037.037-.018.015-.038.022-.04.026-.04.017-.04.019-.053.012-.05.015-.042.01-.044.008-.047-.008-.045-.007-.016-.011-.033,0-.037-.016-.035-.011-.029-.019-.014-.009-.033-.039-.03-.028-.015-.017-.017-.022-.025-.043-.012-.053-.014-.05-.025-.056,0-.056,0-.057.006-.053,0-.052.01-.049.022-.045.018-.055.023-.044.042-.041.024-.036.047-.036.036-.034.038-.029.058-.036.039-.015.055-.017.039-.01.047-.009.05,0,.046,0,.034,0,.036.01.027.015.049.017.051.032.025.041.044.039-.2.126-.019-.023-.022-.04h-.033l-.035-.012-.029-.015-.033,0-.051.014-.045.007-.019.008-.017.023-.041.017-.021.012,0,.017-.028.024-.025.029,0,.025-.022.053v.033l0,.025.007.074.022.078.014.048.008.036.04.058.017.022.021.03.041.029.026.015.015.01.032,0,.013.01.032-.014.025.008.059-.019.04-.022.03-.023.034-.033.027-.033.022-.04.01-.043.01-.048Z",
    transform: "translate(-198.648 -69.087)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_399",
    "data-name": "Grupo 399",
    transform: "translate(10.661 3.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_398",
    "data-name": "Grupo 398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1512",
    "data-name": "Trazado 1512",
    d: "M199.078,70.256l-.27-.073-.065-.047-.14-.192-.061-.288.006-.069,0-.049.013-.062.09-.2.2-.184.122-.065.157-.041.159-.013.137.05.1.075.017.027.135.119-.392.246-.087-.1-.046-.018-.071.017-.013.017-.089.061-.024.1.043.186.089.1.045-.01.031.009.07-.039.047-.057.032-.209.443-.051-.057.229,0,.077-.137.219-.074.073-.18.1Zm-.12-.231h.009l-.073-.058-.093-.148-.051-.248,0-.042-.007.018,0,.046-.006.069.006.075.073.187Zm.534-.287-.008.041.012-.041Zm-.164-.529.006.012.008,0Zm-.084-.011h.047l-.026-.014-.042,0Z",
    transform: "translate(-198.541 -68.977)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_401",
    "data-name": "Grupo 401",
    transform: "translate(12.043 3.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_400",
    "data-name": "Grupo 400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1513",
    "data-name": "Trazado 1513",
    d: "M200.165,69.774l-.157-.98.207-.058.161.98Z",
    transform: "translate(-200.008 -68.736)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_403",
    "data-name": "Grupo 403",
    transform: "translate(11.928 3.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_402",
    "data-name": "Grupo 402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1514",
    "data-name": "Trazado 1514",
    d: "M200.075,69.894l-.189-1.181.4-.114.194,1.181Zm.04-1.035.124.778.013,0-.127-.777Z",
    transform: "translate(-199.886 -68.599)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_405",
    "data-name": "Grupo 405",
    transform: "translate(12.766 3.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_404",
    "data-name": "Grupo 404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1515",
    "data-name": "Trazado 1515",
    d: "M200.775,69.07V69l0-.07.013-.062.018-.058.013-.041.032-.035.01-.045.048-.04.012-.025.047-.041.016-.026.049-.024.047-.031.051-.014.063-.024.059-.015.057-.008.053-.01.057,0h.046l.052.019.046.01.041.025.04.02.041.027.024.036.018.033.026.047.022.038.015.05.006.061,0,.06,0,.068,0,.051-.02.055,0,.057-.029.047-.011.041-.024.044-.041.055-.023.036-.05.034-.033.035-.049.034-.051.019-.047.022-.051.019-.064.017-.056,0-.054.007h-.056l-.046,0-.051-.016-.048-.01-.038-.02-.031-.031-.041-.029-.031-.034-.019-.028-.027-.053-.012-.045-.014-.052-.011-.041Zm.22-.047v.089l.018.024.01.043.007.022.021.028.015.015.029.025.041.029.024,0,.039.012.025.006.021,0h.066l.03-.019.034,0,.019-.013.028-.02.026-.011.017-.024.029-.014.028-.033.011-.026.007-.027.036-.068v-.077l.012-.037-.013-.048V68.86l-.01-.039-.008-.027-.01-.038-.008-.032-.017-.026-.017-.018-.018-.019-.041-.027-.025-.012-.025-.007-.034,0-.031.01h-.086l-.043.017-.019.012-.029.013-.027.021-.018.017-.025.033-.02.006-.012.038-.017.021-.028.067-.011.074v.081Z",
    transform: "translate(-200.775 -68.429)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_407",
    "data-name": "Grupo 407",
    transform: "translate(12.664 2.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_406",
    "data-name": "Grupo 406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1516",
    "data-name": "Trazado 1516",
    d: "M201.147,69.6l-.054,0-.2-.076-.135-.138-.078-.222-.011-.168.02-.153.082-.215.171-.168.217-.1.2-.041.071.006h.056l.206.085.079.062.093.159.024.072.014.142,0,.083.007.057-.02.055,0,.068-.174.282-.132.1-.244.091Zm-.046-.21.029.008h.008Zm-.066-.018.066.017-.127-.094-.085-.154,0-.162.025-.17-.01.024-.028.109,0,.116.041.187.055.073Zm.136-.175.055.015.056-.006.023-.014h.032l.109-.116.024-.047.008-.09-.047-.19-.06-.039-.043.009-.093.011-.052.033-.083.127-.009.089.038.184Zm.461-.039,0,.009.025-.054Zm.042-.164v.076l.007-.01,0-.045.019-.054,0-.029,0-.084-.034-.152-.053-.093-.105-.055.088.075.048.1.051.218Z",
    transform: "translate(-200.667 -68.32)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_409",
    "data-name": "Grupo 409",
    transform: "translate(14.181 2.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_408",
    "data-name": "Grupo 408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1517",
    "data-name": "Trazado 1517",
    d: "M202.277,69.3l.082-1.027.208-.021.391.658.037-.691.2-.022-.071,1.029-.207.017-.385-.641-.046.667Z",
    transform: "translate(-202.277 -68.201)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_411",
    "data-name": "Grupo 411",
    transform: "translate(14.069 2.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_410",
    "data-name": "Grupo 410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1518",
    "data-name": "Trazado 1518",
    d: "M202.158,69.415l.1-1.239.357-.035.252.425.024-.443.408-.043-.085,1.237-.358.028-.252-.417-.029.428Zm.236-.4-.012.165h0Zm.1-.656.467.776h0l-.462-.776Z",
    transform: "translate(-202.158 -68.08)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_413",
    "data-name": "Grupo 413",
    transform: "translate(4.621 4.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_412",
    "data-name": "Grupo 412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1519",
    "data-name": "Trazado 1519",
    d: "M192.418,82.332c-1.238-4.324,1.612-9.495,6.412-11.627s9.9-.343,11.493,4.009-1.211,9.522-6.356,11.624-10.287.317-11.549-4.006",
    transform: "translate(-192.129 -69.807)",
    fill: "#67982b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_415",
    "data-name": "Grupo 415",
    transform: "translate(4.525 4.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_414",
    "data-name": "Grupo 414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1520",
    "data-name": "Trazado 1520",
    d: "M199.653,87.315a8.692,8.692,0,0,1-3.792-.825,6.623,6.623,0,0,1-3.546-4.136h0c-1.243-4.342,1.658-9.612,6.468-11.747a9.494,9.494,0,0,1,7.516-.24,7.406,7.406,0,0,1,4.114,4.307c1.609,4.379-1.268,9.651-6.413,11.754A11.6,11.6,0,0,1,199.653,87.315ZM192.511,82.3a6.34,6.34,0,0,0,3.438,4.009,9.894,9.894,0,0,0,7.974-.069c5.045-2.061,7.871-7.217,6.3-11.495a7.207,7.207,0,0,0-4-4.19,9.305,9.305,0,0,0-7.354.239c-4.721,2.1-7.572,7.257-6.355,11.505Z",
    transform: "translate(-192.027 -69.703)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_417",
    "data-name": "Grupo 417",
    transform: "translate(10.282 9.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_416",
    "data-name": "Grupo 416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1521",
    "data-name": "Trazado 1521",
    d: "M198.265,80.4a3.888,3.888,0,0,1,2.444-4.439c1.881-.813,3.827-.133,4.391,1.53a3.749,3.749,0,0,1-2.421,4.442c-1.934.806-3.885.129-4.413-1.533",
    transform: "translate(-198.138 -75.614)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_419",
    "data-name": "Grupo 419",
    transform: "translate(10.182 9.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_418",
    "data-name": "Grupo 418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1522",
    "data-name": "Trazado 1522",
    d: "M201.044,82.362a3.376,3.376,0,0,1-1.422-.3,2.7,2.7,0,0,1-1.46-1.643h0a4.006,4.006,0,0,1,2.5-4.563,3.775,3.775,0,0,1,3-.073,2.784,2.784,0,0,1,1.527,1.664c.594,1.7-.517,3.747-2.478,4.568A4.359,4.359,0,0,1,201.044,82.362Zm-2.688-2a2.462,2.462,0,0,0,1.352,1.52A3.947,3.947,0,0,0,205,77.514a2.581,2.581,0,0,0-1.418-1.543,3.554,3.554,0,0,0-2.836.073A3.8,3.8,0,0,0,198.356,80.358Z",
    transform: "translate(-198.032 -75.507)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_421",
    "data-name": "Grupo 421",
    transform: "translate(5.254 9.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_420",
    "data-name": "Grupo 420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1523",
    "data-name": "Trazado 1523",
    d: "M208.836,79.566l.238.124.213.035-.008.056.009.155.029.015.11.011.085.083.042.1h.047l.067.019.015.048-.084.124-.105.285-.057.082-.119-.028-.057.036.04.132-.123.154.036.081-.042.015-.16-.028-.25-.113-.108-.08-.085-.164-.041-.138.007-.1.133-.2.084-.04-.036-.04-.121-.043-.128.042-.142.131-.249-.123-.39,0-.313-.047-.057.007-.086.036-.171.135-.055.1-.092.3-.124.223-.122.147-.065.031-.127.1-.132.149-.017.109.036.076.032.032.216.055.1.051.113.019.063.1-.1.156-.25.282-.092.05-.252.084-.032-.029-.106-.136-.055-.15-.1-.115-.106.087-.045.134-.119.044-.188-.083-.14-.081-.115-.107-.115-.027-.062-.01-.18.068-.211.008-.126.016-.36.108-.171.064-.037.075-.013.119-.03.02-.227-.136-.124-.15-.11-.053-.085-.01-.041.01-.056.056.151.134-.044.043-.169.031-.157-.013-.043-.025-.172-.413-.273-.065-.566.007-.043.016-.184-.073-.077-.078-.171-.116-.178-.04-.1.012-.116.094.059.044.162,0,.042.068-.027.2-.022.009-.108-.006-.122-.037-.226-.011-.1.041-.138-.035-.106-.057-.107-.093-.1-.16.01-.089.036-.082-.038-.2-.107-.055-.013-.043.018-.106.042-.024-.05-.052-.089-.074-.394-.09-.106-.006-.127-.03-.205-.071-.335-.183-.492-.158-.108-.057L198,80.127l-.04-.034,0-.088.04-.025.126-.043-.011-.041-.175-.056-.009-.073-.058-.053-.134.008-.106.083-.075.12-.271.236-.518.192-.341.05-.285-.017-.19.031-.271.094-.255,0-.171-.047-.164-.013-.3.074-.194.054-.365.146-.205.063-.174.017-.19-.024-.138,0-.287-.064-.027-.024-.166-.016-.027-.021-.106,0-.066-.046.038-.036-.039-.257.041-.067v-.05l-.081-.1.04-.029.011-.09.086-.218-.008-.04.281-.777.522-.237.412-.171.025.007.015-.037-.042-.225-.075-.064-.2-.047-.1-.116-.341-.047-.554-.188h.024l.585-.237-.116-.434,1.721-.722V76.38l.039-.032.024,0,.026.015.045-.014.011.01.015.006.032-.006.037.014.009-.011-.018-.016,0-.023.028-.031.015-.033,0-.012.006-.018,0-.021.047-.039-.02-.036.01-.05-.008-.029.034-.031.009-.015.015-.027-.01-.041.006-.024.016-.025,0-.023v-.044l0-.031.013-.041.017-.018.023,0,.028-.03.033-.009.049-.029.025.006-.025-.006.027.017-.008.023-.017.021-.009.008-.016.026-.019.014-.006.022.012,0,.048-.027-.01.045.006.022.011-.041.04-.029.046-.039,0,.013.008-.013,0,.009.023,0,.051-.054.008-.013.008.026-.023.033,0,.01.012-.024.021-.008v.006l0,.021.014.012.008.033,0,.018.008.036.009.033v.041l0,.028,0,.06,0,.016-.023.049,0,.039.022.085.009.072-.009.055-.008.019-.008.011.009.039.014.008.013,0,.032,0,.015.015.031-.012.008,0,.006.02-.016.01-.023,0-.008.012-.008.014v.138l.02.079.011.041.016.014,0,.018.015.014.016.022.033-.009.015.011.009.036.023.018v0l0,.022-.009.007-.017.019-.007.033.007.026.034.034-.018.023v.047l.017.022-.006.028.019.032-.006.019-.015.027v.008l.007.019-.011.014.011.038,0,.013-.008.014-.007-.028,0-.022v-.042l.006-.023,0-.028-.029.057,0,.018-.006.024h.01l-.015.024.021-.006-.007.024.016.012-.025.037,0,.019-.019.018,0,.008-.008.019.012,0-.02.008-.008.066-.008.006-.015.031.007.024-.02.018,0,.023-.016-.014,0-.013,0,.024-.009,0-.036-.01-.011,0,.006.024-.03.011-.017.027-.021.012,0,.022,0,.014.007.023,0,.033-.027.026-.008.023,0,.01-.022.039.007.023v0l-.021.011-.015.018-.02.017-.007.023.02.025,0,.013.012.006.017.02-.02.01-.032.013-.023.008-.021.008,0-.008-.029.012-.011,0-.018.016-.014,0-.017.026h-.011l-.022.008-.018.022.106.006.207-.08.084.059.151.016.042-.021.117-.127.1-.029.044.048.023-.008h.024l.016.015.032-.008.205-.1.166-.147.152-.085.288-.111.293-.067.412-.17.322-.211.205-.094.1-.073.072-.08.178-.1.153-.023.062.014.237-.094.132-.107.177-.075.083-.023.246.009.227-.082.236-.068.2.01.265.087h.47l.112.028.138.076.016.058.1.353.062.317-.051.708.17.531.074.657.089.4.008.162-.04.19.059.176.2.151.043.072.01.036.021-.009.088.108.046.033.205.2.2.1.442.158.3.025.118.042.1.041.171-.011.041.009.084.145.134.011.026.1.069.072.444-.174.058-.015.374,0,.153-.043.1-.04.08-.057.092-.171.063-.066.285-.157.292-.3.051-.024.1-.024.053.144.046,0,.094-.108-.04-.263.062-.164.032-.043.109-.073.357-.119.205.008.244-.041.263-.084.234-.041h.215l.373.1Z",
    transform: "translate(-192.801 -75.668)",
    fill: "#004990"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_423",
    "data-name": "Grupo 423",
    transform: "translate(4.701 9.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_422",
    "data-name": "Grupo 422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1524",
    "data-name": "Trazado 1524",
    d: "M203.841,82.488l-.308-.191-.055-.065-.127.125-.212.039-.214-.028-.073-.042-.165-.4-.223-.054-.55.019-.037.014-.255-.111-.077-.078-.163-.1.039.062-.04.3-.12.04-.108-.006-.147-.041-.178-.007-.106.046-.2-.053-.106-.057-.144-.129-.12-.19.023-.154.024-.053-.023-.115-.1-.053-.033-.107.023-.133-.043-.036-.37-.085-.089,0-.145-.033-.215-.073-.351-.189-.474-.15-.124-.064-.354-.147-.074-.063,0-.19.032-.021-.042-.013-.012-.1-.057,0-.067.053-.086.127-.3.255-.518.191-.362.056-.306-.016-.168.03-.271.1-.3-.008-.171-.047-.128-.008-.477.123-.354.142-.213.066-.2.022-.213-.025-.122,0-.337-.072-.023-.021-.161-.015-.025-.019-.1,0-.192-.136.09-.084-.036-.242.04-.065-.122-.145.093-.067.011-.071.075-.189-.008-.038.305-.845.941-.414-.023-.122-.029-.024-.211-.049-.1-.112-.3-.042-1.155-.391h.614l.487-.2-.115-.433,1.74-.73v-.024l.107-.09.09.014.061-.025-.008-.039.027-.04h0l.014-.064-.018-.065.063-.058,0-.023.073-.26.02-.021L195,75.423l.614.137-.007.027.013-.02.028.017.056-.089.018.045.08-.138.139.49,0,.041,0,.054-.027.089.03.167,0,.026.072.02.047.13-.067.066v.075l.024.083.01,0,.068.051.035.057.1-.191-.05.379.016.016-.022.028-.006.044h0l-.006.038.021.036,0,.006.035,0-.049.086,0,.01-.011.019.012.024-.007.016,0,.011-.024.044.162.048-.218.107-.01.051,0,.006-.038.066,0,.019-.008,0-.025.114-.089-.064,0,0-.01.1-.025.024-.016.041v.066l-.015.009.1.071.094.01.123-.135.192-.053.05.054.037.007.168-.082.154-.138.171-.1.3-.117.307-.072.4-.165.305-.2.219-.1.077-.062.082-.087.215-.117.171-.025.049.012.194-.077.144-.112.288-.106.241.008.209-.074.259-.075.243.017.249.081h.454l.161.041.176.1.124.453.067.338-.05.7.163.513.078.675.088.39.01.192-.037.176.041.12.2.16.067.087.114.122.206.2.182.1.416.148.31.03.2.075.162-.01.1.022.08.138.152.013.041.143.45-.168.384-.008.224-.074.04-.03.1-.174.088-.085.271-.15.311-.313.051-.024.21-.051,0,.011-.021-.135.086-.214.057-.067.134-.085.374-.124.224.008.223-.04.25-.081.247-.043.245,0,.387.1.119.016.223.117.3.049-.024.155,0,.059.089.009.132.139.024.04.12.035.046.146-.111.166-.1.263-.107.161-.089-.021.021.067-.118.148.055.125-.171.061-.211-.041-.25-.113-.157-.126-.085-.165-.053-.172.009-.14.109-.164-.024.008-.177.164-.291-.144-.366,0-.314-.046-.03,0-.059.024-.144.114-.044.081-.085.279-.133.243-.166.188-.065.032-.11.086-.1.113-.008.049.014.032.188.048.105.051.142.024.123.187-.134.212-.287.317-.091.049-.326.11-.076-.07-.133-.176-.048-.13-.026-.03-.009.008-.051.153-.2.075-.226-.1-.151-.086-.113-.1L204.977,82l-.187.064-.328.023-.471.153-.01.024-.017.148Zm2.267-.339.077.1.251-.1.239-.268.053-.088,0,0-.1-.022-.1-.051-.22-.053-.073-.081-.048-.1.025-.171.152-.171.142-.11.061-.032.108-.13.114-.209.084-.278.089-.15.2-.148.114-.043.071-.008.326.049.42.015.187.091.128-.1.16-.054.2.082.128.141-.183.087-.1.154,0,.049.036.121.066.124.09.066.246.1.121-.151-.046-.154.159-.1.092.022.017-.024.094-.263.035-.054h-.052l-.061-.139-.045-.044-.14-.034-.051-.026-.011-.189-.152-.03-.219-.115-.078-.007-.378-.1h-.2l-.217.04-.25.08-.258.045-.207-.006-.327.109-.1.073-.048.125.043.284-.152.173-.165.017-.048-.134-.026.009-.306.31-.27.15-.043.044-.116.195-.08.057-.115.05-.191.051-.408.016-.5.2-.134-.139-.014-.052-.116-.01-.086-.148-.166.01L203.607,81l-.309-.03-.443-.158-.231-.125-.3-.287-.036.017-.087-.171-.212-.157-.078-.233.044-.2-.008-.149-.086-.383-.076-.667-.171-.53.051-.715-.059-.3-.1-.363-.089-.049-.1-.025-.461,0-.268-.088-.17-.008-.219.063-.239.087-.25-.009-.068.019-.151.064-.148.115-.267.106-.074-.017-.115.017-.147.086-.06.068-.111.087-.224.106-.309.2-.429.178-.309.073-.274.106-.138.079-.171.149-.309.13-.02-.018-.035.01-.057-.048-.016,0-.127.129-.069.033-.206-.022-.061-.043-.176.068-.331-.017.227-.259.041.008.016-.008.021-.071.038-.049v0l.057-.125,0-.017.008-.075.049-.054,0-.023.112-.063h0l.019-.058-.078.021.107-.2,0-.014.028-.083v0l0-.022-.006-.007-.031-.169.008-.039-.1-.145-.035-.147V76.46l-.038-.022-.045-.135.034-.066-.031-.145,0-.054v0l-.024-.132-.039.061,0-.01-.073.266-.08-.313-.012.021.012.05-.062.122.042.076-.07.057v0l-.021.065.018.016-.045.092-.046.056-.089-.019-.03,0-.029-.01-.021.007v.024l-1.7.713.116.436-.426.172.283.1.359.048.108.12.216.061.1.088.055.29-.06.147-.077-.021-.38.158-.48.219-.256.708.009.041-.093.235-.012.1.044.053v.116l-.037.06.033.219.07,0,.03.023.17.016.033.029.261.058.114-.007.206.025.152-.017.185-.059.357-.143.524-.137.181.015.177.046.224,0,.254-.089.208-.035.307.015.321-.049.479-.18.246-.214.09-.133.131-.1.208-.013.118.106.007.046.165.053.053.187-.155.053.4.172.476.151.353.191.307.09.088,0,.454.114.147.134.09.093-.114.066,0,.019.1.053.054.275-.047.137.073.117.1.083.074.039.094.023.086-.037.251.012.157.041.009-.073-.129,0-.192-.143.239-.195.149-.018.23.058.171.116.076.075.129.052.041-.009.566-.007.349.08.178.426.116.009.027,0-.109-.1.153-.151.086-.023.135.023.145.079.113.137.1.061.009-.03.055-.112.21-.078.366-.11.142-.02.2-.008.189-.072.237.049.135.127.122.067.14.061.035-.013.04-.116.2-.166.189.219Z",
    transform: "translate(-192.214 -75.402)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_425",
    "data-name": "Grupo 425",
    transform: "translate(16.247 16.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_424",
    "data-name": "Grupo 424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1525",
    "data-name": "Trazado 1525",
    d: "M204.655,82.845l-.163-.134-.021.011.156.138Z",
    transform: "translate(-204.471 -82.712)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_427",
    "data-name": "Grupo 427",
    transform: "translate(16.072 16.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_426",
    "data-name": "Grupo 426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1526",
    "data-name": "Trazado 1526",
    d: "M204.6,82.98l-.319-.283.186-.1.074.032.276.227Z",
    transform: "translate(-204.285 -82.594)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_429",
    "data-name": "Grupo 429",
    transform: "translate(16.227 16.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_428",
    "data-name": "Grupo 428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1527",
    "data-name": "Trazado 1527",
    d: "M204.681,82.774v.04l-.028.032-.164-.133-.04.071Z",
    transform: "translate(-204.45 -82.713)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_431",
    "data-name": "Grupo 431",
    transform: "translate(16.05 16.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_430",
    "data-name": "Grupo 430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1528",
    "data-name": "Trazado 1528",
    d: "M204.654,82.976l-.128-.1-.264.011.187-.335.145.118.178-.008v.184Z",
    transform: "translate(-204.261 -82.547)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_433",
    "data-name": "Grupo 433",
    transform: "translate(16.247 16.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_432",
    "data-name": "Grupo 432"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1529",
    "data-name": "Trazado 1529",
    d: "M204.627,82.86l-.074.073-.082-.041.157-.2-.157.024Z",
    transform: "translate(-204.471 -82.698)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_435",
    "data-name": "Grupo 435",
    transform: "translate(16.016 16.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_434",
    "data-name": "Grupo 434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1530",
    "data-name": "Trazado 1530",
    d: "M204.558,83.048l-.26-.129.1-.123-.172-.152.631-.094-.179.222.085.075Z",
    transform: "translate(-204.226 -82.551)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_437",
    "data-name": "Grupo 437",
    transform: "translate(13.433 21.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_436",
    "data-name": "Grupo 436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1531",
    "data-name": "Trazado 1531",
    d: "M201.484,89.588l.324-.088.026.059.026.054.017.022.03.023.034.037.026.01.038,0,.017.015.034,0,.062.009.079-.02.081-.008.066-.029.031-.011.029-.02.04-.035.048-.045.017-.03.018-.022.008-.022-.006-.025.006-.016-.006-.024-.008-.031-.006-.019-.014-.017-.029-.01-.027-.013-.039-.013h-.038l-.1-.006-.174-.011-.133-.006-.111-.013-.078-.025-.038-.023-.027-.009-.043-.025-.033-.025-.02-.037-.033-.034-.008-.037-.021-.033-.012-.087-.006-.024,0-.037.02-.052.02-.064.031-.057.018-.026.027-.025.018-.028.018-.021.073-.048.019-.016.042-.026.074-.036.076-.025.044-.019.043-.007.1-.025.07-.016.081-.008.071-.006.059,0,.053.01.061.008.041.026.038.016.043.02.045.036.019.032.024.038.034.039.013.043v.1l-.337.074-.015-.057-.018-.019-.007-.024L202.4,88.7l-.029-.031-.014-.009-.015-.009-.061,0-.06-.006-.071.012-.066.008-.064.027-.052.029-.053.029-.017.026-.019.024,0,.028-.006.026,0,.031,0,.024.017.023.028.012.041.014.073.009.1.009.119.008.109.007.113.015.073,0,.074.02.067.015.042.03.045.035.034.039.034.04.015.056.016.06.01.041,0,.034.006.064-.018.06-.023.058-.011.041-.026.036-.021.023-.026.036-.043.055-.041.031-.03.019-.063.04-.086.046-.083.035-.1.024-.1.027-.094.017-.068,0-.074,0h-.057l-.063-.008-.061-.013-.044-.021-.052-.021-.043-.025-.043-.025-.035-.042-.023-.042-.011-.048-.027-.055Z",
    transform: "translate(-201.484 -88.378)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_439",
    "data-name": "Grupo 439",
    transform: "translate(13.309 21.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_438",
    "data-name": "Grupo 438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1532",
    "data-name": "Trazado 1532",
    d: "M202.045,90.093l-.213-.01-.184-.062-.127-.08-.077-.125-.092-.3.491-.134-.016,0-.1-.03-.2-.132-.093-.173-.018-.138,0-.037.1-.242.092-.1.22-.133.353-.1.167-.016.236.038.2.132.1.2,0,.182-.366.081h0l.2.054.09.068.1.133.046.175-.006.052.008.063-.073.21-.12.153-.159.112-.183.089-.321.074Zm-.081-.206.078,0,.14-.019.266-.08.2-.122.092-.138.035-.1,0-.046,0-.032-.031-.119-.106-.1-.123-.031h-.052l-.645-.093-.054-.1,0-.036.016-.122.083-.1.205-.1.146-.023.073.007.078,0,.153.118.017.041.169-.041-.023-.031-.074-.092-.236-.061-.194.026-.253.073-.1.053-.14.134-.057.146.076.192.113.063.058.016.6.05.116.071.048.148-.006.015,0,.025-.077.141-.131.11-.141.057-.167.031-.069-.011-.065.008-.21-.153-.028-.056-.143.04.064.142.161.079.093.012Zm.087-.276.056.008.236-.069.078-.084,0-.018,0-.014v-.006l-.062-.016-.5-.033.1.19L202,89.6Zm-.088-.757.072.011.341.025-.048-.115-.026-.028-.025,0-.061-.006-.114.017Z",
    transform: "translate(-201.352 -88.27)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_441",
    "data-name": "Grupo 441",
    transform: "translate(15.308 21.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_440",
    "data-name": "Grupo 440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1533",
    "data-name": "Trazado 1533",
    d: "M203.78,89.562l-.306-1.454.351-.114.31,1.46Z",
    transform: "translate(-203.474 -87.994)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_443",
    "data-name": "Grupo 443",
    transform: "translate(15.191 21.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_442",
    "data-name": "Grupo 442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1534",
    "data-name": "Trazado 1534",
    d: "M203.7,89.683l-.347-1.652.545-.177.353,1.662Zm-.11-1.515.264,1.255.16-.047-.267-1.259Z",
    transform: "translate(-203.349 -87.854)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_445",
    "data-name": "Grupo 445",
    transform: "translate(16.403 20.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_444",
    "data-name": "Grupo 444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1535",
    "data-name": "Trazado 1535",
    d: "M205.885,88.154l.345-.054.006.059-.007.065,0,.06-.019.06-.019.051-.024.055-.023.039-.034.057-.033.048-.037.044-.041.036-.049.037-.05.034-.052.037-.065.026-.061.04-.086.03-.079.023-.08.018-.08.02-.073-.009-.073,0-.077-.013-.036-.012-.029-.012-.069-.031-.067-.03-.047-.043-.063-.047-.052-.057-.041-.062-.022-.031-.021-.034-.012-.047-.009-.038-.035-.079-.024-.089-.008-.079-.008-.073.011-.081.008-.07.025-.081.03-.072.038-.072.057-.06.051-.071.046-.046.071-.057L205,87.52l.04-.025.03-.022.044-.014.084-.048.078-.026.063-.021.078-.023.071-.01.066-.01.063,0,.073,0,.056.022.079.017.057.046.061.054.066.057-.3.219-.038-.049-.043-.034-.015-.009-.041-.012-.026-.011-.027,0-.06,0-.06.006h-.024l-.043.009-.054.021-.041.025-.043.02-.038.035-.029.026-.041.031-.025.034-.025.038-.015.04-.013.041-.011.047-.014.041.015.052-.01.051.014.051.013.055.019.061.029.059.025.057.029.064.033.033.034.034.035.038.03.02.044.024.038.006.04.014.04.009.045-.006.036-.008.056-.015.035,0,.053-.019.052-.036.061-.038.04-.037.024-.04.017-.024.018-.027.014-.036,0-.025.013-.042.007-.064Z",
    transform: "translate(-204.636 -87.321)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_447",
    "data-name": "Grupo 447",
    transform: "translate(16.301 20.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_446",
    "data-name": "Grupo 446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1536",
    "data-name": "Trazado 1536",
    d: "M205.4,89.036l-.092-.011-.057,0-.185-.046-.166-.08-.168-.153-.106-.17-.08-.253-.02-.167.019-.173.063-.181.057-.1.156-.179.211-.154.043-.014.065-.04.242-.079.15-.024.187.013.162.055.283.243-.482.351-.124-.142-.113-.019-.051.006h-.017l-.134.058-.134.154-.028.1.012.045-.009.052.11.291.143.113.069.021.174-.038.118-.081.059-.1,0,0,.02-.1v-.163l.537-.084.016.168-.007.084,0,.064-.1.242-.113.164-.21.16-.322.135Zm-.083-.214.07.008.3-.083.041-.029.21-.13.087-.1.1-.217,0-.042v-.01l-.141.022-.024.146-.1.187-.04.037-.15.1-.263.057-.161-.043-.081-.049-.138-.147-.141-.385.01-.05-.017-.058.064-.2.084-.117.2-.144.14-.045h.013l.071,0,.241.061.034.027.121-.089-.066-.056-.232-.039-.317.085-.267.174-.134.157-.058.123-.025.122-.011.083.038.2.126.261.133.117.177.075.062.009Z",
    transform: "translate(-204.528 -87.214)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_449",
    "data-name": "Grupo 449",
    transform: "translate(18.462 19.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_448",
    "data-name": "Grupo 448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1537",
    "data-name": "Trazado 1537",
    d: "M208.612,87.145l-.338.219-.315-.185-.6.392.062.359-.312.209-.287-1.573.327-.211Zm-.9-.106-.532-.309.116.584Z",
    transform: "translate(-206.822 -86.356)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_451",
    "data-name": "Grupo 451",
    transform: "translate(18.35 19.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_450",
    "data-name": "Grupo 450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1538",
    "data-name": "Trazado 1538",
    d: "M207.03,88.3l-.327-1.793.434-.28,1.666.9-.534.347-.315-.185-.491.321.061.358Zm-.1-1.695.248,1.354.128-.086-.062-.36.708-.463.315.185.141-.091-1.259-.679-.1.065.853.494-.68.449-.186-.935Zm.389.316.042.214.154-.1Z",
    transform: "translate(-206.703 -86.231)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_453",
    "data-name": "Grupo 453",
    transform: "translate(0.598 19.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_452",
    "data-name": "Grupo 452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1539",
    "data-name": "Trazado 1539",
    d: "M188.062,86.635l-.169-.47-.018-.034-.009-.043-.007-.026,0-.045,0-.031.006-.028,0-.031.006-.027.025-.041.011-.008.056-.06.048-.045.043-.015.029-.021.083-.039.044-.014.033-.007.031,0,.033-.008.024.006.039.01.022,0,0,.011.036.008.029.023.027.022.019.032.016.025.029.087.066.146.394-.2.105.285Zm.358-.522-.025-.062-.02-.039-.017-.03-.024-.01-.026-.02-.011-.006-.034,0-.024,0-.022.008-.018.02-.031.019-.008.013-.018.032-.01.008-.006.013,0,.026.009.04.007.04.028.077Z",
    transform: "translate(-187.859 -85.643)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_455",
    "data-name": "Grupo 455",
    transform: "translate(0.261 17.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_454",
    "data-name": "Grupo 454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1540",
    "data-name": "Trazado 1540",
    d: "M188.4,84.466l.083.329.188-.022.076.3-1.167.087-.076-.316.987-.792.076.3Zm-.216.163-.366.252.409-.049Z",
    transform: "translate(-187.501 -84.051)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_457",
    "data-name": "Grupo 457",
    transform: "translate(0 16.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_456",
    "data-name": "Grupo 456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1541",
    "data-name": "Trazado 1541",
    d: "M187.33,84.047l-.106-.862.213-.066.711.359-.067-.575.232-.076.113.936-.224.058-.7-.338.059.489Z",
    transform: "translate(-187.224 -82.827)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_459",
    "data-name": "Grupo 459",
    transform: "translate(4.12 5.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_458",
    "data-name": "Grupo 458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1542",
    "data-name": "Trazado 1542",
    d: "M191.6,71.257l.338-.379L192,70.82l.041-.041.047-.039.048-.03.051-.02.049-.016.043-.012.034,0,.064-.01.037.016.046.007.034.011.1.04.028.03.052.026.045.048.035.053.044.043,0,.023.006.025.032.037v.092l.009.04-.011.041-.009.051-.014.036-.025.041-.066.091-.046.075-.36.391Zm.392-.112.4.33.05-.066.043-.045.027-.028.025-.037,0-.027.007-.017.006-.028-.006-.019-.007-.028-.017-.023-.022-.039-.029-.032-.041-.035-.056-.044-.024,0-.036-.013-.039-.023-.032.007-.012-.007-.031.01-.011,0-.03.008-.02.012-.047.028-.033.04Z",
    transform: "translate(-191.597 -70.654)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_461",
    "data-name": "Grupo 461",
    transform: "translate(5.216 3.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_460",
    "data-name": "Grupo 460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1543",
    "data-name": "Trazado 1543",
    d: "M192.761,70.034l.7-.641.138.142-.441.41.1.106.407-.369.134.136-.407.373.125.15.459-.425.139.157-.711.654Z",
    transform: "translate(-192.761 -69.393)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_463",
    "data-name": "Grupo 463",
    transform: "translate(6.472 3.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_462",
    "data-name": "Grupo 462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1544",
    "data-name": "Trazado 1544",
    d: "M194.312,69.515l.246-.206.056.042.023.012.024.006.044-.008.031-.008.042-.006.017-.019.032-.012.015-.022.025-.02.016-.021.016-.033.006-.018,0-.024,0-.015-.008-.026-.023,0v0l0-.008-.026-.01-.019,0-.032,0-.031,0-.109.052-.1.046-.092.03-.073.022-.073.008h-.024l-.032,0-.049-.015-.016-.024-.024-.008-.016-.015-.017-.03-.018-.024-.011-.04,0-.038-.009-.043V69l.023-.044,0-.024.008-.021.016-.027.014-.024.034-.043.041-.047.065-.048.062-.059.085-.055.04-.022.041-.021.028-.012.041-.016.042-.013.03-.008.023.007.043,0,.024,0,.035.008.055.039.057.048-.255.208-.026-.017-.034-.006-.006-.019h-.011l-.021,0-.035.008-.02,0-.04.016-.017.018-.029.017-.017.017-.017.024,0,.011-.008.012,0,.01.006.018-.006.023.013.01v0l.012,0,0,0h.023l.019,0,.02-.008.071-.028.1-.045.089-.042.067-.032.063-.009.042-.008.055-.008.035.007.034.007.039.021.026.021.028.02.028.025.024.045.012.046.01.043v.09l-.022.051-.007.054-.044.047-.031.049-.044.046-.064.055-.055.053-.055.032-.045.033-.058.035-.052.021-.048.024-.041.014-.024,0-.008,0h-.036l-.078,0-.033-.012-.027-.019-.054-.034-.026-.021Z",
    transform: "translate(-194.094 -68.516)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_465",
    "data-name": "Grupo 465",
    transform: "translate(7.845 2.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_464",
    "data-name": "Grupo 464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1545",
    "data-name": "Trazado 1545",
    d: "M196.265,68.359l-.343.212.034.171-.3.188-.1-1.078.332-.206.815.625-.314.2Zm-.167-.142-.266-.253.055.385Z",
    transform: "translate(-195.551 -67.646)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_467",
    "data-name": "Grupo 467",
    transform: "translate(8.96 1.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_466",
    "data-name": "Grupo 466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1546",
    "data-name": "Trazado 1546",
    d: "M197.075,68.049l-.34-.915.525-.266.068-.034.063-.017.05-.023.046-.016.037.008.037,0,.042,0,.039.021.029.019.031.034.025.021.015.051.008.032v.041l.011.042-.012.034-.013.038,0,.025-.026.038-.023.034-.045.044-.042.04.041,0,.047.008.031,0,.041.021.027.024.027.015.26.188-.362.181-.266-.2-.05-.036-.038-.011-.012-.007-.033.009-.02,0-.021.013-.019.008.131.374Zm.112-.7.138-.062.028-.023.047-.03.008-.011.019-.013.008-.015,0-.014.008-.01,0-.018-.008-.031-.007-.025-.024-.012,0-.012-.025-.007-.021,0h-.024l-.04.017-.041.017-.137.064Z",
    transform: "translate(-196.735 -66.779)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_469",
    "data-name": "Grupo 469",
    transform: "translate(10.375 0.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_468",
    "data-name": "Grupo 468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1547",
    "data-name": "Trazado 1547",
    d: "M198.475,67.37l-.238-.966.538-.192.071-.024.062-.02.057-.023.043,0,.043,0,.038.014.036.013.029.022.016.014.015.015.03.034.021.024.012.048v.043l.01.037-.013.035v.033l-.024.044,0,.009-.016.026-.024.025-.025.032-.047.04-.057.037.057,0,.033,0,.039.012.029.024.038.019.027.019.228.22-.373.139-.241-.229-.042-.039-.015-.008-.021,0-.023,0-.012,0h-.033l-.01,0-.041.008.106.393Zm.182-.688.14-.053.031-.01.048-.036.008,0,.017-.019.009-.013.006-.013.009-.014,0-.023-.008-.024-.006-.019-.015-.019-.016-.013,0-.015-.031,0h-.024l-.031.008-.041.01-.143.056Z",
    transform: "translate(-198.237 -66.139)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_471",
    "data-name": "Grupo 471",
    transform: "translate(11.814 0.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_470",
    "data-name": "Grupo 470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1548",
    "data-name": "Trazado 1548",
    d: "M199.769,66.375l0-.063,0-.051,0-.06.018-.051.009-.053.019-.051.022-.039.029-.055.036-.039.031-.041.044-.039.045-.034.047-.029.051-.021.058-.027.071-.025.064-.014.054-.008.049-.006.068-.006.046,0,.047.015.05.014.024.008.015.011.04.023.041.032.022.037.024.043.032.034.025.052,0,.055.014.052.006.055,0,.038v.077l.009.032-.012.037-.01.04-.014.027,0,.032-.013.031-.038.066-.052.055-.044.048-.023.019-.039.028-.068.037-.069.032-.083.028-.083.019-.084.024-.077,0H200.1l-.024-.008-.038-.01-.023-.01-.028-.013-.043-.036-.054-.04-.019-.025-.03-.026-.009-.033-.018-.029-.02-.073-.013-.043Zm.328-.09.02.063.008.033.007.022.024.049.017.019.014.008.04.027.021,0,.015.009.045,0h.031l.023,0,.049-.022.049-.022.035-.037.025-.031.006-.024.015-.031,0-.025,0-.029,0-.031v-.038l-.01-.079-.016-.059-.015-.051-.024-.047-.015-.006-.027-.014-.029-.025-.033,0-.035-.008h-.022l-.023,0-.021.009-.031,0-.018.013-.049.03-.025.029-.034.04-.022.041-.008.054,0,.065Z",
    transform: "translate(-199.765 -65.666)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_473",
    "data-name": "Grupo 473",
    transform: "translate(13.404 0.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_472",
    "data-name": "Grupo 472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1549",
    "data-name": "Trazado 1549",
    d: "M201.453,65.438l.317-.051.011.782.513-.08,0,.25-.844.135Z",
    transform: "translate(-201.453 -65.387)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_475",
    "data-name": "Grupo 475",
    transform: "translate(14.619 0.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_474",
    "data-name": "Grupo 474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1550",
    "data-name": "Trazado 1550",
    d: "M202.83,65.233l.318-.015L203.1,66l.513-.038-.028.258-.841.058Z",
    transform: "translate(-202.742 -65.218)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_477",
    "data-name": "Grupo 477",
    transform: "translate(15.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_476",
    "data-name": "Grupo 476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1551",
    "data-name": "Trazado 1551",
    d: "M204.083,65.691l.014-.069.017-.054,0-.027.015-.026.021-.049.03-.049.031-.041.043-.042.034-.033.046-.036.049-.025.051-.019.048-.026.065-.017h.042l.073-.009.056,0,.06.007.059.008.06.018.048.01.05.017.032.029.041.025.036.044.022.033.01.041.028.053.013.041,0,.048.007.059-.006.055,0,.061-.02.046V65.8l-.032.083,0,.031-.017.019-.016.021-.012.037-.017.018-.05.06-.026.025-.026.023-.019.013-.024.024-.07.038-.03.013-.041.012-.043.008-.033.006-.084.013-.081,0-.081,0-.078-.015-.065-.024-.037-.01-.025-.011-.028-.013-.018-.029-.025-.011-.02-.027-.038-.055-.027-.05-.008-.033-.013-.038-.009-.033v-.041l.009-.041-.009-.032Zm.314.008-.008.082.006.056.006.024.01.033.006.019,0,.017.02.034.04.021.025.01.015.009h.1l.021-.008h.033l.011,0,.026-.024.01,0,.026-.028.023-.034.027-.026,0-.028.024-.061.02-.087.01-.072,0-.056-.006-.054-.021-.039-.03-.025-.04-.022-.016-.009-.013-.015-.045,0-.056,0-.041.013-.02.006-.02.018-.035.026-.046.043-.028.047-.013.032,0,.033Z",
    transform: "translate(-204.063 -65.166)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_479",
    "data-name": "Grupo 479",
    transform: "translate(16.176 2.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_478",
    "data-name": "Grupo 478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1552",
    "data-name": "Trazado 1552",
    d: "M205.084,68.949l.2.089-.044.078-.036.033-.028.025-.063.057-.057.043-.029.01-.041.017-.035,0-.041.012-.076.016-.08-.006-.047-.006-.05-.013-.04-.021-.04-.024-.029-.024-.046-.031-.018-.028-.033-.037-.014-.048-.024-.038,0-.046-.011-.042.007-.059-.007-.055.021-.054.007-.056.024-.063.019-.059.03-.053.028-.053.031-.044.024-.036.059-.04.038-.03.036-.03.049-.029.05-.021.044-.01.051-.017h.057l.042,0h.055l.04.016.048.006.077.027.03.024.04.021.021.033.03.019.024.044.012.044.008.06-.007.06-.2.012-.008-.029-.011-.039-.008-.025-.024-.033-.028-.025-.028-.018-.023-.011L205,68.436l-.057,0-.055.007-.019.012-.021.007-.031.015-.028.022-.026.019-.016.028-.016.022-.024.036-.027.038-.013.03-.01.041-.02.05-.007.048v.032l-.013.078v.036l.009.033.015.051.006.02.016.024.019.02.013.014.026,0,.025.017.025.007.024,0h.034l.043-.012.044-.01.029-.013.05-.029.033-.039.024-.037Z",
    transform: "translate(-204.395 -68.258)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_481",
    "data-name": "Grupo 481",
    transform: "translate(16.072 2.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_480",
    "data-name": "Grupo 480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1553",
    "data-name": "Trazado 1553",
    d: "M204.831,69.429l-.21-.028-.215-.144-.106-.173-.015-.113.008-.078-.009-.057.143-.371.088-.117.25-.159.135-.035.252.019.13.051.146.127.043.109.011.073-.015.171-.367.023-.088-.19-.079-.007-.1.057-.081.142-.025.107-.014.092.029.087.074.025.11-.041.04-.054.061-.137.392.178-.119.2-.249.19-.122.032Zm-.267-.3.019.012-.039-.064-.035-.164.015-.1V68.8l.007-.059.032-.1-.048.124-.023.1,0,.029-.006.062Zm.592-.742.036.031.058.1.025,0-.021-.045Z",
    transform: "translate(-204.285 -68.153)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_483",
    "data-name": "Grupo 483",
    transform: "translate(17.327 3.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_482",
    "data-name": "Grupo 482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1554",
    "data-name": "Trazado 1554",
    d: "M205.617,69.443l.409-1,.734.183-.064.16-.537-.124-.094.224.5.123-.065.161-.492-.117-.113.27.546.143-.066.164Z",
    transform: "translate(-205.617 -68.443)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_485",
    "data-name": "Grupo 485",
    transform: "translate(17.189 2.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_484",
    "data-name": "Grupo 484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1555",
    "data-name": "Trazado 1555",
    d: "M206.431,69.744l-.961-.237.486-1.192.934.233-.14.35-.539-.124-.015.035.5.123-.141.35-.493-.117-.035.083.544.143Zm-.683-.379.009,0,.174-.415-.014,0Zm.33-.81-.105.259.108-.258Z",
    transform: "translate(-205.47 -68.315)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_487",
    "data-name": "Grupo 487",
    transform: "translate(18.422 3.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_486",
    "data-name": "Grupo 486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1556",
    "data-name": "Trazado 1556",
    d: "M206.779,69.781l.532-.971.182.079.037.79.354-.642.166.065-.518.967-.185-.078-.03-.787-.357.637Z",
    transform: "translate(-206.779 -68.81)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_489",
    "data-name": "Grupo 489",
    transform: "translate(18.274 3.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_488",
    "data-name": "Grupo 488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1557",
    "data-name": "Trazado 1557",
    d: "M207.569,70.192l-.33-.139-.018-.49-.222.4-.376-.127.635-1.159.325.141.023.494.223-.4.355.14Z",
    transform: "translate(-206.623 -68.672)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_491",
    "data-name": "Grupo 491",
    transform: "translate(19.722 3.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_490",
    "data-name": "Grupo 490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1558",
    "data-name": "Trazado 1558",
    d: "M208.159,70.392l.539-.755-.263-.148.105-.147.691.382-.1.152-.265-.141-.526.758Z",
    transform: "translate(-208.159 -69.342)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_493",
    "data-name": "Grupo 493",
    transform: "translate(19.573 3.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_492",
    "data-name": "Grupo 492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1559",
    "data-name": "Trazado 1559",
    d: "M208.36,70.619l-.358-.2.539-.754-.263-.149.224-.312.868.479-.218.319-.265-.141Z",
    transform: "translate(-208.002 -69.201)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_495",
    "data-name": "Grupo 495",
    transform: "translate(20.408 4.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_494",
    "data-name": "Grupo 494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1560",
    "data-name": "Trazado 1560",
    d: "M208.887,70.834l.767-.834.334.252.054.057.043.036.024.04.035.038.011.033.008.033,0,.047,0,.029-.018.051-.012.035-.021.041-.035.044-.044.038-.049.03-.02.012-.033.013-.02.008-.034,0-.052.015-.05-.008-.063-.016-.025-.01-.027-.016.011.069.009.064v.038l-.009.042-.022.125-.044.231-.2-.138.064-.284.023-.111,0-.068,0-.019,0-.014-.012-.039-.033-.033-.046-.039-.022-.024-.318.35Zm.594-.357.122.089.1.066.031.024.013.01h.046l.012.006.033-.014.01,0,.021-.008.018-.018.018-.017.028-.017,0-.022,0-.015.011-.036v-.008l0-.03-.02-.023-.013-.006-.111-.1-.124-.1Z",
    transform: "translate(-208.887 -70)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_497",
    "data-name": "Grupo 497",
    transform: "translate(20.256 4.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_496",
    "data-name": "Grupo 496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1561",
    "data-name": "Trazado 1561",
    d: "M209.668,71.535l-.389-.265.106-.511h0l-.008,0-.01-.022-.31.341-.329-.241.906-.985.408.307.19.218.023.074.008.061,0,.051-.061.162-.046.06-.2.13-.125.033-.05-.009-.012.089Zm-.16-.354.019.012.047-.25-.006-.04Zm-.117-.42h.032l.049-.031Zm.437-.114.036.083.024,0Zm.2-.093-.009.073-.085.075.071-.055.039-.076.017-.05-.02-.061-.006.053,0,.022Zm-.405-.1.165.1.04-.041-.148-.125Z",
    transform: "translate(-208.726 -69.854)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_499",
    "data-name": "Grupo 499",
    transform: "translate(21.482 5.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_498",
    "data-name": "Grupo 498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1562",
    "data-name": "Trazado 1562",
    d: "M210.272,71.232l.065-.052.055-.04.041-.018.026-.022.061-.028.1-.034.013.007.023,0,.047,0,.043-.008.049.008.039.011.036,0,.039.024.053.017.036.044.05.044.047.032.022.04.026.042.015.05.01.033.006.056,0,.046v.041l0,.06-.021.045-.016.026,0,.021-.021.051-.029.044-.053.052-.035.043-.056.044-.043.046-.048.04-.048.03-.063.025-.052.019-.05.019-.021.008-.033.008-.046,0-.057,0-.051-.006-.036-.007-.051-.012-.042-.025-.045-.025-.043-.034-.042-.024-.029-.052-.033-.033-.025-.046-.024-.036,0-.055,0-.047-.016-.046.012-.046.006-.055.022-.04.019-.056.021-.044.032-.05.041-.052.039-.029Zm.146.131-.058.076-.052.061-.026.03-.011.03-.015.033,0,.023v.038l0,.026.007.024v.032l.007.024.02.027.02.021.02.029.044.028.045.031.059.007.059,0,.032-.01.031-.01.071-.027.073-.032.061-.061.036-.031.037-.038.051-.057.014-.032.013-.033.017-.059.015-.03v-.032l-.008-.028-.007-.018-.008-.027-.02-.025-.021-.028-.014-.012-.051-.046-.054-.021-.024,0-.017-.011h-.07l-.032.007-.033,0-.062.026-.067.044Z",
    transform: "translate(-210.028 -71.031)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_501",
    "data-name": "Grupo 501",
    transform: "translate(21.376 5.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_500",
    "data-name": "Grupo 500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1563",
    "data-name": "Trazado 1563",
    d: "M210.528,72.2l-.252-.043-.194-.122-.138-.233-.028-.153.093-.287.087-.122.294-.229.082-.041.145-.052.026.013.092-.013.177.041.118.063.073.076.07.059.081.184.013.123-.013.153-.1.2-.254.248-.058.038-.25.091Zm.244-.292-.228.088.037-.006Zm.062-.054-.023.023Zm.1-.1-.053.052Zm-.5.032.069.006.162-.063.175-.2.024-.073-.02-.048-.058-.06-.069-.023-.08.008-.05.021-.11.075-.141.2,0,.018,0,.02.04.088Zm-.295-.029.01.015-.015-.118,0-.026V71.6l.056-.142.1-.123-.114.13-.059.18.012.046Zm.918-.238-.074.177-.033.037.069-.1Zm-.24-.378.008,0Z",
    transform: "translate(-209.915 -70.921)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_503",
    "data-name": "Grupo 503",
    transform: "translate(22.101 6.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_502",
    "data-name": "Grupo 502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1564",
    "data-name": "Trazado 1564",
    d: "M211.239,73.322l-.125-.176.169-.213-.221-.333-.252.083-.124-.172,1.17-.326.115.18Zm.169-.552.287-.345-.438.125Z",
    transform: "translate(-210.685 -72.185)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_505",
    "data-name": "Grupo 505",
    transform: "translate(21.934 6.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_504",
    "data-name": "Grupo 504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1565",
    "data-name": "Trazado 1565",
    d: "M211.227,73.486l-.251-.35.171-.215-.138-.206-.249.082-.253-.351,1.383-.385.194.3Zm0-.344v0l.063-.083Zm.164-.217,0,0,.051-.066Z",
    transform: "translate(-210.507 -72.06)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_507",
    "data-name": "Grupo 507",
    transform: "translate(22.813 7.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_506",
    "data-name": "Grupo 506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1566",
    "data-name": "Trazado 1566",
    d: "M211.441,73.617l1.008-.53.131.268-.613.519.772-.206.132.268-1.023.533-.089-.171.814-.409-.894.23-.074-.169.708-.581-.8.414Z",
    transform: "translate(-211.441 -73.087)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_509",
    "data-name": "Grupo 509",
    transform: "translate(22.68 7.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_508",
    "data-name": "Grupo 508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1567",
    "data-name": "Trazado 1567",
    d: "M211.8,74.592l-.182-.354.058-.029-.059.015-.066-.15h0l-.074-.168.014-.011-.025.013-.161-.351,1.187-.624.083.17.555-.288-.5.408.071.145-.328.277.415-.111.078.16.594-.153-.537.27.077.156Z",
    transform: "translate(-211.299 -72.814)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_511",
    "data-name": "Grupo 511",
    transform: "translate(23.346 8.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_510",
    "data-name": "Grupo 510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1568",
    "data-name": "Trazado 1568",
    d: "M212.006,74.91l1.071-.415.233.692-.18.069-.171-.506-.243.1.161.467-.176.072-.16-.467-.3.108.168.535-.168.062Z",
    transform: "translate(-212.006 -74.495)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_513",
    "data-name": "Grupo 513",
    transform: "translate(23.22 8.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_512",
    "data-name": "Grupo 512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1569",
    "data-name": "Trazado 1569",
    d: "M212.168,75.75l-.3-.908,1.26-.489.3.886-.369.142-.171-.5-.054.022.161.467-.366.149-.161-.472-.112.041.168.534Zm.414-.966-.069.027.07-.025Z",
    transform: "translate(-211.872 -74.353)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_515",
    "data-name": "Grupo 515",
    transform: "translate(23.655 9.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_514",
    "data-name": "Grupo 514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1570",
    "data-name": "Trazado 1570",
    d: "M212.334,76.052l1.093-.3.082.415.011.075.009.064-.008.054-.008.051-.01.041-.014.036-.023.036-.02.016-.018.018-.039.03-.026.026-.043.017-.063.019-.055.01-.049,0-.05-.008-.056-.015L213,76.613l-.046-.037-.016-.055-.029-.057-.012.036-.024.04-.027.031-.016.027-.059.075-.045.043-.041.045-.205.182-.041-.245.217-.212.092-.081.054-.057.006-.023.019-.013.008-.017-.006-.02,0-.023.008-.018-.009-.066,0-.044-.458.125Zm.664.034.032.139.024.112.01.038.008.024,0,.012.017.014.015.006.027.011v.006h.034l.023-.007h.021l.041-.022.03-.021.009-.008.018-.017,0-.022.015-.032-.006-.014,0-.056-.017-.094-.025-.152Z",
    transform: "translate(-212.334 -75.754)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_517",
    "data-name": "Grupo 517",
    transform: "translate(23.538 9.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_516",
    "data-name": "Grupo 516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1571",
    "data-name": "Trazado 1571",
    d: "M212.405,77.134l-.08-.478.4-.4v-.01l-.437.12-.075-.4,1.289-.351.127.682-.048.219-.093.113-.089.071-.179.051-.134-.009-.067-.018-.115-.068-.145.164Zm.138-.407,0,.012.151-.147.043-.057Zm.562-.185.1.01.11-.042.09-.1.008-.041-.057.094-.122.075Zm.049-.207.007,0,.056-.035-.025-.176-.078.023Zm-.224-.055.006.01-.007-.026v0l0,.009Zm-.01-.292v0l.359-.1Z",
    transform: "translate(-212.21 -75.619)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_519",
    "data-name": "Grupo 519",
    transform: "translate(23.794 11.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_518",
    "data-name": "Grupo 518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1572",
    "data-name": "Trazado 1572",
    d: "M212.482,77.3l1.126-.165,0,.211-1.116.167Z",
    transform: "translate(-212.482 -77.134)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_521",
    "data-name": "Grupo 521",
    transform: "translate(23.692 11.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_520",
    "data-name": "Grupo 520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1573",
    "data-name": "Trazado 1573",
    d: "M212.381,77.622l-.008-.418,1.333-.2-.009.417Zm.2-.243v.008l.917-.141Z",
    transform: "translate(-212.373 -77.009)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_523",
    "data-name": "Grupo 523",
    transform: "translate(23.757 11.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_522",
    "data-name": "Grupo 522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1574",
    "data-name": "Trazado 1574",
    d: "M212.861,78.609l-.089.2-.08-.022-.079-.023-.059-.036-.042-.057-.027-.057-.03-.057-.011-.073,0-.074.008-.05.009-.052.019-.043.012-.045.033-.044.035-.043.024-.025.044-.049.04-.03.037-.028.056-.021.053-.02.051-.025.055-.015L213,77.9h.056l.13,0,.052.013.062.007.052.014.042.025.043.019.038.035.035.034.034.029.024.041.024.033.012.039,0,.051,0,.056,0,.056-.008.048,0,.03-.022.057-.013.035-.014.033-.037.04-.011.029-.05.041-.024.031-.06.037-.06.028-.051.025-.041-.21.039-.016.03-.011.04-.03.04-.028v-.029l.035-.044.007-.023.008-.048,0-.023-.008-.024-.008-.023-.01-.035-.007-.021-.015-.009-.025-.044-.028-.009-.028-.017-.065-.017-.034,0-.043-.01-.089,0-.1.013-.047.007-.033.008-.03.011-.035.011-.029.018-.028.021-.029.022-.019.024-.02.01-.017.028-.019.048,0,.028,0,.03,0,.038v.037l.022.028.022.032.029.025.041.023.042.016Z",
    transform: "translate(-212.442 -77.9)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_525",
    "data-name": "Grupo 525",
    transform: "translate(23.657 11.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_524",
    "data-name": "Grupo 524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1575",
    "data-name": "Trazado 1575",
    d: "M213.173,78.929l-.083-.422.164-.089.041-.052.008-.044-.038-.079-.06-.022-.033,0-.045-.011-.3.056-.079.071-.01.032,0,.016,0,.044.062.056.076.018.126.025-.178.395-.269-.079-.089-.062-.042-.057-.075-.158-.011-.073.02-.21.049-.131.143-.171.116-.085.222-.084.164-.019.141,0,.206.049.229.179.073.16,0,.051,0,.066,0,.042-.016.121-.07.158-.144.158Zm-.525-.266.061.017,0-.01-.056-.03-.047-.039-.068-.089v0l.071.126Zm.789-.531.01.007.026.045.022.071,0-.027,0-.038-.074-.09Zm-.213-.118.165.057-.083-.048L213.17,78l-.3.039.059-.009.217-.018.041.01Z",
    transform: "translate(-212.336 -77.791)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_527",
    "data-name": "Grupo 527",
    transform: "translate(23.477 13.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_526",
    "data-name": "Grupo 526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1576",
    "data-name": "Trazado 1576",
    d: "M212.145,80.2l.051-.222.277-.079.087-.406-.231-.1.036-.22,1.025.455-.04.217Zm.522-.361.452-.117-.384-.166Z",
    transform: "translate(-212.145 -79.175)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_529",
    "data-name": "Grupo 529",
    transform: "translate(23.339 13.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_528",
    "data-name": "Grupo 528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1577",
    "data-name": "Trazado 1577",
    d: "M212,80.342l.1-.451.276-.078.057-.265-.227-.1.07-.428,1.219.541-.067.357Zm.8-.649h0Zm-.364-.368.219.1,0-.011-.22-.1Z",
    transform: "translate(-211.999 -79.02)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_531",
    "data-name": "Grupo 531",
    transform: "translate(23.098 14.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_530",
    "data-name": "Grupo 530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1578",
    "data-name": "Trazado 1578",
    d: "M212.025,80.586l1.061.182-.061.191-.869.295.723.122-.073.19-1.063-.185.056-.2.858-.292-.707-.117Z",
    transform: "translate(-211.743 -80.586)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_533",
    "data-name": "Grupo 533",
    transform: "translate(22.97 14.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_532",
    "data-name": "Grupo 532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1579",
    "data-name": "Trazado 1579",
    d: "M212.863,81.673l-1.256-.218.1-.358.525-.179-.431-.071.151-.383,1.258.216-.112.351-.535.182.448.075Z",
    transform: "translate(-211.607 -80.464)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_535",
    "data-name": "Grupo 535",
    transform: "translate(22.452 15.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_534",
    "data-name": "Grupo 534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1580",
    "data-name": "Trazado 1580",
    d: "M211.057,82.714l.121-.22.263-.011.205-.391-.179-.15.1-.212.817.7-.12.21Zm.6-.24.44-.012-.3-.256Z",
    transform: "translate(-211.057 -81.73)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_537",
    "data-name": "Grupo 537",
    transform: "translate(22.274 15.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_536",
    "data-name": "Grupo 536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1581",
    "data-name": "Trazado 1581",
    d: "M210.868,82.817l.236-.432.262-.011.139-.267-.177-.149.2-.4.981.841-.188.332Zm.36-.235,0,.008.431-.025Zm.518-.547.495.418.006-.01-.654-.561-.01.023.161.135Zm.064.321h0Z",
    transform: "translate(-210.868 -81.557)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_539",
    "data-name": "Grupo 539",
    transform: "translate(23.896 3.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_538",
    "data-name": "Grupo 538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1582",
    "data-name": "Trazado 1582",
    d: "M213.479,68.905l.2.228-.65.56.32.35-.209.178-.546-.578Z",
    transform: "translate(-212.591 -68.905)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_541",
    "data-name": "Grupo 541",
    transform: "translate(24.662 4.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_540",
    "data-name": "Grupo 540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1583",
    "data-name": "Trazado 1583",
    d: "M214.332,69.868l.2.247-.932.687-.2-.24Z",
    transform: "translate(-213.403 -69.868)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_543",
    "data-name": "Grupo 543",
    transform: "translate(25.119 5.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_542",
    "data-name": "Grupo 542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1584",
    "data-name": "Trazado 1584",
    d: "M214.862,70.591l.317.494.031.065.011.029.009.034,0,.059.007.022-.012.033-.022.043-.031.05-.033.044-.058.033-.028.022-.041,0-.045.012-.058,0-.027-.007-.038,0-.017-.019-.04-.013.016.047,0,.052-.009.044-.011.044-.02.039-.038.034-.034.034-.039.027-.04.024-.039.017-.036,0-.043.016-.036,0-.05-.008-.027-.013-.037-.006-.026-.007-.019-.027-.053-.047-.09-.1-.268-.471Zm-.208.5.071.115.029.058.027.008.017.011.023,0,.025,0,.021-.008.02-.008.018-.019.008-.011.015-.018.018-.017-.008-.026-.006-.015-.009-.028-.011-.032-.071-.12Zm-.393.235.08.138.022.033.032.023.015.019.027,0,.015.006.031-.007.02,0,.017-.017.023-.008.02-.012.007-.019,0-.022,0-.029,0-.025-.009-.029-.022-.032-.083-.138Z",
    transform: "translate(-213.888 -70.591)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_545",
    "data-name": "Grupo 545",
    transform: "translate(25.773 6.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_544",
    "data-name": "Grupo 544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1585",
    "data-name": "Trazado 1585",
    d: "M215.621,71.849l.352.753-.22.112-.222-.461-.163.076.212.437-.212.1-.215-.435-.2.1.229.485-.232.117-.366-.763Z",
    transform: "translate(-214.583 -71.849)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_547",
    "data-name": "Grupo 547",
    transform: "translate(26.281 7.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_546",
    "data-name": "Grupo 546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1586",
    "data-name": "Trazado 1586",
    d: "M215.122,73.575l1.072-.427.166.5.041.124.006.055-.01.041,0,.048-.01.033-.021.041-.009.007-.016.028-.025.03-.036.036-.043.022-.05.024-.044.013-.044,0-.043.013-.015-.006-.024,0-.04-.012-.037-.007-.028-.011-.028-.024-.047-.031-.039-.047-.006.049-.008.018.008.018-.015.027-.034.046-.036.039-.018.021-.266.267-.108-.333.283-.291.033-.043.038-.035,0-.049-.011-.035-.009-.024-.438.172Zm.734.045.04.122.051.082.007.022.038.008.024.006.035-.008.033-.011.026-.022.007-.013.008-.018.016-.023,0-.027-.008-.027,0-.048-.057-.131Z",
    transform: "translate(-215.122 -73.148)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_549",
    "data-name": "Grupo 549",
    transform: "translate(26.694 8.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_548",
    "data-name": "Grupo 548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1587",
    "data-name": "Trazado 1587",
    d: "M216.625,74.526l.184.946-.273.075-.073-.323-.838.227-.064-.3.838-.228-.054-.317Z",
    transform: "translate(-215.56 -74.526)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_551",
    "data-name": "Grupo 551",
    transform: "translate(26.848 10.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_550",
    "data-name": "Grupo 550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1588",
    "data-name": "Trazado 1588",
    d: "M215.966,76.753l-.033-.366-.2-.014-.011-.327,1.16.187.017.349-1.113.583-.025-.337Zm.237-.111.395-.191-.411-.038Z",
    transform: "translate(-215.724 -76.046)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_553",
    "data-name": "Grupo 553",
    transform: "translate(26.88 11.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_552",
    "data-name": "Grupo 552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1589",
    "data-name": "Trazado 1589",
    d: "M216.936,77.484l-.026.474-.011.076,0,.064-.022.05-.019.048-.015.027-.017.022-.024.037-.038.035-.039.029-.034.035-.041.024-.1.045-.117.016-.11.027h-.085l-.072-.007-.073,0h-.025l-.028-.01-.052-.013-.034-.028-.045-.025-.03-.024-.026-.039-.044-.026-.008-.026-.014-.042-.021-.1.006-.055v-.041l.026-.482Zm-.275.345-.62.044-.02.09,0,.036.006.045.009.028.007.023.016.021.015.022.02.011.029.017.036,0,.047,0,.119,0,.08-.013.071-.009.03-.012.022-.008.041-.026.028-.021,0-.013.008-.013.016-.027.02-.043,0-.064Z",
    transform: "translate(-215.758 -77.484)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_555",
    "data-name": "Grupo 555",
    transform: "translate(10.104 25.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_554",
    "data-name": "Grupo 554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1590",
    "data-name": "Trazado 1590",
    d: "M198.233,91.831l.516.016.075.008.048.008.063.017.041.017.054.019.031.029.019.036.033.029.008.04.014.052.009.038.01.045v.047l-.008.058-.022.1-.019.073-.033.067-.014.031-.006.027-.032.057-.039.038-.039.04-.027.036-.054.023-.041.036-.045.016-.042.02-.044.011-.117.018h-.045l-.048,0-.531-.014Zm.273.245-.142.578h.1l.091-.008.034-.007.022,0,.032-.018.022-.013.029-.019.018-.028.019-.024.024-.05.015-.041.019-.058.017-.08,0-.066-.008-.028-.006-.028,0-.009,0-.021-.006-.02-.018-.021-.038-.007-.036-.006-.017-.013h-.059Z",
    transform: "translate(-197.949 -91.831)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_557",
    "data-name": "Grupo 557",
    transform: "translate(11.671 25.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_556",
    "data-name": "Grupo 556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1591",
    "data-name": "Trazado 1591",
    d: "M199.76,91.852l.96-.045-.03.213-.6.041-.016.161.545-.034-.032.215-.544.031-.023.2.608-.036-.04.236-.971.057Z",
    transform: "translate(-199.613 -91.807)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_559",
    "data-name": "Grupo 559",
    transform: "translate(13.208 24.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_558",
    "data-name": "Grupo 558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1592",
    "data-name": "Trazado 1592",
    d: "M201.245,91.74l.478-.076.174.594.192-.656.477-.078-.014,1.026-.3.054.016-.78-.238.817-.265.044-.228-.746.007.778-.3.044Z",
    transform: "translate(-201.245 -91.524)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_561",
    "data-name": "Grupo 561",
    transform: "translate(15.001 24.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_560",
    "data-name": "Grupo 560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1593",
    "data-name": "Trazado 1593",
    d: "M203.157,91.921l-.006-.064,0-.054,0-.056.024-.056.008-.053.024-.053.024-.041.034-.053.039-.038.04-.042.047-.041.024-.008.031-.019.049-.031.055-.025.068-.018.065-.03.068-.014.072-.008.071-.012.05,0,.057,0,.049,0,.056.021.051.011.033.03.042.03.024.034.044.034.013.052.026.047.013.054,0,.052.011.089,0,.071,0,.078-.02.068-.043.069,0,.024-.016.028-.059.057-.046.048-.073.043-.074.038-.073.044-.048.006-.055.02-.091.024-.092.006-.073.007-.046.006-.023-.006-.07-.02-.027-.008-.038-.01-.029-.022-.028-.008-.017-.025-.029-.015-.052-.056-.009-.034-.008-.028-.02-.034L203.176,92l-.011-.045Zm.36-.1.008.068.025.057.025.042.032.029.024.01.016.01.05,0,.014.01.022,0,.059-.01.032-.011.024-.008.055-.024.038-.033.009-.015.019-.023.024-.049.006-.027,0-.025.007-.072L204,91.676l0-.064-.039-.053-.008-.03-.015-.008-.032-.035-.042-.01-.039-.018-.035,0h-.014l-.058.011-.052.025-.041.024-.041.034-.027.031-.017.027-.019.021,0,.049-.021.069Z",
    transform: "translate(-203.148 -91.206)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_563",
    "data-name": "Grupo 563",
    transform: "translate(16.614 24.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_562",
    "data-name": "Grupo 562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1594",
    "data-name": "Trazado 1594",
    d: "M205.7,91.2l.342-.03-.009.054,0,.052-.023.057-.022.054-.024.044-.025.045-.051.038-.024.041-.05.033-.062.037-.065.035-.078.027-.089.032-.035.012-.042.01-.039,0-.044.015-.026-.009h-.032l-.039.006-.027-.008-.038,0-.026-.011-.07-.022-.056-.035-.062-.051-.041-.057-.011-.042-.022-.03-.036-.092-.01-.041-.009-.07,0-.046,0-.054.023-.058.012-.045.01-.051.025-.039.039-.05.036-.043.026-.036.061-.036.05-.045.055-.024.065-.028.065-.027.1-.033.061-.01.034-.008.081-.008.047,0,.04.013.065.015.031.023.04.015.028.014.031.024.042.067-.292.167-.017-.016,0-.019-.028-.018-.017-.009-.026-.008-.013-.011H205.5l-.047.008-.059.014-.021.008-.03.02-.041.028-.031.024-.015.028-.008.019-.008.015-.024.05v.045l0,.056.015.056.031.066.026.056.027.055.027.008.017.016.026.011.027.01.023-.008.036,0,.066-.03.034-.01.041-.025.041-.028.018-.025.014-.04.025-.041v-.046Z",
    transform: "translate(-204.86 -90.647)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_565",
    "data-name": "Grupo 565",
    transform: "translate(18.013 23.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_564",
    "data-name": "Grupo 564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1595",
    "data-name": "Trazado 1595",
    d: "M206.763,91.21l-.418-.9.556-.267.129-.062.067-.024.046-.013.057-.006h.045l.016,0,.026.007.012.007.018.014.042.019,0,.015.027.01.033.03.022.039.009.038.013.039,0,.034v.045l-.017.026-.012.041-.016.031-.037.039-.008.024-.021.012-.056.05h.047l.058-.007.074.01.061.042.284.182-.377.185-.306-.189-.056-.024-.028-.008-.011,0h-.025l-.024,0-.023.008-.023.008-.03.017.164.37Zm.087-.692.125-.071.045-.014.053-.036.028-.03.008-.008.008-.024.006-.016,0-.015,0-.019-.006-.016,0-.011-.015-.016-.014,0,0-.01-.027-.01-.032.011h-.024l-.078.033-.148.074Z",
    transform: "translate(-206.345 -89.94)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_567",
    "data-name": "Grupo 567",
    transform: "translate(19.676 22.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_566",
    "data-name": "Grupo 566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1596",
    "data-name": "Trazado 1596",
    d: "M208.918,89.891l-.382.214.038.173-.322.189-.141-1.061.352-.209.926.59-.345.213Zm-.188-.143-.313-.236.08.37Z",
    transform: "translate(-208.11 -89.198)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_569",
    "data-name": "Grupo 569",
    transform: "translate(20.854 21.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_568",
    "data-name": "Grupo 568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1597",
    "data-name": "Trazado 1597",
    d: "M210.242,88.691l.313-.144.018.056.016.057.014.051-.01.049v.046l-.008.049-.025.051-.035.048-.026.037-.04.059-.062.042-.058.054-.07.057-.075.035-.073.04-.068.023-.064.012-.038,0-.037,0-.064-.013-.077-.008-.039-.01-.039-.008-.061-.046-.074-.045-.057-.06-.049-.05-.026-.048-.026-.046-.014-.051-.013-.046-.012-.041.009-.057.009-.047.012-.046.01-.044.024-.045.035-.051.037-.042.047-.049.048-.046.059-.047.076-.06.085-.045.057-.021.031-.011.046-.01.034-.008.037,0h.037l.079.012.051.007.038.008.041.022.027.015-.22.245-.04-.017L210,88.49l-.049,0h-.024l-.036,0-.042.021-.02.017-.024.008-.041.047-.009.019-.028.024-.013.042,0,.023,0,.026,0,.017,0,.019.015.05.007.023.018.024.04.052.063.049.038.044.027.015.025.011.026.006h.014l.052.013.022-.014.024,0,.041-.025.041-.024.04-.035.04-.029,0-.033.007-.018.008-.019.015-.034-.013-.043-.01-.039Z",
    transform: "translate(-209.361 -88.211)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_571",
    "data-name": "Grupo 571",
    transform: "translate(21.921 21.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_570",
    "data-name": "Grupo 570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1598",
    "data-name": "Trazado 1598",
    d: "M210.493,87.737l.292-.24.721.71-.282.236Z",
    transform: "translate(-210.493 -87.497)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_573",
    "data-name": "Grupo 573",
    transform: "translate(22.804 20.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_572",
    "data-name": "Grupo 572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1599",
    "data-name": "Trazado 1599",
    d: "M212.41,87.115l-.287.3.093.145-.264.259-.521-.933.291-.282,1.135.3-.269.268Zm-.239-.073-.382-.135.215.314Z",
    transform: "translate(-211.431 -86.605)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_575",
    "data-name": "Grupo 575",
    transform: "translate(15.099 5.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_574",
    "data-name": "Grupo 574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1600",
    "data-name": "Trazado 1600",
    d: "M205.843,71.374l.078-.052.041-.214-.138-.038-.351-.03-.151.076-.072.034h-.171l-.026.025-.131.03-.028-.06.274-.125.026-.065-.083-.017-.017.027-.287.156-.129-.048-.026-.054-.011-.006-.052-.066h-.044l-.1.079-.1.046-.181-.035-.06.057h-.2l-.164.025-.077.09-.1.061-.234.069-.067.118.009.037.047.082.051.064-.01.126.128.044,0,.029-.083.184.073.013.066.08-.067.164-.077.036.007.024.077.041,0,.023.168.028-.023.086.043.071v.037l-.008.012.1.015.07.126.061-.027.144.061.016-.027,0-.1.107-.291-.046-.159.126-.043.009-.045.027-.016.076-.106.037-.025.083.014v.041l.073.055.1-.07.157-.092.037-.154.126-.107.154-.024.016-.022.1-.017.141-.062.09-.051.163-.069.15.036.034.037.134-.009-.02.013-.029.026-.053.006-.032-.036.083-.061Z",
    transform: "translate(-203.252 -70.939)",
    fill: "#004990"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_577",
    "data-name": "Grupo 577",
    transform: "translate(14.99 5.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_576",
    "data-name": "Grupo 576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1601",
    "data-name": "Trazado 1601",
    d: "M204.052,72.938l-.186-.079-.106.047-.091-.164-.209-.032.076-.109-.043-.07.006-.021-.158-.026.008-.051-.051-.027-.042-.15.12-.056.029-.071,0,0-.165-.029.1-.228-.105-.037.014-.165-.025-.032-.087-.2.108-.19.273-.08.065-.041.092-.107.2-.031h.172l.069-.065.2.039.073-.033.112-.088h.128l.113.146.048.017.225-.125.038-.061.272.057-.058.144.176-.089.38.033.248.065-.066.349-.033.022.314-.024-.379.267-.138.015-.079-.088-.088-.021-.362.168-.082.016-.018.024-.167.026-.079.067-.04.164-.341.223-.143-.106-.063.083-.011.057-.09.031.029.1-.112.3,0,.106Zm-.187-.3.058.024.1-.27-.064-.22.163-.057.007-.032.048-.028.089-.112.071-.049.208.035v.035l.008-.006.128-.075.035-.145.172-.147.142-.023.015-.021.139-.024.4-.188.143.034-.014-.044.106-.07.015-.079-.047-.013-.3-.024-.242.107h-.13l-.018.017-.237.056-.044-.094-.006,0-.211-.079-.051-.085-.052.04-.152.071-.162-.031-.052.049-.237,0-.11.018-.079.085-.1.061-.217.066-.024.042.1.141-.008.088.134.046-.025.139-.036.077.116.139-.089.217.007,0,.195.032-.04.153.038.05.049.008.049.089Z",
    transform: "translate(-203.136 -70.818)",
    fill: "#ba8618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_579",
    "data-name": "Grupo 579",
    transform: "translate(5.549 5.258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_578",
    "data-name": "Grupo 578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1602",
    "data-name": "Trazado 1602",
    d: "M199.913,86.4a7.743,7.743,0,0,1-3.362-.729,5.924,5.924,0,0,1-3.171-3.687h0c-1.13-3.86,1.451-8.54,5.751-10.433a8.489,8.489,0,0,1,6.72-.212,6.547,6.547,0,0,1,3.632,3.814c1.416,3.893-1.148,8.586-5.716,10.458A10.23,10.23,0,0,1,199.913,86.4Zm-6.338-4.473a5.648,5.648,0,0,0,3.064,3.56,8.754,8.754,0,0,0,7.049-.064c4.469-1.831,6.981-6.408,5.6-10.2a6.342,6.342,0,0,0-3.52-3.7,8.283,8.283,0,0,0-6.558.211c-4.21,1.854-6.739,6.425-5.638,10.19Z",
    transform: "translate(-193.114 -70.748)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_581",
    "data-name": "Grupo 581",
    transform: "translate(6.677 6.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_580",
    "data-name": "Grupo 580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1603",
    "data-name": "Trazado 1603",
    d: "M200.2,85.407a6.678,6.678,0,0,1-2.88-.62,5.15,5.15,0,0,1-2.771-3.192h0c-.989-3.336,1.24-7.384,4.967-9.024a7.334,7.334,0,0,1,5.826-.171,5.611,5.611,0,0,1,3.11,3.291c1.217,3.359-.992,7.409-4.925,9.028A8.779,8.779,0,0,1,200.2,85.407Zm-5.455-3.87A4.885,4.885,0,0,0,197.4,84.6a7.5,7.5,0,0,0,6.044-.071c3.833-1.578,5.991-5.513,4.811-8.771a5.415,5.415,0,0,0-3-3.174,7.145,7.145,0,0,0-5.664.17c-3.637,1.6-5.815,5.54-4.854,8.78Z",
    transform: "translate(-194.312 -71.877)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_583",
    "data-name": "Grupo 583",
    transform: "translate(7.831 7.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_582",
    "data-name": "Grupo 582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1604",
    "data-name": "Trazado 1604",
    d: "M200.5,84.384a5.59,5.59,0,0,1-2.406-.518,4.34,4.34,0,0,1-2.339-2.691h0c-.865-2.843.96-6.164,4.154-7.561a6.178,6.178,0,0,1,4.922-.133,4.655,4.655,0,0,1,2.571,2.757c1,2.814-.848,6.211-4.126,7.572A7.287,7.287,0,0,1,200.5,84.384Zm2.109-11.148a6.552,6.552,0,0,0-2.618.564c-3.049,1.334-4.863,4.615-4.041,7.316h0a4.141,4.141,0,0,0,2.231,2.566,6.226,6.226,0,0,0,5.017-.06c3.179-1.32,4.98-4.6,4.013-7.317a4.458,4.458,0,0,0-2.461-2.638A5.346,5.346,0,0,0,202.605,73.236Z",
    transform: "translate(-195.536 -73.032)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_585",
    "data-name": "Grupo 585",
    transform: "translate(11.302 10.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_584",
    "data-name": "Grupo 584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1605",
    "data-name": "Trazado 1605",
    d: "M201.346,81.336a2.376,2.376,0,0,1-.994-.208,1.907,1.907,0,0,1-1.042-1.156h0a2.8,2.8,0,0,1,1.748-3.19,2.656,2.656,0,0,1,2.111-.047,1.956,1.956,0,0,1,1.073,1.162,2.723,2.723,0,0,1-1.742,3.2A2.979,2.979,0,0,1,201.346,81.336ZM199.5,79.91a1.709,1.709,0,0,0,.933,1.033,2.484,2.484,0,0,0,1.985-.037,2.52,2.52,0,0,0,1.629-2.945,1.76,1.76,0,0,0-.964-1.042,2.465,2.465,0,0,0-1.948.048A2.6,2.6,0,0,0,199.5,79.91Z",
    transform: "translate(-199.221 -76.537)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_587",
    "data-name": "Grupo 587",
    transform: "translate(8.987 8.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_586",
    "data-name": "Grupo 586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1606",
    "data-name": "Trazado 1606",
    d: "M200.786,83.367a4.516,4.516,0,0,1-1.926-.411,3.55,3.55,0,0,1-1.92-2.184h0c-.707-2.3.764-4.985,3.348-6.109a5.029,5.029,0,0,1,4-.107,3.77,3.77,0,0,1,2.076,2.226c.806,2.312-.663,5-3.345,6.121A5.829,5.829,0,0,1,200.786,83.367Zm-3.651-2.655a3.356,3.356,0,0,0,1.812,2.06,4.973,4.973,0,0,0,3.993-.057c2.582-1.08,4-3.657,3.231-5.866a3.564,3.564,0,0,0-1.965-2.107,4.824,4.824,0,0,0-3.837.107c-2.448,1.065-3.9,3.7-3.235,5.862Z",
    transform: "translate(-196.763 -74.192)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_589",
    "data-name": "Grupo 589",
    transform: "translate(10.07 9.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_588",
    "data-name": "Grupo 588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1607",
    "data-name": "Trazado 1607",
    d: "M201.021,82.464a3.477,3.477,0,0,1-1.475-.314,2.759,2.759,0,0,1-1.493-1.692h0a4.078,4.078,0,0,1,2.578-4.7,3.871,3.871,0,0,1,3.074-.079,2.9,2.9,0,0,1,1.594,1.715,3.966,3.966,0,0,1-2.568,4.716A4.445,4.445,0,0,1,201.021,82.464ZM198.247,80.4a2.563,2.563,0,0,0,1.385,1.568,4.082,4.082,0,0,0,5.475-4.508,2.693,2.693,0,0,0-1.484-1.594,3.659,3.659,0,0,0-2.911.078,3.925,3.925,0,0,0-2.465,4.455Z",
    transform: "translate(-197.914 -75.397)",
    fill: "#161615"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_592",
    "data-name": "Grupo 592",
    transform: "translate(1.353 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_591",
    "data-name": "Grupo 591"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1608",
    "data-name": "Trazado 1608",
    d: "M37.617,143.558v-7.042h1.491c2.749,0,3.987.956,3.987,3.361,0,2.543-1.516,3.681-4.107,3.681Zm.914-6.278v5.512h.457c2.023,0,3.134-.826,3.134-2.915,0-1.936-1.066-2.6-3.014-2.6Z",
    transform: "translate(-37.617 -136.516)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_594",
    "data-name": "Grupo 594",
    transform: "translate(8.754 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_593",
    "data-name": "Grupo 593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1609",
    "data-name": "Trazado 1609",
    d: "M49.451,137.246H46.4v2.389h2.8v.732H46.4v2.456h3.332l-.06.735H45.474v-7.043H49.51Z",
    transform: "translate(-45.474 -136.515)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_596",
    "data-name": "Grupo 596",
    transform: "translate(14.708 67.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_595",
    "data-name": "Grupo 595"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1610",
    "data-name": "Trazado 1610",
    d: "M57.2,140.649c0,2.009-.906,3.036-2.728,3.036-1.785,0-2.676-.9-2.676-3.036v-4.132h.918v4.146c0,1.6.619,2.252,1.825,2.252s1.776-.616,1.776-2.252v-4.146H57.2Z",
    transform: "translate(-51.794 -136.517)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_598",
    "data-name": "Grupo 598",
    transform: "translate(21.584 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_597",
    "data-name": "Grupo 597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1611",
    "data-name": "Trazado 1611",
    d: "M64.519,137.246H62.265v6.312h-.92v-6.312H59.093v-.731h5.484Z",
    transform: "translate(-59.093 -136.515)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_600",
    "data-name": "Grupo 600",
    transform: "translate(28.096 67.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_599",
    "data-name": "Grupo 599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1612",
    "data-name": "Trazado 1612",
    d: "M69.679,137.67a2.17,2.17,0,0,0-1.352-.48c-.825,0-1.221.371-1.221.834,0,.558.243.87,1.121,1.391l.633.381a2.362,2.362,0,0,1,1.451,2.021c0,1.071-.865,1.861-2.354,1.861a2.918,2.918,0,0,1-1.951-.627l.328-.824a2.389,2.389,0,0,0,1.6.643c.978,0,1.431-.434,1.431-.929,0-.611-.322-.906-1.134-1.425l-.642-.4c-.973-.631-1.415-1.1-1.415-2.074,0-.9.815-1.657,2.117-1.657a2.631,2.631,0,0,1,1.718.522Z",
    transform: "translate(-66.006 -136.384)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_602",
    "data-name": "Grupo 602",
    transform: "translate(33.819 67.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_601",
    "data-name": "Grupo 601"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1613",
    "data-name": "Trazado 1613",
    d: "M75.5,136.385a2.7,2.7,0,0,1,1.851.61l-.34.7a2.232,2.232,0,0,0-1.511-.545c-1.3,0-2.447.765-2.447,2.817,0,2.114.878,2.941,2.335,2.941a2.413,2.413,0,0,0,1.623-.544l.268.653a2.923,2.923,0,0,1-2.03.661c-1.917,0-3.169-1.124-3.169-3.638a3.317,3.317,0,0,1,3.421-3.653",
    transform: "translate(-72.081 -136.385)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_604",
    "data-name": "Grupo 604",
    transform: "translate(40.765 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_603",
    "data-name": "Grupo 603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1614",
    "data-name": "Trazado 1614",
    d: "M84.913,143.558H84v-3.19h-3.62v3.19h-.924v-7.042h.924v3.119H84v-3.119h.914Z",
    transform: "translate(-79.454 -136.516)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_606",
    "data-name": "Grupo 606",
    transform: "translate(48.509 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_605",
    "data-name": "Grupo 605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1615",
    "data-name": "Trazado 1615",
    d: "M91.639,137.246H88.594v2.389h2.793v.732H88.594v2.456h3.332l-.068.735H87.675v-7.043h4.032Z",
    transform: "translate(-87.675 -136.515)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_608",
    "data-name": "Grupo 608",
    transform: "translate(56.726 67.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_607",
    "data-name": "Grupo 607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1616",
    "data-name": "Trazado 1616",
    d: "M101.152,137.066l-3.582,5.74v.019h3.9l-.059.733H96.4v-.547l3.642-5.741v-.024H96.582v-.73h4.57Z",
    transform: "translate(-96.397 -136.516)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_610",
    "data-name": "Grupo 610",
    transform: "translate(63.373 67.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_609",
    "data-name": "Grupo 609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1617",
    "data-name": "Trazado 1617",
    d: "M108.792,140.649c0,2.009-.9,3.036-2.7,3.036-1.764,0-2.642-.9-2.642-3.036v-4.132h.9v4.146c0,1.6.619,2.252,1.8,2.252s1.745-.616,1.745-2.252v-4.146h.886Z",
    transform: "translate(-103.453 -136.517)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_612",
    "data-name": "Grupo 612",
    transform: "translate(70.429 67.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_611",
    "data-name": "Grupo 611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1618",
    "data-name": "Trazado 1618",
    d: "M114.565,137.67a2.113,2.113,0,0,0-1.336-.48c-.8,0-1.206.371-1.206.834,0,.558.244.87,1.113,1.391l.626.381a2.37,2.37,0,0,1,1.43,2.021c0,1.071-.858,1.861-2.321,1.861a2.815,2.815,0,0,1-1.928-.627l.321-.824a2.356,2.356,0,0,0,1.568.643c.975,0,1.421-.434,1.421-.929,0-.611-.328-.906-1.117-1.425l-.628-.4c-.973-.631-1.415-1.1-1.415-2.074,0-.9.817-1.657,2.1-1.657a2.618,2.618,0,0,1,1.705.522Z",
    transform: "translate(-110.944 -136.384)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_614",
    "data-name": "Grupo 614",
    transform: "translate(75.599 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_613",
    "data-name": "Grupo 613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1619",
    "data-name": "Trazado 1619",
    d: "M121.522,143.558l-.8-2.255h-2.571l-.8,2.255h-.923l2.69-7.042h.715l2.693,7.042Zm-2.06-5.88h-.02l-1.051,2.945H120.5Z",
    transform: "translate(-116.432 -136.516)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_616",
    "data-name": "Grupo 616",
    transform: "translate(83.098 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_615",
    "data-name": "Grupo 615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1620",
    "data-name": "Trazado 1620",
    d: "M131.124,143.558h-.881v-5.027h-.02l-2.076,5.027h-.78l-2.068-5.027h-.021v5.027h-.886v-7.042h.995l2.4,5.784h.019l2.408-5.784h.907Z",
    transform: "translate(-124.392 -136.516)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_618",
    "data-name": "Grupo 618",
    transform: "translate(92.069 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_617",
    "data-name": "Grupo 617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1621",
    "data-name": "Trazado 1621",
    d: "M140.638,143.558h-.873v-5.027h-.014l-2.078,5.027h-.783l-2.074-5.027H134.8v5.027h-.883v-7.042h.993l2.409,5.784h.021l2.4-5.784h.9Z",
    transform: "translate(-133.915 -136.516)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_620",
    "data-name": "Grupo 620",
    transform: "translate(101.074 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_619",
    "data-name": "Grupo 619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1622",
    "data-name": "Trazado 1622",
    d: "M147.4,137.246h-3.01v2.389h2.762v.732h-2.762v2.456h3.282l-.053.735h-4.141v-7.043h3.975Z",
    transform: "translate(-143.475 -136.515)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_622",
    "data-name": "Grupo 622",
    transform: "translate(107.017 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_621",
    "data-name": "Grupo 621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1623",
    "data-name": "Trazado 1623",
    d: "M155.179,143.558h-.847l-3.623-5.445H150.7v5.445h-.914v-7.042h.847l3.609,5.415h.028v-5.415h.912Z",
    transform: "translate(-149.783 -136.516)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_624",
    "data-name": "Grupo 624",
    transform: "translate(113.822 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_623",
    "data-name": "Grupo 623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1624",
    "data-name": "Trazado 1624",
    d: "M162.1,143.558l-.806-2.255h-2.57l-.8,2.255h-.922l2.682-7.042h.729l2.689,7.042Zm-2.059-5.88h-.027l-1.054,2.945h2.108Z",
    transform: "translate(-157.006 -136.516)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_626",
    "data-name": "Grupo 626",
    transform: "translate(121.339 67.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_625",
    "data-name": "Grupo 625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1625",
    "data-name": "Trazado 1625",
    d: "M168.729,143.558l-1.71-2.869c-.183.011-.364.017-.56.017h-.573v2.852h-.9v-7.043h1.525c1.959,0,2.828.674,2.828,1.967a1.979,1.979,0,0,1-1.42,2.012l1.914,3.064Zm-2.218-6.312h-.625v2.728h.573c1.316,0,1.918-.5,1.918-1.443,0-.887-.589-1.285-1.866-1.285",
    transform: "translate(-164.986 -136.515)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_628",
    "data-name": "Grupo 628",
    transform: "translate(127.753 67.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_627",
    "data-name": "Grupo 627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1626",
    "data-name": "Trazado 1626",
    d: "M174.729,139.937v.026a1.668,1.668,0,0,1,1.509,1.687c0,1.1-.83,1.908-2.815,1.908h-1.628v-7.041h1.536c1.972,0,2.7.7,2.7,1.79a1.593,1.593,0,0,1-1.3,1.63m-1.4-2.69h-.626v2.388h.613c1.2,0,1.774-.469,1.774-1.3,0-.637-.511-1.093-1.761-1.093m.155,3.121h-.782v2.456h.718c1.332,0,1.853-.431,1.853-1.238,0-.775-.663-1.218-1.789-1.218",
    transform: "translate(-171.795 -136.517)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_630",
    "data-name": "Grupo 630",
    transform: "translate(134.087 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_629",
    "data-name": "Grupo 629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1627",
    "data-name": "Trazado 1627",
    d: "M182.431,137.246h-3.013v2.389h2.762v.732h-2.762v2.456h3.3l-.066.735h-4.132v-7.043H182.5Z",
    transform: "translate(-178.518 -136.515)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_632",
    "data-name": "Grupo 632",
    transform: "translate(139.521 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_631",
    "data-name": "Grupo 631"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1628",
    "data-name": "Trazado 1628",
    d: "M185.2,137.156h-.873v-.641h2.657v.641H186.1v5.758h.913v.643h-2.725v-.643h.914Z",
    transform: "translate(-184.287 -136.516)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_634",
    "data-name": "Grupo 634",
    transform: "translate(143.265 67.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_633",
    "data-name": "Grupo 633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1629",
    "data-name": "Trazado 1629",
    d: "M193.639,137.246H191.4v6.312h-.9v-6.312h-2.239v-.731h5.433Z",
    transform: "translate(-188.261 -136.515)",
    fill: "#ce0017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_636",
    "data-name": "Grupo 636",
    transform: "translate(0 41.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_635",
    "data-name": "Grupo 635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1630",
    "data-name": "Trazado 1630",
    d: "M128.29,122V125a3.7,3.7,0,0,1-2.675,1.341,1.767,1.767,0,0,1-1.931-1.911c0-1.484,1.445-2.195,3.887-2.368Zm2.184-2.729c0-2.858-1.312-4.385-4.133-4.385-2.2,0-4.478,1.245-4.478,2.825,0,.763.486,1.117,1.314,1.117.133,0,.566-.026.566-.026a9.287,9.287,0,0,1,.612-2.285,4.738,4.738,0,0,1,1.584-.262c1.74,0,2.351,1.09,2.351,3.329v1.247h-.72c-3.023,0-6.248,1.09-6.248,3.822a3.188,3.188,0,0,0,3.411,3.333,4.184,4.184,0,0,0,3.669-1.88h.059a1.821,1.821,0,0,0,2.064,1.8c1.468,0,2.086-.807,2.086-1.072a1.747,1.747,0,0,0-.238-.726,1.292,1.292,0,0,1-.956.347c-.524,0-.944-.347-.944-1.488Zm-12.663.261c0-2.933-1.525-4.646-4.153-4.646a5.854,5.854,0,0,0-4.431,1.888h-.087l.166-1.732-3.164.315c-.645.044-.985.356-.985.8a1.23,1.23,0,0,0,.02.2l1.958.256v9.7l-.992.324c-.507.154-.827.376-.827.844a1.126,1.126,0,0,0,.026.195h5.68a1.219,1.219,0,0,0,.273-.689c0-.2-.106-.269-.379-.333l-1.609-.342v-8.419a5.253,5.253,0,0,1,3.435-1.277,2.73,2.73,0,0,1,2.894,3.048v6.648l-.989.324c-.513.154-.828.376-.828.844a1.09,1.09,0,0,0,.027.195h5.679a1.274,1.274,0,0,0,.272-.689c0-.2-.106-.269-.377-.333l-1.607-.342ZM99.735,122V125a3.731,3.731,0,0,1-2.69,1.341,1.767,1.767,0,0,1-1.927-1.911c0-1.484,1.438-2.195,3.892-2.368Zm2.168-2.729c0-2.858-1.311-4.385-4.131-4.385-2.2,0-4.478,1.245-4.478,2.825,0,.763.484,1.117,1.311,1.117.139,0,.56-.026.56-.026a9.536,9.536,0,0,1,.626-2.285,4.689,4.689,0,0,1,1.58-.262c1.746,0,2.364,1.09,2.364,3.329v1.247H99.01c-3.033,0-6.257,1.09-6.257,3.822a3.189,3.189,0,0,0,3.416,3.333,4.214,4.214,0,0,0,3.674-1.88h.047a1.822,1.822,0,0,0,2.065,1.8c1.481,0,2.093-.807,2.093-1.072a1.811,1.811,0,0,0-.238-.726,1.313,1.313,0,0,1-.971.347c-.509,0-.936-.347-.936-1.488Zm-12.664.261c0-3.015-1.573-4.646-4.129-4.646a6.059,6.059,0,0,0-4.584,2.074,3.6,3.6,0,0,0-3.437-2.074,5.664,5.664,0,0,0-4.288,1.888h-.087l.166-1.732-3.167.315c-.639.044-.992.356-.992.8a.969.969,0,0,0,.025.2l1.96.256v9.7l-.994.324c-.512.154-.83.376-.83.844a1.126,1.126,0,0,0,.026.195H74.6a1.264,1.264,0,0,0,.266-.689c0-.2-.106-.269-.371-.333l-1.613-.342v-8.419a4.9,4.9,0,0,1,3.432-1.277c1.345,0,2.575.693,2.575,3.048v6.648l-.989.324c-.512.154-.834.376-.834.844a1.165,1.165,0,0,0,.025.195h5.684a1.3,1.3,0,0,0,.269-.689c0-.2-.1-.269-.375-.333l-1.61-.342v-6.778a8.758,8.758,0,0,0-.155-1.506,4.866,4.866,0,0,1,3.594-1.412c1.339,0,2.569.693,2.569,3.048v6.648l-.983.324c-.512.154-.835.376-.835.844a1.552,1.552,0,0,0,.019.195H90.96a1.264,1.264,0,0,0,.266-.689c0-.2-.106-.269-.37-.333l-1.617-.342Zm-30.388.574c.241-2.6,1.289-3.879,3.06-3.879s2.359,1.323,2.359,2.789a4.557,4.557,0,0,1-.138,1.09Zm7.406,1.239a9.962,9.962,0,0,0,.294-2.1,4.027,4.027,0,0,0-4.371-4.358c-2.872,0-5.662,2.267-5.662,6.772,0,4.532,2.553,6.328,5.552,6.328,2.844,0,4.561-1.386,4.561-2.04a1.2,1.2,0,0,0-.348-.744,4.84,4.84,0,0,1-3.307,1.22c-2.576,0-4.126-1.768-4.16-5.077ZM52.6,108.8l-3.166.31c-.644.052-.994.365-.994.8a1.222,1.222,0,0,0,.021.217l1.964.256v15.93l-.991.324c-.515.154-.829.376-.829.844a1.126,1.126,0,0,0,.026.195h5.681a1.285,1.285,0,0,0,.265-.689c0-.2-.106-.269-.368-.333l-1.609-.342ZM43.164,122V125a3.742,3.742,0,0,1-2.684,1.341,1.771,1.771,0,0,1-1.941-1.911c0-1.484,1.46-2.195,3.9-2.368Zm2.166-2.729c0-2.858-1.32-4.385-4.131-4.385-2.2,0-4.485,1.245-4.485,2.825,0,.763.491,1.117,1.32,1.117.131,0,.558-.026.558-.026a10.269,10.269,0,0,1,.621-2.285,4.8,4.8,0,0,1,1.586-.262c1.739,0,2.365,1.09,2.365,3.329v1.247h-.726c-3.041,0-6.257,1.09-6.257,3.822a3.187,3.187,0,0,0,3.408,3.333,4.2,4.2,0,0,0,3.68-1.88h.054a1.815,1.815,0,0,0,2.059,1.8c1.481,0,2.093-.807,2.093-1.072a1.848,1.848,0,0,0-.233-.726,1.327,1.327,0,0,1-.975.347c-.5,0-.937-.347-.937-1.488Z",
    transform: "translate(-36.181 -108.797)",
    fill: "#3e4243"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_638",
    "data-name": "Grupo 638",
    transform: "translate(0.091 21.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_637",
    "data-name": "Grupo 637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1631",
    "data-name": "Trazado 1631",
    d: "M139.275,101.633V95.839c0-2.279-1.092-3.577-3.109-3.577a3.274,3.274,0,0,0-2.721,1.239h-.052V92.489h-2.243v9.144h2.441v-6.7a2.52,2.52,0,0,1,1.73-.64c1.042,0,1.5.577,1.5,1.932v5.4ZM127.629,88.6h-2.8l-1.816,2.588h2.121l2.5-2.547Zm-1.575,8.448c0,2-.822,2.785-1.833,2.785s-1.832-.752-1.832-2.785c0-1.964.833-2.753,1.832-2.753s1.833.736,1.833,2.753m2.5,0c0-3.326-1.86-4.789-4.263-4.789-2.3,0-4.4,1.559-4.4,4.789,0,3.332,1.884,4.807,4.266,4.807,2.284,0,4.4-1.565,4.4-4.807M117.481,89.58a1.3,1.3,0,0,0-1.41-1.368,1.361,1.361,0,1,0,0,2.718,1.3,1.3,0,0,0,1.41-1.35m-.193,2.909h-2.441v9.144h2.441Zm-4.823.524a4.2,4.2,0,0,0-2.585-.751,4.543,4.543,0,0,0-4.84,4.719c0,3.588,1.82,4.878,4.416,4.878a4.018,4.018,0,0,0,3.028-.977l-.7-1.66a3.18,3.18,0,0,1-1.958.614c-1.322,0-2.288-.752-2.288-2.855a2.376,2.376,0,0,1,2.56-2.7,2.615,2.615,0,0,1,1.666.584Zm-13.708,7.011A1.049,1.049,0,0,1,97.731,98.9c0-.737.665-1.05,1.917-1.1l.487-.024v1.681a1.774,1.774,0,0,1-1.378.572m-3.329-.894a2.54,2.54,0,0,0,2.63,2.729,2.374,2.374,0,0,0,2.256-1.238h.033c0,.358.033.756.06,1.013h2.245a18.165,18.165,0,0,1-.152-2.459V96.1c0-2.639-1.239-3.841-3.446-3.841a4.805,4.805,0,0,0-3.5,1.347l.756,1.517a3.232,3.232,0,0,1,2.238-.886c1.06,0,1.586.6,1.586,1.792v.315h-.387c-2.424,0-4.32.852-4.32,2.784m-1.6-6.737a4.378,4.378,0,0,0-.775-.077,2.411,2.411,0,0,0-2.338,1.45h-.041V92.489H88.419v9.144h2.45V95.3a2.348,2.348,0,0,1,2.082-.947,1.811,1.811,0,0,1,.712.119ZM82.187,94.1c.854,0,1.326.622,1.326,1.6,0,.131,0,.258-.012.425H80.458c.059-1.354.757-2.028,1.73-2.028m3.507,1.824c0-2.408-1.24-3.666-3.278-3.666-2.34,0-4.3,1.485-4.3,4.738,0,3.472,1.825,4.859,4.38,4.859a4.426,4.426,0,0,0,3.359-1.073l-.565-1.634a3.837,3.837,0,0,1-2.246.723c-1.561,0-2.426-.614-2.565-2.153h5.064a9.267,9.267,0,0,0,.154-1.792M71.525,94.3c1.161,0,1.914.736,1.914,2.662,0,2.123-.831,2.983-2.3,2.983a2.339,2.339,0,0,1-1.185-.294V94.818a2.5,2.5,0,0,1,1.574-.519m4.411,2.553c0-3.13-1.424-4.59-3.5-4.59A3.158,3.158,0,0,0,69.8,93.5H69.76V92.489H67.513v12.9h2.438v-3.9a3.653,3.653,0,0,0,1.626.341c2.612,0,4.359-1.683,4.359-4.988m-13.52.2c0,2-.819,2.785-1.831,2.785s-1.836-.752-1.836-2.785c0-1.964.835-2.753,1.836-2.753s1.831.736,1.831,2.753m2.5,0c0-3.33-1.859-4.789-4.264-4.789-2.3,0-4.4,1.559-4.4,4.789,0,3.332,1.885,4.807,4.266,4.807,2.284,0,4.4-1.565,4.4-4.807m-13.3,0c0,2-.811,2.785-1.818,2.785s-1.84-.752-1.84-2.785c0-1.964.834-2.753,1.84-2.753.986,0,1.818.736,1.818,2.753m2.5,0c0-3.33-1.861-4.789-4.257-4.789-2.286,0-4.408,1.559-4.408,4.789,0,3.332,1.889,4.807,4.268,4.807,2.284,0,4.4-1.565,4.4-4.807m-10.4-4.039a4.206,4.206,0,0,0-2.584-.751,4.549,4.549,0,0,0-4.847,4.719c0,3.588,1.819,4.878,4.418,4.878a4.026,4.026,0,0,0,3.031-.977l-.7-1.66a3.17,3.17,0,0,1-1.958.614c-1.315,0-2.288-.752-2.288-2.855a2.378,2.378,0,0,1,2.567-2.7A2.591,2.591,0,0,1,43,94.863Z",
    transform: "translate(-36.278 -88.212)",
    fill: "#3e4243"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_672",
    "data-name": "Grupo 672",
    transform: "translate(15 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_656",
    "data-name": "Grupo 656",
    transform: "translate(271.236 60.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_641",
    "data-name": "Grupo 641",
    transform: "translate(0 0.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1632",
    "data-name": "Trazado 1632",
    d: "M271.236,60.257h1.007V70.335h-1.007Z",
    transform: "translate(-271.236 -60.257)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_642",
    "data-name": "Grupo 642",
    transform: "translate(3.152 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1633",
    "data-name": "Trazado 1633",
    d: "M273.526,62.217h.959V63.5a3.681,3.681,0,0,1,1.028-1.042,2.927,2.927,0,0,1,1.53-.439,2.543,2.543,0,0,1,1.028.213,2.2,2.2,0,0,1,.8.564,3.005,3.005,0,0,1,.535,1.012,3.543,3.543,0,0,1,1.2-1.334,2.84,2.84,0,0,1,1.546-.456,2.415,2.415,0,0,1,1.362.391,2.328,2.328,0,0,1,.878,1.09,5.807,5.807,0,0,1,.288,2.1V69.67h-.98V65.6a5.3,5.3,0,0,0-.171-1.647,1.493,1.493,0,0,0-.584-.724,1.751,1.751,0,0,0-.987-.274,2.146,2.146,0,0,0-1.273.411,2.365,2.365,0,0,0-.844,1.1,6.958,6.958,0,0,0-.266,2.289V69.67h-.961V65.854a6.563,6.563,0,0,0-.167-1.832,1.532,1.532,0,0,0-.586-.775,1.7,1.7,0,0,0-.994-.292,2.133,2.133,0,0,0-1.243.4,2.374,2.374,0,0,0-.857,1.078,5.841,5.841,0,0,0-.277,2.077V69.67h-.959Z",
    transform: "translate(-273.526 -62.024)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_643",
    "data-name": "Grupo 643",
    transform: "translate(16.206 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1634",
    "data-name": "Trazado 1634",
    d: "M283.012,62.217h.958v1.369a3.862,3.862,0,0,1,1.307-1.171,3.481,3.481,0,0,1,1.65-.391,3.68,3.68,0,0,1,2.717,1.144,3.783,3.783,0,0,1,1.128,2.755,3.847,3.847,0,0,1-1.119,2.791,3.766,3.766,0,0,1-4.335.778,4.126,4.126,0,0,1-1.349-1.1V72.4h-.958Zm3.836.732a2.815,2.815,0,0,0-2.095.87,2.967,2.967,0,0,0-.851,2.162,3.052,3.052,0,0,0,.38,1.526,2.765,2.765,0,0,0,1.086,1.075,3.021,3.021,0,0,0,1.493.4,2.813,2.813,0,0,0,1.452-.4,2.93,2.93,0,0,0,1.083-1.119,3.026,3.026,0,0,0,0-3.011,2.888,2.888,0,0,0-2.553-1.5Z",
    transform: "translate(-283.012 -62.024)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_644",
    "data-name": "Grupo 644",
    transform: "translate(25.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1635",
    "data-name": "Trazado 1635",
    d: "M289.851,60.073h.958V70.4h-.958Z",
    transform: "translate(-289.851 -60.073)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_645",
    "data-name": "Grupo 645",
    transform: "translate(28.207 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1636",
    "data-name": "Trazado 1636",
    d: "M298.371,67.2l.808.424a4.383,4.383,0,0,1-.918,1.261,3.669,3.669,0,0,1-1.173.729,4.1,4.1,0,0,1-1.475.25,3.561,3.561,0,0,1-2.852-1.195,4.032,4.032,0,0,1-1.029-2.7,3.982,3.982,0,0,1,.871-2.528,3.561,3.561,0,0,1,2.956-1.412A3.68,3.68,0,0,1,298.6,63.47a4.028,4.028,0,0,1,.822,2.547h-6.706a3.04,3.04,0,0,0,.83,2.13,2.649,2.649,0,0,0,1.983.83,3.17,3.17,0,0,0,1.107-.2,2.913,2.913,0,0,0,.917-.526A4.471,4.471,0,0,0,298.371,67.2Zm0-2.008a3.179,3.179,0,0,0-.559-1.226,2.647,2.647,0,0,0-.972-.739,2.95,2.95,0,0,0-1.269-.282,2.731,2.731,0,0,0-1.885.706,3.19,3.19,0,0,0-.871,1.541Z",
    transform: "translate(-291.732 -62.024)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_646",
    "data-name": "Grupo 646",
    transform: "translate(37.542 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1637",
    "data-name": "Trazado 1637",
    d: "M298.515,62.217h.958V63.5a3.7,3.7,0,0,1,1.029-1.042,2.926,2.926,0,0,1,1.529-.439,2.545,2.545,0,0,1,1.029.213,2.2,2.2,0,0,1,.8.564,3.055,3.055,0,0,1,.535,1.012,3.543,3.543,0,0,1,1.2-1.334,2.833,2.833,0,0,1,1.544-.456,2.422,2.422,0,0,1,1.364.391,2.328,2.328,0,0,1,.878,1.09,5.807,5.807,0,0,1,.288,2.1V69.67h-.98V65.6a5.344,5.344,0,0,0-.171-1.647,1.493,1.493,0,0,0-.584-.724,1.754,1.754,0,0,0-.987-.274,2.15,2.15,0,0,0-1.274.411,2.371,2.371,0,0,0-.842,1.1,6.95,6.95,0,0,0-.267,2.289V69.67H303.6V65.854a6.549,6.549,0,0,0-.168-1.832,1.529,1.529,0,0,0-.585-.775,1.7,1.7,0,0,0-.994-.292,2.132,2.132,0,0,0-1.243.4,2.374,2.374,0,0,0-.857,1.078,5.834,5.834,0,0,0-.278,2.077V69.67h-.958Z",
    transform: "translate(-298.515 -62.024)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_647",
    "data-name": "Grupo 647",
    transform: "translate(50.345 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1638",
    "data-name": "Trazado 1638",
    d: "M314.457,67.2l.808.424a4.384,4.384,0,0,1-.918,1.261,3.661,3.661,0,0,1-1.174.729,4.087,4.087,0,0,1-1.474.25,3.561,3.561,0,0,1-2.851-1.195,4.032,4.032,0,0,1-1.029-2.7,3.983,3.983,0,0,1,.871-2.528,3.561,3.561,0,0,1,2.956-1.412,3.68,3.68,0,0,1,3.044,1.446,4.028,4.028,0,0,1,.822,2.547H308.8a3.04,3.04,0,0,0,.83,2.13,2.649,2.649,0,0,0,1.983.83,3.176,3.176,0,0,0,1.107-.2,2.915,2.915,0,0,0,.917-.526A4.509,4.509,0,0,0,314.457,67.2Zm0-2.008a3.178,3.178,0,0,0-.559-1.226,2.647,2.647,0,0,0-.972-.739,2.95,2.95,0,0,0-1.269-.282,2.731,2.731,0,0,0-1.885.706,3.179,3.179,0,0,0-.871,1.541Z",
    transform: "translate(-307.818 -62.024)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_648",
    "data-name": "Grupo 648",
    transform: "translate(59.827 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1639",
    "data-name": "Trazado 1639",
    d: "M314.708,62.217h.959v1.335a4,4,0,0,1,1.274-1.146,3.129,3.129,0,0,1,1.521-.381,2.638,2.638,0,0,1,1.482.425,2.538,2.538,0,0,1,.957,1.144,6.063,6.063,0,0,1,.308,2.24V69.67h-.959V66.114a8.7,8.7,0,0,0-.107-1.719,1.882,1.882,0,0,0-.64-1.113,1.928,1.928,0,0,0-1.233-.373,2.367,2.367,0,0,0-1.558.574,2.7,2.7,0,0,0-.908,1.426,9.86,9.86,0,0,0-.136,2.027V69.67h-.959Z",
    transform: "translate(-314.708 -62.024)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_649",
    "data-name": "Grupo 649",
    transform: "translate(67.629 0.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1640",
    "data-name": "Trazado 1640",
    d: "M321.686,60.153h.959v2.768h1.521v.828h-1.521v6.625h-.959V63.749h-1.309v-.828h1.309Z",
    transform: "translate(-320.377 -60.153)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_650",
    "data-name": "Grupo 650",
    transform: "translate(72.522 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1641",
    "data-name": "Trazado 1641",
    d: "M331.693,62.217V69.67h-.945V68.389a4.1,4.1,0,0,1-1.353,1.1,3.776,3.776,0,0,1-4.342-.778,3.843,3.843,0,0,1-1.12-2.791,3.784,3.784,0,0,1,1.13-2.755,3.684,3.684,0,0,1,2.719-1.144,3.517,3.517,0,0,1,1.661.391,3.78,3.78,0,0,1,1.3,1.171V62.217Zm-3.833.732a2.892,2.892,0,0,0-2.556,1.5,3.017,3.017,0,0,0,0,3.011,2.933,2.933,0,0,0,1.084,1.119,2.827,2.827,0,0,0,1.46.4,3.008,3.008,0,0,0,1.492-.4,2.78,2.78,0,0,0,1.085-1.075,3.067,3.067,0,0,0,.38-1.526,2.963,2.963,0,0,0-.852-2.162A2.822,2.822,0,0,0,327.86,62.949Z",
    transform: "translate(-323.932 -62.024)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_651",
    "data-name": "Grupo 651",
    transform: "translate(82.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1642",
    "data-name": "Trazado 1642",
    d: "M338.667,60.073V70.4h-.945V69.123a4.1,4.1,0,0,1-1.353,1.1,3.778,3.778,0,0,1-4.343-.778,3.848,3.848,0,0,1-1.12-2.791,3.78,3.78,0,0,1,1.131-2.755,3.684,3.684,0,0,1,2.719-1.144,3.522,3.522,0,0,1,1.661.391,3.78,3.78,0,0,1,1.3,1.171V60.073Zm-3.833,3.61a2.892,2.892,0,0,0-2.556,1.5,3.021,3.021,0,0,0,0,3.011,2.953,2.953,0,0,0,1.084,1.119,2.836,2.836,0,0,0,1.462.4,3.012,3.012,0,0,0,1.492-.4,2.78,2.78,0,0,0,1.085-1.075,3.067,3.067,0,0,0,.38-1.526,2.963,2.963,0,0,0-.852-2.162A2.821,2.821,0,0,0,334.834,63.683Z",
    transform: "translate(-330.905 -60.073)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_652",
    "data-name": "Grupo 652",
    transform: "translate(91.688 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1643",
    "data-name": "Trazado 1643",
    d: "M341.751,62.024a3.692,3.692,0,0,1,2.854,1.247,4,4,0,0,1-.058,5.422,3.939,3.939,0,0,1-5.6,0,3.99,3.99,0,0,1-.059-5.414A3.69,3.69,0,0,1,341.751,62.024Zm0,.94a2.766,2.766,0,0,0-2.056.884,2.95,2.95,0,0,0-.859,2.136,3.034,3.034,0,0,0,.392,1.508,2.78,2.78,0,0,0,1.058,1.079,3.012,3.012,0,0,0,2.929,0,2.783,2.783,0,0,0,1.06-1.079,3.032,3.032,0,0,0,.391-1.508,2.942,2.942,0,0,0-.863-2.136A2.765,2.765,0,0,0,341.747,62.964Z",
    transform: "translate(-337.859 -62.024)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_653",
    "data-name": "Grupo 653",
    transform: "translate(105.137 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1644",
    "data-name": "Trazado 1644",
    d: "M347.631,62.217h.959v1.369a3.846,3.846,0,0,1,1.306-1.171,3.481,3.481,0,0,1,1.65-.391,3.68,3.68,0,0,1,2.717,1.144,3.784,3.784,0,0,1,1.13,2.755,3.847,3.847,0,0,1-1.119,2.791,3.768,3.768,0,0,1-4.336.778,4.108,4.108,0,0,1-1.347-1.1V72.4h-.959Zm3.836.732a2.816,2.816,0,0,0-2.095.87,2.967,2.967,0,0,0-.85,2.162,3.066,3.066,0,0,0,.38,1.526,2.765,2.765,0,0,0,1.086,1.075,3.024,3.024,0,0,0,1.493.4,2.812,2.812,0,0,0,1.452-.4,2.943,2.943,0,0,0,1.084-1.119,3.03,3.03,0,0,0,0-3.011,2.888,2.888,0,0,0-2.553-1.5Z",
    transform: "translate(-347.631 -62.024)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_654",
    "data-name": "Grupo 654",
    transform: "translate(114.33 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1645",
    "data-name": "Trazado 1645",
    d: "M358.2,62.024a3.692,3.692,0,0,1,2.854,1.247A4,4,0,0,1,361,68.693a3.937,3.937,0,0,1-5.6,0,3.99,3.99,0,0,1-.059-5.414A3.688,3.688,0,0,1,358.2,62.024Zm0,.94a2.766,2.766,0,0,0-2.056.884,2.95,2.95,0,0,0-.859,2.136,3.034,3.034,0,0,0,.392,1.508,2.771,2.771,0,0,0,1.058,1.079,3.012,3.012,0,0,0,2.929,0,2.78,2.78,0,0,0,1.058-1.079,3.034,3.034,0,0,0,.392-1.508,2.942,2.942,0,0,0-.863-2.136A2.766,2.766,0,0,0,358.2,62.964Z",
    transform: "translate(-354.311 -62.024)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_655",
    "data-name": "Grupo 655",
    transform: "translate(123.516 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1646",
    "data-name": "Trazado 1646",
    d: "M360.986,62.217h.98v1.089a3.453,3.453,0,0,1,.925-.962,1.829,1.829,0,0,1,1.014-.319,1.749,1.749,0,0,1,.849.255l-.5.808a1.339,1.339,0,0,0-.508-.131,1.388,1.388,0,0,0-.925.395,2.474,2.474,0,0,0-.677,1.222,11.654,11.654,0,0,0-.179,2.576V69.67h-.98Z",
    transform: "translate(-360.986 -62.024)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_671",
    "data-name": "Grupo 671",
    transform: "translate(271.802 99.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_658",
    "data-name": "Grupo 658",
    transform: "translate(0 8.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_657",
    "data-name": "Grupo 657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1647",
    "data-name": "Trazado 1647",
    d: "M287.14,114.992V104.407a3.757,3.757,0,0,0-1.5-3.07,4.7,4.7,0,0,0-3.22-1.206h-.526a4.559,4.559,0,0,0-3.295,1.419,4.241,4.241,0,0,0-1.484,3.2v9.788a4.243,4.243,0,0,0,1.484,3.2,4.537,4.537,0,0,0,3.295,1.419h.526a4.766,4.766,0,0,0,3.22-1.21,3.638,3.638,0,0,0,1.5-2.953m-.61,7.7a4.453,4.453,0,0,0-.509.4l-.047.036-.1.084-.109.078-.114.078-.118.08-.117.076-.129.072-.128.069-.132.067-.133.066-.138.062-.143.059-.142.054-.138.048-.139.048-.138.041-.138.034-.135.03-.132.032-.135.025a10.159,10.159,0,0,1-1.66.143h-.421a9.951,9.951,0,0,1-6.913-2.77,9.277,9.277,0,0,1-2.872-6.69V104.372a9.27,9.27,0,0,1,2.872-6.69,9.926,9.926,0,0,1,6.913-2.77h.546a12.526,12.526,0,0,1,1.46.106l.132.025.138.026.138.028.142.034.142.039.138.041.146.047.142.048.142.056.142.058.132.062.133.061.129.066.124.073.118.067.037.022.054.03.051.037.051.034.05.034.051.034.047.034.051.037.044.034.044.036.047.036.044.039.044.039.04.034.041.034.04.034.037.041.04.037.081.062.068.041.1.032.1.006.1-.006.1-.032.088-.05.074-.065.06-.074.05-.091.028-.1.01-.1c0-.347-.007-.822.378-.939a2.63,2.63,0,0,1,.735-.034h3.5c.354,0,.893-.088,1.042.358a5.822,5.822,0,0,1,.034,1.369v22.482a53.983,53.983,0,0,1-.146,6.007c-.614,5.541-3.335,10.257-9.094,11.286a11.867,11.867,0,0,1-9.651-2.9c-.33-.275-1.012-.742-.984-1.215a.768.768,0,0,1,.2-.447s2.232-2.4,2.395-2.616c.158-.176.38-.434.628-.434.352,0,.717.337,1.354.718a9.89,9.89,0,0,0,3.494,1.431,5.214,5.214,0,0,0,2.388-.237c2.92-.962,3.73-4.718,3.9-7.66v-.1l-.011-.048-.011-.051-.015-.045-.021-.045-.028-.044-.03-.039-.03-.037-.037-.03-.037-.032-.044-.028-.043-.021-.048-.017-.047-.014-.051-.007h-.1l-.052.007-.047.014-.044.017Z",
    transform: "translate(-271.647 -94.912)",
    fill: "#c7000e",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_660",
    "data-name": "Grupo 660",
    transform: "translate(39.727 9.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_659",
    "data-name": "Grupo 659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1648",
    "data-name": "Trazado 1648",
    d: "M321.409,123.617v-3.874a.625.625,0,0,0-.176-.487.644.644,0,0,0-.458-.154H310.307a.828.828,0,0,1-.538-.138.468.468,0,0,1-.166-.363.92.92,0,0,1,.136-.468l11.468-22.042.088-.228.04-.226c-.014-.329-.246-.5-.7-.515H301.848a.554.554,0,0,0-.634.65v3.866c-.011.443.2.656.634.645h9.815a.861.861,0,0,1,.52.135.45.45,0,0,1,.175.384l-.04.226-.085.224-11.589,22.042-.088.227-.041.227c.011.333.244.5.7.515h19.562a.633.633,0,0,0,.483-.154.668.668,0,0,0,.151-.491",
    transform: "translate(-300.514 -95.122)",
    fill: "#c7000e",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_662",
    "data-name": "Grupo 662",
    transform: "translate(28.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_661",
    "data-name": "Grupo 661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1649",
    "data-name": "Trazado 1649",
    d: "M292.085,93.873a.754.754,0,0,0,.186.487.817.817,0,0,0,.575.2H296.8a.819.819,0,0,0,.575-.2.678.678,0,0,0,.186-.48V89.286a.87.87,0,0,0-.193-.595.793.793,0,0,0-.575-.2l-.314,0a.83.83,0,0,0-.677.3l-3.319,3.774-.162.19a.9.9,0,0,0-.245.615v.4Z",
    transform: "translate(-292.078 -88.485)",
    fill: "#c7000e",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_664",
    "data-name": "Grupo 664",
    transform: "translate(28.089 9.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_663",
    "data-name": "Grupo 663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1650",
    "data-name": "Trazado 1650",
    d: "M297.544,95.795a.768.768,0,0,0-.158-.519.694.694,0,0,0-.523-.172h-4.116a.656.656,0,0,0-.523.2.733.733,0,0,0-.162.491l0,.113v15.755l.007,11.913a.72.72,0,0,0,.16.519.684.684,0,0,0,.519.175h4.12a.659.659,0,0,0,.523-.2.742.742,0,0,0,.155-.491Z",
    transform: "translate(-292.057 -95.104)",
    fill: "#c7000e",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_666",
    "data-name": "Grupo 666",
    transform: "translate(71.209 30.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_665",
    "data-name": "Grupo 665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1651",
    "data-name": "Trazado 1651",
    d: "M327.147,117.738a.344.344,0,0,0-.288-.121h-2.538l2.858-5.57.072-.264a.454.454,0,0,0-.464-.453h-2.879a.337.337,0,0,0-.29.124l-.092.267.092.266a.348.348,0,0,0,.29.124h2.385l-2.847,5.545-.058.248a.524.524,0,0,0,.116.339.387.387,0,0,0,.328.149h3.028a.352.352,0,0,0,.288-.121l.095-.267Zm4.932-3.946a.35.35,0,0,0-.121-.289l-.26-.095-.264.095a.344.344,0,0,0-.118.289V116.8a.874.874,0,0,1-.867.868h-.089a.869.869,0,0,1-.857-.868v-3.008a.351.351,0,0,0-.118-.289l-.263-.095-.261.095a.351.351,0,0,0-.122.289v3.015a1.889,1.889,0,0,0,.132.738,1.394,1.394,0,0,0,.352.5,1.428,1.428,0,0,0,.517.3,1.964,1.964,0,0,0,.621.1h.089a1.517,1.517,0,0,0,.494-.076.937.937,0,0,0,.373-.223.335.335,0,0,0,.139.227l.244.072.26-.1a.336.336,0,0,0,.121-.281Zm5.158,3.179a1.384,1.384,0,0,0-.2-.782,1.405,1.405,0,0,0-.484-.44,2.4,2.4,0,0,0-.629-.237c-.227-.051-.436-.1-.63-.154a1.7,1.7,0,0,1-.483-.2.444.444,0,0,1-.2-.392v-.034a.511.511,0,0,1,.234-.385,1.069,1.069,0,0,1,.643-.164h.04a1.187,1.187,0,0,1,.535.1c.125.065.244.124.352.175l.219.066a.337.337,0,0,0,.264-.113l.1-.259a.366.366,0,0,0-.142-.3l-.172-.131a1.644,1.644,0,0,0-.284-.143,2.506,2.506,0,0,0-.384-.117,2.038,2.038,0,0,0-.476-.051h-.04a2.482,2.482,0,0,0-.528.061,1.9,1.9,0,0,0-.534.22,1.363,1.363,0,0,0-.417.406,1.06,1.06,0,0,0-.172.614,1.19,1.19,0,0,0,.2.739,1.372,1.372,0,0,0,.483.4,2.523,2.523,0,0,0,.629.209,5.188,5.188,0,0,1,.629.157,1.543,1.543,0,0,1,.484.248.593.593,0,0,1,.193.486l0,.03a.663.663,0,0,1-.259.471,1.064,1.064,0,0,1-.709.216h-.051a1.075,1.075,0,0,1-.575-.2,1.984,1.984,0,0,1-.48-.45l-.162-.138-.179-.037a.408.408,0,0,0-.275.1.337.337,0,0,0-.118.278.839.839,0,0,0,.048.191,1.689,1.689,0,0,0,.314.427,1.948,1.948,0,0,0,.424.319,2.08,2.08,0,0,0,.487.2,1.821,1.821,0,0,0,.5.072h.061a2.019,2.019,0,0,0,.623-.092,1.764,1.764,0,0,0,.564-.268,1.348,1.348,0,0,0,.4-.443,1.243,1.243,0,0,0,.153-.625Zm5.311.853a.373.373,0,0,0-.246-.139.3.3,0,0,1-.261-.34V114.98a1.548,1.548,0,0,0-.121-.615,1.673,1.673,0,0,0-.332-.5,1.434,1.434,0,0,0-.5-.336,1.6,1.6,0,0,0-.626-.12h-.07a1.913,1.913,0,0,0-.414.044,1.482,1.482,0,0,0-.411.154,1.458,1.458,0,0,0-.378.289,1.547,1.547,0,0,0-.295.46l-.041.186a.316.316,0,0,0,.122.26l.257.1.2-.048.149-.158a1.165,1.165,0,0,1,.322-.38.832.832,0,0,1,.494-.131h.07a.922.922,0,0,1,.575.184.766.766,0,0,1,.241.643l-.007.094-.023.083a.474.474,0,0,1-.278.125c-.142.036-.312.067-.5.1s-.385.08-.595.135a2.076,2.076,0,0,0-.572.241,1.335,1.335,0,0,0-.432.418,1.172,1.172,0,0,0-.172.659v.124a1.37,1.37,0,0,0,.142.634,1.454,1.454,0,0,0,.365.457,1.5,1.5,0,0,0,.522.275,1.815,1.815,0,0,0,.592.092h.091a1.585,1.585,0,0,0,1.09-.4.88.88,0,0,0,.26.248,1.139,1.139,0,0,0,.42.139l.076.011a.33.33,0,0,0,.272-.116.416.416,0,0,0,.095-.272Zm-1.272-1.028a.874.874,0,0,1-.867.873h-.091a.969.969,0,0,1-.619-.2.641.641,0,0,1-.237-.522v-.08a.5.5,0,0,1,.179-.413,1.248,1.248,0,0,1,.447-.222,3.96,3.96,0,0,1,.589-.132,4.908,4.908,0,0,0,.6-.116Zm8.827-1.757a1.842,1.842,0,0,0-.132-.728,1.38,1.38,0,0,0-.355-.512,1.525,1.525,0,0,0-.517-.3,1.959,1.959,0,0,0-.617-.095h-.091a1.584,1.584,0,0,0-.7.154,1.829,1.829,0,0,0-.548.425,1.782,1.782,0,0,0-.548-.425,1.581,1.581,0,0,0-.7-.154H345.8a1.434,1.434,0,0,0-.49.078.915.915,0,0,0-.372.226.362.362,0,0,0-.143-.233l-.234-.072a.41.41,0,0,0-.27.1.358.358,0,0,0-.121.286v4.272a.327.327,0,0,0,.121.285l.26.092.264-.092a.327.327,0,0,0,.122-.285v-3.1a.7.7,0,0,1,.26-.57.927.927,0,0,1,.6-.216h.091a.851.851,0,0,1,.867.879v2.984a.361.361,0,0,0,.122.3l.26.1.263-.1a.367.367,0,0,0,.12-.3V115.06a.856.856,0,0,1,.866-.879h.091a.9.9,0,0,1,.621.216.84.84,0,0,1,.237.643v3.025a.335.335,0,0,0,.117.285l.264.092.261-.092a.327.327,0,0,0,.121-.285Zm7.707,0a1.845,1.845,0,0,0-.128-.728,1.358,1.358,0,0,0-.359-.512,1.513,1.513,0,0,0-.518-.3,1.933,1.933,0,0,0-.612-.095H356.1a1.58,1.58,0,0,0-.7.154,1.749,1.749,0,0,0-.548.425,1.818,1.818,0,0,0-.549-.425,1.578,1.578,0,0,0-.7-.154h-.092a1.464,1.464,0,0,0-.494.078.974.974,0,0,0-.372.226.369.369,0,0,0-.139-.233l-.234-.072a.4.4,0,0,0-.27.1.358.358,0,0,0-.121.286v4.272a.327.327,0,0,0,.121.285l.26.092.26-.092a.324.324,0,0,0,.122-.285v-3.1a.708.708,0,0,1,.26-.57.938.938,0,0,1,.606-.216h.092a.851.851,0,0,1,.863.879v2.984a.372.372,0,0,0,.121.3l.264.1.26-.1a.361.361,0,0,0,.122-.3V115.06a.856.856,0,0,1,.866-.879h.091a.9.9,0,0,1,.621.216.839.839,0,0,1,.233.643v3.025a.327.327,0,0,0,.121.285l.264.092.262-.092a.328.328,0,0,0,.117-.285Zm5.029.021a1.7,1.7,0,0,0-.125-.659,1.685,1.685,0,0,0-.345-.526,1.533,1.533,0,0,0-.52-.347,1.617,1.617,0,0,0-.628-.12h-.1a1.534,1.534,0,0,0-.629.127,1.6,1.6,0,0,0-.87.875,1.7,1.7,0,0,0-.125.639v1.759a1.689,1.689,0,0,0,.125.645,1.612,1.612,0,0,0,.348.515,1.678,1.678,0,0,0,.522.347,1.556,1.556,0,0,0,.629.127h.1a1.566,1.566,0,0,0,.9-.267,1.614,1.614,0,0,0,.568-.7l.04-.176a.365.365,0,0,0-.121-.285.385.385,0,0,0-.274-.113l-.19.059-.142.184a1,1,0,0,1-.294.367.757.757,0,0,1-.489.158h-.1a.877.877,0,0,1-.86-.866v-.515h2.2a.371.371,0,0,0,.274-.117.394.394,0,0,0,.109-.274Zm-.765.512h-1.814v-.516a.881.881,0,0,1,.87-.875h.1a.805.805,0,0,1,.589.255.838.838,0,0,1,.257.632Zm5.769-.523a1.925,1.925,0,0,0-.131-.728,1.522,1.522,0,0,0-.352-.517,1.489,1.489,0,0,0-.515-.3,1.947,1.947,0,0,0-.617-.095h-.091a1.475,1.475,0,0,0-.494.078.975.975,0,0,0-.372.226.352.352,0,0,0-.139-.233l-.245-.072a.413.413,0,0,0-.27.1.358.358,0,0,0-.121.286v4.272a.327.327,0,0,0,.121.285l.261.092.263-.092a.325.325,0,0,0,.118-.285l0-3.015a.86.86,0,0,1,.859-.868h.091a.867.867,0,0,1,.86.868v3.015a.33.33,0,0,0,.121.285l.264.092a.378.378,0,0,0,.26-.092.323.323,0,0,0,.12-.285Zm5.421,2.776a.376.376,0,0,0-.248-.139.3.3,0,0,1-.26-.34V114.98a1.549,1.549,0,0,0-.122-.615,1.594,1.594,0,0,0-.33-.5,1.489,1.489,0,0,0-.505-.336,1.571,1.571,0,0,0-.622-.12h-.072a1.857,1.857,0,0,0-.413.044,1.56,1.56,0,0,0-.791.443,1.473,1.473,0,0,0-.3.46l-.037.186a.315.315,0,0,0,.117.26l.261.1.193-.048.153-.158a1.131,1.131,0,0,1,.321-.38.835.835,0,0,1,.494-.131h.072a.9.9,0,0,1,.571.184.758.758,0,0,1,.241.643l0,.094-.023.083a.488.488,0,0,1-.278.125c-.146.036-.31.067-.5.1s-.391.08-.6.135a2.13,2.13,0,0,0-.575.241,1.354,1.354,0,0,0-.429.418,1.171,1.171,0,0,0-.172.659v.124a1.371,1.371,0,0,0,.142.634,1.4,1.4,0,0,0,.366.457,1.488,1.488,0,0,0,.517.275,1.839,1.839,0,0,0,.6.092h.091a1.573,1.573,0,0,0,1.086-.4.913.913,0,0,0,.264.248,1.119,1.119,0,0,0,.422.139l.067.011a.338.338,0,0,0,.278-.116.424.424,0,0,0,.095-.272Zm-1.276-1.028a.831.831,0,0,1-.255.618.843.843,0,0,1-.611.255h-.088a.965.965,0,0,1-.621-.2.645.645,0,0,1-.237-.522v-.08a.5.5,0,0,1,.177-.413,1.268,1.268,0,0,1,.449-.222,4.041,4.041,0,0,1,.589-.132,4.715,4.715,0,0,0,.6-.116Zm5.369-2.891a1.044,1.044,0,0,0-.469-.384,1.545,1.545,0,0,0-.575-.113,1.854,1.854,0,0,0-.336.026l-.219.072-.173.1-.139-.154-.193-.044-.267.1a.361.361,0,0,0-.125.286v4.251a.357.357,0,0,0,.122.3l.26.1.264-.1a.371.371,0,0,0,.118-.3v-3.176l.019-.248.092-.219.2-.16a.88.88,0,0,1,.363-.061.488.488,0,0,1,.293.078l.165.138a.436.436,0,0,0,.315.145.372.372,0,0,0,.261-.1.348.348,0,0,0,.11-.268Zm4.981,1.144a1.7,1.7,0,0,0-.121-.639,1.83,1.83,0,0,0-.348-.526,1.652,1.652,0,0,0-.523-.35,1.552,1.552,0,0,0-.639-.127h-.067a1.43,1.43,0,0,0-.5.085.787.787,0,0,0-.373.25v-2.085a.343.343,0,0,0-.121-.29l-.26-.1-.264.1a.353.353,0,0,0-.118.29v6.426a.307.307,0,0,0,.118.271l.264.085.239-.072a.3.3,0,0,0,.132-.227.993.993,0,0,0,.325.206,1.309,1.309,0,0,0,.542.092h.087a1.586,1.586,0,0,0,.633-.127,1.7,1.7,0,0,0,.515-.347,1.647,1.647,0,0,0,.352-.515,1.529,1.529,0,0,0,.131-.645Zm-.764,1.752a.869.869,0,0,1-.867.868h-.087a.914.914,0,0,1-.6-.216.731.731,0,0,1-.257-.595v-1.892a.706.706,0,0,1,.257-.57.907.907,0,0,1,.6-.216h.087a.827.827,0,0,1,.617.257.839.839,0,0,1,.25.611Zm5.762-1.741a1.757,1.757,0,0,0-.125-.659,1.669,1.669,0,0,0-.348-.526,1.488,1.488,0,0,0-.519-.347,1.624,1.624,0,0,0-.629-.12h-.1a1.548,1.548,0,0,0-.629.127,1.649,1.649,0,0,0-.519.35,1.7,1.7,0,0,0-.347.526,1.627,1.627,0,0,0-.127.639v1.759a1.611,1.611,0,0,0,.473,1.16,1.665,1.665,0,0,0,.519.347,1.571,1.571,0,0,0,.629.127h.1a1.542,1.542,0,0,0,.9-.267,1.561,1.561,0,0,0,.57-.7l.04-.176a.372.372,0,0,0-.118-.285.39.39,0,0,0-.274-.113l-.193.059-.139.184a1,1,0,0,1-.3.367.753.753,0,0,1-.487.158h-.1a.869.869,0,0,1-.856-.866v-.515h2.2a.356.356,0,0,0,.27-.117.386.386,0,0,0,.113-.274Zm-.765.512h-1.814v-.516a.874.874,0,0,1,.867-.875h.1a.83.83,0,0,1,.593.255.856.856,0,0,1,.253.632Zm3.244-3.913a.342.342,0,0,0-.121-.29l-.26-.1-.261.1a.345.345,0,0,0-.118.29v.224a.353.353,0,0,0,.118.292l.261.095.26-.095a.35.35,0,0,0,.121-.292Zm0,2.133a.35.35,0,0,0-.121-.289l-.26-.095-.261.095a.353.353,0,0,0-.118.289v4.272a.329.329,0,0,0,.118.285l.261.092.26-.092a.326.326,0,0,0,.121-.285Zm3.984,4.01a.351.351,0,0,0-.268-.133.751.751,0,0,1-.409-.172.517.517,0,0,1-.173-.413v-2.872h.542a.352.352,0,0,0,.288-.121l.094-.268-.094-.264a.342.342,0,0,0-.288-.124h-.542v-1.775a.343.343,0,0,0-.121-.29l-.26-.1-.266.1a.344.344,0,0,0-.117.29v1.775h-.352a.34.34,0,0,0-.29.124l-.095.264.095.268a.35.35,0,0,0,.29.121h.352v2.894a1.367,1.367,0,0,0,.1.522,1.365,1.365,0,0,0,.7.714,1.36,1.36,0,0,0,.515.1.349.349,0,0,0,.294-.116l.091-.266Zm5.687.491a4.563,4.563,0,0,1-.429-.893,6.6,6.6,0,0,1-.3-1.091,6.8,6.8,0,0,1-.111-1.25,6.526,6.526,0,0,1,.111-1.219,7.066,7.066,0,0,1,.292-1.09,5.223,5.223,0,0,1,.42-.9,3.663,3.663,0,0,1,.487-.656l.112-.244-.122-.264-.26-.113-.26.124a4.218,4.218,0,0,0-.593.793,6.036,6.036,0,0,0-.476,1.027,7.583,7.583,0,0,0-.322,1.2,7.384,7.384,0,0,0-.122,1.34,7.637,7.637,0,0,0,.122,1.365,7.762,7.762,0,0,0,.325,1.223,5.66,5.66,0,0,0,.491,1.029,3.894,3.894,0,0,0,.606.778l.25.118a.369.369,0,0,0,.27-.118.316.316,0,0,0,.133-.255l-.122-.257a3.513,3.513,0,0,1-.5-.65m5.728-3.365a.379.379,0,0,0-.116-.275.365.365,0,0,0-.266-.113H403.39a.36.36,0,0,0-.288.12l-.095.268.095.264a.352.352,0,0,0,.288.12h1.057v1.192a1.137,1.137,0,0,1-.088.454,1.2,1.2,0,0,1-.249.366,1.075,1.075,0,0,1-.361.248,1.091,1.091,0,0,1-.45.1h-.1a1.05,1.05,0,0,1-.443-.1,1.113,1.113,0,0,1-.365-.251,1.183,1.183,0,0,1-.248-.363,1.13,1.13,0,0,1-.091-.454v-3.3a1.124,1.124,0,0,1,.091-.446,1.2,1.2,0,0,1,.248-.367,1.1,1.1,0,0,1,.365-.246,1.048,1.048,0,0,1,.443-.094h.1a1.052,1.052,0,0,1,.782.285,1.317,1.317,0,0,1,.366.714.366.366,0,0,0,.142.25l.244.077.259-.1a.336.336,0,0,0,.122-.278v-.065a1.928,1.928,0,0,0-.216-.663,1.764,1.764,0,0,0-.42-.524,2.271,2.271,0,0,0-.585-.351,1.954,1.954,0,0,0-.694-.124h-.1a1.843,1.843,0,0,0-.745.151,1.9,1.9,0,0,0-.606.416,1.988,1.988,0,0,0-.41.611,1.924,1.924,0,0,0-.151.762v3.3a1.928,1.928,0,0,0,.561,1.376,1.8,1.8,0,0,0,.606.409,1.912,1.912,0,0,0,.745.147h.1a1.906,1.906,0,0,0,.747-.147,1.816,1.816,0,0,0,.608-.409,1.94,1.94,0,0,0,.41-.611,1.985,1.985,0,0,0,.149-.765Zm2.792-3.27a.344.344,0,0,0-.122-.29l-.263-.1-.261.1a.343.343,0,0,0-.122.29v6.4a.327.327,0,0,0,.122.285l.261.092.263-.092a.328.328,0,0,0,.122-.285Zm5.592,6.079a.342.342,0,0,0-.29-.121H410.77l2.863-5.57.067-.264a.423.423,0,0,0-.132-.319.428.428,0,0,0-.328-.133h-2.883a.337.337,0,0,0-.29.124l-.091.267.091.266a.348.348,0,0,0,.29.124h2.389l-2.849,5.545-.06.248a.531.531,0,0,0,.114.339.388.388,0,0,0,.328.149h3.029a.35.35,0,0,0,.29-.121l.091-.267Zm3.465-4.012a7.257,7.257,0,0,0-.318-1.215,5.492,5.492,0,0,0-.477-1.034,3.922,3.922,0,0,0-.6-.779l-.264-.124-.26.113-.118.264.109.244a3.279,3.279,0,0,1,.5.656,5.216,5.216,0,0,1,.417.9,6.623,6.623,0,0,1,.288,1.09,7.111,7.111,0,0,1-.007,2.469,6.6,6.6,0,0,1-.294,1.091,5.081,5.081,0,0,1-.429.893,3.357,3.357,0,0,1-.5.65l-.112.242.121.27.274.118.25-.118a4.222,4.222,0,0,0,.606-.778,5.55,5.55,0,0,0,.483-1.029,7.075,7.075,0,0,0,.333-1.223,7.9,7.9,0,0,0,.118-1.365,7.488,7.488,0,0,0-.116-1.334m7.968,1.2a.407.407,0,0,0-.114-.275.373.373,0,0,0-.268-.113h-1.442a.343.343,0,0,0-.284.12l-.1.268.1.264a.335.335,0,0,0,.284.12h1.06v1.192a1.114,1.114,0,0,1-.091.454,1.214,1.214,0,0,1-.246.366,1.114,1.114,0,0,1-.363.248,1.059,1.059,0,0,1-.447.1h-.1a1.068,1.068,0,0,1-.447-.1,1.116,1.116,0,0,1-.362-.251,1.179,1.179,0,0,1-.246-.363,1.129,1.129,0,0,1-.091-.454v-3.3a1.124,1.124,0,0,1,.091-.446,1.2,1.2,0,0,1,.246-.367,1.1,1.1,0,0,1,.362-.246,1.067,1.067,0,0,1,.447-.094h.1a1.054,1.054,0,0,1,.782.285,1.345,1.345,0,0,1,.366.714.374.374,0,0,0,.139.25l.244.077.261-.1a.343.343,0,0,0,.121-.278v-.065a2.048,2.048,0,0,0-.213-.663,1.765,1.765,0,0,0-.427-.524,2.188,2.188,0,0,0-.582-.351,1.945,1.945,0,0,0-.691-.124h-.1a1.829,1.829,0,0,0-.745.151,1.914,1.914,0,0,0-.606.416,1.971,1.971,0,0,0-.413.611,1.923,1.923,0,0,0-.15.762v3.3a1.907,1.907,0,0,0,.563,1.376,1.791,1.791,0,0,0,.606.409,1.9,1.9,0,0,0,.745.147h.1a1.908,1.908,0,0,0,.746-.147,1.821,1.821,0,0,0,.61-.409,1.917,1.917,0,0,0,.557-1.376Zm7.774.11a1.921,1.921,0,0,0-.131-.728,1.359,1.359,0,0,0-.359-.512,1.488,1.488,0,0,0-.517-.3,1.939,1.939,0,0,0-.612-.095h-.092a1.557,1.557,0,0,0-.7.154,1.734,1.734,0,0,0-.548.425,1.853,1.853,0,0,0-.549-.425,1.588,1.588,0,0,0-.7-.154h-.091a1.441,1.441,0,0,0-.494.078.935.935,0,0,0-.372.226.37.37,0,0,0-.14-.233l-.233-.072a.406.406,0,0,0-.271.1.363.363,0,0,0-.122.286v4.272a.331.331,0,0,0,.122.285l.261.092.26-.092a.317.317,0,0,0,.122-.285v-3.1a.69.69,0,0,1,.263-.57.93.93,0,0,1,.6-.216h.091a.851.851,0,0,1,.863.879l0,2.984a.371.371,0,0,0,.118.3.411.411,0,0,0,.266.1l.26-.1a.36.36,0,0,0,.121-.3V115.06a.857.857,0,0,1,.25-.629.846.846,0,0,1,.615-.25h.092a.882.882,0,0,1,.615.216.821.821,0,0,1,.238.643v3.025a.327.327,0,0,0,.121.285l.264.092.26-.092a.327.327,0,0,0,.121-.285Zm5.2.01a1.655,1.655,0,0,0-.129-.639,1.718,1.718,0,0,0-.345-.526,1.656,1.656,0,0,0-.52-.35,1.562,1.562,0,0,0-.636-.127H436.3a1.423,1.423,0,0,0-.5.085.793.793,0,0,0-.373.25v-2.085a.334.334,0,0,0-.125-.29l-.257-.1-.264.1a.346.346,0,0,0-.121.29l0,6.426a.309.309,0,0,0,.117.271l.264.085.241-.072a.3.3,0,0,0,.132-.227.988.988,0,0,0,.329.206,1.281,1.281,0,0,0,.538.092h.091a1.585,1.585,0,0,0,.629-.127,1.742,1.742,0,0,0,.517-.347,1.672,1.672,0,0,0,.352-.515,1.6,1.6,0,0,0,.132-.645Zm-.768,1.752a.821.821,0,0,1-.252.61.833.833,0,0,1-.611.259h-.091a.914.914,0,0,1-.6-.216.731.731,0,0,1-.257-.595v-1.892a.706.706,0,0,1,.257-.57.907.907,0,0,1,.6-.216h.091a.869.869,0,0,1,.863.868Zm6.57-5.142a.34.34,0,0,0-.122-.29.389.389,0,0,0-.259-.1l-.261.1a.343.343,0,0,0-.122.29v2.7h-2.385v-2.7a.342.342,0,0,0-.121-.29.4.4,0,0,0-.261-.1l-.263.1a.349.349,0,0,0-.118.29v6.4a.332.332,0,0,0,.118.285l.263.092a.4.4,0,0,0,.261-.092.327.327,0,0,0,.121-.285v-2.933h2.385v2.933a.333.333,0,0,0,.122.292l.261.085a.414.414,0,0,0,.259-.085.329.329,0,0,0,.122-.292Z",
    transform: "translate(-323.389 -110.575)",
    fill: "#c7000e",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_668",
    "data-name": "Grupo 668",
    transform: "translate(71.255 19.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_667",
    "data-name": "Grupo 667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1652",
    "data-name": "Trazado 1652",
    d: "M325.613,103.087a.335.335,0,0,0-.284-.12,1.28,1.28,0,0,0-.523.1,1.271,1.271,0,0,0-.683.71,1.505,1.505,0,0,0-.094.535v.817h-.224a.342.342,0,0,0-.288.124l-.095.264.095.268a.342.342,0,0,0,.288.124h.224v3.849a.346.346,0,0,0,.117.285l.264.092.26-.092a.334.334,0,0,0,.123-.285v-3.849h.471a.336.336,0,0,0,.286-.124l.1-.268-.092-.264a.337.337,0,0,0-.293-.124h-.471v-.817a.6.6,0,0,1,.146-.4.486.486,0,0,1,.389-.168.348.348,0,0,0,.284-.122l.095-.268Zm4.48.266a.342.342,0,0,0-.125-.289l-.267-.1-.257.1a.365.365,0,0,0-.116.289v.226a.348.348,0,0,0,.122.292l.26.1.264-.1a.358.358,0,0,0,.118-.292Zm-1.851,0a.347.347,0,0,0-.121-.289l-.262-.1-.264.1a.344.344,0,0,0-.117.289v.226a.345.345,0,0,0,.117.292l.264.1.262-.1a.347.347,0,0,0,.121-.292Zm2.224,2.136a.36.36,0,0,0-.12-.292l-.264-.094-.26.094a.349.349,0,0,0-.121.292V108.5a.844.844,0,0,1-.25.611.835.835,0,0,1-.612.255h-.091a.822.822,0,0,1-.607-.255.832.832,0,0,1-.249-.611v-3.007a.35.35,0,0,0-.123-.292l-.261-.094-.263.094a.359.359,0,0,0-.118.292V108.5a1.923,1.923,0,0,0,.128.735,1.383,1.383,0,0,0,.87.805,2.014,2.014,0,0,0,.623.095h.091a1.616,1.616,0,0,0,.49-.076.912.912,0,0,0,.373-.223.321.321,0,0,0,.143.226l.238.073.264-.095a.349.349,0,0,0,.12-.282Zm4.292.113a1.006,1.006,0,0,0-.465-.381,1.544,1.544,0,0,0-.584-.117,1.742,1.742,0,0,0-.328.028l-.223.072-.173.1-.139-.157-.193-.045-.264.1a.343.343,0,0,0-.128.286v4.25a.367.367,0,0,0,.121.3l.261.095.26-.095a.368.368,0,0,0,.122-.3v-3.172l.019-.25.092-.216.2-.158a.815.815,0,0,1,.362-.062.513.513,0,0,1,.3.076l.162.138a.43.43,0,0,0,.315.143.366.366,0,0,0,.259-.1.343.343,0,0,0,.113-.264Zm5.739-2.249a.347.347,0,0,0-.121-.289l-.262-.1-.263.1a.354.354,0,0,0-.12.289v6.408a.344.344,0,0,0,.12.285l.263.092.262-.092a.337.337,0,0,0,.121-.285Zm5.377,3.4a1.876,1.876,0,0,0-.132-.732,1.388,1.388,0,0,0-.867-.82,2,2,0,0,0-.612-.094h-.091a1.482,1.482,0,0,0-.491.078,1.033,1.033,0,0,0-.374.223.363.363,0,0,0-.139-.23l-.244-.072a.415.415,0,0,0-.271.1.358.358,0,0,0-.121.286v4.272a.337.337,0,0,0,.121.285l.26.092.266-.092a.338.338,0,0,0,.117-.285v-3.011a.833.833,0,0,1,.257-.622.824.824,0,0,1,.606-.248h.088a.811.811,0,0,1,.612.255.85.85,0,0,1,.25.615v3.011a.337.337,0,0,0,.121.285l.264.092a.393.393,0,0,0,.262-.092.339.339,0,0,0,.118-.285Zm3.768,2.747a.356.356,0,0,0-.264-.135.715.715,0,0,1-.409-.168.519.519,0,0,1-.175-.411v-2.871h.544a.331.331,0,0,0,.285-.124l.1-.268-.1-.264a.331.331,0,0,0-.285-.124h-.544v-1.778a.358.358,0,0,0-.12-.289l-.264-.1-.26.1a.347.347,0,0,0-.121.289v1.778h-.352a.34.34,0,0,0-.288.124l-.095.264.095.268a.34.34,0,0,0,.288.124h.352v2.89a1.351,1.351,0,0,0,.381.948,1.308,1.308,0,0,0,.937.388.352.352,0,0,0,.292-.117l.091-.268Zm4.822-2.741a1.683,1.683,0,0,0-.125-.655,1.65,1.65,0,0,0-.348-.528,1.5,1.5,0,0,0-.517-.348,1.636,1.636,0,0,0-.63-.12h-.1a1.582,1.582,0,0,0-.63.127,1.7,1.7,0,0,0-.518.351,1.546,1.546,0,0,0-.345.526,1.649,1.649,0,0,0-.128.643V108.5a1.654,1.654,0,0,0,.128.647,1.514,1.514,0,0,0,.345.515,1.636,1.636,0,0,0,.518.347,1.582,1.582,0,0,0,.63.127h.1a1.546,1.546,0,0,0,.9-.268,1.577,1.577,0,0,0,.568-.7l.039-.176a.363.363,0,0,0-.12-.285.387.387,0,0,0-.272-.113l-.19.055-.139.189a1.042,1.042,0,0,1-.3.367.8.8,0,0,1-.49.154h-.1a.829.829,0,0,1-.607-.255.837.837,0,0,1-.246-.607v-.519h2.192a.349.349,0,0,0,.271-.117.385.385,0,0,0,.111-.267Zm-.765.512h-1.81v-.515a.862.862,0,0,1,.863-.873h.1a.81.81,0,0,1,.59.252.844.844,0,0,1,.256.632Zm4.892-1.665a1.006,1.006,0,0,0-.468-.381,1.513,1.513,0,0,0-.579-.117,1.828,1.828,0,0,0-.333.028l-.22.072-.169.1-.146-.157-.189-.045-.267.1a.361.361,0,0,0-.125.286v4.25a.364.364,0,0,0,.122.3l.259.095.264-.095a.367.367,0,0,0,.12-.3v-3.172l.019-.25.091-.216.2-.158a.811.811,0,0,1,.362-.062.5.5,0,0,1,.294.076l.169.138a.417.417,0,0,0,.311.143.371.371,0,0,0,.261-.1.345.345,0,0,0,.11-.264Zm4.741,1.148a1.9,1.9,0,0,0-.129-.732,1.461,1.461,0,0,0-.355-.519,1.421,1.421,0,0,0-.512-.3,2.018,2.018,0,0,0-.615-.094h-.091a1.463,1.463,0,0,0-.49.078,1.015,1.015,0,0,0-.373.223.362.362,0,0,0-.143-.23l-.24-.072a.415.415,0,0,0-.274.1.356.356,0,0,0-.118.286v4.272a.335.335,0,0,0,.118.285l.264.092.26-.092a.338.338,0,0,0,.122-.285v-3.011a.84.84,0,0,1,.253-.622.828.828,0,0,1,.606-.248h.091a.812.812,0,0,1,.61.255.838.838,0,0,1,.249.615v3.011a.333.333,0,0,0,.127.285l.264.092a.394.394,0,0,0,.26-.092.341.341,0,0,0,.116-.285Zm5.424,2.77a.374.374,0,0,0-.248-.138.3.3,0,0,1-.262-.336v-2.374a1.546,1.546,0,0,0-.121-.61,1.53,1.53,0,0,0-.835-.839,1.6,1.6,0,0,0-.623-.12h-.07a1.877,1.877,0,0,0-.413.045,1.394,1.394,0,0,0-.413.154,1.362,1.362,0,0,0-.376.289,1.521,1.521,0,0,0-.3.46l-.044.184a.326.326,0,0,0,.121.259l.264.095.19-.044.153-.154a1.09,1.09,0,0,1,.321-.385.851.851,0,0,1,.494-.127h.07a.924.924,0,0,1,.572.183.756.756,0,0,1,.241.644l0,.089-.023.083a.473.473,0,0,1-.278.128c-.146.03-.31.061-.5.095s-.388.08-.595.135a2.217,2.217,0,0,0-.572.241,1.26,1.26,0,0,0-.434.418,1.176,1.176,0,0,0-.172.659v.122a1.325,1.325,0,0,0,.142.629,1.4,1.4,0,0,0,.365.464,1.567,1.567,0,0,0,.522.275,1.852,1.852,0,0,0,.592.092h.092a1.581,1.581,0,0,0,1.084-.4.91.91,0,0,0,.266.245.991.991,0,0,0,.422.145l.067.01a.328.328,0,0,0,.277-.117.413.413,0,0,0,.095-.271Zm-1.276-1.027a.818.818,0,0,1-.255.618.847.847,0,0,1-.608.25h-.092a.967.967,0,0,1-.619-.191.644.644,0,0,1-.237-.523v-.083a.5.5,0,0,1,.176-.409,1.312,1.312,0,0,1,.45-.223,4.049,4.049,0,0,1,.589-.129,5.579,5.579,0,0,0,.6-.117Zm4.686,1a.365.365,0,0,0-.267-.135.707.707,0,0,1-.406-.168.5.5,0,0,1-.178-.411v-2.871h.542a.331.331,0,0,0,.286-.124l.1-.268-.1-.264a.331.331,0,0,0-.286-.124h-.542v-1.778a.347.347,0,0,0-.121-.289l-.26-.1-.26.1a.348.348,0,0,0-.122.289v1.778H370.2a.339.339,0,0,0-.283.124l-.094.264.094.268a.339.339,0,0,0,.283.124h.356v2.89a1.336,1.336,0,0,0,.1.519,1.249,1.249,0,0,0,.281.429,1.174,1.174,0,0,0,.422.286,1.231,1.231,0,0,0,.511.1.358.358,0,0,0,.295-.117l.092-.268Zm2.476-6.143a.345.345,0,0,0-.118-.289l-.263-.1-.26.1a.344.344,0,0,0-.122.289v.226a.344.344,0,0,0,.122.292l.26.1.263-.1a.346.346,0,0,0,.118-.292Zm0,2.136a.351.351,0,0,0-.118-.292l-.263-.094-.26.094a.349.349,0,0,0-.122.292v4.272a.334.334,0,0,0,.122.285l.26.092.263-.092a.335.335,0,0,0,.118-.285Zm5.147,1.261a1.626,1.626,0,0,0-.129-.643,1.564,1.564,0,0,0-.344-.526,1.7,1.7,0,0,0-.519-.351,1.586,1.586,0,0,0-.633-.127h-.1a1.557,1.557,0,0,0-.629.127,1.68,1.68,0,0,0-.517.351,1.616,1.616,0,0,0-.348.526,1.647,1.647,0,0,0-.127.643V108.5a1.653,1.653,0,0,0,.127.647,1.583,1.583,0,0,0,.348.515,1.621,1.621,0,0,0,.517.347,1.557,1.557,0,0,0,.629.127h.1a1.586,1.586,0,0,0,.633-.127,1.642,1.642,0,0,0,.519-.347,1.531,1.531,0,0,0,.344-.515,1.631,1.631,0,0,0,.129-.647Zm-.768,1.746a.862.862,0,0,1-.857.866h-.087a.821.821,0,0,1-.612-.255.831.831,0,0,1-.255-.611v-1.751a.834.834,0,0,1,.255-.611.8.8,0,0,1,.6-.255h.1a.819.819,0,0,1,.607.255.835.835,0,0,1,.25.611Zm5.856-1.746a1.851,1.851,0,0,0-.131-.732,1.387,1.387,0,0,0-.867-.82,2,2,0,0,0-.612-.094h-.091a1.493,1.493,0,0,0-.494.078,1.063,1.063,0,0,0-.373.223.373.373,0,0,0-.138-.23l-.245-.072a.425.425,0,0,0-.274.1.365.365,0,0,0-.118.286v4.272a.343.343,0,0,0,.118.285l.266.092.263-.092a.343.343,0,0,0,.118-.285v-3.011a.86.86,0,0,1,.863-.87h.091a.818.818,0,0,1,.61.255.856.856,0,0,1,.251.615v3.011a.337.337,0,0,0,.121.285l.267.092.26-.092a.338.338,0,0,0,.116-.285Zm5.428,2.77a.388.388,0,0,0-.248-.138.305.305,0,0,1-.264-.336v-2.374a1.6,1.6,0,0,0-.451-1.112,1.527,1.527,0,0,0-.505-.337,1.6,1.6,0,0,0-.622-.12h-.072a1.859,1.859,0,0,0-.413.045,1.571,1.571,0,0,0-.793.443,1.7,1.7,0,0,0-.3.46l-.037.184a.312.312,0,0,0,.118.259l.262.095.193-.044.153-.154a1.09,1.09,0,0,1,.321-.385.839.839,0,0,1,.494-.127h.072a.929.929,0,0,1,.571.183.757.757,0,0,1,.244.644l0,.089-.026.083a.473.473,0,0,1-.278.128c-.142.03-.311.061-.5.095s-.389.08-.6.135a2.259,2.259,0,0,0-.572.241,1.3,1.3,0,0,0-.435.418,1.187,1.187,0,0,0-.171.659v.122a1.375,1.375,0,0,0,.139.629,1.478,1.478,0,0,0,.373.464,1.5,1.5,0,0,0,.517.275,1.861,1.861,0,0,0,.593.092h.091a1.6,1.6,0,0,0,1.089-.4.855.855,0,0,0,.26.245,1,1,0,0,0,.42.145l.076.01a.336.336,0,0,0,.277-.117.437.437,0,0,0,.095-.271Zm-1.276-1.027a.826.826,0,0,1-.257.618.856.856,0,0,1-.608.25h-.091a.969.969,0,0,1-.621-.191.652.652,0,0,1-.237-.523v-.083a.5.5,0,0,1,.176-.409,1.312,1.312,0,0,1,.45-.223,4.175,4.175,0,0,1,.589-.129,5.628,5.628,0,0,0,.6-.117Zm4.489.992a.352.352,0,0,0-.294-.124.576.576,0,0,1-.555-.574v-5.435a.347.347,0,0,0-.121-.289l-.262-.1-.263.1a.353.353,0,0,0-.118.289V108.8a1.336,1.336,0,0,0,.1.519,1.312,1.312,0,0,0,.281.429,1.192,1.192,0,0,0,.424.286,1.248,1.248,0,0,0,.513.1.365.365,0,0,0,.294-.117l.088-.268Zm4.822-2.73a1.661,1.661,0,0,0-.129-.655,1.628,1.628,0,0,0-.348-.528,1.5,1.5,0,0,0-.517-.348,1.631,1.631,0,0,0-.63-.12h-.1a1.586,1.586,0,0,0-.633.127,1.72,1.72,0,0,0-.519.351,1.668,1.668,0,0,0-.469,1.168V108.5a1.628,1.628,0,0,0,.125.647,1.573,1.573,0,0,0,.344.515,1.658,1.658,0,0,0,.519.347,1.586,1.586,0,0,0,.633.127h.1a1.559,1.559,0,0,0,.9-.268,1.542,1.542,0,0,0,.564-.7l.045-.176a.38.38,0,0,0-.122-.285.388.388,0,0,0-.271-.113l-.193.055-.142.189a.96.96,0,0,1-.3.367.772.772,0,0,1-.487.154h-.1a.825.825,0,0,1-.607-.255.833.833,0,0,1-.253-.607v-.519h2.2a.361.361,0,0,0,.275-.117.379.379,0,0,0,.111-.267Zm-.768.512h-1.814v-.515a.869.869,0,0,1,.867-.873h.1a.811.811,0,0,1,.589.252.846.846,0,0,1,.257.632Z",
    transform: "translate(-323.423 -102.967)",
    fill: "#c7000e",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_670",
    "data-name": "Grupo 670",
    transform: "translate(71.71 8.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_669",
    "data-name": "Grupo 669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1653",
    "data-name": "Trazado 1653",
    d: "M327.667,96.846a1.944,1.944,0,0,0-.149-.753,1.967,1.967,0,0,0-1.012-1.027,1.792,1.792,0,0,0-.74-.151h-1.632a.4.4,0,0,0-.381.388v6.281a.384.384,0,0,0,.114.274.377.377,0,0,0,.267.117h1.632a1.773,1.773,0,0,0,.74-.156,1.951,1.951,0,0,0,.6-.413,1.9,1.9,0,0,0,.41-.619,1.973,1.973,0,0,0,.149-.756Zm-.764,3.186a1.153,1.153,0,0,1-.091.457,1.21,1.21,0,0,1-.245.367,1.169,1.169,0,0,1-.362.25,1.1,1.1,0,0,1-.446.089h-1.241v-5.5h1.251a1.007,1.007,0,0,1,.447.094,1.067,1.067,0,0,1,.355.246,1.17,1.17,0,0,1,.241.372,1.1,1.1,0,0,1,.091.453Zm5.881-1.39a1.769,1.769,0,0,0-.125-.656,1.6,1.6,0,0,0-.867-.875,1.625,1.625,0,0,0-.629-.121h-.1a1.558,1.558,0,0,0-1.146.482,1.561,1.561,0,0,0-.348.524,1.607,1.607,0,0,0-.125.639v1.759a1.623,1.623,0,0,0,.125.643,1.591,1.591,0,0,0,.348.515,1.668,1.668,0,0,0,.517.347,1.58,1.58,0,0,0,.629.127h.1a1.534,1.534,0,0,0,.9-.268,1.587,1.587,0,0,0,.568-.7l.04-.172a.4.4,0,0,0-.392-.4l-.193.059-.142.189a1.011,1.011,0,0,1-.294.367.792.792,0,0,1-.487.154h-.1a.869.869,0,0,1-.856-.866v-.515h2.2a.369.369,0,0,0,.27-.117.4.4,0,0,0,.113-.271Zm-.765.511H330.2v-.515a.874.874,0,0,1,.866-.875h.1a.816.816,0,0,1,.592.255.852.852,0,0,1,.253.634Zm5.718-1.775a.363.363,0,0,0-.125-.295l-.26-.094-.261.094a.358.358,0,0,0-.121.292v3.007a.869.869,0,0,1-.863.87h-.095a.869.869,0,0,1-.852-.87V97.374a.359.359,0,0,0-.122-.292l-.264-.094-.26.094a.373.373,0,0,0-.121.295v3.015a1.886,1.886,0,0,0,.131.735,1.471,1.471,0,0,0,.352.5,1.44,1.44,0,0,0,.522.3,1.989,1.989,0,0,0,.615.094h.095a1.529,1.529,0,0,0,.491-.076.942.942,0,0,0,.372-.222.352.352,0,0,0,.142.23l.241.067.26-.094a.347.347,0,0,0,.125-.284Zm3.9,4.008a.351.351,0,0,0-.267-.133.745.745,0,0,1-.41-.172.5.5,0,0,1-.176-.409V97.8h.545a.335.335,0,0,0,.285-.124l.1-.266-.1-.263a.327.327,0,0,0-.285-.128h-.545V95.238a.352.352,0,0,0-.121-.289l-.26-.1-.264.1a.363.363,0,0,0-.118.289v1.778h-.352a.334.334,0,0,0-.288.128l-.094.263.094.266a.342.342,0,0,0,.288.124h.352v2.891a1.4,1.4,0,0,0,.1.522,1.237,1.237,0,0,0,.282.425,1.273,1.273,0,0,0,.936.388.356.356,0,0,0,.292-.117l.092-.264Zm4.961-.827a1.37,1.37,0,0,0-.2-.787,1.4,1.4,0,0,0-.483-.439,2.52,2.52,0,0,0-.63-.238c-.226-.051-.435-.1-.629-.15a1.7,1.7,0,0,1-.483-.206.437.437,0,0,1-.2-.391v-.03a.511.511,0,0,1,.234-.389,1.07,1.07,0,0,1,.643-.164h.041a1.211,1.211,0,0,1,.534.1c.129.065.244.127.351.178l.222.063a.346.346,0,0,0,.263-.11l.1-.257a.371.371,0,0,0-.139-.3l-.176-.127a1.408,1.408,0,0,0-.281-.147,2.872,2.872,0,0,0-.383-.117,2.023,2.023,0,0,0-.48-.052h-.041a2.288,2.288,0,0,0-.527.066,1.672,1.672,0,0,0-.534.22,1.338,1.338,0,0,0-.416.4,1.058,1.058,0,0,0-.173.618,1.154,1.154,0,0,0,.2.735,1.3,1.3,0,0,0,.48.406,2.619,2.619,0,0,0,.629.209,5.737,5.737,0,0,1,.629.158,1.514,1.514,0,0,1,.484.246.585.585,0,0,1,.2.486v.029a.647.647,0,0,1-.257.472,1.046,1.046,0,0,1-.71.216h-.051a1.067,1.067,0,0,1-.574-.2,1.98,1.98,0,0,1-.48-.45l-.164-.139-.179-.036a.414.414,0,0,0-.274.1.351.351,0,0,0-.118.274.7.7,0,0,0,.051.193,1.593,1.593,0,0,0,.312.428,1.968,1.968,0,0,0,.422.323,2.635,2.635,0,0,0,.487.2,1.978,1.978,0,0,0,.5.067h.061a2.187,2.187,0,0,0,.626-.089,1.9,1.9,0,0,0,.566-.271,1.43,1.43,0,0,0,.4-.443,1.238,1.238,0,0,0,.153-.621Zm4.766-.478-.263-.1-.255.1a.379.379,0,0,0-.128.3.96.96,0,0,1-.26.614.8.8,0,0,1-.6.259h-.088a.874.874,0,0,1-.87-.87l0-1.751a.852.852,0,0,1,.25-.614.831.831,0,0,1,.607-.255h.1a.813.813,0,0,1,.6.248.954.954,0,0,1,.26.632.353.353,0,0,0,.128.288l.255.089.263-.092a.355.355,0,0,0,.118-.293,1.61,1.61,0,0,0-.128-.639,1.7,1.7,0,0,0-.348-.524,1.531,1.531,0,0,0-.515-.358,1.607,1.607,0,0,0-.629-.124h-.1a1.588,1.588,0,0,0-1.148.475,1.724,1.724,0,0,0-.345.522,1.6,1.6,0,0,0-.132.648v1.759a1.647,1.647,0,0,0,.125.643,1.733,1.733,0,0,0,.348.515,1.654,1.654,0,0,0,.522.347,1.563,1.563,0,0,0,.63.127h.1a1.561,1.561,0,0,0,.629-.127,1.656,1.656,0,0,0,.866-.873,1.6,1.6,0,0,0,.125-.645.346.346,0,0,0-.118-.3m5.17-1.446a1.631,1.631,0,0,0-.125-.639,1.6,1.6,0,0,0-.348-.524,1.558,1.558,0,0,0-1.146-.482h-.083a1.556,1.556,0,0,0-.5.08.88.88,0,0,0-.373.226V95.238a.359.359,0,0,0-.118-.289l-.263-.1-.264.1a.363.363,0,0,0-.118.289v6.408a.347.347,0,0,0,.118.288l.264.089.263-.089a.343.343,0,0,0,.118-.288V98.583a.766.766,0,0,1,.081-.351.882.882,0,0,1,.206-.257.821.821,0,0,1,.295-.157,1.114,1.114,0,0,1,.336-.055,1.048,1.048,0,0,1,.322.055.85.85,0,0,1,.293.157.709.709,0,0,1,.206.268.975.975,0,0,1,.074.391v3.013a.344.344,0,0,0,.12.288.425.425,0,0,0,.263.089l.26-.089a.338.338,0,0,0,.122-.288Zm4.99.008a1.6,1.6,0,0,0-.129-.656,1.617,1.617,0,0,0-.344-.528,1.692,1.692,0,0,0-.518-.347,1.627,1.627,0,0,0-.63-.121h-.1a1.552,1.552,0,0,0-1.145.482,1.563,1.563,0,0,0-.35.524,1.63,1.63,0,0,0-.124.639v1.759a1.646,1.646,0,0,0,.124.643,1.594,1.594,0,0,0,.35.515,1.678,1.678,0,0,0,.516.347,1.585,1.585,0,0,0,.629.127h.1a1.542,1.542,0,0,0,.9-.268,1.622,1.622,0,0,0,.571-.7l.037-.172a.364.364,0,0,0-.121-.289.382.382,0,0,0-.271-.113l-.194.059-.138.189a1.064,1.064,0,0,1-.3.367.782.782,0,0,1-.489.154h-.1a.869.869,0,0,1-.855-.866v-.515h2.2a.365.365,0,0,0,.271-.117.4.4,0,0,0,.111-.271Zm-.768.511h-1.81v-.515a.831.831,0,0,1,.257-.621.841.841,0,0,1,.608-.255h.1a.816.816,0,0,1,.589.255.837.837,0,0,1,.253.634Zm9.678-.641a.391.391,0,0,0-.116-.272.362.362,0,0,0-.267-.116h-1.442a.351.351,0,0,0-.288.12l-.091.268.091.267a.351.351,0,0,0,.288.12h1.06v1.192a1.122,1.122,0,0,1-.092.454,1.212,1.212,0,0,1-.246.363,1.188,1.188,0,0,1-.362.252,1.143,1.143,0,0,1-.446.092h-.1a1.117,1.117,0,0,1-.809-.344,1.212,1.212,0,0,1-.25-.366,1.192,1.192,0,0,1-.088-.454V96.78a1.129,1.129,0,0,1,.339-.811,1.24,1.24,0,0,1,.362-.25,1.123,1.123,0,0,1,.447-.089h.1a1.041,1.041,0,0,1,.778.285,1.327,1.327,0,0,1,.369.718.357.357,0,0,0,.142.248l.241.078.26-.1a.343.343,0,0,0,.122-.282V96.52a2,2,0,0,0-.217-.667,1.891,1.891,0,0,0-.423-.526,2.105,2.105,0,0,0-.585-.345,1.839,1.839,0,0,0-.687-.128h-.1a1.89,1.89,0,0,0-.745.151,1.91,1.91,0,0,0-.608.416,1.986,1.986,0,0,0-.41.611,1.893,1.893,0,0,0-.149.762v3.3a1.9,1.9,0,0,0,.149.762,1.923,1.923,0,0,0,.41.611,1.877,1.877,0,0,0,.608.411,1.935,1.935,0,0,0,.745.145h.1a1.96,1.96,0,0,0,.745-.145,1.9,1.9,0,0,0,1.014-1.023,1.9,1.9,0,0,0,.153-.762Zm5.109.131a1.743,1.743,0,0,0-.125-.656,1.7,1.7,0,0,0-.348-.528,1.66,1.66,0,0,0-.517-.347,1.632,1.632,0,0,0-.63-.121h-.1a1.622,1.622,0,0,0-.629.124,1.6,1.6,0,0,0-.517.358,1.534,1.534,0,0,0-.345.524,1.633,1.633,0,0,0-.128.639v1.759a1.648,1.648,0,0,0,.128.643,1.562,1.562,0,0,0,.345.515,1.637,1.637,0,0,0,.517.347,1.585,1.585,0,0,0,.629.127h.1a1.537,1.537,0,0,0,.9-.268,1.56,1.56,0,0,0,.568-.7l.04-.172a.373.373,0,0,0-.121-.289.383.383,0,0,0-.27-.113l-.194.059-.139.189a1.033,1.033,0,0,1-.3.367.783.783,0,0,1-.487.154h-.1a.865.865,0,0,1-.852-.866v-.515h2.19a.362.362,0,0,0,.272-.117.391.391,0,0,0,.113-.271Zm-.765.511h-1.81v-.515a.867.867,0,0,1,.863-.875h.1a.816.816,0,0,1,.589.255.84.84,0,0,1,.257.634Zm5.781,1.405a1.26,1.26,0,0,0-.678-1.226,2.522,2.522,0,0,0-.63-.238c-.226-.051-.436-.1-.629-.15a1.685,1.685,0,0,1-.483-.206.434.434,0,0,1-.2-.391v-.03a.509.509,0,0,1,.233-.389,1.074,1.074,0,0,1,.644-.164h.04a1.194,1.194,0,0,1,.534.1c.129.065.244.127.352.178l.224.063a.348.348,0,0,0,.26-.11l.1-.257a.379.379,0,0,0-.143-.3l-.179-.127a1.276,1.276,0,0,0-.278-.147,2.639,2.639,0,0,0-.383-.117,2,2,0,0,0-.479-.052h-.041a2.27,2.27,0,0,0-.527.066,1.679,1.679,0,0,0-.533.22,1.333,1.333,0,0,0-.418.4,1.058,1.058,0,0,0-.172.618,1.181,1.181,0,0,0,.2.735,1.357,1.357,0,0,0,.483.406,2.512,2.512,0,0,0,.63.209,5.819,5.819,0,0,1,.629.158,1.449,1.449,0,0,1,.48.246.579.579,0,0,1,.2.486v.029a.652.652,0,0,1-.257.472,1.046,1.046,0,0,1-.71.216h-.047a1.05,1.05,0,0,1-.575-.2,1.951,1.951,0,0,1-.484-.45l-.158-.139-.183-.036a.4.4,0,0,0-.271.1.34.34,0,0,0-.121.274.651.651,0,0,0,.051.193,1.5,1.5,0,0,0,.311.428,1.934,1.934,0,0,0,.423.323,2.6,2.6,0,0,0,.487.2,1.994,1.994,0,0,0,.5.067h.062a2.177,2.177,0,0,0,.625-.089,1.855,1.855,0,0,0,.563-.271,1.343,1.343,0,0,0,.4-.443,1.223,1.223,0,0,0,.151-.621Zm4.884-1.916a1.67,1.67,0,0,0-.475-1.185,1.691,1.691,0,0,0-.517-.347,1.63,1.63,0,0,0-.629-.121h-.1a1.607,1.607,0,0,0-.629.124,1.666,1.666,0,0,0-.519.358,1.6,1.6,0,0,0-.348.524,1.629,1.629,0,0,0-.124.639v1.759a1.589,1.589,0,0,0,.472,1.157,1.706,1.706,0,0,0,.519.347,1.561,1.561,0,0,0,.629.127h.1a1.541,1.541,0,0,0,.9-.268,1.584,1.584,0,0,0,.571-.7l.039-.172a.372.372,0,0,0-.12-.289.39.39,0,0,0-.274-.113l-.193.059-.139.189a1.049,1.049,0,0,1-.3.367.786.786,0,0,1-.487.154h-.1a.869.869,0,0,1-.856-.866v-.515h2.2a.366.366,0,0,0,.272-.117.4.4,0,0,0,.111-.271Zm-.765.511h-1.814v-.515a.847.847,0,0,1,.257-.621.837.837,0,0,1,.608-.255h.1a.814.814,0,0,1,.589.255.84.84,0,0,1,.257.634Zm4.09,2.218a.343.343,0,0,0-.294-.12.582.582,0,0,1-.392-.176.54.54,0,0,1-.16-.4V95.238a.334.334,0,0,0-.124-.289l-.257-.1-.264.1a.353.353,0,0,0-.122.289v5.45a1.432,1.432,0,0,0,.1.522,1.26,1.26,0,0,0,.284.425,1.244,1.244,0,0,0,.42.289,1.3,1.3,0,0,0,.513.1.358.358,0,0,0,.294-.117l.092-.264Zm3.163,0a.339.339,0,0,0-.293-.12.583.583,0,0,1-.394-.176.535.535,0,0,1-.161-.4V95.238a.339.339,0,0,0-.12-.289l-.263-.1-.26.1a.352.352,0,0,0-.121.289v5.45a1.375,1.375,0,0,0,.1.522,1.3,1.3,0,0,0,.281.425,1.312,1.312,0,0,0,.422.289,1.3,1.3,0,0,0,.515.1.353.353,0,0,0,.293-.117l.089-.264Zm4.975-.813a1.38,1.38,0,0,0-.2-.787,1.4,1.4,0,0,0-.484-.439,2.451,2.451,0,0,0-.629-.238c-.227-.051-.436-.1-.625-.15a1.671,1.671,0,0,1-.486-.206.43.43,0,0,1-.2-.391v-.03a.506.506,0,0,1,.23-.389,1.075,1.075,0,0,1,.647-.164h.036a1.2,1.2,0,0,1,.535.1c.129.065.248.127.352.178l.223.063a.349.349,0,0,0,.261-.11l.1-.257a.376.376,0,0,0-.139-.3l-.179-.127a1.263,1.263,0,0,0-.284-.147,2.544,2.544,0,0,0-.38-.117,2,2,0,0,0-.478-.052h-.04a2.294,2.294,0,0,0-.531.066,1.711,1.711,0,0,0-.534.22,1.358,1.358,0,0,0-.417.4,1.067,1.067,0,0,0-.169.618,1.189,1.189,0,0,0,.193.735,1.361,1.361,0,0,0,.484.406,2.619,2.619,0,0,0,.629.209,5.738,5.738,0,0,1,.629.158,1.452,1.452,0,0,1,.486.246.6.6,0,0,1,.2.486v.029a.656.656,0,0,1-.257.472,1.033,1.033,0,0,1-.707.216h-.051a1.064,1.064,0,0,1-.575-.2,1.945,1.945,0,0,1-.483-.45l-.16-.139-.183-.036a.4.4,0,0,0-.271.1.344.344,0,0,0-.121.274.911.911,0,0,0,.051.193,1.682,1.682,0,0,0,.311.428,2.01,2.01,0,0,0,.424.323,2.672,2.672,0,0,0,.487.2,2.009,2.009,0,0,0,.5.067h.061a2.172,2.172,0,0,0,.622-.089,1.9,1.9,0,0,0,.566-.271,1.421,1.421,0,0,0,.4-.443,1.224,1.224,0,0,0,.153-.621Zm4.763-.478-.259-.1-.259.1a.4.4,0,0,0-.125.3.94.94,0,0,1-.26.614.8.8,0,0,1-.6.259h-.091a.836.836,0,0,1-.615-.259.851.851,0,0,1-.252-.611V98.631a.871.871,0,0,1,.252-.614.837.837,0,0,1,.606-.255h.1a.811.811,0,0,1,.6.248.934.934,0,0,1,.26.632.377.377,0,0,0,.125.288l.259.089.259-.092a.358.358,0,0,0,.122-.293,1.566,1.566,0,0,0-.132-.639,1.712,1.712,0,0,0-.345-.524,1.6,1.6,0,0,0-.513-.358,1.639,1.639,0,0,0-.63-.124h-.1a1.634,1.634,0,0,0-.63.124,1.606,1.606,0,0,0-.513.351,1.675,1.675,0,0,0-.345.522,1.6,1.6,0,0,0-.132.648v1.759a1.647,1.647,0,0,0,.125.643,1.593,1.593,0,0,0,.35.515,1.628,1.628,0,0,0,.516.347,1.587,1.587,0,0,0,.63.127h.1a1.592,1.592,0,0,0,.63-.127,1.671,1.671,0,0,0,.517-.354,1.719,1.719,0,0,0,.348-.519,1.671,1.671,0,0,0,.125-.645.348.348,0,0,0-.122-.3m5.08-1.446a1.61,1.61,0,0,0-.129-.639,1.581,1.581,0,0,0-.348-.524,1.558,1.558,0,0,0-1.148-.482h-.081a1.548,1.548,0,0,0-.5.08.861.861,0,0,0-.37.226V95.238a.346.346,0,0,0-.124-.289l-.262-.1-.261.1a.356.356,0,0,0-.121.289v6.408a.341.341,0,0,0,.121.288l.261.089.262-.089a.332.332,0,0,0,.124-.288V98.583a.8.8,0,0,1,.078-.351.84.84,0,0,1,.206-.257.8.8,0,0,1,.293-.157,1.155,1.155,0,0,1,.34-.055,1.047,1.047,0,0,1,.321.055.884.884,0,0,1,.292.157.709.709,0,0,1,.206.268.951.951,0,0,1,.074.391v3.013a.337.337,0,0,0,.121.288l.26.089a.423.423,0,0,0,.264-.089.345.345,0,0,0,.122-.288Zm5.4,2.773a.369.369,0,0,0-.242-.139.3.3,0,0,1-.264-.336v-2.37a1.568,1.568,0,0,0-.123-.615,1.6,1.6,0,0,0-.332-.5,1.654,1.654,0,0,0-.5-.336,1.588,1.588,0,0,0-.623-.121h-.07a1.877,1.877,0,0,0-.413.045,1.51,1.51,0,0,0-.413.151,1.661,1.661,0,0,0-.378.292,1.472,1.472,0,0,0-.294.464l-.045.182a.319.319,0,0,0,.122.257l.264.1.19-.044.153-.162a1.089,1.089,0,0,1,.321-.38.841.841,0,0,1,.494-.131h.07a.949.949,0,0,1,.573.184.76.76,0,0,1,.241.645l0,.094-.023.08a.462.462,0,0,1-.278.125c-.145.036-.311.066-.5.1a5.9,5.9,0,0,0-.595.131,2.128,2.128,0,0,0-.577.241,1.354,1.354,0,0,0-.429.418,1.148,1.148,0,0,0-.172.658v.124a1.325,1.325,0,0,0,.142.633,1.351,1.351,0,0,0,.365.46,1.519,1.519,0,0,0,.519.278,1.959,1.959,0,0,0,.595.089h.092a1.565,1.565,0,0,0,1.086-.4.912.912,0,0,0,.26.248,1.129,1.129,0,0,0,.422.142l.072.01a.354.354,0,0,0,.278-.113.423.423,0,0,0,.1-.275Zm-1.274-1.028a.874.874,0,0,1-.863.873h-.092a.958.958,0,0,1-.619-.2.636.636,0,0,1-.237-.522v-.083a.5.5,0,0,1,.176-.41,1.434,1.434,0,0,1,.447-.226,4.022,4.022,0,0,1,.588-.124,5.871,5.871,0,0,0,.6-.117Zm4.649-5.4a.344.344,0,0,0-.288-.121,1.341,1.341,0,0,0-.519.1,1.382,1.382,0,0,0-.411.281,1.276,1.276,0,0,0-.271.429,1.484,1.484,0,0,0-.095.539v.813h-.219a.343.343,0,0,0-.292.128l-.095.263.095.266a.352.352,0,0,0,.292.124h.219v3.849a.334.334,0,0,0,.123.288l.26.089.26-.089a.337.337,0,0,0,.121-.288V97.8h.475a.332.332,0,0,0,.284-.124l.1-.266-.092-.263a.329.329,0,0,0-.29-.128h-.475V96.2a.6.6,0,0,1,.146-.4.479.479,0,0,1,.387-.169.338.338,0,0,0,.288-.122l.1-.268Zm3.3,6.41a.34.34,0,0,0-.263-.133.741.741,0,0,1-.41-.172.51.51,0,0,1-.176-.409V97.8h.545a.335.335,0,0,0,.283-.124l.1-.266-.1-.263a.327.327,0,0,0-.283-.128h-.545V95.238a.352.352,0,0,0-.121-.289l-.262-.1-.26.1a.353.353,0,0,0-.122.289v1.778h-.352a.331.331,0,0,0-.286.128l-.1.263.1.266a.339.339,0,0,0,.286.124h.352v2.891a1.375,1.375,0,0,0,.1.522,1.252,1.252,0,0,0,.281.425,1.3,1.3,0,0,0,.424.289,1.279,1.279,0,0,0,.513.1.356.356,0,0,0,.292-.117l.091-.264Z",
    transform: "translate(-323.753 -94.853)",
    fill: "#c7000e",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1046",
    "data-name": "Grupo 1046",
    transform: "translate(85 -11.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_689",
    "data-name": "Grupo 689",
    transform: "translate(453.733 59.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_673",
    "data-name": "Grupo 673",
    transform: "translate(0 0.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1654",
    "data-name": "Trazado 1654",
    d: "M453.6,59.9h3.85v.757H454.27v2.426h3.151v.758H454.27v3.041h3.151v.758H453.6Z",
    transform: "translate(-453.599 -59.896)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_674",
    "data-name": "Grupo 674",
    transform: "translate(4.905 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1655",
    "data-name": "Trazado 1655",
    d: "M458.24,61.81h.639v1.026a2.849,2.849,0,0,1,.85-.881,1.873,1.873,0,0,1,1.014-.292,1.6,1.6,0,0,1,.989.326,1.9,1.9,0,0,1,.636.878,5.288,5.288,0,0,1,.206,1.721v2.947h-.639V64.8a7.837,7.837,0,0,0-.071-1.32,1.514,1.514,0,0,0-.427-.855,1.171,1.171,0,0,0-.821-.286,1.457,1.457,0,0,0-1.039.442,2.128,2.128,0,0,0-.607,1.094,8.827,8.827,0,0,0-.091,1.558v2.1h-.639Z",
    transform: "translate(-458.24 -61.663)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_675",
    "data-name": "Grupo 675",
    transform: "translate(12.966 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1656",
    "data-name": "Trazado 1656",
    d: "M470.922,63l-.506.364a2.041,2.041,0,0,0-1.794-1.005,1.938,1.938,0,0,0-1.508.672,2.376,2.376,0,0,0-.6,1.635,2.6,2.6,0,0,0,.276,1.176,2.11,2.11,0,0,0,.758.857,1.972,1.972,0,0,0,1.078.3A2.094,2.094,0,0,0,470.416,66l.506.385a2.532,2.532,0,0,1-.957.959,2.724,2.724,0,0,1-1.368.34,2.519,2.519,0,0,1-1.955-.862,3.023,3.023,0,0,1-.776-2.1,3.352,3.352,0,0,1,.363-1.544,2.766,2.766,0,0,1,1-1.113,2.612,2.612,0,0,1,1.42-.4,2.657,2.657,0,0,1,.952.173,2.543,2.543,0,0,1,.779.452A2.378,2.378,0,0,1,470.922,63Z",
    transform: "translate(-465.867 -61.663)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_676",
    "data-name": "Grupo 676",
    transform: "translate(19.102 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1657",
    "data-name": "Trazado 1657",
    d: "M474.267,61.663a2.323,2.323,0,0,1,1.9.957,3.424,3.424,0,0,1-.038,4.164,2.391,2.391,0,0,1-3.734,0,3.415,3.415,0,0,1-.038-4.158A2.322,2.322,0,0,1,474.267,61.663Zm0,.721a1.739,1.739,0,0,0-1.371.679,2.457,2.457,0,0,0-.573,1.641,2.61,2.61,0,0,0,.261,1.157,2.03,2.03,0,0,0,.706.829,1.779,1.779,0,0,0,1.952,0,2.022,2.022,0,0,0,.706-.829,2.623,2.623,0,0,0,.261-1.157,2.453,2.453,0,0,0-.575-1.641A1.741,1.741,0,0,0,474.265,62.384Z",
    transform: "translate(-471.672 -61.663)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_677",
    "data-name": "Grupo 677",
    transform: "translate(25.227 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1658",
    "data-name": "Trazado 1658",
    d: "M480.061,61.663a2.324,2.324,0,0,1,1.9.957,3.424,3.424,0,0,1-.038,4.164,2.391,2.391,0,0,1-3.734,0,3.415,3.415,0,0,1-.038-4.158A2.322,2.322,0,0,1,480.061,61.663Zm0,.721a1.739,1.739,0,0,0-1.371.679,2.457,2.457,0,0,0-.573,1.641,2.609,2.609,0,0,0,.261,1.157,2.022,2.022,0,0,0,.706.829,1.779,1.779,0,0,0,1.952,0,2.021,2.021,0,0,0,.706-.829A2.623,2.623,0,0,0,482,64.7a2.448,2.448,0,0,0-.576-1.641A1.737,1.737,0,0,0,480.06,62.384Z",
    transform: "translate(-477.467 -61.663)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_678",
    "data-name": "Grupo 678",
    transform: "translate(31.603 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1659",
    "data-name": "Trazado 1659",
    d: "M483.5,61.81h.639v1.052a2.737,2.737,0,0,1,.871-.9,2.076,2.076,0,0,1,1.1-.3,2.306,2.306,0,0,1,1.812.878,3.135,3.135,0,0,1,.754,2.115,3.2,3.2,0,0,1-.746,2.145,2.283,2.283,0,0,1-1.8.88,2.154,2.154,0,0,1-1.091-.284,2.855,2.855,0,0,1-.9-.847v3.078H483.5Zm2.558.563a1.764,1.764,0,0,0-1.4.667,2.48,2.48,0,0,0-.568,1.66,2.654,2.654,0,0,0,.253,1.172,2.028,2.028,0,0,0,.725.825,1.806,1.806,0,0,0,1,.3,1.691,1.691,0,0,0,.968-.308,2.138,2.138,0,0,0,.723-.859,2.633,2.633,0,0,0,0-2.313,2.1,2.1,0,0,0-.718-.848A1.733,1.733,0,0,0,486.058,62.373Z",
    transform: "translate(-483.5 -61.663)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_679",
    "data-name": "Grupo 679",
    transform: "translate(37.732 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1660",
    "data-name": "Trazado 1660",
    d: "M493.725,65.635l.539.327a3.442,3.442,0,0,1-.613.968,2.314,2.314,0,0,1-1.764.751,2.239,2.239,0,0,1-1.9-.917,3.51,3.51,0,0,1-.106-4.017,2.276,2.276,0,0,1,1.971-1.083,2.347,2.347,0,0,1,2.029,1.11,3.428,3.428,0,0,1,.549,1.957h-4.472a2.533,2.533,0,0,0,.554,1.635,1.66,1.66,0,0,0,1.321.637,1.964,1.964,0,0,0,1.349-.555A3.417,3.417,0,0,0,493.725,65.635Zm0-1.541a2.607,2.607,0,0,0-.374-.943,1.819,1.819,0,0,0-.646-.568,1.769,1.769,0,0,0-.847-.216,1.69,1.69,0,0,0-1.257.541,2.548,2.548,0,0,0-.581,1.185Z",
    transform: "translate(-489.299 -61.663)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_680",
    "data-name": "Grupo 680",
    transform: "translate(43.811 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1661",
    "data-name": "Trazado 1661",
    d: "M495.05,61.81h.654v.836a2.474,2.474,0,0,1,.616-.739,1.108,1.108,0,0,1,.675-.244,1.054,1.054,0,0,1,.567.194l-.334.62a.79.79,0,0,0-.337-.1.864.864,0,0,0-.616.3,2,2,0,0,0-.452.939A10.351,10.351,0,0,0,495.7,65.6v1.936h-.654Z",
    transform: "translate(-495.05 -61.663)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_681",
    "data-name": "Grupo 681",
    transform: "translate(46.642 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1662",
    "data-name": "Trazado 1662",
    d: "M502.9,61.81v5.724h-.631V66.55a2.845,2.845,0,0,1-.9.847,2.164,2.164,0,0,1-1.093.284,2.286,2.286,0,0,1-1.8-.88,3.206,3.206,0,0,1-.747-2.145,3.136,3.136,0,0,1,.755-2.115,2.31,2.31,0,0,1,1.813-.878,2.1,2.1,0,0,1,1.108.3,2.694,2.694,0,0,1,.87.9V61.81Zm-2.556.563a1.729,1.729,0,0,0-.985.3,2.109,2.109,0,0,0-.72.848,2.629,2.629,0,0,0,0,2.313,2.129,2.129,0,0,0,.723.859,1.705,1.705,0,0,0,.974.308,1.8,1.8,0,0,0,.994-.3,2.018,2.018,0,0,0,.724-.825,2.654,2.654,0,0,0,.253-1.172,2.475,2.475,0,0,0-.568-1.66A1.769,1.769,0,0,0,500.349,62.373Z",
    transform: "translate(-497.729 -61.663)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_682",
    "data-name": "Grupo 682",
    transform: "translate(53.117 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1663",
    "data-name": "Trazado 1663",
    d: "M508.91,63l-.506.364a2.039,2.039,0,0,0-1.793-1.005,1.937,1.937,0,0,0-1.508.672,2.371,2.371,0,0,0-.6,1.635,2.6,2.6,0,0,0,.276,1.176,2.11,2.11,0,0,0,.758.857,1.974,1.974,0,0,0,1.078.3A2.094,2.094,0,0,0,508.4,66l.506.385a2.525,2.525,0,0,1-.956.959,2.724,2.724,0,0,1-1.368.34,2.52,2.52,0,0,1-1.955-.862,3.024,3.024,0,0,1-.776-2.1,3.352,3.352,0,0,1,.363-1.544,2.766,2.766,0,0,1,1-1.113,2.615,2.615,0,0,1,1.42-.4,2.657,2.657,0,0,1,.952.173,2.562,2.562,0,0,1,.78.452A2.378,2.378,0,0,1,508.91,63Z",
    transform: "translate(-503.855 -61.663)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_683",
    "data-name": "Grupo 683",
    transform: "translate(59.1 0.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1664",
    "data-name": "Trazado 1664",
    d: "M510.039,59.572a.479.479,0,0,1,.373.179.636.636,0,0,1,.154.432.629.629,0,0,1-.154.426.476.476,0,0,1-.373.179.471.471,0,0,1-.368-.179.63.63,0,0,1-.155-.426.637.637,0,0,1,.155-.432A.474.474,0,0,1,510.039,59.572Zm-.317,2.357h.639v5.724h-.639Z",
    transform: "translate(-509.516 -59.572)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_684",
    "data-name": "Grupo 684",
    transform: "translate(61.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1665",
    "data-name": "Trazado 1665",
    d: "M514.026,61.8a2.324,2.324,0,0,1,1.9.957,3.424,3.424,0,0,1-.038,4.164,2.391,2.391,0,0,1-3.734,0,3.415,3.415,0,0,1-.038-4.158A2.322,2.322,0,0,1,514.026,61.8Zm0,.721a1.737,1.737,0,0,0-1.37.679,2.457,2.457,0,0,0-.573,1.641A2.608,2.608,0,0,0,512.342,66a2.022,2.022,0,0,0,.706.829,1.779,1.779,0,0,0,1.952,0,2.03,2.03,0,0,0,.706-.829,2.623,2.623,0,0,0,.261-1.157,2.448,2.448,0,0,0-.576-1.641A1.739,1.739,0,0,0,514.024,62.52Zm.318-3.257h.982l-1.348,1.62h-.63Z",
    transform: "translate(-511.432 -59.263)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_685",
    "data-name": "Grupo 685",
    transform: "translate(67.492 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1666",
    "data-name": "Trazado 1666",
    d: "M517.456,61.81h.639v1.026a2.838,2.838,0,0,1,.85-.881,1.873,1.873,0,0,1,1.014-.292,1.6,1.6,0,0,1,.988.326,1.9,1.9,0,0,1,.637.878,5.286,5.286,0,0,1,.206,1.721v2.947h-.639V64.8a7.676,7.676,0,0,0-.072-1.32,1.506,1.506,0,0,0-.426-.855,1.171,1.171,0,0,0-.821-.286,1.46,1.46,0,0,0-1.04.442,2.133,2.133,0,0,0-.606,1.094,8.717,8.717,0,0,0-.091,1.558v2.1h-.639Z",
    transform: "translate(-517.456 -61.663)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_686",
    "data-name": "Grupo 686",
    transform: "translate(75.555 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1667",
    "data-name": "Trazado 1667",
    d: "M530.139,63l-.507.364a2.038,2.038,0,0,0-1.793-1.005,1.938,1.938,0,0,0-1.508.672,2.371,2.371,0,0,0-.6,1.635,2.6,2.6,0,0,0,.276,1.176,2.107,2.107,0,0,0,.757.857,1.978,1.978,0,0,0,1.079.3A2.092,2.092,0,0,0,529.632,66l.507.385a2.539,2.539,0,0,1-.957.959,2.724,2.724,0,0,1-1.368.34,2.517,2.517,0,0,1-1.955-.862,3.024,3.024,0,0,1-.776-2.1,3.364,3.364,0,0,1,.362-1.544,2.768,2.768,0,0,1,1-1.113,2.609,2.609,0,0,1,1.419-.4,2.658,2.658,0,0,1,.953.173,2.544,2.544,0,0,1,.779.452A2.4,2.4,0,0,1,530.139,63Z",
    transform: "translate(-525.084 -61.663)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_687",
    "data-name": "Grupo 687",
    transform: "translate(81.681 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1668",
    "data-name": "Trazado 1668",
    d: "M533.475,61.663a2.324,2.324,0,0,1,1.9.957,3.424,3.424,0,0,1-.038,4.164,2.391,2.391,0,0,1-3.734,0,3.415,3.415,0,0,1-.038-4.158A2.322,2.322,0,0,1,533.475,61.663Zm0,.721a1.739,1.739,0,0,0-1.371.679,2.457,2.457,0,0,0-.573,1.641,2.608,2.608,0,0,0,.261,1.157,2.03,2.03,0,0,0,.706.829,1.779,1.779,0,0,0,1.952,0,2.022,2.022,0,0,0,.706-.829,2.623,2.623,0,0,0,.261-1.157,2.453,2.453,0,0,0-.575-1.641A1.741,1.741,0,0,0,533.473,62.384Z",
    transform: "translate(-530.88 -61.663)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_688",
    "data-name": "Grupo 688",
    transform: "translate(88.048 2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1669",
    "data-name": "Trazado 1669",
    d: "M536.9,61.81h.639v1.026a2.85,2.85,0,0,1,.85-.881,1.873,1.873,0,0,1,1.014-.292,1.6,1.6,0,0,1,.989.326,1.9,1.9,0,0,1,.636.878,5.288,5.288,0,0,1,.206,1.721v2.947H540.6V64.8a7.721,7.721,0,0,0-.071-1.32,1.506,1.506,0,0,0-.427-.855,1.171,1.171,0,0,0-.821-.286,1.457,1.457,0,0,0-1.039.442,2.135,2.135,0,0,0-.607,1.094,8.833,8.833,0,0,0-.091,1.558v2.1H536.9Z",
    transform: "translate(-536.904 -61.663)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_734",
    "data-name": "Grupo 734",
    transform: "translate(451.546 143.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_690",
    "data-name": "Grupo 690",
    transform: "translate(0 0.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1670",
    "data-name": "Trazado 1670",
    d: "M455.7,144.219a4.186,4.186,0,0,1-1.453.215c-1.551,0-2.716-.8-2.716-2.282,0-1.413,1.166-2.37,2.873-2.37a3.509,3.509,0,0,1,1.305.2l-.171.475a3.089,3.089,0,0,0-1.111-.186c-1.289,0-2.146.674-2.146,1.86,0,1.1.775,1.813,2.114,1.813a3.4,3.4,0,0,0,1.158-.186Z",
    transform: "translate(-451.53 -139.782)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_691",
    "data-name": "Grupo 691",
    transform: "translate(4.571 0.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1671",
    "data-name": "Trazado 1671",
    d: "M460.882,142.064a2.33,2.33,0,0,1-2.555,2.376,2.274,2.274,0,0,1-2.472-2.288,2.358,2.358,0,0,1,2.554-2.37A2.258,2.258,0,0,1,460.882,142.064Zm-4.268.074a1.761,1.761,0,1,0,1.763-1.88A1.728,1.728,0,0,0,456.614,142.138Z",
    transform: "translate(-455.855 -139.782)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_692",
    "data-name": "Grupo 692",
    transform: "translate(10.376 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1672",
    "data-name": "Trazado 1672",
    d: "M466.13,142.382c-.041-.63-.09-1.387-.081-1.948h-.025c-.188.528-.415,1.091-.693,1.713l-.971,2.188h-.539l-.89-2.148a17.471,17.471,0,0,1-.635-1.753h-.017c-.016.561-.057,1.318-.106,1.994l-.147,1.934h-.678l.384-4.511h.906l.939,2.182c.228.556.415,1.051.555,1.519h.024a14.854,14.854,0,0,1,.579-1.519l.979-2.182h.907l.342,4.511h-.693Z",
    transform: "translate(-461.347 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_693",
    "data-name": "Grupo 693",
    transform: "translate(17.086 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1673",
    "data-name": "Trazado 1673",
    d: "M468.406,139.852v4.511h-.71v-4.511Z",
    transform: "translate(-467.696 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_694",
    "data-name": "Grupo 694",
    transform: "translate(18.761 0.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1674",
    "data-name": "Trazado 1674",
    d: "M469.46,143.658a2.95,2.95,0,0,0,1.273.294c.726,0,1.151-.315,1.151-.769,0-.422-.294-.663-1.037-.9-.9-.261-1.452-.642-1.452-1.278,0-.7.71-1.225,1.779-1.225a2.942,2.942,0,0,1,1.215.221l-.194.476a2.575,2.575,0,0,0-1.045-.215c-.75,0-1.036.369-1.036.676,0,.422.334.629,1.093.87.93.294,1.4.663,1.4,1.325,0,.7-.628,1.3-1.926,1.3a3.342,3.342,0,0,1-1.4-.287Z",
    transform: "translate(-469.28 -139.782)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_695",
    "data-name": "Grupo 695",
    transform: "translate(23.062 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1675",
    "data-name": "Trazado 1675",
    d: "M474.06,139.852v4.511h-.71v-4.511Z",
    transform: "translate(-473.35 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_696",
    "data-name": "Grupo 696",
    transform: "translate(24.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1676",
    "data-name": "Trazado 1676",
    d: "M479.915,142.116a2.33,2.33,0,0,1-2.555,2.376,2.274,2.274,0,0,1-2.472-2.288,2.358,2.358,0,0,1,2.554-2.37A2.259,2.259,0,0,1,479.915,142.116Zm-4.268.074a1.761,1.761,0,1,0,1.763-1.88A1.728,1.728,0,0,0,475.647,142.19Zm2.946-3.32-1.036.777h-.588l.759-.777Z",
    transform: "translate(-474.888 -138.87)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_697",
    "data-name": "Grupo 697",
    transform: "translate(30.638 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1677",
    "data-name": "Trazado 1677",
    d: "M480.518,144.363v-4.511h.776l1.763,2.282a12.389,12.389,0,0,1,.986,1.466l.017-.007a16.413,16.413,0,0,1-.081-1.854v-1.887h.668v4.511h-.717l-1.747-2.289a13.533,13.533,0,0,1-1.027-1.506l-.025.007c.04.569.057,1.111.057,1.86v1.928Z",
    transform: "translate(-480.518 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_698",
    "data-name": "Grupo 698",
    transform: "translate(37.415 0.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1678",
    "data-name": "Trazado 1678",
    d: "M491.1,144.219a4.191,4.191,0,0,1-1.453.215c-1.551,0-2.717-.8-2.717-2.282,0-1.413,1.167-2.37,2.873-2.37a3.5,3.5,0,0,1,1.305.2l-.171.475a3.087,3.087,0,0,0-1.11-.186c-1.289,0-2.147.674-2.147,1.86,0,1.1.776,1.813,2.114,1.813a3.4,3.4,0,0,0,1.158-.186Z",
    transform: "translate(-486.93 -139.782)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_699",
    "data-name": "Grupo 699",
    transform: "translate(42.476 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1679",
    "data-name": "Trazado 1679",
    d: "M494.566,142.248h-2.138v1.627h2.382v.488h-3.093v-4.511h2.971v.488h-2.261v1.426h2.138Z",
    transform: "translate(-491.718 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_700",
    "data-name": "Grupo 700",
    transform: "translate(46.492 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1680",
    "data-name": "Trazado 1680",
    d: "M495.518,144.363v-4.511h.776l1.763,2.282a12.4,12.4,0,0,1,.986,1.466l.017-.007a16.4,16.4,0,0,1-.081-1.854v-1.887h.668v4.511h-.717l-1.747-2.289a13.532,13.532,0,0,1-1.027-1.506l-.025.007c.04.569.057,1.111.057,1.86v1.928Z",
    transform: "translate(-495.518 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_701",
    "data-name": "Grupo 701",
    transform: "translate(51.236 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1681",
    "data-name": "Trazado 1681",
    d: "M501.679,140.347h-1.673v-.495h4.072v.495H502.4v4.016h-.719Z",
    transform: "translate(-500.006 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_702",
    "data-name": "Grupo 702",
    transform: "translate(55.922 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1682",
    "data-name": "Trazado 1682",
    d: "M504.44,139.914a8.972,8.972,0,0,1,1.362-.094,2.594,2.594,0,0,1,1.592.369,1.033,1.033,0,0,1,.432.856,1.242,1.242,0,0,1-1.036,1.151v.021a1.177,1.177,0,0,1,.807.909,6.165,6.165,0,0,0,.425,1.239h-.736a5.091,5.091,0,0,1-.367-1.078,1,1,0,0,0-1.1-.876h-.669v1.954h-.71Zm.71,2.055h.725c.76,0,1.241-.341,1.241-.856,0-.583-.514-.837-1.264-.843a3.494,3.494,0,0,0-.7.053Z",
    transform: "translate(-504.44 -139.82)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_703",
    "data-name": "Grupo 703",
    transform: "translate(59.988 0.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1683",
    "data-name": "Trazado 1683",
    d: "M513.314,142.064a2.33,2.33,0,0,1-2.555,2.376,2.274,2.274,0,0,1-2.472-2.288,2.358,2.358,0,0,1,2.554-2.37A2.259,2.259,0,0,1,513.314,142.064Zm-4.268.074a1.761,1.761,0,1,0,1.762-1.88A1.728,1.728,0,0,0,509.046,142.138Z",
    transform: "translate(-508.287 -139.782)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_704",
    "data-name": "Grupo 704",
    transform: "translate(65.417 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1684",
    "data-name": "Trazado 1684",
    d: "M514.729,142.944l-.572,1.419h-.735l1.869-4.511h.857l1.877,4.511h-.759l-.588-1.419Zm1.8-.456-.539-1.3c-.122-.295-.2-.561-.285-.823h-.016c-.081.267-.171.542-.278.817l-.539,1.3Z",
    transform: "translate(-513.423 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_705",
    "data-name": "Grupo 705",
    transform: "translate(70.658 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1685",
    "data-name": "Trazado 1685",
    d: "M523.165,142.382c-.041-.63-.09-1.387-.081-1.948h-.025c-.187.528-.415,1.091-.693,1.713l-.971,2.188h-.539l-.889-2.148a17.272,17.272,0,0,1-.636-1.753h-.017c-.016.561-.056,1.318-.106,1.994l-.147,1.934h-.677l.384-4.511h.906l.939,2.182c.228.556.415,1.051.555,1.519h.024a14.883,14.883,0,0,1,.58-1.519l.978-2.182h.907l.342,4.511H523.3Z",
    transform: "translate(-518.382 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_706",
    "data-name": "Grupo 706",
    transform: "translate(77.369 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1686",
    "data-name": "Trazado 1686",
    d: "M527.579,142.248h-2.137v1.627h2.382v.488h-3.093v-4.511H527.7v.488h-2.261v1.426h2.137Z",
    transform: "translate(-524.732 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_707",
    "data-name": "Grupo 707",
    transform: "translate(81.386 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1687",
    "data-name": "Trazado 1687",
    d: "M528.532,139.914a8.973,8.973,0,0,1,1.362-.094,2.6,2.6,0,0,1,1.592.369,1.036,1.036,0,0,1,.432.856,1.243,1.243,0,0,1-1.037,1.151v.021a1.176,1.176,0,0,1,.809.909,6.252,6.252,0,0,0,.424,1.239h-.735a5.088,5.088,0,0,1-.367-1.078,1,1,0,0,0-1.1-.876h-.669v1.954h-.71Zm.71,2.055h.725c.76,0,1.241-.341,1.241-.856,0-.583-.514-.837-1.264-.843a3.493,3.493,0,0,0-.7.053Z",
    transform: "translate(-528.532 -139.82)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_708",
    "data-name": "Grupo 708",
    transform: "translate(85.777 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1688",
    "data-name": "Trazado 1688",
    d: "M533.4,139.852v4.511h-.71v-4.511Z",
    transform: "translate(-532.687 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_709",
    "data-name": "Grupo 709",
    transform: "translate(87.403 0.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1689",
    "data-name": "Trazado 1689",
    d: "M538.4,144.219a4.2,4.2,0,0,1-1.453.215c-1.551,0-2.717-.8-2.717-2.282,0-1.413,1.167-2.37,2.873-2.37a3.5,3.5,0,0,1,1.305.2l-.171.475a3.088,3.088,0,0,0-1.111-.186c-1.288,0-2.146.674-2.146,1.86,0,1.1.776,1.813,2.114,1.813a3.4,3.4,0,0,0,1.158-.186Z",
    transform: "translate(-534.225 -139.782)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_710",
    "data-name": "Grupo 710",
    transform: "translate(92.072 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1690",
    "data-name": "Trazado 1690",
    d: "M539.949,142.944l-.572,1.419h-.734l1.869-4.511h.856l1.878,4.511h-.76l-.588-1.419Zm1.8-.456-.539-1.3c-.122-.295-.205-.561-.286-.823h-.015c-.081.267-.171.542-.278.817l-.539,1.3Z",
    transform: "translate(-538.643 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_711",
    "data-name": "Grupo 711",
    transform: "translate(97.485 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1691",
    "data-name": "Trazado 1691",
    d: "M543.764,144.363v-4.511h.776l1.763,2.282a12.381,12.381,0,0,1,.986,1.466l.017-.007a16.4,16.4,0,0,1-.081-1.854v-1.887h.669v4.511h-.718l-1.747-2.289a13.684,13.684,0,0,1-1.027-1.506l-.025.007c.04.569.057,1.111.057,1.86v1.928Z",
    transform: "translate(-543.764 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_712",
    "data-name": "Grupo 712",
    transform: "translate(102.441 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1692",
    "data-name": "Trazado 1692",
    d: "M549.758,142.944l-.572,1.419h-.733l1.868-4.511h.857l1.877,4.511H552.3l-.588-1.419Zm1.8-.456-.539-1.3c-.122-.295-.2-.561-.285-.823h-.016c-.081.267-.171.542-.277.817l-.539,1.3Z",
    transform: "translate(-548.453 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_713",
    "data-name": "Grupo 713",
    transform: "translate(109.585 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1693",
    "data-name": "Trazado 1693",
    d: "M555.212,139.914a12.27,12.27,0,0,1,1.509-.094,3.628,3.628,0,0,1,2.228.562,1.906,1.906,0,0,1,.775,1.619,2.168,2.168,0,0,1-.792,1.755,3.885,3.885,0,0,1-2.432.649c-.505,0-.93-.021-1.288-.054Zm.709,3.989a5.347,5.347,0,0,0,.718.033c1.519,0,2.343-.7,2.343-1.914.007-1.064-.727-1.74-2.228-1.74a4.861,4.861,0,0,0-.833.06Z",
    transform: "translate(-555.212 -139.82)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_714",
    "data-name": "Grupo 714",
    transform: "translate(115.02 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1694",
    "data-name": "Trazado 1694",
    d: "M563.2,142.248h-2.137v1.627h2.382v.488h-3.093v-4.511h2.971v.488h-2.261v1.426H563.2Z",
    transform: "translate(-560.355 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_715",
    "data-name": "Grupo 715",
    transform: "translate(120.353 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1695",
    "data-name": "Trazado 1695",
    d: "M566.705,142.944l-.572,1.419H565.4l1.869-4.511h.856L570,144.363h-.759l-.589-1.419Zm1.8-.456-.538-1.3c-.123-.295-.205-.561-.286-.823h-.016c-.081.267-.171.542-.277.817l-.539,1.3Z",
    transform: "translate(-565.4 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_716",
    "data-name": "Grupo 716",
    transform: "translate(125.594 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1696",
    "data-name": "Trazado 1696",
    d: "M575.141,142.382c-.041-.63-.09-1.387-.081-1.948h-.024c-.188.528-.417,1.091-.693,1.713l-.971,2.188h-.539l-.89-2.148a17.472,17.472,0,0,1-.635-1.753h-.017c-.017.561-.057,1.318-.107,1.994l-.146,1.934h-.677l.383-4.511h.907l.938,2.182c.228.556.416,1.051.556,1.519h.023a15.148,15.148,0,0,1,.58-1.519l.979-2.182h.906l.344,4.511h-.694Z",
    transform: "translate(-570.359 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_717",
    "data-name": "Grupo 717",
    transform: "translate(132.304 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1697",
    "data-name": "Trazado 1697",
    d: "M576.708,139.914a8.284,8.284,0,0,1,1.3-.094,2.652,2.652,0,0,1,1.51.328.9.9,0,0,1,.457.8c0,.437-.352.818-.93.991v.014a1.259,1.259,0,0,1,1.134,1.131,1.123,1.123,0,0,1-.466.9,3.2,3.2,0,0,1-1.9.423,10.141,10.141,0,0,1-1.1-.054Zm.71,1.848h.644c.752,0,1.192-.322,1.192-.757,0-.528-.49-.736-1.208-.736a3.715,3.715,0,0,0-.628.039Zm0,2.161a4.806,4.806,0,0,0,.6.026c.734,0,1.412-.221,1.412-.876,0-.616-.645-.87-1.421-.87h-.587Z",
    transform: "translate(-576.708 -139.82)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_718",
    "data-name": "Grupo 718",
    transform: "translate(136.729 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1698",
    "data-name": "Trazado 1698",
    d: "M581.6,139.852v4.511h-.71v-4.511Z",
    transform: "translate(-580.894 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_719",
    "data-name": "Grupo 719",
    transform: "translate(138.68 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1699",
    "data-name": "Trazado 1699",
    d: "M585.587,142.248H583.45v1.627h2.382v.488H582.74v-4.511h2.97v.488h-2.26v1.426h2.137Z",
    transform: "translate(-582.74 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_720",
    "data-name": "Grupo 720",
    transform: "translate(142.697 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1700",
    "data-name": "Trazado 1700",
    d: "M586.541,144.363v-4.511h.775l1.763,2.282a12.272,12.272,0,0,1,.987,1.466l.016-.007a16.66,16.66,0,0,1-.081-1.854v-1.887h.669v4.511h-.718l-1.746-2.289a13.691,13.691,0,0,1-1.028-1.506l-.024.007c.04.569.056,1.111.056,1.86v1.928Z",
    transform: "translate(-586.541 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_721",
    "data-name": "Grupo 721",
    transform: "translate(147.44 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1701",
    "data-name": "Trazado 1701",
    d: "M592.7,140.347h-1.673v-.495H595.1v.495H593.42v4.016H592.7Z",
    transform: "translate(-591.028 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_722",
    "data-name": "Grupo 722",
    transform: "translate(152.126 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1702",
    "data-name": "Trazado 1702",
    d: "M598.309,142.248h-2.138v1.627h2.382v.488h-3.092v-4.511h2.97v.488h-2.261v1.426h2.138Z",
    transform: "translate(-595.462 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_723",
    "data-name": "Grupo 723",
    transform: "translate(156.984 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1703",
    "data-name": "Trazado 1703",
    d: "M601.8,144.363v-1.915l-1.739-2.6h.808l.776,1.245c.211.34.375.615.546.93h.016c.155-.295.344-.59.556-.93l.792-1.245h.807l-1.844,2.589v1.921Z",
    transform: "translate(-600.058 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_724",
    "data-name": "Grupo 724",
    transform: "translate(163.644 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1704",
    "data-name": "Trazado 1704",
    d: "M606.36,139.914a12.273,12.273,0,0,1,1.51-.094,3.624,3.624,0,0,1,2.227.562,1.907,1.907,0,0,1,.776,1.619,2.166,2.166,0,0,1-.793,1.755,3.884,3.884,0,0,1-2.431.649c-.506,0-.93-.021-1.289-.054Zm.71,3.989a5.347,5.347,0,0,0,.718.033c1.518,0,2.342-.7,2.342-1.914.007-1.064-.726-1.74-2.228-1.74a4.847,4.847,0,0,0-.832.06Z",
    transform: "translate(-606.36 -139.82)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_725",
    "data-name": "Grupo 725",
    transform: "translate(169.082 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1705",
    "data-name": "Trazado 1705",
    d: "M614.352,142.248h-2.138v1.627H614.6v.488h-3.092v-4.511h2.97v.488h-2.261v1.426h2.138Z",
    transform: "translate(-611.505 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_726",
    "data-name": "Grupo 726",
    transform: "translate(172.822 0.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1706",
    "data-name": "Trazado 1706",
    d: "M615.223,143.658a2.946,2.946,0,0,0,1.273.294c.726,0,1.15-.315,1.15-.769,0-.422-.293-.663-1.036-.9-.9-.261-1.452-.642-1.452-1.278,0-.7.71-1.225,1.779-1.225a2.942,2.942,0,0,1,1.216.221l-.2.476a2.565,2.565,0,0,0-1.044-.215c-.751,0-1.037.369-1.037.676,0,.422.335.629,1.094.87.93.294,1.4.663,1.4,1.325,0,.7-.629,1.3-1.926,1.3a3.342,3.342,0,0,1-1.4-.287Z",
    transform: "translate(-615.043 -139.782)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_727",
    "data-name": "Grupo 727",
    transform: "translate(176.707 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1707",
    "data-name": "Trazado 1707",
    d: "M620.025,142.944l-.572,1.419h-.735l1.869-4.511h.856l1.878,4.511h-.76l-.588-1.419Zm1.8-.456-.539-1.3c-.122-.295-.2-.561-.286-.823h-.015c-.081.267-.171.542-.278.817l-.539,1.3Z",
    transform: "translate(-618.719 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_728",
    "data-name": "Grupo 728",
    transform: "translate(182.12 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1708",
    "data-name": "Trazado 1708",
    d: "M623.84,139.914a8.987,8.987,0,0,1,1.363-.094,2.593,2.593,0,0,1,1.591.369,1.034,1.034,0,0,1,.433.856,1.243,1.243,0,0,1-1.037,1.151v.021a1.178,1.178,0,0,1,.808.909,6.26,6.26,0,0,0,.424,1.239h-.735a5.141,5.141,0,0,1-.368-1.078,1,1,0,0,0-1.1-.876h-.669v1.954h-.71Zm.71,2.055h.726c.76,0,1.241-.341,1.241-.856,0-.583-.515-.837-1.265-.843a3.5,3.5,0,0,0-.7.053Z",
    transform: "translate(-623.84 -139.82)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_729",
    "data-name": "Grupo 729",
    transform: "translate(186.512 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1709",
    "data-name": "Trazado 1709",
    d: "M628,139.914a8.973,8.973,0,0,1,1.362-.094,2.6,2.6,0,0,1,1.592.369,1.036,1.036,0,0,1,.432.856,1.243,1.243,0,0,1-1.037,1.151v.021a1.176,1.176,0,0,1,.809.909,6.248,6.248,0,0,0,.424,1.239h-.735a5.137,5.137,0,0,1-.368-1.078,1,1,0,0,0-1.1-.876h-.668v1.954H628Zm.71,2.055h.725c.76,0,1.241-.341,1.241-.856,0-.583-.514-.837-1.264-.843a3.484,3.484,0,0,0-.7.053Z",
    transform: "translate(-627.996 -139.82)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_730",
    "data-name": "Grupo 730",
    transform: "translate(190.578 0.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1710",
    "data-name": "Trazado 1710",
    d: "M636.87,142.064a2.33,2.33,0,0,1-2.555,2.376,2.274,2.274,0,0,1-2.472-2.288,2.358,2.358,0,0,1,2.553-2.37A2.259,2.259,0,0,1,636.87,142.064Zm-4.268.074a1.761,1.761,0,1,0,1.763-1.88A1.728,1.728,0,0,0,632.6,142.138Z",
    transform: "translate(-631.843 -139.782)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_731",
    "data-name": "Grupo 731",
    transform: "translate(196.529 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1711",
    "data-name": "Trazado 1711",
    d: "M637.473,139.852h.71v4.023h2.351v.488h-3.061Z",
    transform: "translate(-637.473 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_732",
    "data-name": "Grupo 732",
    transform: "translate(200.383 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1712",
    "data-name": "Trazado 1712",
    d: "M641.12,139.852h.71v4.023h2.35v.488h-3.06Z",
    transform: "translate(-641.12 -139.852)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_733",
    "data-name": "Grupo 733",
    transform: "translate(203.6 0.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1713",
    "data-name": "Trazado 1713",
    d: "M649.19,142.064a2.33,2.33,0,0,1-2.555,2.376,2.274,2.274,0,0,1-2.472-2.288,2.358,2.358,0,0,1,2.554-2.37A2.258,2.258,0,0,1,649.19,142.064Zm-4.269.074a1.762,1.762,0,1,0,1.763-1.88A1.728,1.728,0,0,0,644.921,142.138Z",
    transform: "translate(-644.163 -139.782)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1027",
    "data-name": "Grupo 1027",
    transform: "translate(451.251 89.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1026",
    "data-name": "Grupo 1026",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1025",
    "data-name": "Grupo 1025",
    transform: "translate(-0.007 -0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1024",
    "data-name": "Grupo 1024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1023",
    "data-name": "Grupo 1023",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_735",
    "data-name": "Grupo 735",
    transform: "translate(-0.007 -0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1714",
    "data-name": "Trazado 1714",
    d: "M496.488,97.437l-45.251-.014V87.833h45.251Z",
    transform: "translate(-451.237 -87.833)",
    fill: "#00ace8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_736",
    "data-name": "Grupo 736",
    transform: "translate(-0.007 9.591)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_140",
    "data-name": "Rect\\xE1ngulo 140",
    width: 45.251,
    height: 0.154,
    fill: "#00ace8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_737",
    "data-name": "Grupo 737",
    transform: "translate(-0.007 9.745)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_141",
    "data-name": "Rect\\xE1ngulo 141",
    width: 45.251,
    height: 0.154,
    fill: "#07ace6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_738",
    "data-name": "Grupo 738",
    transform: "translate(-0.007 9.899)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_142",
    "data-name": "Rect\\xE1ngulo 142",
    width: 45.251,
    height: 0.154,
    fill: "#0cace5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_739",
    "data-name": "Grupo 739",
    transform: "translate(-0.007 10.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_143",
    "data-name": "Rect\\xE1ngulo 143",
    width: 45.251,
    height: 0.154,
    fill: "#0face4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_740",
    "data-name": "Grupo 740",
    transform: "translate(-0.007 10.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_144",
    "data-name": "Rect\\xE1ngulo 144",
    width: 45.251,
    height: 0.154,
    fill: "#12ace2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_741",
    "data-name": "Grupo 741",
    transform: "translate(-0.007 10.361)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_145",
    "data-name": "Rect\\xE1ngulo 145",
    width: 45.251,
    height: 0.154,
    fill: "#14ace1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_742",
    "data-name": "Grupo 742",
    transform: "translate(-0.007 10.516)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_146",
    "data-name": "Rect\\xE1ngulo 146",
    width: 45.251,
    height: 0.154,
    fill: "#16acdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_743",
    "data-name": "Grupo 743",
    transform: "translate(-0.007 10.67)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_147",
    "data-name": "Rect\\xE1ngulo 147",
    width: 45.251,
    height: 0.154,
    fill: "#18acde"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_744",
    "data-name": "Grupo 744",
    transform: "translate(-0.007 10.824)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_148",
    "data-name": "Rect\\xE1ngulo 148",
    width: 45.251,
    height: 0.154,
    fill: "#1aacdd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_745",
    "data-name": "Grupo 745",
    transform: "translate(-0.007 10.978)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_149",
    "data-name": "Rect\\xE1ngulo 149",
    width: 45.251,
    height: 0.154,
    fill: "#1cacdb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_746",
    "data-name": "Grupo 746",
    transform: "translate(-0.007 11.132)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_150",
    "data-name": "Rect\\xE1ngulo 150",
    width: 45.251,
    height: 0.154,
    fill: "#1dacda"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_747",
    "data-name": "Grupo 747",
    transform: "translate(-0.007 11.287)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_151",
    "data-name": "Rect\\xE1ngulo 151",
    width: 45.251,
    height: 0.154,
    fill: "#1facd8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_748",
    "data-name": "Grupo 748",
    transform: "translate(-0.007 11.441)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_152",
    "data-name": "Rect\\xE1ngulo 152",
    width: 45.251,
    height: 0.154,
    fill: "#20acd7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_749",
    "data-name": "Grupo 749",
    transform: "translate(-0.007 11.595)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_153",
    "data-name": "Rect\\xE1ngulo 153",
    width: 45.251,
    height: 0.154,
    fill: "#22acd5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_750",
    "data-name": "Grupo 750",
    transform: "translate(-0.007 11.749)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_154",
    "data-name": "Rect\\xE1ngulo 154",
    width: 45.251,
    height: 0.154,
    fill: "#23acd4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_751",
    "data-name": "Grupo 751",
    transform: "translate(-0.007 11.903)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_155",
    "data-name": "Rect\\xE1ngulo 155",
    width: 45.251,
    height: 0.154,
    fill: "#24acd3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_752",
    "data-name": "Grupo 752",
    transform: "translate(-0.007 12.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_156",
    "data-name": "Rect\\xE1ngulo 156",
    width: 45.251,
    height: 0.154,
    fill: "#26acd1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_753",
    "data-name": "Grupo 753",
    transform: "translate(-0.007 12.212)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_157",
    "data-name": "Rect\\xE1ngulo 157",
    width: 45.251,
    height: 0.154,
    fill: "#27acd0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_754",
    "data-name": "Grupo 754",
    transform: "translate(-0.007 12.366)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_158",
    "data-name": "Rect\\xE1ngulo 158",
    width: 45.251,
    height: 0.154,
    fill: "#28accf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_755",
    "data-name": "Grupo 755",
    transform: "translate(-0.007 12.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_159",
    "data-name": "Rect\\xE1ngulo 159",
    width: 45.251,
    height: 0.154,
    fill: "#29accd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_756",
    "data-name": "Grupo 756",
    transform: "translate(-0.007 12.674)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_160",
    "data-name": "Rect\\xE1ngulo 160",
    width: 45.251,
    height: 0.154,
    fill: "#2baccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_757",
    "data-name": "Grupo 757",
    transform: "translate(-0.007 12.829)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_161",
    "data-name": "Rect\\xE1ngulo 161",
    width: 45.251,
    height: 0.154,
    fill: "#2cacca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_758",
    "data-name": "Grupo 758",
    transform: "translate(-0.007 12.983)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_162",
    "data-name": "Rect\\xE1ngulo 162",
    width: 45.251,
    height: 0.154,
    fill: "#2dacc9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_759",
    "data-name": "Grupo 759",
    transform: "translate(-0.007 13.137)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_163",
    "data-name": "Rect\\xE1ngulo 163",
    width: 45.251,
    height: 0.154,
    fill: "#2eacc8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_760",
    "data-name": "Grupo 760",
    transform: "translate(-0.007 13.291)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_164",
    "data-name": "Rect\\xE1ngulo 164",
    width: 45.251,
    height: 0.154,
    fill: "#2facc7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_761",
    "data-name": "Grupo 761",
    transform: "translate(-0.007 13.445)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_165",
    "data-name": "Rect\\xE1ngulo 165",
    width: 45.251,
    height: 0.154,
    fill: "#30acc5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_762",
    "data-name": "Grupo 762",
    transform: "translate(-0.007 13.599)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_166",
    "data-name": "Rect\\xE1ngulo 166",
    width: 45.251,
    height: 0.154,
    fill: "#31acc4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_763",
    "data-name": "Grupo 763",
    transform: "translate(-0.007 13.754)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_167",
    "data-name": "Rect\\xE1ngulo 167",
    width: 45.251,
    height: 0.154,
    fill: "#32acc2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_764",
    "data-name": "Grupo 764",
    transform: "translate(-0.007 13.908)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_168",
    "data-name": "Rect\\xE1ngulo 168",
    width: 45.251,
    height: 0.154,
    fill: "#33acc1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_765",
    "data-name": "Grupo 765",
    transform: "translate(-0.007 14.062)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_169",
    "data-name": "Rect\\xE1ngulo 169",
    width: 45.251,
    height: 0.154,
    fill: "#34acc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_766",
    "data-name": "Grupo 766",
    transform: "translate(-0.007 14.216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_170",
    "data-name": "Rect\\xE1ngulo 170",
    width: 45.251,
    height: 0.154,
    fill: "#35acbe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_767",
    "data-name": "Grupo 767",
    transform: "translate(-0.007 14.37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_171",
    "data-name": "Rect\\xE1ngulo 171",
    width: 45.251,
    height: 0.154,
    fill: "#36abbd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_768",
    "data-name": "Grupo 768",
    transform: "translate(-0.007 14.525)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_172",
    "data-name": "Rect\\xE1ngulo 172",
    width: 45.251,
    height: 0.154,
    fill: "#37abbc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_769",
    "data-name": "Grupo 769",
    transform: "translate(-0.007 14.679)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_173",
    "data-name": "Rect\\xE1ngulo 173",
    width: 45.251,
    height: 0.154,
    fill: "#37abba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_770",
    "data-name": "Grupo 770",
    transform: "translate(-0.007 14.833)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_174",
    "data-name": "Rect\\xE1ngulo 174",
    width: 45.251,
    height: 0.154,
    fill: "#38abb9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_771",
    "data-name": "Grupo 771",
    transform: "translate(-0.007 14.987)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_175",
    "data-name": "Rect\\xE1ngulo 175",
    width: 45.251,
    height: 0.154,
    fill: "#39abb8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_772",
    "data-name": "Grupo 772",
    transform: "translate(-0.007 15.141)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_176",
    "data-name": "Rect\\xE1ngulo 176",
    width: 45.251,
    height: 0.154,
    fill: "#3aabb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_773",
    "data-name": "Grupo 773",
    transform: "translate(-0.007 15.296)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_177",
    "data-name": "Rect\\xE1ngulo 177",
    width: 45.251,
    height: 0.154,
    fill: "#3babb5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_774",
    "data-name": "Grupo 774",
    transform: "translate(-0.007 15.45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_178",
    "data-name": "Rect\\xE1ngulo 178",
    width: 45.251,
    height: 0.154,
    fill: "#3cabb4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_775",
    "data-name": "Grupo 775",
    transform: "translate(-0.007 15.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_179",
    "data-name": "Rect\\xE1ngulo 179",
    width: 45.251,
    height: 0.154,
    fill: "#3cabb2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_776",
    "data-name": "Grupo 776",
    transform: "translate(-0.007 15.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_180",
    "data-name": "Rect\\xE1ngulo 180",
    width: 45.251,
    height: 0.154,
    fill: "#3dabb1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_777",
    "data-name": "Grupo 777",
    transform: "translate(-0.007 15.912)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_181",
    "data-name": "Rect\\xE1ngulo 181",
    width: 45.251,
    height: 0.154,
    fill: "#3eabb0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_778",
    "data-name": "Grupo 778",
    transform: "translate(-0.007 16.067)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_182",
    "data-name": "Rect\\xE1ngulo 182",
    width: 45.251,
    height: 0.154,
    fill: "#3fabae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_779",
    "data-name": "Grupo 779",
    transform: "translate(-0.007 16.221)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_183",
    "data-name": "Rect\\xE1ngulo 183",
    width: 45.251,
    height: 0.154,
    fill: "#3fabad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_780",
    "data-name": "Grupo 780",
    transform: "translate(-0.007 16.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_184",
    "data-name": "Rect\\xE1ngulo 184",
    width: 45.251,
    height: 0.154,
    fill: "#40abac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_781",
    "data-name": "Grupo 781",
    transform: "translate(-0.007 16.529)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_185",
    "data-name": "Rect\\xE1ngulo 185",
    width: 45.251,
    height: 0.154,
    fill: "#41abab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_782",
    "data-name": "Grupo 782",
    transform: "translate(-0.007 16.683)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_186",
    "data-name": "Rect\\xE1ngulo 186",
    width: 45.251,
    height: 0.154,
    fill: "#41aba9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_783",
    "data-name": "Grupo 783",
    transform: "translate(-0.007 16.837)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_187",
    "data-name": "Rect\\xE1ngulo 187",
    width: 45.251,
    height: 0.154,
    fill: "#42aba8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_784",
    "data-name": "Grupo 784",
    transform: "translate(-0.007 16.992)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_188",
    "data-name": "Rect\\xE1ngulo 188",
    width: 45.251,
    height: 0.154,
    fill: "#43aba7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_785",
    "data-name": "Grupo 785",
    transform: "translate(-0.007 17.146)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_189",
    "data-name": "Rect\\xE1ngulo 189",
    width: 45.251,
    height: 0.154,
    fill: "#43aba6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_786",
    "data-name": "Grupo 786",
    transform: "translate(-0.007 17.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_190",
    "data-name": "Rect\\xE1ngulo 190",
    width: 45.251,
    height: 0.154,
    fill: "#44aba5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_787",
    "data-name": "Grupo 787",
    transform: "translate(-0.007 17.454)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_191",
    "data-name": "Rect\\xE1ngulo 191",
    width: 45.251,
    height: 0.154,
    fill: "#45aba3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_788",
    "data-name": "Grupo 788",
    transform: "translate(-0.007 17.608)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_192",
    "data-name": "Rect\\xE1ngulo 192",
    width: 45.251,
    height: 0.154,
    fill: "#45aba2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_789",
    "data-name": "Grupo 789",
    transform: "translate(-0.007 17.763)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_193",
    "data-name": "Rect\\xE1ngulo 193",
    width: 45.251,
    height: 0.154,
    fill: "#46aba1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_790",
    "data-name": "Grupo 790",
    transform: "translate(-0.007 17.917)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_194",
    "data-name": "Rect\\xE1ngulo 194",
    width: 45.251,
    height: 0.154,
    fill: "#47aba0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_791",
    "data-name": "Grupo 791",
    transform: "translate(-0.007 18.071)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_195",
    "data-name": "Rect\\xE1ngulo 195",
    width: 45.251,
    height: 0.154,
    fill: "#47ab9e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_792",
    "data-name": "Grupo 792",
    transform: "translate(-0.007 18.225)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_196",
    "data-name": "Rect\\xE1ngulo 196",
    width: 45.251,
    height: 0.154,
    fill: "#48ab9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_793",
    "data-name": "Grupo 793",
    transform: "translate(-0.007 18.379)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_197",
    "data-name": "Rect\\xE1ngulo 197",
    width: 45.251,
    height: 0.154,
    fill: "#48ab9c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_794",
    "data-name": "Grupo 794",
    transform: "translate(-0.007 18.534)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_198",
    "data-name": "Rect\\xE1ngulo 198",
    width: 45.251,
    height: 0.154,
    fill: "#49ab9b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_795",
    "data-name": "Grupo 795",
    transform: "translate(-0.007 18.688)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_199",
    "data-name": "Rect\\xE1ngulo 199",
    width: 45.251,
    height: 0.154,
    fill: "#4aab9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_796",
    "data-name": "Grupo 796",
    transform: "translate(-0.007 18.842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_200",
    "data-name": "Rect\\xE1ngulo 200",
    width: 45.251,
    height: 0.154,
    fill: "#4aab98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_797",
    "data-name": "Grupo 797",
    transform: "translate(-0.007 18.996)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_201",
    "data-name": "Rect\\xE1ngulo 201",
    width: 45.251,
    height: 0.154,
    fill: "#4bab97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_798",
    "data-name": "Grupo 798",
    transform: "translate(-0.007 19.15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_202",
    "data-name": "Rect\\xE1ngulo 202",
    width: 45.251,
    height: 0.154,
    fill: "#4bab96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_799",
    "data-name": "Grupo 799",
    transform: "translate(-0.007 19.305)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_203",
    "data-name": "Rect\\xE1ngulo 203",
    width: 45.251,
    height: 0.154,
    fill: "#4cab95"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_800",
    "data-name": "Grupo 800",
    transform: "translate(-0.007 19.459)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_204",
    "data-name": "Rect\\xE1ngulo 204",
    width: 45.251,
    height: 0.154,
    fill: "#4cab94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_801",
    "data-name": "Grupo 801",
    transform: "translate(-0.007 19.613)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_205",
    "data-name": "Rect\\xE1ngulo 205",
    width: 45.251,
    height: 0.154,
    fill: "#4dab93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_802",
    "data-name": "Grupo 802",
    transform: "translate(-0.007 19.767)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_206",
    "data-name": "Rect\\xE1ngulo 206",
    width: 45.251,
    height: 0.154,
    fill: "#4dab91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_803",
    "data-name": "Grupo 803",
    transform: "translate(-0.007 19.921)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_207",
    "data-name": "Rect\\xE1ngulo 207",
    width: 45.251,
    height: 0.154,
    fill: "#4eab90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_804",
    "data-name": "Grupo 804",
    transform: "translate(-0.007 20.076)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_208",
    "data-name": "Rect\\xE1ngulo 208",
    width: 45.251,
    height: 0.154,
    fill: "#4eab8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_805",
    "data-name": "Grupo 805",
    transform: "translate(-0.007 20.23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_209",
    "data-name": "Rect\\xE1ngulo 209",
    width: 45.251,
    height: 0.154,
    fill: "#4fab8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_806",
    "data-name": "Grupo 806",
    transform: "translate(-0.007 20.384)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_210",
    "data-name": "Rect\\xE1ngulo 210",
    width: 45.251,
    height: 0.154,
    fill: "#4fab8d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_807",
    "data-name": "Grupo 807",
    transform: "translate(-0.007 20.538)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_211",
    "data-name": "Rect\\xE1ngulo 211",
    width: 45.251,
    height: 0.154,
    fill: "#50ab8c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_808",
    "data-name": "Grupo 808",
    transform: "translate(-0.007 20.692)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_212",
    "data-name": "Rect\\xE1ngulo 212",
    width: 45.251,
    height: 0.154,
    fill: "#50ab8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_809",
    "data-name": "Grupo 809",
    transform: "translate(-0.007 20.846)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_213",
    "data-name": "Rect\\xE1ngulo 213",
    width: 45.251,
    height: 0.154,
    fill: "#51ab89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_810",
    "data-name": "Grupo 810",
    transform: "translate(-0.007 21.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_214",
    "data-name": "Rect\\xE1ngulo 214",
    width: 45.251,
    height: 0.154,
    fill: "#51ab88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_811",
    "data-name": "Grupo 811",
    transform: "translate(-0.007 21.155)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_215",
    "data-name": "Rect\\xE1ngulo 215",
    width: 45.251,
    height: 0.154,
    fill: "#52ab87"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_812",
    "data-name": "Grupo 812",
    transform: "translate(-0.007 21.309)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_216",
    "data-name": "Rect\\xE1ngulo 216",
    width: 45.251,
    height: 0.154,
    fill: "#52ab86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_813",
    "data-name": "Grupo 813",
    transform: "translate(-0.007 21.463)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_217",
    "data-name": "Rect\\xE1ngulo 217",
    width: 45.251,
    height: 0.154,
    fill: "#53ab85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_814",
    "data-name": "Grupo 814",
    transform: "translate(-0.007 21.617)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_218",
    "data-name": "Rect\\xE1ngulo 218",
    width: 45.251,
    height: 0.154,
    fill: "#53ab84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_815",
    "data-name": "Grupo 815",
    transform: "translate(-0.007 21.772)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_219",
    "data-name": "Rect\\xE1ngulo 219",
    width: 45.251,
    height: 0.154,
    fill: "#54ab83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_816",
    "data-name": "Grupo 816",
    transform: "translate(-0.007 21.926)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_220",
    "data-name": "Rect\\xE1ngulo 220",
    width: 45.251,
    height: 0.154,
    fill: "#54ab82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_817",
    "data-name": "Grupo 817",
    transform: "translate(-0.007 22.08)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_221",
    "data-name": "Rect\\xE1ngulo 221",
    width: 45.251,
    height: 0.154,
    fill: "#55aa81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_818",
    "data-name": "Grupo 818",
    transform: "translate(-0.007 22.234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_222",
    "data-name": "Rect\\xE1ngulo 222",
    width: 45.251,
    height: 0.154,
    fill: "#55aa80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_819",
    "data-name": "Grupo 819",
    transform: "translate(-0.007 22.388)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_223",
    "data-name": "Rect\\xE1ngulo 223",
    width: 45.251,
    height: 0.154,
    fill: "#55aa7f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_820",
    "data-name": "Grupo 820",
    transform: "translate(-0.007 22.543)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_224",
    "data-name": "Rect\\xE1ngulo 224",
    width: 45.251,
    height: 0.154,
    fill: "#56aa7d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_821",
    "data-name": "Grupo 821",
    transform: "translate(-0.007 22.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_225",
    "data-name": "Rect\\xE1ngulo 225",
    width: 45.251,
    height: 0.154,
    fill: "#56aa7c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_822",
    "data-name": "Grupo 822",
    transform: "translate(-0.007 22.851)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_226",
    "data-name": "Rect\\xE1ngulo 226",
    width: 45.251,
    height: 0.154,
    fill: "#57aa7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_823",
    "data-name": "Grupo 823",
    transform: "translate(-0.007 23.005)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_227",
    "data-name": "Rect\\xE1ngulo 227",
    width: 45.251,
    height: 0.154,
    fill: "#57aa7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_824",
    "data-name": "Grupo 824",
    transform: "translate(-0.007 23.159)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_228",
    "data-name": "Rect\\xE1ngulo 228",
    width: 45.251,
    height: 0.154,
    fill: "#58aa79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_825",
    "data-name": "Grupo 825",
    transform: "translate(-0.007 23.314)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_229",
    "data-name": "Rect\\xE1ngulo 229",
    width: 45.251,
    height: 0.154,
    fill: "#58aa78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_826",
    "data-name": "Grupo 826",
    transform: "translate(-0.007 23.468)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_230",
    "data-name": "Rect\\xE1ngulo 230",
    width: 45.251,
    height: 0.154,
    fill: "#58aa77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_827",
    "data-name": "Grupo 827",
    transform: "translate(-0.007 23.622)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_231",
    "data-name": "Rect\\xE1ngulo 231",
    width: 45.251,
    height: 0.154,
    fill: "#59aa76"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_828",
    "data-name": "Grupo 828",
    transform: "translate(-0.007 23.776)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_232",
    "data-name": "Rect\\xE1ngulo 232",
    width: 45.251,
    height: 0.154,
    fill: "#59aa75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_829",
    "data-name": "Grupo 829",
    transform: "translate(-0.007 23.93)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_233",
    "data-name": "Rect\\xE1ngulo 233",
    width: 45.251,
    height: 0.154,
    fill: "#59aa74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_830",
    "data-name": "Grupo 830",
    transform: "translate(-0.007 24.084)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_234",
    "data-name": "Rect\\xE1ngulo 234",
    width: 45.251,
    height: 0.154,
    fill: "#5aaa73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_831",
    "data-name": "Grupo 831",
    transform: "translate(-0.007 24.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_235",
    "data-name": "Rect\\xE1ngulo 235",
    width: 45.251,
    height: 0.154,
    fill: "#5aaa72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_832",
    "data-name": "Grupo 832",
    transform: "translate(-0.007 24.393)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_236",
    "data-name": "Rect\\xE1ngulo 236",
    width: 45.251,
    height: 0.154,
    fill: "#5baa71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_833",
    "data-name": "Grupo 833",
    transform: "translate(-0.007 24.547)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_237",
    "data-name": "Rect\\xE1ngulo 237",
    width: 45.251,
    height: 0.154,
    fill: "#5baa70"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_834",
    "data-name": "Grupo 834",
    transform: "translate(-0.007 24.701)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_238",
    "data-name": "Rect\\xE1ngulo 238",
    width: 45.251,
    height: 0.154,
    fill: "#5baa6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_835",
    "data-name": "Grupo 835",
    transform: "translate(-0.007 24.855)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_239",
    "data-name": "Rect\\xE1ngulo 239",
    width: 45.251,
    height: 0.154,
    fill: "#5caa6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_836",
    "data-name": "Grupo 836",
    transform: "translate(-0.007 25.01)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_240",
    "data-name": "Rect\\xE1ngulo 240",
    width: 45.251,
    height: 0.154,
    fill: "#5caa6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_837",
    "data-name": "Grupo 837",
    transform: "translate(-0.007 25.164)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_241",
    "data-name": "Rect\\xE1ngulo 241",
    width: 45.251,
    height: 0.154,
    fill: "#5caa6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_838",
    "data-name": "Grupo 838",
    transform: "translate(-0.007 25.318)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_242",
    "data-name": "Rect\\xE1ngulo 242",
    width: 45.251,
    height: 0.154,
    fill: "#5daa6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_839",
    "data-name": "Grupo 839",
    transform: "translate(-0.007 25.472)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_243",
    "data-name": "Rect\\xE1ngulo 243",
    width: 45.251,
    height: 0.154,
    fill: "#5daa6a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_840",
    "data-name": "Grupo 840",
    transform: "translate(-0.007 25.626)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_244",
    "data-name": "Rect\\xE1ngulo 244",
    width: 45.251,
    height: 0.154,
    fill: "#5daa69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_841",
    "data-name": "Grupo 841",
    transform: "translate(-0.007 25.781)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_245",
    "data-name": "Rect\\xE1ngulo 245",
    width: 45.251,
    height: 0.154,
    fill: "#5eaa68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_842",
    "data-name": "Grupo 842",
    transform: "translate(-0.007 25.935)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_246",
    "data-name": "Rect\\xE1ngulo 246",
    width: 45.251,
    height: 0.154,
    fill: "#5eaa67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_843",
    "data-name": "Grupo 843",
    transform: "translate(-0.007 26.089)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_247",
    "data-name": "Rect\\xE1ngulo 247",
    width: 45.251,
    height: 0.154,
    fill: "#5eaa66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_844",
    "data-name": "Grupo 844",
    transform: "translate(-0.007 26.243)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_248",
    "data-name": "Rect\\xE1ngulo 248",
    width: 45.251,
    height: 0.154,
    fill: "#5faa65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_845",
    "data-name": "Grupo 845",
    transform: "translate(-0.007 26.397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_249",
    "data-name": "Rect\\xE1ngulo 249",
    width: 45.251,
    height: 0.154,
    fill: "#5faa64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_846",
    "data-name": "Grupo 846",
    transform: "translate(-0.007 26.552)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_250",
    "data-name": "Rect\\xE1ngulo 250",
    width: 45.251,
    height: 0.154,
    fill: "#5faa63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_847",
    "data-name": "Grupo 847",
    transform: "translate(-0.007 26.706)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_251",
    "data-name": "Rect\\xE1ngulo 251",
    width: 45.251,
    height: 0.154,
    fill: "#5faa62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_848",
    "data-name": "Grupo 848",
    transform: "translate(-0.007 26.86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_252",
    "data-name": "Rect\\xE1ngulo 252",
    width: 45.251,
    height: 0.154,
    fill: "#60aa62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_849",
    "data-name": "Grupo 849",
    transform: "translate(-0.007 27.014)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_253",
    "data-name": "Rect\\xE1ngulo 253",
    width: 45.251,
    height: 0.154,
    fill: "#60aa61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_850",
    "data-name": "Grupo 850",
    transform: "translate(-0.007 27.168)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_254",
    "data-name": "Rect\\xE1ngulo 254",
    width: 45.251,
    height: 0.154,
    fill: "#60aa60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_851",
    "data-name": "Grupo 851",
    transform: "translate(-0.007 27.322)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_255",
    "data-name": "Rect\\xE1ngulo 255",
    width: 45.251,
    height: 0.154,
    fill: "#61aa5f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_852",
    "data-name": "Grupo 852",
    transform: "translate(-0.007 27.477)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_256",
    "data-name": "Rect\\xE1ngulo 256",
    width: 45.251,
    height: 0.154,
    fill: "#61aa5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_853",
    "data-name": "Grupo 853",
    transform: "translate(-0.007 27.631)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_257",
    "data-name": "Rect\\xE1ngulo 257",
    width: 45.251,
    height: 0.154,
    fill: "#61aa5d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_854",
    "data-name": "Grupo 854",
    transform: "translate(-0.007 27.785)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_258",
    "data-name": "Rect\\xE1ngulo 258",
    width: 45.251,
    height: 0.154,
    fill: "#61aa5c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_855",
    "data-name": "Grupo 855",
    transform: "translate(-0.007 27.939)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_259",
    "data-name": "Rect\\xE1ngulo 259",
    width: 45.251,
    height: 0.154,
    fill: "#62aa5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_856",
    "data-name": "Grupo 856",
    transform: "translate(-0.007 28.093)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_260",
    "data-name": "Rect\\xE1ngulo 260",
    width: 45.251,
    height: 0.154,
    fill: "#62aa5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_857",
    "data-name": "Grupo 857",
    transform: "translate(-0.007 28.248)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_261",
    "data-name": "Rect\\xE1ngulo 261",
    width: 45.251,
    height: 0.154,
    fill: "#62aa5a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_858",
    "data-name": "Grupo 858",
    transform: "translate(-0.007 28.402)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_262",
    "data-name": "Rect\\xE1ngulo 262",
    width: 45.251,
    height: 0.154,
    fill: "#62aa59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_859",
    "data-name": "Grupo 859",
    transform: "translate(-0.007 28.556)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_263",
    "data-name": "Rect\\xE1ngulo 263",
    width: 45.251,
    height: 0.154,
    fill: "#63aa58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_860",
    "data-name": "Grupo 860",
    transform: "translate(-0.007 28.71)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_264",
    "data-name": "Rect\\xE1ngulo 264",
    width: 45.251,
    height: 0.154,
    fill: "#63aa57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_861",
    "data-name": "Grupo 861",
    transform: "translate(-0.007 28.864)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_265",
    "data-name": "Rect\\xE1ngulo 265",
    width: 45.251,
    height: 0.154,
    fill: "#63aa56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_862",
    "data-name": "Grupo 862",
    transform: "translate(-0.007 29.019)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_266",
    "data-name": "Rect\\xE1ngulo 266",
    width: 45.251,
    height: 0.154,
    fill: "#63aa56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_863",
    "data-name": "Grupo 863",
    transform: "translate(-0.007 29.173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_267",
    "data-name": "Rect\\xE1ngulo 267",
    width: 45.251,
    height: 0.154,
    fill: "#64aa55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_864",
    "data-name": "Grupo 864",
    transform: "translate(-0.007 29.327)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_268",
    "data-name": "Rect\\xE1ngulo 268",
    width: 45.251,
    height: 0.154,
    fill: "#64aa54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_865",
    "data-name": "Grupo 865",
    transform: "translate(-0.007 29.481)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_269",
    "data-name": "Rect\\xE1ngulo 269",
    width: 45.251,
    height: 0.154,
    fill: "#64a953"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_866",
    "data-name": "Grupo 866",
    transform: "translate(-0.007 29.635)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_270",
    "data-name": "Rect\\xE1ngulo 270",
    width: 45.251,
    height: 0.154,
    fill: "#64a952"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_867",
    "data-name": "Grupo 867",
    transform: "translate(-0.007 29.79)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_271",
    "data-name": "Rect\\xE1ngulo 271",
    width: 45.251,
    height: 0.154,
    fill: "#65a952"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_868",
    "data-name": "Grupo 868",
    transform: "translate(-0.007 29.944)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_272",
    "data-name": "Rect\\xE1ngulo 272",
    width: 45.251,
    height: 0.154,
    fill: "#65a951"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_869",
    "data-name": "Grupo 869",
    transform: "translate(-0.007 30.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_273",
    "data-name": "Rect\\xE1ngulo 273",
    width: 45.251,
    height: 0.154,
    fill: "#65a950"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_870",
    "data-name": "Grupo 870",
    transform: "translate(-0.007 30.252)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_274",
    "data-name": "Rect\\xE1ngulo 274",
    width: 45.251,
    height: 0.154,
    fill: "#65a94f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_871",
    "data-name": "Grupo 871",
    transform: "translate(-0.007 30.406)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_275",
    "data-name": "Rect\\xE1ngulo 275",
    width: 45.251,
    height: 0.154,
    fill: "#65a94f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_872",
    "data-name": "Grupo 872",
    transform: "translate(-0.007 30.56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_276",
    "data-name": "Rect\\xE1ngulo 276",
    width: 45.251,
    height: 0.154,
    fill: "#66a94e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_873",
    "data-name": "Grupo 873",
    transform: "translate(-0.007 30.715)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_277",
    "data-name": "Rect\\xE1ngulo 277",
    width: 45.251,
    height: 0.154,
    fill: "#66a94d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_874",
    "data-name": "Grupo 874",
    transform: "translate(-0.007 30.869)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_278",
    "data-name": "Rect\\xE1ngulo 278",
    width: 45.251,
    height: 0.154,
    fill: "#66a94c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_875",
    "data-name": "Grupo 875",
    transform: "translate(-0.007 31.023)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_279",
    "data-name": "Rect\\xE1ngulo 279",
    width: 45.251,
    height: 0.154,
    fill: "#66a94c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_876",
    "data-name": "Grupo 876",
    transform: "translate(-0.007 31.177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_280",
    "data-name": "Rect\\xE1ngulo 280",
    width: 45.251,
    height: 0.154,
    fill: "#66a94b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_877",
    "data-name": "Grupo 877",
    transform: "translate(-0.007 31.331)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_281",
    "data-name": "Rect\\xE1ngulo 281",
    width: 45.251,
    height: 0.154,
    fill: "#67a94a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_878",
    "data-name": "Grupo 878",
    transform: "translate(-0.007 31.486)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_282",
    "data-name": "Rect\\xE1ngulo 282",
    width: 45.251,
    height: 0.154,
    fill: "#67a94a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_879",
    "data-name": "Grupo 879",
    transform: "translate(-0.007 31.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_283",
    "data-name": "Rect\\xE1ngulo 283",
    width: 45.251,
    height: 0.154,
    fill: "#67a949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_880",
    "data-name": "Grupo 880",
    transform: "translate(-0.007 31.794)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_284",
    "data-name": "Rect\\xE1ngulo 284",
    width: 45.251,
    height: 0.154,
    fill: "#67a948"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_881",
    "data-name": "Grupo 881",
    transform: "translate(-0.007 31.948)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_285",
    "data-name": "Rect\\xE1ngulo 285",
    width: 45.251,
    height: 0.154,
    fill: "#67a947"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_882",
    "data-name": "Grupo 882",
    transform: "translate(-0.007 32.102)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_286",
    "data-name": "Rect\\xE1ngulo 286",
    width: 45.251,
    height: 0.154,
    fill: "#68a947"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_883",
    "data-name": "Grupo 883",
    transform: "translate(-0.007 32.257)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_287",
    "data-name": "Rect\\xE1ngulo 287",
    width: 45.251,
    height: 0.154,
    fill: "#68a946"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_884",
    "data-name": "Grupo 884",
    transform: "translate(-0.007 32.411)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_288",
    "data-name": "Rect\\xE1ngulo 288",
    width: 45.251,
    height: 0.154,
    fill: "#68a945"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_885",
    "data-name": "Grupo 885",
    transform: "translate(-0.007 32.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_289",
    "data-name": "Rect\\xE1ngulo 289",
    width: 45.251,
    height: 0.154,
    fill: "#68a945"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_886",
    "data-name": "Grupo 886",
    transform: "translate(-0.007 32.719)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_290",
    "data-name": "Rect\\xE1ngulo 290",
    width: 45.251,
    height: 0.154,
    fill: "#68a944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_887",
    "data-name": "Grupo 887",
    transform: "translate(-0.007 32.873)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_291",
    "data-name": "Rect\\xE1ngulo 291",
    width: 45.251,
    height: 0.154,
    fill: "#68a943"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_888",
    "data-name": "Grupo 888",
    transform: "translate(-0.007 33.028)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_292",
    "data-name": "Rect\\xE1ngulo 292",
    width: 45.251,
    height: 0.154,
    fill: "#69a943"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_889",
    "data-name": "Grupo 889",
    transform: "translate(-0.007 33.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_293",
    "data-name": "Rect\\xE1ngulo 293",
    width: 45.251,
    height: 0.154,
    fill: "#69a942"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_890",
    "data-name": "Grupo 890",
    transform: "translate(-0.007 33.336)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_294",
    "data-name": "Rect\\xE1ngulo 294",
    width: 45.251,
    height: 0.154,
    fill: "#69a942"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_891",
    "data-name": "Grupo 891",
    transform: "translate(-0.007 33.49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_295",
    "data-name": "Rect\\xE1ngulo 295",
    width: 45.251,
    height: 0.154,
    fill: "#69a941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_892",
    "data-name": "Grupo 892",
    transform: "translate(-0.007 33.644)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_296",
    "data-name": "Rect\\xE1ngulo 296",
    width: 45.251,
    height: 0.154,
    fill: "#69a940"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_893",
    "data-name": "Grupo 893",
    transform: "translate(-0.007 33.798)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_297",
    "data-name": "Rect\\xE1ngulo 297",
    width: 45.251,
    height: 0.154,
    fill: "#69a940"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_894",
    "data-name": "Grupo 894",
    transform: "translate(-0.007 33.953)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_298",
    "data-name": "Rect\\xE1ngulo 298",
    width: 45.251,
    height: 0.154,
    fill: "#6aa93f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_895",
    "data-name": "Grupo 895",
    transform: "translate(-0.007 34.107)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_299",
    "data-name": "Rect\\xE1ngulo 299",
    width: 45.251,
    height: 0.154,
    fill: "#6aa93f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_896",
    "data-name": "Grupo 896",
    transform: "translate(-0.007 34.261)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_300",
    "data-name": "Rect\\xE1ngulo 300",
    width: 45.251,
    height: 0.154,
    fill: "#6aa93e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_897",
    "data-name": "Grupo 897",
    transform: "translate(-0.007 34.415)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_301",
    "data-name": "Rect\\xE1ngulo 301",
    width: 45.251,
    height: 0.154,
    fill: "#6aa93e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_898",
    "data-name": "Grupo 898",
    transform: "translate(-0.007 34.569)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_302",
    "data-name": "Rect\\xE1ngulo 302",
    width: 45.251,
    height: 0.154,
    fill: "#6aa93d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_899",
    "data-name": "Grupo 899",
    transform: "translate(-0.007 34.724)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_303",
    "data-name": "Rect\\xE1ngulo 303",
    width: 45.251,
    height: 0.154,
    fill: "#6aa93d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_900",
    "data-name": "Grupo 900",
    transform: "translate(-0.007 34.878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_304",
    "data-name": "Rect\\xE1ngulo 304",
    width: 45.251,
    height: 0.154,
    fill: "#6aa93c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_901",
    "data-name": "Grupo 901",
    transform: "translate(-0.007 35.032)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_305",
    "data-name": "Rect\\xE1ngulo 305",
    width: 45.251,
    height: 0.154,
    fill: "#6aa93b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_902",
    "data-name": "Grupo 902",
    transform: "translate(-0.007 35.186)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_306",
    "data-name": "Rect\\xE1ngulo 306",
    width: 45.251,
    height: 0.154,
    fill: "#6ba93b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_903",
    "data-name": "Grupo 903",
    transform: "translate(-0.007 35.34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_307",
    "data-name": "Rect\\xE1ngulo 307",
    width: 45.251,
    height: 0.154,
    fill: "#6ba93a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_904",
    "data-name": "Grupo 904",
    transform: "translate(-0.007 35.495)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_308",
    "data-name": "Rect\\xE1ngulo 308",
    width: 45.251,
    height: 0.154,
    fill: "#6ba93a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_905",
    "data-name": "Grupo 905",
    transform: "translate(-0.007 35.649)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_309",
    "data-name": "Rect\\xE1ngulo 309",
    width: 45.251,
    height: 0.154,
    fill: "#6ba939"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_906",
    "data-name": "Grupo 906",
    transform: "translate(-0.007 35.803)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_310",
    "data-name": "Rect\\xE1ngulo 310",
    width: 45.251,
    height: 0.154,
    fill: "#6ba939"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_907",
    "data-name": "Grupo 907",
    transform: "translate(-0.007 35.957)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_311",
    "data-name": "Rect\\xE1ngulo 311",
    width: 45.251,
    height: 0.154,
    fill: "#6ba939"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_908",
    "data-name": "Grupo 908",
    transform: "translate(-0.007 36.111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_312",
    "data-name": "Rect\\xE1ngulo 312",
    width: 45.251,
    height: 0.154,
    fill: "#6ba938"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_909",
    "data-name": "Grupo 909",
    transform: "translate(-0.007 36.266)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_313",
    "data-name": "Rect\\xE1ngulo 313",
    width: 45.251,
    height: 0.154,
    fill: "#6ba938"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_910",
    "data-name": "Grupo 910",
    transform: "translate(-0.007 36.42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_314",
    "data-name": "Rect\\xE1ngulo 314",
    width: 45.251,
    height: 0.154,
    fill: "#6ca937"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_911",
    "data-name": "Grupo 911",
    transform: "translate(-0.007 36.574)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_315",
    "data-name": "Rect\\xE1ngulo 315",
    width: 45.251,
    height: 0.154,
    fill: "#6ca937"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_912",
    "data-name": "Grupo 912",
    transform: "translate(-0.007 36.728)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_316",
    "data-name": "Rect\\xE1ngulo 316",
    width: 45.251,
    height: 0.154,
    fill: "#6ca936"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_913",
    "data-name": "Grupo 913",
    transform: "translate(-0.007 36.882)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_317",
    "data-name": "Rect\\xE1ngulo 317",
    width: 45.251,
    height: 0.154,
    fill: "#6ca936"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_914",
    "data-name": "Grupo 914",
    transform: "translate(-0.007 37.036)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_318",
    "data-name": "Rect\\xE1ngulo 318",
    width: 45.251,
    height: 0.154,
    fill: "#6ca935"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_915",
    "data-name": "Grupo 915",
    transform: "translate(-0.007 37.191)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_319",
    "data-name": "Rect\\xE1ngulo 319",
    width: 45.251,
    height: 0.154,
    fill: "#6ca935"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_916",
    "data-name": "Grupo 916",
    transform: "translate(-0.007 37.345)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_320",
    "data-name": "Rect\\xE1ngulo 320",
    width: 45.251,
    height: 0.154,
    fill: "#6ca935"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_917",
    "data-name": "Grupo 917",
    transform: "translate(-0.007 37.499)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_321",
    "data-name": "Rect\\xE1ngulo 321",
    width: 45.251,
    height: 0.154,
    fill: "#6ca934"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_918",
    "data-name": "Grupo 918",
    transform: "translate(-0.007 37.653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_322",
    "data-name": "Rect\\xE1ngulo 322",
    width: 45.251,
    height: 0.154,
    fill: "#6ca934"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_919",
    "data-name": "Grupo 919",
    transform: "translate(-0.007 37.807)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_323",
    "data-name": "Rect\\xE1ngulo 323",
    width: 45.251,
    height: 0.154,
    fill: "#6ca933"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_920",
    "data-name": "Grupo 920",
    transform: "translate(-0.007 37.962)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_324",
    "data-name": "Rect\\xE1ngulo 324",
    width: 45.251,
    height: 0.154,
    fill: "#6ca933"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_921",
    "data-name": "Grupo 921",
    transform: "translate(-0.007 38.116)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_325",
    "data-name": "Rect\\xE1ngulo 325",
    width: 45.251,
    height: 0.154,
    fill: "#6da933"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_922",
    "data-name": "Grupo 922",
    transform: "translate(-0.007 38.27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_326",
    "data-name": "Rect\\xE1ngulo 326",
    width: 45.251,
    height: 0.154,
    fill: "#6da932"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_923",
    "data-name": "Grupo 923",
    transform: "translate(-0.007 38.424)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_327",
    "data-name": "Rect\\xE1ngulo 327",
    width: 45.251,
    height: 0.154,
    fill: "#6da932"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_924",
    "data-name": "Grupo 924",
    transform: "translate(-0.007 38.578)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_328",
    "data-name": "Rect\\xE1ngulo 328",
    width: 45.251,
    height: 0.154,
    fill: "#6da932"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_925",
    "data-name": "Grupo 925",
    transform: "translate(-0.007 38.733)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_329",
    "data-name": "Rect\\xE1ngulo 329",
    width: 45.251,
    height: 0.154,
    fill: "#6da931"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_926",
    "data-name": "Grupo 926",
    transform: "translate(-0.007 38.887)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_330",
    "data-name": "Rect\\xE1ngulo 330",
    width: 45.251,
    height: 0.154,
    fill: "#6da931"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_927",
    "data-name": "Grupo 927",
    transform: "translate(-0.007 39.041)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_331",
    "data-name": "Rect\\xE1ngulo 331",
    width: 45.251,
    height: 0.154,
    fill: "#6da931"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_928",
    "data-name": "Grupo 928",
    transform: "translate(-0.007 39.195)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_332",
    "data-name": "Rect\\xE1ngulo 332",
    width: 45.251,
    height: 0.154,
    fill: "#6da930"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_929",
    "data-name": "Grupo 929",
    transform: "translate(-0.007 39.349)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_333",
    "data-name": "Rect\\xE1ngulo 333",
    width: 45.251,
    height: 0.154,
    fill: "#6da930"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_930",
    "data-name": "Grupo 930",
    transform: "translate(-0.007 39.504)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_334",
    "data-name": "Rect\\xE1ngulo 334",
    width: 45.251,
    height: 0.154,
    fill: "#6da930"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_931",
    "data-name": "Grupo 931",
    transform: "translate(-0.007 39.658)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_335",
    "data-name": "Rect\\xE1ngulo 335",
    width: 45.251,
    height: 0.154,
    fill: "#6da92f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_932",
    "data-name": "Grupo 932",
    transform: "translate(-0.007 39.812)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_336",
    "data-name": "Rect\\xE1ngulo 336",
    width: 45.251,
    height: 0.154,
    fill: "#6da92f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_933",
    "data-name": "Grupo 933",
    transform: "translate(-0.007 39.966)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_337",
    "data-name": "Rect\\xE1ngulo 337",
    width: 45.251,
    height: 0.154,
    fill: "#6da92f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_934",
    "data-name": "Grupo 934",
    transform: "translate(-0.007 40.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_338",
    "data-name": "Rect\\xE1ngulo 338",
    width: 45.251,
    height: 0.154,
    fill: "#6da92e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_935",
    "data-name": "Grupo 935",
    transform: "translate(-0.007 40.274)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_339",
    "data-name": "Rect\\xE1ngulo 339",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_936",
    "data-name": "Grupo 936",
    transform: "translate(-0.007 40.429)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_340",
    "data-name": "Rect\\xE1ngulo 340",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_937",
    "data-name": "Grupo 937",
    transform: "translate(-0.007 40.583)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_341",
    "data-name": "Rect\\xE1ngulo 341",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_938",
    "data-name": "Grupo 938",
    transform: "translate(-0.007 40.737)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_342",
    "data-name": "Rect\\xE1ngulo 342",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_939",
    "data-name": "Grupo 939",
    transform: "translate(-0.007 40.891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_343",
    "data-name": "Rect\\xE1ngulo 343",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_940",
    "data-name": "Grupo 940",
    transform: "translate(-0.007 41.045)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_344",
    "data-name": "Rect\\xE1ngulo 344",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_941",
    "data-name": "Grupo 941",
    transform: "translate(-0.007 41.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_345",
    "data-name": "Rect\\xE1ngulo 345",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_942",
    "data-name": "Grupo 942",
    transform: "translate(-0.007 41.354)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_346",
    "data-name": "Rect\\xE1ngulo 346",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_943",
    "data-name": "Grupo 943",
    transform: "translate(-0.007 41.508)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_347",
    "data-name": "Rect\\xE1ngulo 347",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_944",
    "data-name": "Grupo 944",
    transform: "translate(-0.007 41.662)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_348",
    "data-name": "Rect\\xE1ngulo 348",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_945",
    "data-name": "Grupo 945",
    transform: "translate(-0.007 41.816)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_349",
    "data-name": "Rect\\xE1ngulo 349",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_946",
    "data-name": "Grupo 946",
    transform: "translate(-0.007 41.971)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_350",
    "data-name": "Rect\\xE1ngulo 350",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_947",
    "data-name": "Grupo 947",
    transform: "translate(-0.007 42.125)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_351",
    "data-name": "Rect\\xE1ngulo 351",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_948",
    "data-name": "Grupo 948",
    transform: "translate(-0.007 42.279)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_352",
    "data-name": "Rect\\xE1ngulo 352",
    width: 45.251,
    height: 0.154,
    fill: "#6ea92b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_949",
    "data-name": "Grupo 949",
    transform: "translate(-0.007 42.433)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_353",
    "data-name": "Rect\\xE1ngulo 353",
    width: 45.251,
    height: 0.154,
    fill: "#6eaa2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_950",
    "data-name": "Grupo 950",
    transform: "translate(-0.007 42.587)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_354",
    "data-name": "Rect\\xE1ngulo 354",
    width: 45.251,
    height: 0.154,
    fill: "#6eaa2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_951",
    "data-name": "Grupo 951",
    transform: "translate(-0.007 42.742)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_355",
    "data-name": "Rect\\xE1ngulo 355",
    width: 45.251,
    height: 0.154,
    fill: "#6eaa2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_952",
    "data-name": "Grupo 952",
    transform: "translate(-0.007 42.896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_356",
    "data-name": "Rect\\xE1ngulo 356",
    width: 45.251,
    height: 0.154,
    fill: "#6eaa2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_953",
    "data-name": "Grupo 953",
    transform: "translate(-0.007 43.05)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_357",
    "data-name": "Rect\\xE1ngulo 357",
    width: 45.251,
    height: 0.154,
    fill: "#6eaa2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_954",
    "data-name": "Grupo 954",
    transform: "translate(-0.007 43.204)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_358",
    "data-name": "Rect\\xE1ngulo 358",
    width: 45.251,
    height: 0.154,
    fill: "#6eaa2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_955",
    "data-name": "Grupo 955",
    transform: "translate(-0.007 43.358)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_359",
    "data-name": "Rect\\xE1ngulo 359",
    width: 45.251,
    height: 0.154,
    fill: "#6eaa2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_956",
    "data-name": "Grupo 956",
    transform: "translate(-0.007 43.512)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_360",
    "data-name": "Rect\\xE1ngulo 360",
    width: 45.251,
    height: 0.154,
    fill: "#6eaa2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_957",
    "data-name": "Grupo 957",
    transform: "translate(-0.007 43.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_361",
    "data-name": "Rect\\xE1ngulo 361",
    width: 45.251,
    height: 0.154,
    fill: "#6eaa2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_958",
    "data-name": "Grupo 958",
    transform: "translate(-0.007 43.821)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_362",
    "data-name": "Rect\\xE1ngulo 362",
    width: 45.251,
    height: 0.154,
    fill: "#6faa2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_959",
    "data-name": "Grupo 959",
    transform: "translate(-0.007 43.975)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_363",
    "data-name": "Rect\\xE1ngulo 363",
    width: 45.251,
    height: 0.154,
    fill: "#6faa2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_960",
    "data-name": "Grupo 960",
    transform: "translate(-0.007 44.129)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_364",
    "data-name": "Rect\\xE1ngulo 364",
    width: 45.251,
    height: 0.154,
    fill: "#6faa29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_961",
    "data-name": "Grupo 961",
    transform: "translate(-0.007 44.283)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_365",
    "data-name": "Rect\\xE1ngulo 365",
    width: 45.251,
    height: 0.154,
    fill: "#6faa29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_962",
    "data-name": "Grupo 962",
    transform: "translate(-0.007 44.438)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_366",
    "data-name": "Rect\\xE1ngulo 366",
    width: 45.251,
    height: 0.154,
    fill: "#6faa29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_963",
    "data-name": "Grupo 963",
    transform: "translate(-0.007 44.592)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_367",
    "data-name": "Rect\\xE1ngulo 367",
    width: 45.251,
    height: 0.154,
    fill: "#6faa29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_964",
    "data-name": "Grupo 964",
    transform: "translate(-0.007 44.746)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_368",
    "data-name": "Rect\\xE1ngulo 368",
    width: 45.251,
    height: 0.154,
    fill: "#6faa29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_965",
    "data-name": "Grupo 965",
    transform: "translate(-0.007 44.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_369",
    "data-name": "Rect\\xE1ngulo 369",
    width: 45.251,
    height: 0.154,
    fill: "#6faa29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_966",
    "data-name": "Grupo 966",
    transform: "translate(-0.007 45.054)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_370",
    "data-name": "Rect\\xE1ngulo 370",
    width: 45.251,
    height: 0.154,
    fill: "#6faa29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_967",
    "data-name": "Grupo 967",
    transform: "translate(-0.007 45.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_371",
    "data-name": "Rect\\xE1ngulo 371",
    width: 45.251,
    height: 0.154,
    fill: "#6faa29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_968",
    "data-name": "Grupo 968",
    transform: "translate(-0.007 45.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_372",
    "data-name": "Rect\\xE1ngulo 372",
    width: 45.251,
    height: 0.154,
    fill: "#6faa29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_969",
    "data-name": "Grupo 969",
    transform: "translate(-0.007 45.517)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_373",
    "data-name": "Rect\\xE1ngulo 373",
    width: 45.251,
    height: 0.154,
    fill: "#6faa29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_970",
    "data-name": "Grupo 970",
    transform: "translate(-0.007 45.671)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_374",
    "data-name": "Rect\\xE1ngulo 374",
    width: 45.251,
    height: 0.154,
    fill: "#6faa29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_971",
    "data-name": "Grupo 971",
    transform: "translate(-0.007 45.825)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_375",
    "data-name": "Rect\\xE1ngulo 375",
    width: 45.251,
    height: 0.154,
    fill: "#6faa29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_972",
    "data-name": "Grupo 972",
    transform: "translate(-0.007 45.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_376",
    "data-name": "Rect\\xE1ngulo 376",
    width: 45.251,
    height: 0.035,
    fill: "#6faa29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_973",
    "data-name": "Grupo 973",
    transform: "translate(-0.007 46.015)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_377",
    "data-name": "Rect\\xE1ngulo 377",
    width: 45.251,
    height: 0.035,
    fill: "#6eaa2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_974",
    "data-name": "Grupo 974",
    transform: "translate(-0.007 46.05)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_378",
    "data-name": "Rect\\xE1ngulo 378",
    width: 45.251,
    height: 0.035,
    fill: "#6eaa2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_975",
    "data-name": "Grupo 975",
    transform: "translate(-0.007 46.085)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_379",
    "data-name": "Rect\\xE1ngulo 379",
    width: 45.251,
    height: 0.035,
    fill: "#6ea92b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_976",
    "data-name": "Grupo 976",
    transform: "translate(-0.007 46.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_380",
    "data-name": "Rect\\xE1ngulo 380",
    width: 45.251,
    height: 0.035,
    fill: "#6ea92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_977",
    "data-name": "Grupo 977",
    transform: "translate(-0.007 46.155)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_381",
    "data-name": "Rect\\xE1ngulo 381",
    width: 45.251,
    height: 0.035,
    fill: "#6ea92d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_978",
    "data-name": "Grupo 978",
    transform: "translate(-0.007 46.19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_382",
    "data-name": "Rect\\xE1ngulo 382",
    width: 45.251,
    height: 0.035,
    fill: "#6ea92e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_979",
    "data-name": "Grupo 979",
    transform: "translate(-0.007 46.225)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_383",
    "data-name": "Rect\\xE1ngulo 383",
    width: 45.251,
    height: 0.035,
    fill: "#6da92f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_980",
    "data-name": "Grupo 980",
    transform: "translate(-0.007 46.261)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_384",
    "data-name": "Rect\\xE1ngulo 384",
    width: 45.251,
    height: 0.035,
    fill: "#6da930"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_981",
    "data-name": "Grupo 981",
    transform: "translate(-0.007 46.296)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_385",
    "data-name": "Rect\\xE1ngulo 385",
    width: 45.251,
    height: 0.035,
    fill: "#6da930"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_982",
    "data-name": "Grupo 982",
    transform: "translate(-0.007 46.331)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_386",
    "data-name": "Rect\\xE1ngulo 386",
    width: 45.251,
    height: 0.035,
    fill: "#6da931"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_983",
    "data-name": "Grupo 983",
    transform: "translate(-0.007 46.366)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_387",
    "data-name": "Rect\\xE1ngulo 387",
    width: 45.251,
    height: 0.035,
    fill: "#6da932"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_984",
    "data-name": "Grupo 984",
    transform: "translate(-0.007 46.401)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_388",
    "data-name": "Rect\\xE1ngulo 388",
    width: 45.251,
    height: 0.035,
    fill: "#6da933"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_985",
    "data-name": "Grupo 985",
    transform: "translate(-0.007 46.436)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_389",
    "data-name": "Rect\\xE1ngulo 389",
    width: 45.251,
    height: 0.035,
    fill: "#6ca934"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_986",
    "data-name": "Grupo 986",
    transform: "translate(-0.007 46.471)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_390",
    "data-name": "Rect\\xE1ngulo 390",
    width: 45.251,
    height: 0.035,
    fill: "#6ca934"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_987",
    "data-name": "Grupo 987",
    transform: "translate(-0.007 46.506)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_391",
    "data-name": "Rect\\xE1ngulo 391",
    width: 45.251,
    height: 0.035,
    fill: "#6ca935"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_988",
    "data-name": "Grupo 988",
    transform: "translate(-0.007 46.542)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_392",
    "data-name": "Rect\\xE1ngulo 392",
    width: 45.251,
    height: 0.035,
    fill: "#6ca936"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_989",
    "data-name": "Grupo 989",
    transform: "translate(-0.007 46.577)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_393",
    "data-name": "Rect\\xE1ngulo 393",
    width: 45.251,
    height: 0.035,
    fill: "#6ca937"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_990",
    "data-name": "Grupo 990",
    transform: "translate(-0.007 46.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_394",
    "data-name": "Rect\\xE1ngulo 394",
    width: 45.251,
    height: 0.035,
    fill: "#6ba938"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_991",
    "data-name": "Grupo 991",
    transform: "translate(-0.007 46.647)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_395",
    "data-name": "Rect\\xE1ngulo 395",
    width: 45.251,
    height: 0.035,
    fill: "#6ba939"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_992",
    "data-name": "Grupo 992",
    transform: "translate(-0.007 46.682)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_396",
    "data-name": "Rect\\xE1ngulo 396",
    width: 45.251,
    height: 0.035,
    fill: "#6ba939"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_993",
    "data-name": "Grupo 993",
    transform: "translate(-0.007 46.717)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_397",
    "data-name": "Rect\\xE1ngulo 397",
    width: 45.251,
    height: 0.035,
    fill: "#6ba93a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_994",
    "data-name": "Grupo 994",
    transform: "translate(-0.007 46.752)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_398",
    "data-name": "Rect\\xE1ngulo 398",
    width: 45.251,
    height: 0.035,
    fill: "#6ba93b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_995",
    "data-name": "Grupo 995",
    transform: "translate(-0.007 46.787)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_399",
    "data-name": "Rect\\xE1ngulo 399",
    width: 45.251,
    height: 0.035,
    fill: "#6aa93c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_996",
    "data-name": "Grupo 996",
    transform: "translate(-0.007 46.823)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_400",
    "data-name": "Rect\\xE1ngulo 400",
    width: 45.251,
    height: 0.035,
    fill: "#6aa93d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_997",
    "data-name": "Grupo 997",
    transform: "translate(-0.007 46.858)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_401",
    "data-name": "Rect\\xE1ngulo 401",
    width: 45.251,
    height: 0.035,
    fill: "#6aa93e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_998",
    "data-name": "Grupo 998",
    transform: "translate(-0.007 46.893)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_402",
    "data-name": "Rect\\xE1ngulo 402",
    width: 45.251,
    height: 0.035,
    fill: "#6aa93e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_999",
    "data-name": "Grupo 999",
    transform: "translate(-0.007 46.928)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_403",
    "data-name": "Rect\\xE1ngulo 403",
    width: 45.251,
    height: 0.035,
    fill: "#6aa93f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1000",
    "data-name": "Grupo 1000",
    transform: "translate(-0.007 46.963)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_404",
    "data-name": "Rect\\xE1ngulo 404",
    width: 45.251,
    height: 0.035,
    fill: "#69a940"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1001",
    "data-name": "Grupo 1001",
    transform: "translate(-0.007 46.998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_405",
    "data-name": "Rect\\xE1ngulo 405",
    width: 45.251,
    height: 0.035,
    fill: "#69a941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1002",
    "data-name": "Grupo 1002",
    transform: "translate(-0.007 47.033)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_406",
    "data-name": "Rect\\xE1ngulo 406",
    width: 45.251,
    height: 0.035,
    fill: "#69a942"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1003",
    "data-name": "Grupo 1003",
    transform: "translate(-0.007 47.069)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_407",
    "data-name": "Rect\\xE1ngulo 407",
    width: 45.251,
    height: 0.035,
    fill: "#69a943"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1004",
    "data-name": "Grupo 1004",
    transform: "translate(-0.007 47.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_408",
    "data-name": "Rect\\xE1ngulo 408",
    width: 45.251,
    height: 0.035,
    fill: "#69a943"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1005",
    "data-name": "Grupo 1005",
    transform: "translate(-0.007 47.139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_409",
    "data-name": "Rect\\xE1ngulo 409",
    width: 45.251,
    height: 0.035,
    fill: "#68a944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1006",
    "data-name": "Grupo 1006",
    transform: "translate(-0.007 47.174)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_410",
    "data-name": "Rect\\xE1ngulo 410",
    width: 45.251,
    height: 0.035,
    fill: "#68a945"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1007",
    "data-name": "Grupo 1007",
    transform: "translate(-0.007 47.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_411",
    "data-name": "Rect\\xE1ngulo 411",
    width: 45.251,
    height: 0.035,
    fill: "#68a946"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1008",
    "data-name": "Grupo 1008",
    transform: "translate(-0.007 47.244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_412",
    "data-name": "Rect\\xE1ngulo 412",
    width: 45.251,
    height: 0.035,
    fill: "#68a947"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1009",
    "data-name": "Grupo 1009",
    transform: "translate(-0.007 47.279)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_413",
    "data-name": "Rect\\xE1ngulo 413",
    width: 45.251,
    height: 0.035,
    fill: "#67a948"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1010",
    "data-name": "Grupo 1010",
    transform: "translate(-0.007 47.314)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_414",
    "data-name": "Rect\\xE1ngulo 414",
    width: 45.251,
    height: 0.035,
    fill: "#67a949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1011",
    "data-name": "Grupo 1011",
    transform: "translate(-0.007 47.35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_415",
    "data-name": "Rect\\xE1ngulo 415",
    width: 45.251,
    height: 0.035,
    fill: "#67a949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1012",
    "data-name": "Grupo 1012",
    transform: "translate(-0.007 47.385)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_416",
    "data-name": "Rect\\xE1ngulo 416",
    width: 45.251,
    height: 0.035,
    fill: "#67a94a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1013",
    "data-name": "Grupo 1013",
    transform: "translate(-0.007 47.42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_417",
    "data-name": "Rect\\xE1ngulo 417",
    width: 45.251,
    height: 0.035,
    fill: "#67a94b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1014",
    "data-name": "Grupo 1014",
    transform: "translate(-0.007 47.455)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_418",
    "data-name": "Rect\\xE1ngulo 418",
    width: 45.251,
    height: 0.035,
    fill: "#66a94c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1015",
    "data-name": "Grupo 1015",
    transform: "translate(-0.007 47.49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_419",
    "data-name": "Rect\\xE1ngulo 419",
    width: 45.251,
    height: 0.035,
    fill: "#66a94d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1016",
    "data-name": "Grupo 1016",
    transform: "translate(-0.007 47.525)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_420",
    "data-name": "Rect\\xE1ngulo 420",
    width: 45.251,
    height: 0.035,
    fill: "#66a94e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1017",
    "data-name": "Grupo 1017",
    transform: "translate(-0.007 47.56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_421",
    "data-name": "Rect\\xE1ngulo 421",
    width: 45.251,
    height: 0.035,
    fill: "#66a94f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1018",
    "data-name": "Grupo 1018",
    transform: "translate(-0.007 47.595)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_422",
    "data-name": "Rect\\xE1ngulo 422",
    width: 45.251,
    height: 0.035,
    fill: "#65a950"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1019",
    "data-name": "Grupo 1019",
    transform: "translate(-0.007 47.631)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_423",
    "data-name": "Rect\\xE1ngulo 423",
    width: 45.251,
    height: 0.035,
    fill: "#65a950"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1020",
    "data-name": "Grupo 1020",
    transform: "translate(-0.007 47.666)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_424",
    "data-name": "Rect\\xE1ngulo 424",
    width: 45.251,
    height: 0.035,
    fill: "#65aa51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1021",
    "data-name": "Grupo 1021",
    transform: "translate(-0.007 47.701)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_425",
    "data-name": "Rect\\xE1ngulo 425",
    width: 45.251,
    height: 0.035,
    fill: "#65aa52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1022",
    "data-name": "Grupo 1022",
    transform: "translate(-0.007 47.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1715",
    "data-name": "Trazado 1715",
    d: "M451.237,133l45.251.014H451.237Z",
    transform: "translate(-451.237 -132.997)",
    fill: "#64aa53"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1028",
    "data-name": "Grupo 1028",
    transform: "translate(505.29 92.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1717",
    "data-name": "Trazado 1717",
    d: "M533.426,128.445a19.118,19.118,0,0,1-7.98,1.6c-8.933,0-14.266-5.818-14.266-15.563,0-10.024,5.424-16.008,14.511-16.008a17.064,17.064,0,0,1,7.613,1.6l1.709.856,2.163-7.557-1.122-.6c-1.166-.628-4.525-2.088-10.546-2.088-13.616,0-23.128,9.864-23.128,23.988,0,14.073,8.622,23.165,21.966,23.165,5.428,0,9.563-1.137,11.622-2.2l1.115-.576-1.892-7.5Z",
    transform: "translate(-499.486 -90.685)",
    fill: "#1e5422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1718",
    "data-name": "Trazado 1718",
    d: "M557.6,98.476a17.061,17.061,0,0,1,7.613,1.6l1.709.856,2.164-7.557-1.124-.6c-1.165-.628-4.525-2.088-10.545-2.088-13.617,0-23.129,9.864-23.129,23.988,0,14.073,8.622,23.165,21.966,23.165,5.429,0,9.563-1.137,11.622-2.2l1.116-.576-1.892-7.5-1.765.887a19.118,19.118,0,0,1-7.98,1.6c-8.933,0-14.266-5.818-14.266-15.563C543.088,104.46,548.513,98.476,557.6,98.476Z",
    transform: "translate(-491.563 -90.685)",
    fill: "#1e5422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1719",
    "data-name": "Trazado 1719",
    d: "M582.3,91.343l-15.058,45.825H576.1l4.284-13.417h12.323l4.406,13.417h9.031L591.024,91.343Zm8.261,24.935h-8.047l3.368-10.29c.212-.691.422-1.4.631-2.141.211.728.441,1.471.692,2.235Z",
    transform: "translate(-484.686 -90.648)",
    fill: "#1e5422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1720",
    "data-name": "Trazado 1720",
    d: "M636.93,96.8c-4.022-3.876-9.846-5.759-17.81-5.759a75.427,75.427,0,0,0-11.566.9l-1.34.209v44.725l1.4.164a85.281,85.281,0,0,0,9.854.518c8.487,0,15.188-2.289,19.37-6.612,4.181-4.255,6.391-10.373,6.391-17.692C643.229,106.3,641.107,100.763,636.93,96.8Zm-18.421,33.16c-1.107,0-2.561-.016-3.8-.123V98.885a31.687,31.687,0,0,1,4.658-.3c4.987,0,8.815,1.308,11.378,3.888,2.513,2.529,3.774,6.22,3.745,10.982C634.488,124.254,628.962,129.964,618.508,129.964Z",
    transform: "translate(-476.468 -90.665)",
    fill: "#1e5422"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1045",
    "data-name": "Grupo 1045",
    transform: "translate(458.108 96.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1030",
    "data-name": "Grupo 1030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1029",
    "data-name": "Grupo 1029"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1721",
    "data-name": "Trazado 1721",
    d: "M457.738,94.588v15.526h7.555l-6.264-7.763,6.742-7.763Z",
    transform: "translate(-457.738 -94.588)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1032",
    "data-name": "Grupo 1032",
    transform: "translate(16.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1031",
    "data-name": "Grupo 1031"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1722",
    "data-name": "Trazado 1722",
    d: "M473.029,94.588v15.526h7.555l-6.263-7.763,6.742-7.763Z",
    transform: "translate(-473.029 -94.588)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1034",
    "data-name": "Grupo 1034",
    transform: "translate(23.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1033",
    "data-name": "Grupo 1033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1723",
    "data-name": "Trazado 1723",
    d: "M487.426,94.588l-7.746,7.636,7.746,7.89Z",
    transform: "translate(-479.679 -94.588)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1036",
    "data-name": "Grupo 1036",
    transform: "translate(16.161 17.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1035",
    "data-name": "Grupo 1035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1724",
    "data-name": "Trazado 1724",
    d: "M473.029,111.2l7.029,7.585-7.029,8.57Z",
    transform: "translate(-473.029 -111.205)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1038",
    "data-name": "Grupo 1038",
    transform: "translate(23.19 17.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1037",
    "data-name": "Grupo 1037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1725",
    "data-name": "Trazado 1725",
    d: "M479.68,111.2h7.746v16.018H479.68l6.614-8.433Z",
    transform: "translate(-479.68 -111.205)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1040",
    "data-name": "Grupo 1040",
    transform: "translate(0 25.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1039",
    "data-name": "Grupo 1039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1726",
    "data-name": "Trazado 1726",
    d: "M472.561,126.814l-7.077-8.433-7.745,8.433Z",
    transform: "translate(-457.739 -118.381)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1042",
    "data-name": "Grupo 1042",
    transform: "translate(0 17.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1041",
    "data-name": "Grupo 1041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1727",
    "data-name": "Trazado 1727",
    d: "M457.738,118.789V111.2h14.822v7.585l-7.411-6.6Z",
    transform: "translate(-457.738 -111.205)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1044",
    "data-name": "Grupo 1044",
    transform: "translate(7.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1043",
    "data-name": "Grupo 1043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1728",
    "data-name": "Trazado 1728",
    d: "M472.162,94.588l-7.411,7.636,7.411,7.89Z",
    transform: "translate(-464.751 -94.588)",
    fill: "#161615"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1377",
    "data-name": "Grupo 1377",
    transform: "translate(141.312 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1048",
    "data-name": "Grupo 1048",
    transform: "translate(671.134 87.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1047",
    "data-name": "Grupo 1047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1729",
    "data-name": "Trazado 1729",
    d: "M731.617,117.914a30.241,30.241,0,1,1-30.241-30.242,30.242,30.242,0,0,1,30.241,30.242",
    transform: "translate(-671.134 -87.672)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1050",
    "data-name": "Grupo 1050",
    transform: "translate(677.425 93.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1049",
    "data-name": "Grupo 1049"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1730",
    "data-name": "Trazado 1730",
    d: "M677.044,117.106a23.767,23.767,0,1,1,23.767,23.775,23.771,23.771,0,0,1-23.767-23.775",
    transform: "translate(-677.044 -93.331)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1052",
    "data-name": "Grupo 1052",
    transform: "translate(684.846 131.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1051",
    "data-name": "Grupo 1051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1731",
    "data-name": "Trazado 1731",
    d: "M686.063,130.329l-.347-.275a.522.522,0,0,0,.11-.344.471.471,0,0,0-.162-.3.491.491,0,0,0-.3-.161.267.267,0,0,0-.228.078.19.19,0,0,0-.061.129.368.368,0,0,0,.049.183c.026.048.088.155.191.319a1.209,1.209,0,0,1,.21.511.584.584,0,0,1-.165.466.577.577,0,0,1-.292.164.59.59,0,0,1-.358-.031,1.075,1.075,0,0,1-.368-.248.926.926,0,0,1-.325-.571.659.659,0,0,1,.185-.512l.335.3a.391.391,0,0,0-.084.265.447.447,0,0,0,.152.25.5.5,0,0,0,.276.153.161.161,0,0,0,.147-.049.181.181,0,0,0,.047-.146,1.176,1.176,0,0,0-.193-.394,2.239,2.239,0,0,1-.238-.453.636.636,0,0,1-.019-.333.706.706,0,0,1,.509-.5.643.643,0,0,1,.391.031,1.3,1.3,0,0,1,.407.278.972.972,0,0,1,.331.593.84.84,0,0,1-.2.6",
    transform: "translate(-684.016 -128.813)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1054",
    "data-name": "Grupo 1054",
    transform: "translate(683.576 130.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1053",
    "data-name": "Grupo 1053",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1732",
    "data-name": "Trazado 1732",
    d: "M684.822,127.973l-1.709,1.435-.291-.347,1.71-1.435Z",
    transform: "translate(-682.823 -127.626)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1056",
    "data-name": "Grupo 1056",
    transform: "translate(682.225 128.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1055",
    "data-name": "Grupo 1055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1733",
    "data-name": "Trazado 1733",
    d: "M683.534,127.575l-.276-.346a.538.538,0,0,0,.184-.31.488.488,0,0,0-.091-.33.5.5,0,0,0-.255-.224.276.276,0,0,0-.241.024.213.213,0,0,0-.088.113.385.385,0,0,0,.008.187c.014.054.051.172.114.354a1.25,1.25,0,0,1,.09.546.587.587,0,0,1-.267.417.57.57,0,0,1-.32.093.6.6,0,0,1-.343-.109,1.121,1.121,0,0,1-.3-.325.923.923,0,0,1-.187-.631.658.658,0,0,1,.295-.457l.26.37a.394.394,0,0,0-.143.24.458.458,0,0,0,.092.279.508.508,0,0,0,.235.212.163.163,0,0,0,.154-.017.177.177,0,0,0,.079-.13,1.21,1.21,0,0,0-.1-.428,2.231,2.231,0,0,1-.129-.495.609.609,0,0,1,.056-.33.7.7,0,0,1,.61-.375.64.64,0,0,1,.371.117,1.244,1.244,0,0,1,.333.364.97.97,0,0,1,.191.65.846.846,0,0,1-.329.538",
    transform: "translate(-681.553 -125.906)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1058",
    "data-name": "Grupo 1058",
    transform: "translate(680.64 126.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1057",
    "data-name": "Grupo 1057"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1734",
    "data-name": "Trazado 1734",
    d: "M682.556,124.568l-1.638.872.311.583-.333.177-.831-1.565.333-.176.31.581,1.637-.872Z",
    transform: "translate(-680.064 -124.169)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1060",
    "data-name": "Grupo 1060",
    transform: "translate(679.678 123.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1059",
    "data-name": "Grupo 1059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1735",
    "data-name": "Trazado 1735",
    d: "M681.836,123.1l-2.083.8-.593-1.542.352-.135.431,1.121.461-.178-.4-1.041.352-.135.4,1.041.564-.217-.446-1.161.353-.135Z",
    transform: "translate(-679.16 -121.514)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1062",
    "data-name": "Grupo 1062",
    transform: "translate(678.915 120.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1061",
    "data-name": "Grupo 1061"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1736",
    "data-name": "Trazado 1736",
    d: "M681.075,121l-2.183.465-.142-.663,1.407-.709-1.572-.069-.142-.664,2.184-.464.086.41-1.718.366,1.811.065.09.425-1.628.794,1.719-.363Z",
    transform: "translate(-678.444 -118.898)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1064",
    "data-name": "Grupo 1064",
    transform: "translate(678.656 118.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1063",
    "data-name": "Grupo 1063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1737",
    "data-name": "Trazado 1737",
    d: "M680.5,117.961l-.522-.139-.079-.892.49-.236-.043-.484-2.145,1.084.04.476,2.3.671Zm-1.759-.472.8-.382.053.61Z",
    transform: "translate(-678.2 -116.209)",
    fill: "#161112"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1066",
    "data-name": "Grupo 1066",
    transform: "translate(678.664 114.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1065",
    "data-name": "Grupo 1065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1738",
    "data-name": "Trazado 1738",
    d: "M680.528,113.184a.774.774,0,0,0-.137-.335.98.98,0,0,0-.362-.286,1.494,1.494,0,0,0-.464-.125,1.65,1.65,0,0,0-.532.007.949.949,0,0,0-.384.168.742.742,0,0,0-.246.308,1.623,1.623,0,0,0-.094.415l-.1.815,2.215.274.1-.841a1.351,1.351,0,0,0,0-.4m-.382.413-.042.333-1.466-.18.024-.2a1.99,1.99,0,0,1,.066-.364.426.426,0,0,1,.13-.194.5.5,0,0,1,.23-.1,1.314,1.314,0,0,1,.4,0,1.46,1.46,0,0,1,.4.1.478.478,0,0,1,.2.143.4.4,0,0,1,.07.192,1.226,1.226,0,0,1-.012.271",
    transform: "translate(-678.208 -112.42)",
    fill: "#161112"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1068",
    "data-name": "Grupo 1068",
    transform: "translate(679.094 111.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1067",
    "data-name": "Grupo 1067"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1739",
    "data-name": "Trazado 1739",
    d: "M680.776,111.955l-2.164-.54.4-1.6.366.092-.292,1.165.481.12.27-1.084.366.092-.269,1.084.585.146.3-1.207.365.092Z",
    transform: "translate(-678.612 -109.812)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1070",
    "data-name": "Grupo 1070",
    transform: "translate(680.428 108.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1069",
    "data-name": "Grupo 1069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1740",
    "data-name": "Trazado 1740",
    d: "M681.872,108.411l-2.007-.936.192-.409,1.664.775.473-1.014.342.159Z",
    transform: "translate(-679.866 -106.827)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1072",
    "data-name": "Grupo 1072",
    transform: "translate(681.903 105.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1071",
    "data-name": "Grupo 1071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1741",
    "data-name": "Trazado 1741",
    d: "M681.5,104.372l-.253.4,1.435,1.918.252-.4-.334-.427.476-.76.533.106.258-.414Zm.854,1.174-.541-.693.865.175Z",
    transform: "translate(-681.251 -104.372)",
    fill: "#161112"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1074",
    "data-name": "Grupo 1074",
    transform: "translate(684.195 102.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1073",
    "data-name": "Grupo 1073",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_427",
    "data-name": "Rect\\xE1ngulo 427",
    width: 0.451,
    height: 2.232,
    transform: "matrix(0.669, -0.743, 0.743, 0.669, 0, 0.336)",
    fill: "#1e1618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1076",
    "data-name": "Grupo 1076",
    transform: "translate(685.273 100.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1075",
    "data-name": "Grupo 1075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1742",
    "data-name": "Trazado 1742",
    d: "M685.94,102.464l-1.523-1.633.321-.3,1.691.467-1.02-1.094.3-.284,1.523,1.633-.331.308-1.661-.457,1,1.073Z",
    transform: "translate(-684.416 -99.622)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1078",
    "data-name": "Grupo 1078",
    transform: "translate(687.357 98.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1077",
    "data-name": "Grupo 1077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1743",
    "data-name": "Trazado 1743",
    d: "M688.195,100.545l-1.064-1.52-.541.38-.215-.31,1.449-1.016.217.31-.539.377,1.063,1.52Z",
    transform: "translate(-686.375 -98.079)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1080",
    "data-name": "Grupo 1080",
    transform: "translate(689.638 97.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1079",
    "data-name": "Grupo 1079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1744",
    "data-name": "Trazado 1744",
    d: "M689.565,99.608l-1.047-1.971,1.458-.776.177.333-1.059.563.232.439.986-.525.177.333-.985.525.283.533,1.1-.583.179.333Z",
    transform: "translate(-688.518 -96.861)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1082",
    "data-name": "Grupo 1082",
    transform: "translate(692.336 96.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1081",
    "data-name": "Grupo 1081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1745",
    "data-name": "Trazado 1745",
    d: "M692.3,97.391l-.135-.352.906-.348.318.832a1.2,1.2,0,0,1-.295.373,1.479,1.479,0,0,1-.471.293,1.225,1.225,0,0,1-.623.082.945.945,0,0,1-.516-.253,1.357,1.357,0,0,1-.335-.51,1.292,1.292,0,0,1-.086-.632.98.98,0,0,1,.25-.542,1.146,1.146,0,0,1,.459-.3,1.054,1.054,0,0,1,.669-.068.783.783,0,0,1,.453.343l-.39.238a.47.47,0,0,0-.259-.179.527.527,0,0,0-.336.027.61.61,0,0,0-.369.343.789.789,0,0,0,.036.582.88.88,0,0,0,.378.495.589.589,0,0,0,.5.02.8.8,0,0,0,.245-.153,1,1,0,0,0,.18-.214l-.1-.264Z",
    transform: "translate(-691.051 -95.94)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1084",
    "data-name": "Grupo 1084",
    transform: "translate(695.049 95.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1083",
    "data-name": "Grupo 1083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1746",
    "data-name": "Trazado 1746",
    d: "M695.718,96.8a2.634,2.634,0,0,0-.335-.29,1.078,1.078,0,0,0-.28-.123.71.71,0,0,0,.378-.307.594.594,0,0,0,.042-.437.638.638,0,0,0-.179-.318.506.506,0,0,0-.3-.144,1.566,1.566,0,0,0-.52.067l-.921.229.54,2.166.439-.109-.226-.906.088-.022a.783.783,0,0,1,.228-.03.338.338,0,0,1,.156.056,3.407,3.407,0,0,1,.31.261l.431.394.523-.13Zm-.642-.843a.239.239,0,0,1-.1.122,1.715,1.715,0,0,1-.385.123l-.324.082-.138-.55.342-.086c.178-.044.285-.067.321-.072a.258.258,0,0,1,.289.207.293.293,0,0,1,0,.175",
    transform: "translate(-693.6 -95.173)",
    fill: "#161112"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1086",
    "data-name": "Grupo 1086",
    transform: "translate(697.883 95.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1085",
    "data-name": "Grupo 1085"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1747",
    "data-name": "Trazado 1747",
    d: "M697.407,94.8l-.476.042-.668,2.3.477-.042.139-.522.891-.078.237.488.484-.043Zm-.424,1.389.228-.849.381.8Z",
    transform: "translate(-696.263 -94.798)",
    fill: "#161112"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1088",
    "data-name": "Grupo 1088",
    transform: "translate(700.724 95.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1087",
    "data-name": "Grupo 1087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1748",
    "data-name": "Trazado 1748",
    d: "M700.432,96.155l.43.149a.984.984,0,0,1-.353.536.947.947,0,0,1-.6.158.959.959,0,0,1-.721-.33,1.163,1.163,0,0,1-.258-.84,1.223,1.223,0,0,1,.318-.857.98.98,0,0,1,.766-.281.922.922,0,0,1,.658.265.888.888,0,0,1,.213.419l-.448.09a.484.484,0,0,0-.156-.28.479.479,0,0,0-.3-.11.5.5,0,0,0-.408.164.876.876,0,0,0-.176.571.939.939,0,0,0,.131.608.5.5,0,0,0,.391.193.449.449,0,0,0,.313-.1.669.669,0,0,0,.2-.353",
    transform: "translate(-698.932 -94.689)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1090",
    "data-name": "Grupo 1090",
    transform: "translate(703.456 95.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1089",
    "data-name": "Grupo 1089",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_428",
    "data-name": "Rect\\xE1ngulo 428",
    width: 2.232,
    height: 0.453,
    transform: "translate(0 2.21) rotate(-81.998)",
    fill: "#1e1618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1092",
    "data-name": "Grupo 1092",
    transform: "translate(704.912 95.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1091",
    "data-name": "Grupo 1091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1749",
    "data-name": "Trazado 1749",
    d: "M704.94,95.77a1.047,1.047,0,0,0-.693-.49,1.214,1.214,0,0,0-.489-.03.875.875,0,0,0-.328.125,1.045,1.045,0,0,0-.277.248,1.411,1.411,0,0,0-.238.531,1.16,1.16,0,0,0,.083.886,1.053,1.053,0,0,0,.7.486,1.035,1.035,0,0,0,.837-.106,1.372,1.372,0,0,0,.41-1.65m-.367.776a.846.846,0,0,1-.31.524.6.6,0,0,1-.861-.215.837.837,0,0,1-.032-.6.85.85,0,0,1,.305-.518.627.627,0,0,1,.873.215.835.835,0,0,1,.025.6",
    transform: "translate(-702.866 -95.238)",
    fill: "#161112"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1094",
    "data-name": "Grupo 1094",
    transform: "translate(707.528 96.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1093",
    "data-name": "Grupo 1093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1750",
    "data-name": "Trazado 1750",
    d: "M705.324,97.95l.8-2.084.409.156.32,1.727.537-1.4.39.149-.8,2.084-.422-.161-.319-1.7-.525,1.371Z",
    transform: "translate(-705.324 -95.866)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1096",
    "data-name": "Grupo 1096",
    transform: "translate(711.501 98.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1095",
    "data-name": "Grupo 1095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1751",
    "data-name": "Trazado 1751",
    d: "M710.4,99.575l.293.35a.986.986,0,0,1-.578.277.947.947,0,0,1-.6-.172.963.963,0,0,1-.448-.654,1.159,1.159,0,0,1,.213-.853,1.221,1.221,0,0,1,.712-.571.99.99,0,0,1,.8.153.927.927,0,0,1,.425.566.871.871,0,0,1-.032.47l-.432-.154a.469.469,0,0,0,.011-.32.474.474,0,0,0-.2-.25.5.5,0,0,0-.434-.07.865.865,0,0,0-.443.4.94.94,0,0,0-.2.589.5.5,0,0,0,.234.367.455.455,0,0,0,.323.072.666.666,0,0,0,.351-.2",
    transform: "translate(-709.055 -97.924)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1098",
    "data-name": "Grupo 1098",
    transform: "translate(713.397 99.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1097",
    "data-name": "Grupo 1097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1752",
    "data-name": "Trazado 1752",
    d: "M710.836,100.914l1.435-1.711,1.265,1.062-.242.29-.921-.772-.317.38.855.716-.243.29-.856-.717-.387.463.952.8-.242.288Z",
    transform: "translate(-710.836 -99.204)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1100",
    "data-name": "Grupo 1100",
    transform: "translate(715.26 101.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1099",
    "data-name": "Grupo 1099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1753",
    "data-name": "Trazado 1753",
    d: "M712.588,102.46l1.633-1.522.3.32-.468,1.691,1.094-1.021.286.307-1.633,1.522-.308-.329.456-1.664-1.073,1Z",
    transform: "translate(-712.588 -100.938)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1102",
    "data-name": "Grupo 1102",
    transform: "translate(717.304 103.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1101",
    "data-name": "Grupo 1101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1754",
    "data-name": "Trazado 1754",
    d: "M714.507,104.75l1.5-1.09-.389-.535.306-.221,1.041,1.433-.307.221-.386-.532-1.5,1.091Z",
    transform: "translate(-714.507 -102.903)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1104",
    "data-name": "Grupo 1104",
    transform: "translate(718.309 106.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1103",
    "data-name": "Grupo 1103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1755",
    "data-name": "Trazado 1755",
    d: "M717.293,107a.6.6,0,0,0,.434-.065.646.646,0,0,0,.265-.252.515.515,0,0,0,.067-.329,1.672,1.672,0,0,0-.192-.489l-.445-.838-1.971,1.049.213.4.823-.439.043.082a.728.728,0,0,1,.084.213.341.341,0,0,1-.017.163,3.259,3.259,0,0,1-.178.364l-.277.515.251.475.257-.444a2.3,2.3,0,0,0,.2-.4,1.077,1.077,0,0,0,.053-.3.7.7,0,0,0,.39.292m-.493-1.129.5-.266.165.31c.085.162.135.26.148.294a.279.279,0,0,1,0,.193.265.265,0,0,1-.132.137.288.288,0,0,1-.17.039.249.249,0,0,1-.142-.068,1.652,1.652,0,0,1-.215-.345Z",
    transform: "translate(-715.451 -105.028)",
    fill: "#161112"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1106",
    "data-name": "Grupo 1106",
    transform: "translate(719.745 108.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1105",
    "data-name": "Grupo 1105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1756",
    "data-name": "Trazado 1756",
    d: "M718.353,109.819a1.179,1.179,0,0,0,.69-.582,1.048,1.048,0,0,0,0-.848,1.224,1.224,0,0,0-.255-.417.825.825,0,0,0-.291-.2,1.064,1.064,0,0,0-.361-.085,1.451,1.451,0,0,0-.573.111,1.157,1.157,0,0,0-.677.575,1.176,1.176,0,0,0,.566,1.474,1.174,1.174,0,0,0,.9-.03m-1.1-.734a.576.576,0,0,1,.023-.486,1.045,1.045,0,0,1,1.075-.417.625.625,0,0,1,.324.838.839.839,0,0,1-.475.363.86.86,0,0,1-.607.048.572.572,0,0,1-.341-.345",
    transform: "translate(-716.8 -107.688)",
    fill: "#161112"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1108",
    "data-name": "Grupo 1108",
    transform: "translate(720.393 111.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1107",
    "data-name": "Grupo 1107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1757",
    "data-name": "Trazado 1757",
    d: "M719.772,110.86l-2.363-.383.1.467.536.076.186.876-.457.295.1.477,2-1.34Zm-1.2.814-.128-.6.871.122Z",
    transform: "translate(-717.409 -110.477)",
    fill: "#161112"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1110",
    "data-name": "Grupo 1110",
    transform: "translate(720.971 114.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1109",
    "data-name": "Grupo 1109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1758",
    "data-name": "Trazado 1758",
    d: "M717.952,113.147l2.224-.2.06.676-1.483.532,1.551.26.06.677-2.223.194-.036-.416,1.749-.153-1.788-.286-.038-.433,1.713-.589-1.751.151Z",
    transform: "translate(-717.952 -112.952)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1112",
    "data-name": "Grupo 1112",
    transform: "translate(721.086 117.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1111",
    "data-name": "Grupo 1111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1759",
    "data-name": "Trazado 1759",
    d: "M718.118,115.966l2.231.078-.058,1.652-.377-.013.044-1.2-.5-.017-.039,1.117-.377-.015.038-1.115-.6-.021-.043,1.242-.377-.012Z",
    transform: "translate(-718.06 -115.966)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1114",
    "data-name": "Grupo 1114",
    transform: "translate(720.655 120.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1113",
    "data-name": "Grupo 1113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1760",
    "data-name": "Trazado 1760",
    d: "M717.967,118.3l-.07.447.921.146-.014.092a.829.829,0,0,1-.062.22.338.338,0,0,1-.112.119,2.84,2.84,0,0,1-.361.184l-.531.244-.083.531.472-.2a2.63,2.63,0,0,0,.4-.194,1.09,1.09,0,0,0,.221-.21.713.713,0,0,0,.135.467.6.6,0,0,0,.386.211.632.632,0,0,0,.363-.042.512.512,0,0,0,.252-.222,1.678,1.678,0,0,0,.141-.506l.149-.937Zm1.706,1.085c-.028.18-.049.288-.059.323a.256.256,0,0,1-.3.186.285.285,0,0,1-.156-.071.242.242,0,0,1-.076-.139,1.8,1.8,0,0,1,.037-.4l.051-.33.561.089Z",
    transform: "translate(-717.655 -118.304)",
    fill: "#161112"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1116",
    "data-name": "Grupo 1116",
    transform: "translate(720.315 122.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1115",
    "data-name": "Grupo 1115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1761",
    "data-name": "Trazado 1761",
    d: "M717.469,120.7l2.134.653-.132.433-2.135-.654Z",
    transform: "translate(-717.336 -120.702)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1118",
    "data-name": "Grupo 1118",
    transform: "translate(719.594 124.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1117",
    "data-name": "Grupo 1117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1762",
    "data-name": "Trazado 1762",
    d: "M717.357,123.575l-.289.354a.994.994,0,0,1-.382-.514.952.952,0,0,1,.056-.617.965.965,0,0,1,.556-.565,1.166,1.166,0,0,1,.879.047,1.213,1.213,0,0,1,.694.591.986.986,0,0,1,0,.818.932.932,0,0,1-.476.527.884.884,0,0,1-.466.056l.068-.452a.482.482,0,0,0,.316-.051.466.466,0,0,0,.208-.245.51.51,0,0,0-.015-.441.855.855,0,0,0-.476-.36.932.932,0,0,0-.615-.085.5.5,0,0,0-.316.3.456.456,0,0,0-.008.331.653.653,0,0,0,.263.307",
    transform: "translate(-716.658 -122.167)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1120",
    "data-name": "Grupo 1120",
    transform: "translate(718.041 126.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1119",
    "data-name": "Grupo 1119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1763",
    "data-name": "Trazado 1763",
    d: "M716.285,124.074l-.232.418.356.408-.434.782-.539-.077-.235.425,2.387.3.23-.417Zm.09,1.664.3-.534.576.663Z",
    transform: "translate(-715.2 -124.074)",
    fill: "#161112"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1122",
    "data-name": "Grupo 1122",
    transform: "translate(716.613 128.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1121",
    "data-name": "Grupo 1121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1764",
    "data-name": "Trazado 1764",
    d: "M714.9,126.412l1.805,1.313-.257.354-1.75-.137,1.209.879-.245.339-1.805-1.313.265-.364,1.719.13-1.187-.863Z",
    transform: "translate(-713.859 -126.412)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1124",
    "data-name": "Grupo 1124",
    transform: "translate(714.653 130.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1123",
    "data-name": "Grupo 1123",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1765",
    "data-name": "Trazado 1765",
    d: "M713.572,128.206l-.331.345.236.486-.623.644-.5-.214-.339.349,2.227.908.332-.343Zm-.344,1.632.424-.44.386.791Z",
    transform: "translate(-712.017 -128.206)",
    fill: "#161112"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1126",
    "data-name": "Grupo 1126",
    transform: "translate(682.3 98.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1125",
    "data-name": "Grupo 1125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1766",
    "data-name": "Trazado 1766",
    d: "M681.624,116.811a18.892,18.892,0,1,1,18.892,18.9,18.895,18.895,0,0,1-18.892-18.9",
    transform: "translate(-681.624 -97.913)",
    fill: "#42692d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1128",
    "data-name": "Grupo 1128",
    transform: "translate(693.845 110.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1127",
    "data-name": "Grupo 1127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1767",
    "data-name": "Trazado 1767",
    d: "M692.469,116.225a7.218,7.218,0,1,1,7.217,7.22,7.219,7.219,0,0,1-7.217-7.22",
    transform: "translate(-692.469 -109.005)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1130",
    "data-name": "Grupo 1130",
    transform: "translate(684.164 105.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1129",
    "data-name": "Grupo 1129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1768",
    "data-name": "Trazado 1768",
    d: "M713.525,124.49l.366.455.36.259-.062.112-.059.335.023.052.194.119.113.254-.005.248.084.03.111.11,0,.108-.227.2-.379.5-.143.11-.2-.144-.136.026-.032.3-.291.22,0,.192-.08,0-.281-.2-.385-.455-.135-.255-.049-.42.034-.327.064-.2.366-.3.162-.021-.02-.116-.2-.2-.253,0-.334.133-.383-.483-.7-.344-.531-.374-.112-.031-.169,0-.4.134-.166.161-.375.555-.347.358-.316.186H708.5l-.286.105-.346.218-.087.214,0,.174.052.113.336.286.16.194.2.144.056.253-.267.248-.646.382-.2.02-.484-.033-.05-.089-.106-.395-.021-.354-.105-.345-.26.085-.171.249-.224,0-.309-.347-.191-.279-.162-.345-.171-.161-.11-.059-.365-.03-.388-.179-.255-.062-.7-.1-.365-.006-.114.11-.095.251-.055.028-.32-.5-.135-.417-.193-.228-.137-.089-.084-.028-.141.085.191.417-.086.053-.336-.087-.273-.175-.058-.082-.066-1.03-.468-.389-1.027-.49-.085,0-.307-.308-.105-.252-.245-.389-.278-.255-.225-.056-.252.1.082.138.311.145.023.164-.18.413h-.052l-.17-.111-.221-.2-.383-.2-.2,0-.247-.2-.169-.228-.132-.28-.105-.442.091-.191.112-.137.034-.44-.159-.22v-.087l.107-.213.06-.029-.045-.141-.1-.221-.671-.568-.224-.118-.191-.162-.331-.335-.526-.7-.83-.792-.159-.217-.553-.587-.06-.11.053-.188.083-.007.274,0v-.082l-.278-.282,0-.162-.082-.169-.25-.115-.244.095-.206.194-.658.246-1.053-.051-.679-.21-.51-.312-.367-.094-.568-.065-.479-.23-.311-.261-.295-.177-.6-.118-.4-.062-.748-.013-.432-.064-.339-.116-.342-.227-.251-.123-.514-.4-.054-.081-.287-.171-.05-.083-.173-.111-.111-.171.088-.023.068-.589.12-.105.027-.108-.082-.284.062-.026.082-.187.268-.386.03-.1.942-1.393,1.12-.035.889.015.054.03.028-.053.045-.554-.114-.188-.335-.308-.144-.336-.619-.394-.963-.945.062.028,1.233.02.044-1.011,3.67.039.034-.087.07-.024.031,0,.032.02.037.055.075,0,.035.046.023.018.057.021.062.068.017-.03-.008-.048.012-.044.064-.044.051-.059v-.024l.022-.035.011-.042.079-.047.011-.1.048-.106-.01-.043.078-.052.043-.015.034-.056.016-.105.021-.032.049-.047.017-.051.016-.086.029-.067.053-.08.036-.021.049.016.069-.028.064.015.119-.009.023.027-.026-.023.027.047-.012.033-.039.037-.041.017-.03.03-.036.019-.022.032.006.031.1-.021h.027l-.06.089-.022.05h.022l.054-.067.077-.049.1-.021.007.02.028-.006.013.021.029.009.138-.077.026-.007v.054l-.072.052-.014.023.068-.037.019-.006.014.027,0,.037.017.05v.06l.008.05-.013.1.005.077-.042.1-.01.053-.048.113-.012.045-.069.094-.028.068-.009.193-.029.159-.054.106-.03.023-.013.021.005.1.018.037.022.015.049.016.03.045.059.007.019.01.008.036-.051.016-.045-.007-.022.006-.016.024-.068.307-.02.168v.11l.015.044,0,.057.013.037.027.053.055.017.026.033.006.085.031.061,0,.021-.019.033-.042.018-.027.022-.034.064,0,.051.059.116-.055.032-.04.061,0,.022.015.079-.014.052.01.077-.015.039-.04.043-.013.021v.039l-.016.028,0,.081-.012.047h-.026l.02-.057,0-.056.014-.084.021-.046.044-.052-.087.083-.005.07-.035.034.026.005-.048.024.036.015-.024.047,0,.046-.045.046,0,.055-.035.015-.02.018-.006.035.013.027-.048.005-.046.106-.034.023-.032.054-.007.057-.046.011-.021.037-.016-.024.006-.047-.029.057-.022,0-.052-.049-.028,0v.051l-.048.007-.054.037-.043.016-.031.028-.008.036.014.061-.018.06-.079.045-.017.021-.014.039-.072.057,0,.046-.006.022-.036.015-.03.029-.045.017-.022.026v.067l.014.04.026.026.006.047-.047.014-.052,0-.042-.014-.047.007-.021-.018-.05,0-.019-.013-.031.026-.043-.017-.037.027-.028-.009-.039,0-.048.021.192.109.443.031.124.2.281.175h.087l.292-.163.228.029.053.146h.026l.062.027V110l.067.015.455-.017.4-.161.315-.05.615.042.6.116.869.016.74-.15.456-.016.2-.052.194-.108.4-.049.285.086.11.088.507.009.314-.106.369.007.172.028.444.23.506.034.473.089.372.2.417.422.9.419.188.17.2.3,0,.133-.012.843-.1.71-.528,1.466L701.564,116l-.248,1.446-.078.942-.085.354-.2.357.018.442.276.467.049.2v.08l.033,0,.077.3.082.116.242.584.3.412.717.731.521.313.2.2.138.171.343.117.05.052.078.395.227.144,0,.219.08.226.9.016.139.031.673.315.312.034.19,0,.175-.054.28-.269.175-.086.6-.092.716-.381.135,0,.168.054.027.342.079.026.26-.135.066-.607.23-.277.088-.06.226-.047.728.04.369.2.475.149.535.04.447.112.385.179.616.563Z",
    transform: "translate(-683.375 -104.255)",
    fill: "#262652"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1132",
    "data-name": "Grupo 1132",
    transform: "translate(683.915 105.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1131",
    "data-name": "Grupo 1131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1769",
    "data-name": "Trazado 1769",
    d: "M707.48,128.29l-.581-.039-.105-.2-.107-.4-.027-.385-.05-.156-.061.019-.189.276-.376-.006-.353-.4-.2-.3-.162-.339-.133-.127-.063-.032-.386-.042-.389-.179-.227-.052-.689-.094-.281,0-.043.04-.1.276-.235.116-.414-.653-.126-.389-.182-.2.156.343-.26.162-.446-.123-.32-.218-.08-.118-.064-1-.418-.346-.963-.455-.115,0-.383-.4-.107-.252-.22-.349-.092-.084.034.245-.238.55-.2-.006-.209-.134-.226-.2-.333-.174-.215,0-.317-.257-.168-.229-.148-.3-.13-.527.115-.241.1-.129.026-.336-.155-.215.019-.208.12-.24-.008-.024-.08-.172-.645-.546-.2-.1-.219-.18-.341-.346-.539-.713-.814-.772-.177-.238-.565-.6-.088-.166.1-.352.185-.016-.141-.144,0-.188-.043-.085-.139-.065-.152.061-.237.205-.689.257-1.086-.053-.716-.215-.525-.315-.345-.088-.6-.076-.48-.231-.344-.281-.25-.148-.962-.175-.727-.011-.451-.066-.4-.141-.341-.227-.233-.112-.577-.455-.034-.052-.309-.205-.033-.051-.189-.138-.229-.351.195-.052.063-.543.133-.132-.11-.379.134-.054.055-.129.268-.391.043-.125.987-1.459,1.2-.038.829.014.031-.382-.077-.126-.358-.346-.125-.292-.578-.368-.988-.965.174-.253.032.014,1.049.018.044-1.011,3.714.039.022-.053.227-.061.1.043.044.038.071,0,.037.05.05-.037.047-.134.079-.105.027-.06-.022-.1.184-.123.058-.158.045-.056.012-.067.038-.1.118-.153.1-.055.061.02.064-.024.086.02.171-.013.052.056-.059.072.074-.043.065.111-.011.027.05-.011.014.03.093-.04.2-.057.017.752-.13.349-.067.1-.007.167-.046.222-.055.11.012,0,.064.049.066.034.034.083.027.135-.175.1-.065.368.018.153.031.01.087.111.048.23-.05.119-.066.052.095.189-.141.082.012.056-.015.057.011.086-.031.08.166.043-.219.122v0l-.046.182-.081,0-.024.088.04.088-.157.038-.031.069-.044.054-.015.1-.084.021-.125.209-.1-.174-.05.021,0,.016-.046.16-.1.055-.015.04-.064.076-.021.069-.084.042.029.126.061.005.147.236.215.132.3-.168.374.048.057.159.107.048.348-.013.378-.151.349-.059.648.039.614.119.842.012.707-.146.482-.019.163-.048.215-.111.433-.053.368.123.069.054.426.007.315-.106.4.007.241.045.416.216.473.032.537.106.408.227.4.4.911.433.216.2.221.342-.013,1.023-.1.73-.527,1.472-.021,1.261-.25,1.469-.077.928-.105.418-.179.318.014.358.274.477.15.557.065.09.259.617.283.379.689.7.535.328.315.349.364.143.081.086.074.373.244.155-.005.279.034.1.794.014.169.033.68.316.439.034.116-.036.293-.271.219-.1.568-.088.728-.386.221.011.267.086.023.275.049-.027.063-.569.292-.343.145-.083.246-.051.813.06.369.2.448.137.5.035.473.115.452.216.616.562.178.132.351.439.455.327-.115.211-.042.24.174.108.147.33,0,.17.034.028.159.156-.005.245-.279.242-.384.5-.236.182-.2-.144-.023.216-.283.215,0,.275-.286-.01-.349-.25-.385-.455-.17-.339-.049-.42.034-.361.085-.27.42-.348-.041-.04-.159,0-.413.165-.434-.546-.672-.329-.53-.37-.066-.018-.122,0-.34.114-.142.136-.352.529-.4.407-.353.206-.15,0-.26.1-.274.177-.057.142,0,.106.023.05.311.265.166.2.231.168.088.4-.332.31-.737.423Zm-.392-.34.386.026.155-.015.616-.364.175-.166-.024-.109-.179-.136-.161-.194-.357-.319-.07-.146.015-.266.106-.261.388-.245.344-.131.121,0,.261-.153.331-.343.358-.533.247-.22.423-.143.236.009.158.053.531.374.738.376.311.392.254-.1.348,0,.276.275.06.327-.281.036-.3.245-.05.152-.028.294.045.357.124.231.351.41.1.073v-.027l.3-.226.037-.352.317-.057.156.114.034-.026.366-.482.181-.16-.022-.023-.158-.056.006-.326-.079-.178-.195-.121-.06-.138.077-.42-.278-.208-.351-.437-.145-.1-.613-.559-.363-.169-.418-.1-.511-.037-.509-.155-.365-.193-.675-.037-.176.036-.044.03-.185.224-.07.642-.391.2-.242-.076-.027-.343-.047-.015-.072,0-.729.379-.571.087-.131.065-.326.291-.2.062-.216,0-.375-.049-.673-.316-.105-.018-.98-.015-.126-.353,0-.161-.209-.132-.081-.411-.344-.117-.166-.207-.172-.177-.534-.327-.717-.731-.316-.429-.26-.617-.089-.137-.048-.189-.035,0-.031-.153v-.061l-.039-.16-.285-.519-.02-.488.214-.377.08-.332.073-.919.25-1.458.029-1.314.529-1.467.093-.678.011-.908-.16-.246-.156-.142-.922-.441-.4-.4-.329-.177-.449-.085-.548-.048-.424-.219-.147-.023-.319-.005-.315.106-.585-.011-.129-.1-.226-.068-.336.04-.169.094-.232.067-.491.021-.714.146-.9-.013-.622-.119-.6-.038-.281.049-.421.162-.475.018-.214-.047V110.1h-.011l-.083-.159-.083-.01-.283.159-.172,0-.368-.247-.082-.133-.427-.045-.465-.261.479-.2.037.014.048-.038.074.045.015-.014v-.059l.143-.122,0-.05.181-.178-.006-.027.02-.083.126-.127.043-.016v-.128l.25.043.183-.3-.159-.066.246-.176,0-.06.094-.087,0-.013.013-.048-.014-.071.033-.111.031-.047-.022-.042.024-.161.07-.106,0-.029-.042-.013-.078-.175-.026-.258.021-.186.071-.334-.073-.12-.009-.176.105-.166.023-.134.017-.22.048-.108.054-.082.093-.253,0-.044.01-.088-.391.216.138-.235-.022.029-.3-.017.035-.108-.016-.078-.02.068-.06.056-.031.126-.065.1-.07.045-.038.084-.017.15-.105.09-.116.151.005.033-.128.243-.312-.242-.076,0-.017.045-3.625-.039-.044,1.013-1.027-.017.656.644.633.4.15.348.34.319.138.232-.065.663-.1.2-.159-.089-.85-.014-1.035.032-.882,1.306-.045.128-.268.385-.086.205.059.2-.05.195-.111.1-.069.6.182.135.03.049.3.2.039.06.494.384.225.105.343.226.319.111.4.056.73.011.417.065.652.137.295.177.332.275.423.2.542.062.431.116.511.312.642.194.982.043.6-.224.234-.2.3-.119.361.166.123.252,0,.134.279.282-.005.3-.391-.005-.005.02.02.036.539.571.172.233.811.771.542.716.317.32.181.151.2.1.74.641.2.51-.135.065-.067.133.163.225-.043.545-.144.176-.047.108.093.391.121.248.141.185.19.15.215.02.416.221.259.222.1-.231-.005-.036-.277-.13-.2-.334.467-.193.343.105.3.287.244.39.107.246.264.244.063.015,1.026.49.554.452.082,1.075.227.144.12.031-.151-.331.322-.194.188.067.171.12.22.28.13.4.17.266.049-.089.162-.155.428.007.724.1.27.064.392.178.4.046.145.082.2.209.163.344.179.259.25.279.071,0,.154-.225.461-.151.151.5.029.389Z",
    transform: "translate(-683.141 -104.102)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1134",
    "data-name": "Grupo 1134",
    transform: "translate(694.504 136.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1133",
    "data-name": "Grupo 1133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1770",
    "data-name": "Trazado 1770",
    d: "M693.1,135.423l.662.1a.816.816,0,0,0,.116.534.736.736,0,0,0,.442.271.751.751,0,0,0,.514-.015.414.414,0,0,0,.241-.277.311.311,0,0,0-.018-.214.547.547,0,0,0-.2-.2q-.107-.07-.492-.276a1.849,1.849,0,0,1-.664-.511.9.9,0,0,1,.124-1.173.924.924,0,0,1,.492-.232,1.674,1.674,0,0,1,.672.046,1.411,1.411,0,0,1,.858.506,1,1,0,0,1,.146.811l-.67-.143a.592.592,0,0,0-.09-.411.668.668,0,0,0-.39-.214.772.772,0,0,0-.477.005.253.253,0,0,0-.156.18.259.259,0,0,0,.049.224,1.779,1.779,0,0,0,.552.373,3.3,3.3,0,0,1,.655.414.928.928,0,0,1,.277.424,1.018,1.018,0,0,1-.822,1.3,1.886,1.886,0,0,1-.742-.059,1.473,1.473,0,0,1-.886-.525,1.292,1.292,0,0,1-.189-.936",
    transform: "translate(-693.089 -133.41)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1136",
    "data-name": "Grupo 1136",
    transform: "translate(698.455 136.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1135",
    "data-name": "Grupo 1135",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_429",
    "data-name": "Rect\\xE1ngulo 429",
    width: 3.382,
    height: 0.685,
    transform: "matrix(0.087, -0.996, 0.996, 0.087, 0, 3.37)",
    fill: "#1e1618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1138",
    "data-name": "Grupo 1138",
    transform: "translate(700.58 136.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1137",
    "data-name": "Grupo 1137",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1771",
    "data-name": "Trazado 1771",
    d: "M701.1,136.123l.667.18a1.481,1.481,0,0,1-.477.846,1.438,1.438,0,0,1-.889.3,1.466,1.466,0,0,1-1.124-.422,1.768,1.768,0,0,1-.476-1.243,1.844,1.844,0,0,1,.39-1.328,1.5,1.5,0,0,1,1.13-.508,1.41,1.41,0,0,1,1.021.333,1.334,1.334,0,0,1,.367.612l-.671.183a.7.7,0,0,0-.731-.541.776.776,0,0,0-.6.291,1.327,1.327,0,0,0-.2.881,1.429,1.429,0,0,0,.263.9.751.751,0,0,0,.61.251.682.682,0,0,0,.462-.189,1.015,1.015,0,0,0,.263-.555",
    transform: "translate(-698.796 -133.95)",
    fill: "#1e1618",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1140",
    "data-name": "Grupo 1140",
    transform: "translate(704.809 136.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1139",
    "data-name": "Grupo 1139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1772",
    "data-name": "Trazado 1772",
    d: "M703.927,133.42l-.7.176-.456,3.6.7-.176.086-.815,1.317-.328.468.676.716-.178Zm-.306,2.18.141-1.325.759,1.1Z",
    transform: "translate(-702.769 -133.42)",
    fill: "#161112"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1142",
    "data-name": "Grupo 1142",
    transform: "translate(672.775 119.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1141",
    "data-name": "Grupo 1141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1773",
    "data-name": "Trazado 1773",
    d: "M674.979,118.239l-.836.073-.033-.382a.9.9,0,0,0-.248-.612.7.7,0,0,0-.552-.159.679.679,0,0,0-.5.233.8.8,0,0,0-.13.583l.1,1.16,2.258-.2Zm-1.8.158-.017-.2a.375.375,0,0,1,.05-.275.257.257,0,0,1,.174-.087.23.23,0,0,1,.188.068.447.447,0,0,1,.095.278l.016.172Z",
    transform: "translate(-672.676 -117.155)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1144",
    "data-name": "Grupo 1144",
    transform: "translate(672.684 116.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1143",
    "data-name": "Grupo 1143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1774",
    "data-name": "Trazado 1774",
    d: "M674.852,116.069l-.372-.12.015-.792.374-.108.014-.733-2.28.81-.013.767,2.249.891Zm-.859-.278-.81-.263L674,115.3Z",
    transform: "translate(-672.59 -114.316)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1146",
    "data-name": "Grupo 1146",
    transform: "translate(672.771 113.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1145",
    "data-name": "Grupo 1145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1775",
    "data-name": "Trazado 1775",
    d: "M672.671,113.576l.243-1.963.448.055,1.161,1.421.161-1.308.483.061-.262,2.132-.467-.057-1.149-1.407-.137,1.125Z",
    transform: "translate(-672.671 -111.613)",
    fill: "#786621",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1148",
    "data-name": "Grupo 1148",
    transform: "translate(686.996 92.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1147",
    "data-name": "Grupo 1147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1776",
    "data-name": "Trazado 1776",
    d: "M688.6,93.062a1.5,1.5,0,0,0-.193-.535,1.694,1.694,0,0,0-.253-.362,1.01,1.01,0,0,0-.33-.236.8.8,0,0,0-.389-.064,1.226,1.226,0,0,0-.477.159l-.92.489,1.063,2,.919-.489a1.627,1.627,0,0,0,.34-.25.745.745,0,0,0,.194-.308.927.927,0,0,0,.046-.4m-.716.4a.723.723,0,0,1-.254.191l-.151.08-.581-1.091.155-.083a.5.5,0,0,1,.407-.067.754.754,0,0,1,.335.381,1.047,1.047,0,0,1,.138.371.326.326,0,0,1-.049.218",
    transform: "translate(-686.035 -91.862)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1150",
    "data-name": "Grupo 1150",
    transform: "translate(689.825 90.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1149",
    "data-name": "Grupo 1149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1777",
    "data-name": "Trazado 1777",
    d: "M688.693,91.2l1.737-.7.182.449-1.087.44.135.334,1.007-.407.173.428-1.007.408.167.413,1.117-.451.194.475-1.769.715Z",
    transform: "translate(-688.693 -90.495)",
    fill: "#786621",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1152",
    "data-name": "Grupo 1152",
    transform: "translate(692.788 89.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1151",
    "data-name": "Grupo 1151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1778",
    "data-name": "Trazado 1778",
    d: "M691.644,91.662l.631-.212a.5.5,0,0,0,.149.214.369.369,0,0,0,.333.053.35.35,0,0,0,.205-.128.22.22,0,0,0,.036-.18.2.2,0,0,0-.115-.131.886.886,0,0,0-.379-.034,1.538,1.538,0,0,1-.706-.1.556.556,0,0,1-.3-.371.593.593,0,0,1,.012-.344.657.657,0,0,1,.232-.314,1.4,1.4,0,0,1,.514-.231,1.139,1.139,0,0,1,.681-.015.7.7,0,0,1,.395.427l-.625.209a.363.363,0,0,0-.165-.188.345.345,0,0,0-.243-.007.286.286,0,0,0-.165.1.161.161,0,0,0-.026.137.116.116,0,0,0,.072.08.556.556,0,0,0,.247.021,2.922,2.922,0,0,1,.686.022.705.705,0,0,1,.345.168.654.654,0,0,1,.174.3.734.734,0,0,1-.013.42.756.756,0,0,1-.252.357,1.329,1.329,0,0,1-.5.232,1.12,1.12,0,0,1-.83-.006.879.879,0,0,1-.39-.481",
    transform: "translate(-691.476 -89.829)",
    fill: "#786621",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1154",
    "data-name": "Grupo 1154",
    transform: "translate(695.721 89.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1153",
    "data-name": "Grupo 1153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1779",
    "data-name": "Trazado 1779",
    d: "M695.476,89.253l-.758.121-.486,2.372.7-.113.054-.385.783-.126.169.351.725-.115Zm-.415,1.486.117-.844.373.766Z",
    transform: "translate(-694.232 -89.253)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1156",
    "data-name": "Grupo 1156",
    transform: "translate(698.79 89.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1155",
    "data-name": "Grupo 1155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1780",
    "data-name": "Trazado 1780",
    d: "M698.956,90.438a.737.737,0,0,0-.116-.115.685.685,0,0,0-.185-.078.861.861,0,0,0,.244-.1.62.62,0,0,0,.213-.23.613.613,0,0,0,.068-.328.627.627,0,0,0-.117-.364.523.523,0,0,0-.283-.2,1.7,1.7,0,0,0-.5-.038l-1.166.042.079,2.265.7-.026-.032-.918h.062a.29.29,0,0,1,.174.047.5.5,0,0,1,.132.168l.4.679.792-.029-.364-.642a.843.843,0,0,0-.1-.137m-.514-.634a.192.192,0,0,1-.112.075,1.161,1.161,0,0,1-.184.038l-.3.01-.016-.461.309-.011a.418.418,0,0,1,.263.05.212.212,0,0,1,.074.166.217.217,0,0,1-.038.133",
    transform: "translate(-697.115 -88.987)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1158",
    "data-name": "Grupo 1158",
    transform: "translate(701.804 89.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1157",
    "data-name": "Grupo 1157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1781",
    "data-name": "Trazado 1781",
    d: "M701.875,90.7a.8.8,0,0,0-.087-.146.689.689,0,0,0-.1-.128.7.7,0,0,0-.176-.1.846.846,0,0,0,.252-.072.666.666,0,0,0,.261-.9.536.536,0,0,0-.262-.226,1.7,1.7,0,0,0-.491-.089l-1.163-.082-.159,2.261.7.049.065-.914.062,0a.3.3,0,0,1,.166.064.535.535,0,0,1,.115.183l.325.716.789.054Zm-.533-.831a.178.178,0,0,1-.117.063.938.938,0,0,1-.188.018l-.295-.021.032-.46.307.021a.414.414,0,0,1,.257.077.21.21,0,0,1,.06.174.216.216,0,0,1-.054.129",
    transform: "translate(-699.946 -88.959)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1160",
    "data-name": "Grupo 1160",
    transform: "translate(704.74 89.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1159",
    "data-name": "Grupo 1159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1782",
    "data-name": "Trazado 1782",
    d: "M704.879,89.759a1.2,1.2,0,0,0-.813-.437,1.071,1.071,0,0,0-1.339.976,1.276,1.276,0,0,0,.05.677.96.96,0,0,0,.342.446,1.463,1.463,0,0,0,.608.219,1.282,1.282,0,0,0,.644-.04.961.961,0,0,0,.444-.33,1.394,1.394,0,0,0,.233-.623,1.14,1.14,0,0,0-.168-.888m-.519.767a.844.844,0,0,1-.205.5.486.486,0,0,1-.689-.113,1.019,1.019,0,0,1,.155-.976.428.428,0,0,1,.361-.095.444.444,0,0,1,.323.2.7.7,0,0,1,.055.482",
    transform: "translate(-702.704 -89.3)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1162",
    "data-name": "Grupo 1162",
    transform: "translate(707.745 89.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1161",
    "data-name": "Grupo 1161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1783",
    "data-name": "Trazado 1783",
    d: "M706.19,89.832l.668.2-.5,1.636,1.047.318-.163.533L705.527,92Z",
    transform: "translate(-705.527 -89.832)",
    fill: "#786621",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1164",
    "data-name": "Grupo 1164",
    transform: "translate(710.203 90.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1163",
    "data-name": "Grupo 1163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1784",
    "data-name": "Trazado 1784",
    d: "M708.686,90.617l.648.262-.64,1.585,1.016.411-.209.515-1.665-.672Z",
    transform: "translate(-707.836 -90.617)",
    fill: "#786621",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1166",
    "data-name": "Grupo 1166",
    transform: "translate(712.828 92.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1165",
    "data-name": "Grupo 1165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1785",
    "data-name": "Trazado 1785",
    d: "M712.686,92.785a1.185,1.185,0,0,0-.628-.678,1.07,1.07,0,0,0-1.582.485,1.273,1.273,0,0,0-.174.658.965.965,0,0,0,.178.532,1.474,1.474,0,0,0,.5.406,1.259,1.259,0,0,0,.622.171.944.944,0,0,0,.527-.168,1.4,1.4,0,0,0,.424-.512,1.147,1.147,0,0,0,.129-.894m-.741.557a.838.838,0,0,1-.358.407.422.422,0,0,1-.376-.035.427.427,0,0,1-.237-.295.757.757,0,0,1,.117-.495.773.773,0,0,1,.347-.379.427.427,0,0,1,.37.029.444.444,0,0,1,.242.295.7.7,0,0,1-.105.474",
    transform: "translate(-710.302 -91.933)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1168",
    "data-name": "Grupo 1168",
    transform: "translate(725.564 107.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1167",
    "data-name": "Grupo 1167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1786",
    "data-name": "Trazado 1786",
    d: "M724.41,106.091l.229.661-1.617.558.357,1.036-.526.181-.585-1.7Z",
    transform: "translate(-722.267 -106.091)",
    fill: "#786621",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1170",
    "data-name": "Grupo 1170",
    transform: "translate(726.372 109.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1169",
    "data-name": "Grupo 1169",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_430",
    "data-name": "Rect\\xE1ngulo 430",
    width: 2.266,
    height: 0.702,
    transform: "translate(0 0.584) rotate(-14.941)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1172",
    "data-name": "Grupo 1172",
    transform: "translate(726.789 111.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1171",
    "data-name": "Grupo 1171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1787",
    "data-name": "Trazado 1787",
    d: "M725.861,111.595l-.2-1.3-2.239.354.189,1.194a2.98,2.98,0,0,0,.08.306.756.756,0,0,0,.115.25.591.591,0,0,0,.254.187.613.613,0,0,0,.327.031.557.557,0,0,0,.336-.169.636.636,0,0,0,.143-.386.568.568,0,0,0,.188.218.5.5,0,0,0,.36.07.529.529,0,0,0,.369-.237.711.711,0,0,0,.081-.522m-1.361.222a.2.2,0,0,1-.149.1.215.215,0,0,1-.181-.047.394.394,0,0,1-.1-.242l-.056-.353.453-.07.056.35a.424.424,0,0,1-.02.264m.842-.214a.187.187,0,0,1-.143.087.205.205,0,0,1-.171-.037.361.361,0,0,1-.092-.218l-.048-.3.426-.067.049.3a.36.36,0,0,1-.021.231",
    transform: "translate(-723.418 -110.298)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1174",
    "data-name": "Grupo 1174",
    transform: "translate(727.22 114.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1173",
    "data-name": "Grupo 1173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1788",
    "data-name": "Trazado 1788",
    d: "M726.083,113.2l.132,1.869-.483.034-.083-1.169-.36.026.077,1.083-.46.033-.078-1.083-.445.03.084,1.2-.511.036-.133-1.9Z",
    transform: "translate(-723.823 -113.196)",
    fill: "#786621",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1176",
    "data-name": "Grupo 1176",
    transform: "translate(727.257 117.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1175",
    "data-name": "Grupo 1175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1789",
    "data-name": "Trazado 1789",
    d: "M723.934,115.946l-.025.7.918.031,0,.063a.29.29,0,0,1-.06.169.494.494,0,0,1-.178.12l-.7.35-.027.79.666-.316a.913.913,0,0,0,.143-.093.766.766,0,0,0,.123-.108.754.754,0,0,0,.091-.179.833.833,0,0,0,.081.249.615.615,0,0,0,.214.229.694.694,0,0,0,.694,0,.529.529,0,0,0,.215-.269,1.666,1.666,0,0,0,.075-.493l.039-1.168Zm1.771,1.073a.442.442,0,0,1-.067.26.232.232,0,0,1-.3.015.188.188,0,0,1-.067-.117,1.136,1.136,0,0,1-.025-.186l.012-.3.461.017Z",
    transform: "translate(-723.857 -115.946)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1178",
    "data-name": "Grupo 1178",
    transform: "translate(726.964 120.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1177",
    "data-name": "Grupo 1177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1790",
    "data-name": "Trazado 1790",
    d: "M726.042,118.877l-.332,2.1-.555-.088.113-.707-1.686-.266.111-.691,1.685.267.111-.707Z",
    transform: "translate(-723.582 -118.79)",
    fill: "#786621",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1180",
    "data-name": "Grupo 1180",
    transform: "translate(726.138 123.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1179",
    "data-name": "Grupo 1179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1791",
    "data-name": "Trazado 1791",
    d: "M723.444,120.892l-.185.691.332.207-.2.766-.392.013-.188.709,2.408-.234.2-.741Zm.454,1.648.127-.479.723.45Z",
    transform: "translate(-722.806 -120.892)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1182",
    "data-name": "Grupo 1182",
    transform: "translate(725.433 126.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1181",
    "data-name": "Grupo 1181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1792",
    "data-name": "Trazado 1792",
    d: "M722.612,123.76l-.374.971a1.613,1.613,0,0,0-.092.412.762.762,0,0,0,.055.36.934.934,0,0,0,.23.334,1.543,1.543,0,0,0,.5.279,1.654,1.654,0,0,0,.429.105.977.977,0,0,0,.4-.037.788.788,0,0,0,.334-.207,1.255,1.255,0,0,0,.258-.433l.371-.972Zm1.323,1.444a.5.5,0,0,1-.264.317.769.769,0,0,1-.5-.067,1.061,1.061,0,0,1-.348-.189.334.334,0,0,1-.107-.2.735.735,0,0,1,.066-.31l.063-.161,1.155.443Z",
    transform: "translate(-722.144 -123.76)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1184",
    "data-name": "Grupo 1184",
    transform: "translate(686.839 140.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1183",
    "data-name": "Grupo 1183",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1793",
    "data-name": "Trazado 1793",
    d: "M688.434,138.1a.794.794,0,0,0-.164-.359,1.247,1.247,0,0,0-.4-.307l-.919-.489-1.064,2,.92.489a1.6,1.6,0,0,0,.4.141.741.741,0,0,0,.363-.011.939.939,0,0,0,.36-.188,1.5,1.5,0,0,0,.337-.459,1.721,1.721,0,0,0,.158-.413.969.969,0,0,0,.012-.406m-.8.5a1.049,1.049,0,0,1-.232.324.339.339,0,0,1-.208.081.738.738,0,0,1-.3-.1l-.152-.082.581-1.093.154.083a.509.509,0,0,1,.283.3.77.77,0,0,1-.128.491",
    transform: "translate(-685.888 -136.946)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1186",
    "data-name": "Grupo 1186",
    transform: "translate(689.627 141.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1185",
    "data-name": "Grupo 1185",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1794",
    "data-name": "Trazado 1794",
    d: "M689.357,138.175l1.737.7-.182.448-1.086-.439-.135.334,1.007.408-.172.428-1.007-.407-.167.414,1.118.451-.192.476-1.77-.715Z",
    transform: "translate(-688.507 -138.175)",
    fill: "#786621",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1188",
    "data-name": "Grupo 1188",
    transform: "translate(692.426 142.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1187",
    "data-name": "Grupo 1187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1795",
    "data-name": "Trazado 1795",
    d: "M691.723,139.111l.892.24-.017,1.423.7-1.241.888.238-.587,2.189-.554-.147.447-1.669-.874,1.553-.5-.133.022-1.784-.448,1.669-.554-.148Z",
    transform: "translate(-691.136 -139.111)",
    fill: "#786621",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1190",
    "data-name": "Grupo 1190",
    transform: "translate(696.086 143.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1189",
    "data-name": "Grupo 1189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1796",
    "data-name": "Trazado 1796",
    d: "M696.735,140.43a1.178,1.178,0,0,0-2.143.576,1.286,1.286,0,0,0,.062.676.966.966,0,0,0,.35.44,1.434,1.434,0,0,0,.611.209,1.269,1.269,0,0,0,.643-.052.943.943,0,0,0,.438-.339,1.382,1.382,0,0,0,.224-.626,1.139,1.139,0,0,0-.184-.884m-.507.776a.844.844,0,0,1-.2.5.487.487,0,0,1-.691-.1.775.775,0,0,1-.057-.507.756.756,0,0,1,.2-.473.422.422,0,0,1,.358-.1.449.449,0,0,1,.327.195.7.7,0,0,1,.063.481",
    transform: "translate(-694.575 -139.989)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1192",
    "data-name": "Grupo 1192",
    transform: "translate(699.273 143.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1191",
    "data-name": "Grupo 1191",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1797",
    "data-name": "Trazado 1797",
    d: "M699.153,141.634l.607.207a1.136,1.136,0,0,1-.21.425.866.866,0,0,1-.338.249,1.254,1.254,0,0,1-.506.07,1.473,1.473,0,0,1-.6-.128.969.969,0,0,1-.393-.392,1.3,1.3,0,0,1-.145-.7,1.168,1.168,0,0,1,.329-.854,1.135,1.135,0,0,1,.857-.271,1.154,1.154,0,0,1,.666.2,1,1,0,0,1,.345.545l-.621.115a.56.56,0,0,0-.062-.153.432.432,0,0,0-.14-.128.428.428,0,0,0-.19-.049.416.416,0,0,0-.373.178,1.162,1.162,0,0,0-.014.96.392.392,0,0,0,.316.152.4.4,0,0,0,.309-.1.694.694,0,0,0,.16-.321",
    transform: "translate(-697.569 -140.242)",
    fill: "#786621",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1194",
    "data-name": "Grupo 1194",
    transform: "translate(702.312 143.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1193",
    "data-name": "Grupo 1193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1798",
    "data-name": "Trazado 1798",
    d: "M702.443,141.736a1.1,1.1,0,0,0-.11-.133.725.725,0,0,0-.122-.109.684.684,0,0,0-.188-.066.84.84,0,0,0,.237-.112.628.628,0,0,0,.2-.241.694.694,0,0,0-.085-.689.534.534,0,0,0-.295-.183,1.693,1.693,0,0,0-.5-.011l-1.162.1.2,2.258.7-.062-.081-.914.063,0a.294.294,0,0,1,.176.036.544.544,0,0,1,.142.163l.432.656.789-.068Zm-.657-.739a.19.19,0,0,1-.109.082,1,1,0,0,1-.181.046l-.295.027-.039-.461.306-.027a.427.427,0,0,1,.266.035.232.232,0,0,1,.052.3",
    transform: "translate(-700.423 -140.182)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1196",
    "data-name": "Grupo 1196",
    transform: "translate(705.39 143.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1195",
    "data-name": "Grupo 1195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1799",
    "data-name": "Trazado 1799",
    d: "M704.472,139.762l-.753.146-.4,2.388.7-.137.039-.387.78-.152.182.346.72-.14Zm-.362,1.5.087-.847.4.754Z",
    transform: "translate(-703.315 -139.762)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1198",
    "data-name": "Grupo 1198",
    transform: "translate(708.169 142.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1197",
    "data-name": "Grupo 1197",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1800",
    "data-name": "Trazado 1800",
    d: "M707.588,140.3l.642-.014a1.143,1.143,0,0,1-.053.47.842.842,0,0,1-.233.35,1.236,1.236,0,0,1-.451.238,1.439,1.439,0,0,1-.607.085.955.955,0,0,1-.5-.234,1.275,1.275,0,0,1-.375-.606,1.169,1.169,0,0,1,.017-.912,1.135,1.135,0,0,1,.712-.55,1.156,1.156,0,0,1,.694-.044,1.026,1.026,0,0,1,.511.395l-.545.319a.6.6,0,0,0-.111-.122.417.417,0,0,0-.176-.072.446.446,0,0,0-.481.313.785.785,0,0,0,.046.453.83.83,0,0,0,.268.455.394.394,0,0,0,.348.034.387.387,0,0,0,.253-.2.685.685,0,0,0,.042-.357",
    transform: "translate(-705.926 -139.051)",
    fill: "#786621",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1200",
    "data-name": "Grupo 1200",
    transform: "translate(710.738 141.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1199",
    "data-name": "Grupo 1199",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_431",
    "data-name": "Rect\\xE1ngulo 431",
    width: 0.702,
    height: 2.266,
    transform: "translate(0 0.263) rotate(-22.012)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1202",
    "data-name": "Grupo 1202",
    transform: "translate(712.808 140.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1201",
    "data-name": "Grupo 1201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1801",
    "data-name": "Trazado 1801",
    d: "M710.961,137.378l-.677.359.311,2.4.631-.335-.073-.383.7-.373.276.276.647-.344Zm.092,1.538-.162-.837.6.6Z",
    transform: "translate(-710.284 -137.378)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1204",
    "data-name": "Grupo 1204",
    transform: "translate(707.756 102.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1203",
    "data-name": "Grupo 1203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1802",
    "data-name": "Trazado 1802",
    d: "M710.813,104.5l.189-.033.221-.411-.254-.213-.632-.392-.328.005h-.157l-.346-.153-.055.032-.262-.05-.011-.155h.609l.065-.13-.125-.106-.065.047-.641.06-.2-.208-.023-.153-.035-.009-.039-.208-.093-.032-.229.073h-.231l-.318-.23-.171.059-.361-.188-.312-.1-.221.13-.239.033-.476-.1-.228.2.006.1.026.2.075.195-.1.263.189.189-.011.072-.285.328.138.083.068.236-.221.271-.19.009v.052l.14.169-.032.051.286.2-.083.158.032.188-.038.088-.018.01.158.123.082.343h.139l.221.254.042-.038.064-.2.378-.533.032-.376.269.023.042-.1.083.005.188-.153.092-.018.131.1-.017.092.124.171.221-.042.361-.065.165-.271.31-.113.282.1.063-.04.2.056h.319l.2-.016h.329l.253.2.056.116.238.092-.032.032-.05.015-.13-.047-.027-.092.183-.066Z",
    transform: "translate(-705.538 -102.007)",
    fill: "#262652",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1206",
    "data-name": "Grupo 1206",
    transform: "translate(707.6 102.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1205",
    "data-name": "Grupo 1205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1803",
    "data-name": "Trazado 1803",
    d: "M706.422,106.087l-.281-.323h-.192l-.1-.409-.308-.243.184-.092-.034-.192.044-.083-.3-.211.052-.08-.1-.126v-.255l.268-.013.127-.154-.028-.1-.248-.147.352-.4-.186-.185.115-.3-.053-.139-.047-.418.345-.3.525.108.182-.024.253-.15.378.119.327.168.185-.063.343.248h.156l.257-.083.228.081.039.2.051.112.015.1.117.117.554-.069.1-.075.312.267-.164.326h-.032l.034.014.494-.005.672.416.37.308-.319.59-.149.026-.009.081.184.07-.269.243-.1.03-.252-.093-.081-.227-.183-.147-.833.009-.13-.037-.067.045-.3-.1-.206.075-.172.285-.748.136-.221-.306.01-.046-.186.151-.032,0-.043.1-.227-.02-.023.263-.389.548-.069.215Zm-.227-.634h.087l.109.123.02-.039.353-.5.042-.49.313.028.04-.1.132.011.211-.147.159-.03.263.2-.021.121.026.036.417-.077.158-.258.413-.15.262.09.057-.038.247.069.877-.015.3.243.02-.155.228-.039.126-.232-.156-.131-.576-.354-.474,0-.305-.135-.036.021-.436-.083-.018-.26-.062.005-.288-.295-.018-.11-.049-.1-.016-.092-.19.053h-.283l-.293-.212-.158.054-.421-.22-.219-.067-.22.116-.265.036-.426-.088-.113.1.028.208.086.216-.085.225.172.171-.028.2-.193.222.031.019.108.375-.312.381.06.075-.013.02.277.2-.122.23.032.183-.016.038.094.075Z",
    transform: "translate(-705.391 -101.847)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1208",
    "data-name": "Grupo 1208",
    transform: "translate(684.49 100.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1207",
    "data-name": "Grupo 1207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1804",
    "data-name": "Trazado 1804",
    d: "M700.384,133.388a16.709,16.709,0,1,1,16.7-16.709,16.725,16.725,0,0,1-16.7,16.709m0-33.105a16.4,16.4,0,1,0,16.391,16.4,16.413,16.413,0,0,0-16.391-16.4",
    transform: "translate(-683.681 -99.971)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1210",
    "data-name": "Grupo 1210",
    transform: "translate(686.804 103.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1209",
    "data-name": "Grupo 1209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1805",
    "data-name": "Trazado 1805",
    d: "M700.243,130.932a14.393,14.393,0,1,1,14.39-14.393,14.407,14.407,0,0,1-14.39,14.393m0-28.475a14.081,14.081,0,1,0,14.078,14.082,14.095,14.095,0,0,0-14.078-14.082",
    transform: "translate(-685.855 -102.145)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1212",
    "data-name": "Grupo 1212",
    transform: "translate(689.165 105.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1211",
    "data-name": "Grupo 1211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1806",
    "data-name": "Trazado 1806",
    d: "M700.1,128.425a12.03,12.03,0,1,1,12.027-12.03,12.043,12.043,0,0,1-12.027,12.03m0-23.749A11.718,11.718,0,1,0,711.814,116.4,11.73,11.73,0,0,0,700.1,104.677",
    transform: "translate(-688.073 -104.365)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1214",
    "data-name": "Grupo 1214",
    transform: "translate(696.251 112.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1213",
    "data-name": "Grupo 1213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1807",
    "data-name": "Trazado 1807",
    d: "M699.636,120.9A4.907,4.907,0,1,1,704.541,116a4.912,4.912,0,0,1-4.905,4.907m0-9.5A4.594,4.594,0,1,0,704.228,116a4.6,4.6,0,0,0-4.592-4.594",
    transform: "translate(-694.73 -111.09)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1216",
    "data-name": "Grupo 1216",
    transform: "translate(698.67 114.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1215",
    "data-name": "Grupo 1215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1808",
    "data-name": "Trazado 1808",
    d: "M699.524,118.344a2.524,2.524,0,1,1,2.523-2.524,2.525,2.525,0,0,1-2.523,2.524m0-4.736a2.212,2.212,0,1,0,2.211,2.212,2.213,2.213,0,0,0-2.211-2.212",
    transform: "translate(-697.002 -113.296)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1218",
    "data-name": "Grupo 1218",
    transform: "translate(691.528 107.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1217",
    "data-name": "Grupo 1217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1809",
    "data-name": "Trazado 1809",
    d: "M699.956,125.92a9.668,9.668,0,1,1,9.665-9.668,9.677,9.677,0,0,1-9.665,9.668m0-19.023a9.356,9.356,0,1,0,9.354,9.356,9.364,9.364,0,0,0-9.354-9.356",
    transform: "translate(-690.293 -106.585)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1220",
    "data-name": "Grupo 1220",
    transform: "translate(693.689 110.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1219",
    "data-name": "Grupo 1219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1810",
    "data-name": "Trazado 1810",
    d: "M699.7,123.611a7.376,7.376,0,1,1,7.374-7.376,7.383,7.383,0,0,1-7.374,7.376m0-14.44a7.064,7.064,0,1,0,7.062,7.064,7.071,7.071,0,0,0-7.062-7.064",
    transform: "translate(-692.323 -108.859)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1222",
    "data-name": "Grupo 1222",
    transform: "translate(738.938 94.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1221",
    "data-name": "Grupo 1221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1811",
    "data-name": "Trazado 1811",
    d: "M740.356,114.456a5.621,5.621,0,0,0,1.055,2.838q1.44,1.71,4.933,1.71a10.622,10.622,0,0,0,3.4-.45,3.224,3.224,0,0,0,2.476-3.214A2.372,2.372,0,0,0,751,113.215a13.192,13.192,0,0,0-3.846-1.3l-3-.657a18.689,18.689,0,0,1-6.076-2.125q-2.8-1.916-2.8-6a7.963,7.963,0,0,1,2.74-6.184q2.738-2.462,8.047-2.462a12.337,12.337,0,0,1,7.563,2.322,8.252,8.252,0,0,1,3.282,6.737h-5.563A3.969,3.969,0,0,0,749.115,100a7.664,7.664,0,0,0-3.449-.7,6.564,6.564,0,0,0-3.661.9,2.853,2.853,0,0,0-1.368,2.517,2.375,2.375,0,0,0,1.349,2.218,16.789,16.789,0,0,0,3.68,1.146l4.863,1.146a12.376,12.376,0,0,1,4.791,2.011,6.78,6.78,0,0,1,2.477,5.658,7.949,7.949,0,0,1-2.935,6.3q-2.936,2.508-8.292,2.51-5.472,0-8.605-2.473a8.174,8.174,0,0,1-3.134-6.794Z",
    transform: "translate(-734.831 -94.496)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1224",
    "data-name": "Grupo 1224",
    transform: "translate(767.457 95.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1223",
    "data-name": "Grupo 1223"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_432",
    "data-name": "Rect\\xE1ngulo 432",
    width: 5.751,
    height: 27.703,
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1226",
    "data-name": "Grupo 1226",
    transform: "translate(778.822 95.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1225",
    "data-name": "Grupo 1225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1812",
    "data-name": "Trazado 1812",
    d: "M776.147,98.181a11.408,11.408,0,0,1,8.517-3.42q6.915,0,10.115,4.586a10,10,0,0,1,1.9,5.168h-5.788a7.91,7.91,0,0,0-1.418-3.007,6.286,6.286,0,0,0-9.464.742q-1.787,2.547-1.786,7.209t1.885,6.982a5.905,5.905,0,0,0,4.789,2.322,5.425,5.425,0,0,0,4.54-1.993,8.726,8.726,0,0,0,1.434-3.215h5.751a12.474,12.474,0,0,1-3.8,7.368,11.068,11.068,0,0,1-7.837,2.838,11.762,11.762,0,0,1-9.3-3.834q-3.383-3.853-3.383-10.563,0-7.254,3.848-11.182",
    transform: "translate(-772.299 -94.761)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1228",
    "data-name": "Grupo 1228",
    transform: "translate(805.854 95.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1227",
    "data-name": "Grupo 1227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1813",
    "data-name": "Trazado 1813",
    d: "M807.582,95.255h6.551l9.8,27.7h-6.278l-1.828-5.695h-10.2l-1.878,5.695h-6.056ZM807.2,112.49H814.3l-3.5-10.9Z",
    transform: "translate(-797.693 -95.255)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1230",
    "data-name": "Grupo 1230",
    transform: "translate(737.947 129.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1229",
    "data-name": "Grupo 1229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1814",
    "data-name": "Trazado 1814",
    d: "M734.571,130.226a1.485,1.485,0,0,0,.2.728,1.333,1.333,0,0,0,1.206.523,2.054,2.054,0,0,0,.7-.115.807.807,0,0,0,.615-.8.7.7,0,0,0-.261-.613,2.571,2.571,0,0,0-.826-.312l-.691-.162a3.064,3.064,0,0,1-.959-.347,1.114,1.114,0,0,1-.485-.986,1.542,1.542,0,0,1,.477-1.165,1.884,1.884,0,0,1,1.354-.456,2.306,2.306,0,0,1,1.369.4,1.459,1.459,0,0,1,.563,1.278h-.671a1.35,1.35,0,0,0-.219-.649,1.251,1.251,0,0,0-1.062-.412,1.188,1.188,0,0,0-.869.266.843.843,0,0,0-.265.616.606.606,0,0,0,.313.565,4.476,4.476,0,0,0,.927.287l.715.168a2.168,2.168,0,0,1,.8.333,1.266,1.266,0,0,1,.485,1.072,1.346,1.346,0,0,1-.621,1.251,2.721,2.721,0,0,1-1.442.377,2.127,2.127,0,0,1-1.5-.5,1.712,1.712,0,0,1-.531-1.352Z",
    transform: "translate(-733.9 -126.527)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1232",
    "data-name": "Grupo 1232",
    transform: "translate(737.736 128.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1231",
    "data-name": "Grupo 1231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1815",
    "data-name": "Trazado 1815",
    d: "M735.943,132.3a2.334,2.334,0,0,1-1.643-.559,1.922,1.922,0,0,1-.6-1.507.211.211,0,0,1,.211-.209h.671a.212.212,0,0,1,.21.2,1.275,1.275,0,0,0,.17.625,1.128,1.128,0,0,0,1.028.427,1.876,1.876,0,0,0,.632-.1.6.6,0,0,0,.476-.6.5.5,0,0,0-.17-.441,2.46,2.46,0,0,0-.755-.28l-.691-.161a3.24,3.24,0,0,1-1.027-.378,1.316,1.316,0,0,1-.579-1.16,1.749,1.749,0,0,1,.543-1.317,2.1,2.1,0,0,1,1.5-.513,2.52,2.52,0,0,1,1.49.438,1.662,1.662,0,0,1,.651,1.45.21.21,0,0,1-.21.211h-.671a.212.212,0,0,1-.209-.185,1.15,1.15,0,0,0-.179-.548,1.065,1.065,0,0,0-.894-.328,1.012,1.012,0,0,0-.721.2.641.641,0,0,0-.2.468.394.394,0,0,0,.207.383,4.136,4.136,0,0,0,.872.265l.714.168a2.312,2.312,0,0,1,.877.37,1.47,1.47,0,0,1,.571,1.239,1.551,1.551,0,0,1-.723,1.431,2.94,2.94,0,0,1-1.551.408m-1.814-1.853a1.432,1.432,0,0,0,.458.986,1.925,1.925,0,0,0,1.356.446,2.539,2.539,0,0,0,1.334-.345,1.145,1.145,0,0,0,.518-1.072,1.054,1.054,0,0,0-.4-.9,1.952,1.952,0,0,0-.719-.3l-.715-.168a4.085,4.085,0,0,1-.983-.309.816.816,0,0,1-.42-.749,1.051,1.051,0,0,1,.327-.765,1.39,1.39,0,0,1,1.018-.328,1.451,1.451,0,0,1,1.23.5,1.379,1.379,0,0,1,.232.566h.271a1.159,1.159,0,0,0-.465-.9,2.108,2.108,0,0,0-1.248-.361,1.69,1.69,0,0,0-1.208.4,1.324,1.324,0,0,0-.413,1.012.9.9,0,0,0,.394.811,2.89,2.89,0,0,0,.888.317l.692.162a2.708,2.708,0,0,1,.9.343.9.9,0,0,1,.353.787,1.01,1.01,0,0,1-.754.993,2.256,2.256,0,0,1-.776.128,1.532,1.532,0,0,1-1.382-.618,1.561,1.561,0,0,1-.218-.632Z",
    transform: "translate(-733.702 -126.33)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1234",
    "data-name": "Grupo 1234",
    transform: "translate(743.512 129.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1233",
    "data-name": "Grupo 1233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1816",
    "data-name": "Trazado 1816",
    d: "M739.128,126.652h.656v.731h-.656Zm0,1.445h.656v3.82h-.656Z",
    transform: "translate(-739.128 -126.652)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1236",
    "data-name": "Grupo 1236",
    transform: "translate(743.303 128.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1235",
    "data-name": "Grupo 1235",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1817",
    "data-name": "Trazado 1817",
    d: "M739.8,132.14h-.656a.209.209,0,0,1-.21-.21v-3.821a.209.209,0,0,1,.21-.21h.656a.21.21,0,0,1,.211.21v3.821a.21.21,0,0,1-.211.21m-.446-.42h.236v-3.4h-.236Zm.446-4.113h-.656a.21.21,0,0,1-.21-.211v-.731a.209.209,0,0,1,.21-.21h.656a.21.21,0,0,1,.211.21v.731a.211.211,0,0,1-.211.211m-.446-.422h.236v-.311h-.236Z",
    transform: "translate(-738.931 -126.455)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1238",
    "data-name": "Grupo 1238",
    transform: "translate(745.457 130.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1237",
    "data-name": "Grupo 1237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1818",
    "data-name": "Trazado 1818",
    d: "M741.575,130.633a.932.932,0,0,0,.165.495,1.047,1.047,0,0,0,.863.312,1.293,1.293,0,0,0,.644-.156.515.515,0,0,0,.278-.482.409.409,0,0,0-.223-.376,2.634,2.634,0,0,0-.56-.183l-.522-.129a2.566,2.566,0,0,1-.736-.273.81.81,0,0,1-.423-.724,1.1,1.1,0,0,1,.4-.881,1.6,1.6,0,0,1,1.069-.337,1.5,1.5,0,0,1,1.269.509,1.109,1.109,0,0,1,.236.7h-.61a.725.725,0,0,0-.158-.4,1.024,1.024,0,0,0-.789-.253.966.966,0,0,0-.567.139.431.431,0,0,0-.193.367.453.453,0,0,0,.253.4,1.567,1.567,0,0,0,.43.158l.435.1a3.376,3.376,0,0,1,.95.326.865.865,0,0,1,.377.778,1.175,1.175,0,0,1-.394.885,1.689,1.689,0,0,1-1.2.374,1.62,1.62,0,0,1-1.228-.39,1.461,1.461,0,0,1-.386-.962Z",
    transform: "translate(-740.955 -127.898)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1240",
    "data-name": "Grupo 1240",
    transform: "translate(745.246 130.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1239",
    "data-name": "Grupo 1239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1819",
    "data-name": "Trazado 1819",
    d: "M742.582,132.207a1.824,1.824,0,0,1-1.383-.457,1.671,1.671,0,0,1-.442-1.1.213.213,0,0,1,.21-.22h.62a.212.212,0,0,1,.211.193.72.72,0,0,0,.12.383.859.859,0,0,0,.7.231,1.091,1.091,0,0,0,.542-.129.306.306,0,0,0,.17-.3.2.2,0,0,0-.117-.194,2.489,2.489,0,0,0-.507-.161l-.521-.129a2.71,2.71,0,0,1-.8-.3,1.026,1.026,0,0,1-.52-.9,1.307,1.307,0,0,1,.472-1.042,1.812,1.812,0,0,1,1.206-.386,1.7,1.7,0,0,1,1.434.591,1.306,1.306,0,0,1,.28.828.21.21,0,0,1-.21.205h-.609a.211.211,0,0,1-.211-.193.513.513,0,0,0-.114-.283.854.854,0,0,0-.623-.172.786.786,0,0,0-.444.1.226.226,0,0,0-.105.2c0,.065.018.142.15.22a1.337,1.337,0,0,0,.373.133l.435.1a3.51,3.51,0,0,1,1.016.354,1.065,1.065,0,0,1,.47.954,1.383,1.383,0,0,1-.459,1.038,1.9,1.9,0,0,1-1.344.431m-1.38-1.352a1.2,1.2,0,0,0,.305.609,1.443,1.443,0,0,0,1.074.321,1.505,1.505,0,0,0,1.055-.315.968.968,0,0,0,.328-.732.658.658,0,0,0-.281-.6,3.1,3.1,0,0,0-.883-.3l-.435-.1a1.72,1.72,0,0,1-.491-.182.651.651,0,0,1-.354-.58.642.642,0,0,1,.28-.538,1.153,1.153,0,0,1,.69-.179,1.222,1.222,0,0,1,.945.323,1.013,1.013,0,0,1,.175.326h.2a.917.917,0,0,0-.172-.358,1.287,1.287,0,0,0-1.1-.426,1.4,1.4,0,0,0-.934.287.891.891,0,0,0-.324.721.6.6,0,0,0,.324.545,2.338,2.338,0,0,0,.675.247l.52.13a2.673,2.673,0,0,1,.613.2.619.619,0,0,1,.331.559.725.725,0,0,1-.387.666,1.5,1.5,0,0,1-.746.183,1.244,1.244,0,0,1-1.027-.392.991.991,0,0,1-.182-.415Z",
    transform: "translate(-740.757 -127.7)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1242",
    "data-name": "Grupo 1242",
    transform: "translate(749.523 129.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1241",
    "data-name": "Grupo 1241",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1820",
    "data-name": "Trazado 1820",
    d: "M745.294,126.985h.651v1.072h.613v.526h-.613v2.506a.273.273,0,0,0,.136.269.581.581,0,0,0,.252.039l.1,0a1.256,1.256,0,0,0,.126-.013v.513a1.57,1.57,0,0,1-.23.047,2.234,2.234,0,0,1-.261.014.7.7,0,0,1-.613-.231,1.028,1.028,0,0,1-.161-.6v-2.542h-.519v-.526h.519Z",
    transform: "translate(-744.775 -126.985)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1244",
    "data-name": "Grupo 1244",
    transform: "translate(749.313 129.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1243",
    "data-name": "Grupo 1243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1821",
    "data-name": "Trazado 1821",
    d: "M746.081,132.18a.9.9,0,0,1-.786-.321,1.237,1.237,0,0,1-.2-.721v-2.33h-.309a.211.211,0,0,1-.211-.211v-.527a.211.211,0,0,1,.211-.211h.309V127a.21.21,0,0,1,.211-.21h.651a.21.21,0,0,1,.212.21v.861h.4a.211.211,0,0,1,.211.211v.527a.211.211,0,0,1-.211.211h-.4v2.3c0,.016,0,.071.019.08a.4.4,0,0,0,.158.018l.091,0c.032,0,.067-.005.106-.011a.2.2,0,0,1,.166.05.212.212,0,0,1,.072.159v.513a.212.212,0,0,1-.152.2,1.78,1.78,0,0,1-.264.052,2.382,2.382,0,0,1-.285.016M745,128.386h.31a.21.21,0,0,1,.21.211v2.541a.829.829,0,0,0,.123.48.556.556,0,0,0,.441.142,2.014,2.014,0,0,0,.235-.013l.046-.006v-.119a.783.783,0,0,1-.364-.064.469.469,0,0,1-.249-.455V128.6a.211.211,0,0,1,.21-.211h.4v-.105h-.4a.211.211,0,0,1-.21-.211v-.861h-.232v.861a.21.21,0,0,1-.21.211H745Z",
    transform: "translate(-744.577 -126.788)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1246",
    "data-name": "Grupo 1246",
    transform: "translate(752.286 130.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1245",
    "data-name": "Grupo 1245",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1822",
    "data-name": "Trazado 1822",
    d: "M749.959,128.1a1.453,1.453,0,0,1,.581.5,1.73,1.73,0,0,1,.256.677,4.521,4.521,0,0,1,.056.845h-2.792a1.665,1.665,0,0,0,.275.94.911.911,0,0,0,.793.354,1.018,1.018,0,0,0,.8-.335,1.119,1.119,0,0,0,.237-.45h.634a1.329,1.329,0,0,1-.167.472,1.674,1.674,0,0,1-.316.425,1.481,1.481,0,0,1-.722.387,2.171,2.171,0,0,1-.523.057,1.6,1.6,0,0,1-1.208-.522,2.042,2.042,0,0,1-.494-1.46,2.219,2.219,0,0,1,.5-1.5,1.639,1.639,0,0,1,1.3-.577,1.729,1.729,0,0,1,.787.192m.231,1.507a1.664,1.664,0,0,0-.181-.67.926.926,0,0,0-.877-.466.964.964,0,0,0-.739.32,1.211,1.211,0,0,0-.317.815Z",
    transform: "translate(-747.37 -127.911)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1248",
    "data-name": "Grupo 1248",
    transform: "translate(752.075 130.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1247",
    "data-name": "Grupo 1247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1823",
    "data-name": "Trazado 1823",
    d: "M749.085,132.2a1.817,1.817,0,0,1-1.36-.587,2.253,2.253,0,0,1-.552-1.606,2.429,2.429,0,0,1,.551-1.639,1.844,1.844,0,0,1,1.462-.65,1.944,1.944,0,0,1,.881.215,1.656,1.656,0,0,1,.662.569,1.922,1.922,0,0,1,.289.758,4.515,4.515,0,0,1,.061.831.248.248,0,0,1,0,.049.218.218,0,0,1-.212.21H748.3a1.3,1.3,0,0,0,.218.607.707.707,0,0,0,.622.267.812.812,0,0,0,.643-.265.922.922,0,0,0,.191-.365.21.21,0,0,1,.2-.155h.635a.21.21,0,0,1,.158.07.222.222,0,0,1,.052.165,1.567,1.567,0,0,1-.193.547,1.9,1.9,0,0,1-.353.478,1.723,1.723,0,0,1-.82.439,2.409,2.409,0,0,1-.572.063m.1-4.061a1.432,1.432,0,0,0-1.145.5,2.027,2.027,0,0,0-.446,1.365,1.843,1.843,0,0,0,.437,1.316,1.381,1.381,0,0,0,1.054.457,1.913,1.913,0,0,0,.471-.052,1.269,1.269,0,0,0,.626-.332,1.522,1.522,0,0,0,.28-.376,1.652,1.652,0,0,0,.076-.161h-.209a1.346,1.346,0,0,1-.229.378,1.228,1.228,0,0,1-.959.408,1.111,1.111,0,0,1-.963-.442,1.867,1.867,0,0,1-.315-1.056.21.21,0,0,1,.061-.152.206.206,0,0,1,.15-.065h2.58a3.389,3.389,0,0,0-.05-.591,1.549,1.549,0,0,0-.227-.606,1.255,1.255,0,0,0-.5-.425,1.547,1.547,0,0,0-.693-.169m1.018,1.7h-2.115a.211.211,0,0,1-.209-.218,1.426,1.426,0,0,1,.371-.951,1.176,1.176,0,0,1,.893-.387,1.139,1.139,0,0,1,1.061.573,1.83,1.83,0,0,1,.208.754.206.206,0,0,1-.054.162.21.21,0,0,1-.155.068m-1.878-.42h1.636a1.167,1.167,0,0,0-.122-.356.717.717,0,0,0-.7-.36.757.757,0,0,0-.584.253.925.925,0,0,0-.234.462",
    transform: "translate(-747.172 -127.713)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1250",
    "data-name": "Grupo 1250",
    transform: "translate(757.137 130.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1249",
    "data-name": "Grupo 1249",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1824",
    "data-name": "Trazado 1824",
    d: "M751.927,128h.639v.545a2.1,2.1,0,0,1,.415-.412,1.25,1.25,0,0,1,.724-.219,1.146,1.146,0,0,1,.739.226,1.169,1.169,0,0,1,.286.38,1.4,1.4,0,0,1,.5-.457,1.42,1.42,0,0,1,.654-.149,1.068,1.068,0,0,1,1.054.559,1.837,1.837,0,0,1,.151.811v2.555h-.671v-2.667a.622.622,0,0,0-.193-.527.758.758,0,0,0-.467-.144.932.932,0,0,0-.655.254,1.118,1.118,0,0,0-.275.849v2.233h-.656V129.33a1.311,1.311,0,0,0-.093-.57.569.569,0,0,0-.548-.268.947.947,0,0,0-.665.282,1.393,1.393,0,0,0-.3,1.026v2.035h-.645Z",
    transform: "translate(-751.927 -127.911)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1252",
    "data-name": "Grupo 1252",
    transform: "translate(756.926 130.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1251",
    "data-name": "Grupo 1251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1825",
    "data-name": "Trazado 1825",
    d: "M757.1,132.059h-.671a.21.21,0,0,1-.211-.21v-2.668a.477.477,0,0,0-.106-.359.56.56,0,0,0-.343-.1.72.72,0,0,0-.511.2.936.936,0,0,0-.207.7v2.233a.21.21,0,0,1-.211.21h-.656a.21.21,0,0,1-.21-.21v-2.506a1.074,1.074,0,0,0-.07-.474c-.035-.064-.113-.155-.362-.155a.738.738,0,0,0-.519.227,1.232,1.232,0,0,0-.234.872v2.036a.209.209,0,0,1-.21.21h-.645a.21.21,0,0,1-.211-.21v-3.84a.21.21,0,0,1,.211-.21h.638a.21.21,0,0,1,.211.21v.024c.029-.023.056-.045.086-.065a1.468,1.468,0,0,1,.843-.257,1.354,1.354,0,0,1,.871.273,1.2,1.2,0,0,1,.178.187,1.5,1.5,0,0,1,.385-.287,1.631,1.631,0,0,1,.748-.172,1.266,1.266,0,0,1,1.242.676,2,2,0,0,1,.173.9v2.556a.21.21,0,0,1-.211.21m-.46-.42h.249v-2.345a1.624,1.624,0,0,0-.129-.716.866.866,0,0,0-.866-.443,1.128,1.128,0,0,0-.985.515.211.211,0,0,1-.36-.023.986.986,0,0,0-.233-.314.944.944,0,0,0-.6-.178,1.039,1.039,0,0,0-.606.182,1.487,1.487,0,0,0-.208.184,1.106,1.106,0,0,1,.644-.207.766.766,0,0,1,.733.378,1.481,1.481,0,0,1,.119.672v2.3h.235v-2.023a1.317,1.317,0,0,1,.341-1,1.136,1.136,0,0,1,.8-.311.963.963,0,0,1,.594.185.815.815,0,0,1,.277.7Zm-4.494,0h.224v-1.826a1.776,1.776,0,0,1,.258-1.055.216.216,0,0,1-.125,0,.212.212,0,0,1-.141-.2v-.334h-.216Z",
    transform: "translate(-751.729 -127.713)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1254",
    "data-name": "Grupo 1254",
    transform: "translate(763.622 130.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1253",
    "data-name": "Grupo 1253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1826",
    "data-name": "Trazado 1826",
    d: "M760.256,129.513a.351.351,0,0,0,.3-.186.569.569,0,0,0,.044-.248.532.532,0,0,0-.235-.481,1.255,1.255,0,0,0-.671-.149.852.852,0,0,0-.715.274.9.9,0,0,0-.153.45h-.6a1.116,1.116,0,0,1,.46-.99,1.879,1.879,0,0,1,1.026-.278,2.08,2.08,0,0,1,1.1.258.874.874,0,0,1,.419.8v2.212a.272.272,0,0,0,.041.161c.027.04.085.061.174.061a.829.829,0,0,0,.1-.005c.035,0,.073-.009.114-.016v.477a1.641,1.641,0,0,1-.229.053,1.605,1.605,0,0,1-.215.012.533.533,0,0,1-.484-.237.927.927,0,0,1-.112-.354,1.629,1.629,0,0,1-.565.448,1.751,1.751,0,0,1-.814.191,1.212,1.212,0,0,1-.873-.325,1.076,1.076,0,0,1-.339-.811,1.043,1.043,0,0,1,.333-.827,1.59,1.59,0,0,1,.875-.361Zm-1.358,1.743a.757.757,0,0,0,.484.161,1.464,1.464,0,0,0,.659-.158.884.884,0,0,0,.538-.855v-.519a1.08,1.08,0,0,1-.3.127,2.573,2.573,0,0,1-.365.071l-.39.05a1.486,1.486,0,0,0-.527.147.569.569,0,0,0-.3.536.53.53,0,0,0,.2.44",
    transform: "translate(-758.02 -127.905)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1256",
    "data-name": "Grupo 1256",
    transform: "translate(763.413 130.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1255",
    "data-name": "Grupo 1255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1827",
    "data-name": "Trazado 1827",
    d: "M759.245,132.188a1.421,1.421,0,0,1-1.019-.382,1.286,1.286,0,0,1-.4-.963,1.249,1.249,0,0,1,.4-.985,1.8,1.8,0,0,1,.987-.413l1.029-.129c.109-.013.127-.053.134-.068a.358.358,0,0,0,.022-.158.312.312,0,0,0-.137-.3,1.058,1.058,0,0,0-.558-.116.66.66,0,0,0-.548.191.7.7,0,0,0-.112.348.212.212,0,0,1-.209.185h-.6a.211.211,0,0,1-.15-.064.214.214,0,0,1-.061-.152,1.315,1.315,0,0,1,.559-1.162,2.1,2.1,0,0,1,1.138-.311,2.3,2.3,0,0,1,1.208.288,1.091,1.091,0,0,1,.519.983V131.2c.019,0,.05,0,.08,0s.064-.007.1-.014a.214.214,0,0,1,.172.046.211.211,0,0,1,.076.162v.477a.211.211,0,0,1-.152.2,2.184,2.184,0,0,1-.258.06,1.835,1.835,0,0,1-.245.013.737.737,0,0,1-.662-.334c-.013-.02-.024-.043-.036-.066a2.206,2.206,0,0,1-.367.233,1.966,1.966,0,0,1-.909.214m.46-3.938a1.432,1.432,0,0,1,.785.183.729.729,0,0,1,.331.657.762.762,0,0,1-.064.342.551.551,0,0,1-.46.3l-1.029.129a1.4,1.4,0,0,0-.762.311.837.837,0,0,0-.262.67.867.867,0,0,0,.273.659,1,1,0,0,0,.728.266,1.547,1.547,0,0,0,.716-.167,1.742,1.742,0,0,0,.353-.235,1.5,1.5,0,0,1-.168.1,1.3,1.3,0,0,1-1.366-.028.741.741,0,0,1-.284-.6.78.78,0,0,1,.407-.721,1.7,1.7,0,0,1,.6-.171l.391-.051a2.26,2.26,0,0,0,.336-.066.872.872,0,0,0,.246-.1.209.209,0,0,1,.214-.007.213.213,0,0,1,.111.184v.518a1.117,1.117,0,0,1-.238.722.2.2,0,0,1,.113,0,.211.211,0,0,1,.155.175.679.679,0,0,0,.081.271.314.314,0,0,0,.305.138,1.464,1.464,0,0,0,.187-.009l.047-.01v-.081h0a.392.392,0,0,1-.348-.153.493.493,0,0,1-.078-.279v-2.212a.664.664,0,0,0-.318-.624,1.887,1.887,0,0,0-.989-.227,1.659,1.659,0,0,0-.913.246.8.8,0,0,0-.345.6h.2a.947.947,0,0,1,.164-.369,1.05,1.05,0,0,1,.881-.354m.677,1.965-.038.011a2.839,2.839,0,0,1-.395.078l-.387.05a1.245,1.245,0,0,0-.45.121.362.362,0,0,0-.194.353.319.319,0,0,0,.123.274.548.548,0,0,0,.354.116,1.276,1.276,0,0,0,.566-.135.678.678,0,0,0,.421-.667Z",
    transform: "translate(-757.823 -127.707)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1258",
    "data-name": "Grupo 1258",
    transform: "translate(770.752 129.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1257",
    "data-name": "Grupo 1257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1828",
    "data-name": "Trazado 1828",
    d: "M767.1,128.2a1.711,1.711,0,0,1,.388.377v-1.939h.621v5.283h-.581v-.533a1.4,1.4,0,0,1-.531.512,1.519,1.519,0,0,1-.7.158,1.423,1.423,0,0,1-1.107-.539,2.116,2.116,0,0,1-.468-1.436,2.489,2.489,0,0,1,.427-1.454,1.394,1.394,0,0,1,1.219-.614,1.366,1.366,0,0,1,.737.186m-1.44,2.878a.911.911,0,0,0,.833.416.878.878,0,0,0,.733-.386,1.829,1.829,0,0,0,.287-1.1,1.644,1.644,0,0,0-.3-1.077.924.924,0,0,0-.732-.349.965.965,0,0,0-.786.373,1.717,1.717,0,0,0-.3,1.1,1.908,1.908,0,0,0,.261,1.033",
    transform: "translate(-764.718 -126.635)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1260",
    "data-name": "Grupo 1260",
    transform: "translate(770.543 128.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1259",
    "data-name": "Grupo 1259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1829",
    "data-name": "Trazado 1829",
    d: "M766.306,132.278a1.634,1.634,0,0,1-1.267-.612,2.332,2.332,0,0,1-.518-1.573,2.71,2.71,0,0,1,.463-1.574,1.6,1.6,0,0,1,1.392-.7,1.574,1.574,0,0,1,.848.219.731.731,0,0,1,.066.046v-1.431a.211.211,0,0,1,.211-.211h.621a.211.211,0,0,1,.211.211v5.283a.211.211,0,0,1-.211.211h-.581a.21.21,0,0,1-.209-.192,1.3,1.3,0,0,1-.228.147,1.735,1.735,0,0,1-.8.181m.07-4.043a1.186,1.186,0,0,0-1.045.524,2.286,2.286,0,0,0-.389,1.334,1.912,1.912,0,0,0,.416,1.3,1.209,1.209,0,0,0,.947.467,1.324,1.324,0,0,0,.608-.135,1.147,1.147,0,0,0,.4-.361,1.056,1.056,0,0,1-.8.353,1.112,1.112,0,0,1-1.015-.515,2.122,2.122,0,0,1-.293-1.143,1.93,1.93,0,0,1,.348-1.229,1.171,1.171,0,0,1,.951-.45,1.128,1.128,0,0,1,.891.424,1.843,1.843,0,0,1,.346,1.214,2.074,2.074,0,0,1-.311,1.207.21.21,0,0,1,.326.176v.325h.16v-4.864h-.2v1.73a.211.211,0,0,1-.375.132,1.475,1.475,0,0,0-.337-.331,1.158,1.158,0,0,0-.624-.153m.123.562a.756.756,0,0,0-.623.295,1.524,1.524,0,0,0-.254.964,1.708,1.708,0,0,0,.229.921.708.708,0,0,0,.657.317.672.672,0,0,0,.563-.3,1.644,1.644,0,0,0,.245-.979,1.456,1.456,0,0,0-.247-.942.712.712,0,0,0-.57-.275",
    transform: "translate(-764.521 -126.437)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1262",
    "data-name": "Grupo 1262",
    transform: "translate(775.44 130.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1261",
    "data-name": "Grupo 1261",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1830",
    "data-name": "Trazado 1830",
    d: "M771.711,128.1a1.468,1.468,0,0,1,.581.5,1.714,1.714,0,0,1,.256.677,4.423,4.423,0,0,1,.057.845h-2.792a1.656,1.656,0,0,0,.275.94.91.91,0,0,0,.792.354,1.021,1.021,0,0,0,.8-.335,1.145,1.145,0,0,0,.237-.45h.633a1.3,1.3,0,0,1-.166.472,1.671,1.671,0,0,1-.316.425,1.484,1.484,0,0,1-.723.387,2.158,2.158,0,0,1-.523.057,1.6,1.6,0,0,1-1.207-.522,2.037,2.037,0,0,1-.494-1.46,2.218,2.218,0,0,1,.5-1.5,1.641,1.641,0,0,1,1.3-.577,1.734,1.734,0,0,1,.788.192m.231,1.507a1.665,1.665,0,0,0-.181-.67.927.927,0,0,0-.878-.466.967.967,0,0,0-.739.32,1.211,1.211,0,0,0-.316.815Z",
    transform: "translate(-769.122 -127.911)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1264",
    "data-name": "Grupo 1264",
    transform: "translate(775.228 130.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1263",
    "data-name": "Grupo 1263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1831",
    "data-name": "Trazado 1831",
    d: "M770.836,132.2a1.813,1.813,0,0,1-1.359-.587,2.247,2.247,0,0,1-.554-1.606,2.428,2.428,0,0,1,.55-1.639,1.85,1.85,0,0,1,1.464-.65,1.946,1.946,0,0,1,.881.215,1.671,1.671,0,0,1,.662.569,1.919,1.919,0,0,1,.287.758,4.424,4.424,0,0,1,.06.831.189.189,0,0,1,.006.049.21.21,0,0,1-.211.21h-2.571a1.312,1.312,0,0,0,.217.607.71.71,0,0,0,.623.267.812.812,0,0,0,.643-.265.919.919,0,0,0,.192-.365.209.209,0,0,1,.2-.155h.634a.211.211,0,0,1,.157.07.215.215,0,0,1,.051.166,1.54,1.54,0,0,1-.19.546,1.915,1.915,0,0,1-.356.478,1.71,1.71,0,0,1-.819.439,2.4,2.4,0,0,1-.572.063m.1-4.061a1.434,1.434,0,0,0-1.147.5,2.028,2.028,0,0,0-.447,1.365,1.844,1.844,0,0,0,.439,1.316,1.383,1.383,0,0,0,1.054.457,1.922,1.922,0,0,0,.473-.052,1.266,1.266,0,0,0,.625-.332,1.5,1.5,0,0,0,.279-.376,1.465,1.465,0,0,0,.077-.161h-.209a1.325,1.325,0,0,1-.228.377,1.229,1.229,0,0,1-.96.409,1.113,1.113,0,0,1-.963-.442,1.872,1.872,0,0,1-.314-1.056.213.213,0,0,1,.211-.217H772.4a3.371,3.371,0,0,0-.05-.591,1.562,1.562,0,0,0-.226-.606,1.266,1.266,0,0,0-.5-.425,1.543,1.543,0,0,0-.692-.169m1.018,1.7H769.84a.211.211,0,0,1-.21-.218,1.422,1.422,0,0,1,.373-.951,1.171,1.171,0,0,1,.893-.387,1.144,1.144,0,0,1,1.061.573,1.881,1.881,0,0,1,.208.754.215.215,0,0,1-.054.162.212.212,0,0,1-.155.068m-1.88-.42h1.637a1.156,1.156,0,0,0-.121-.356.717.717,0,0,0-.7-.36.761.761,0,0,0-.585.253.934.934,0,0,0-.235.462",
    transform: "translate(-768.923 -127.713)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1266",
    "data-name": "Grupo 1266",
    transform: "translate(782.9 129.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1265",
    "data-name": "Grupo 1265"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_433",
    "data-name": "Rect\\xE1ngulo 433",
    width: 0.644,
    height: 5.265,
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1268",
    "data-name": "Grupo 1268",
    transform: "translate(782.689 128.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1267",
    "data-name": "Grupo 1267",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1832",
    "data-name": "Trazado 1832",
    d: "M776.787,132.14h-.645a.209.209,0,0,1-.21-.21v-5.266a.209.209,0,0,1,.21-.21h.645a.209.209,0,0,1,.21.21v5.266a.209.209,0,0,1-.21.21m-.434-.42h.225v-4.844h-.225Z",
    transform: "translate(-775.932 -126.455)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1270",
    "data-name": "Grupo 1270",
    transform: "translate(784.883 130.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1269",
    "data-name": "Grupo 1269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1833",
    "data-name": "Trazado 1833",
    d: "M780.229,129.513a.351.351,0,0,0,.3-.186.571.571,0,0,0,.043-.248.531.531,0,0,0-.234-.481,1.255,1.255,0,0,0-.671-.149.85.85,0,0,0-.715.274.912.912,0,0,0-.154.45h-.6a1.116,1.116,0,0,1,.461-.99,1.876,1.876,0,0,1,1.026-.278,2.082,2.082,0,0,1,1.1.258.876.876,0,0,1,.419.8v2.212a.279.279,0,0,0,.04.161.2.2,0,0,0,.175.061.841.841,0,0,0,.1-.005c.035,0,.073-.009.114-.016v.477a1.646,1.646,0,0,1-.23.053,1.583,1.583,0,0,1-.215.012.532.532,0,0,1-.483-.237.909.909,0,0,1-.112-.354,1.625,1.625,0,0,1-.566.448,1.745,1.745,0,0,1-.813.191,1.212,1.212,0,0,1-.873-.325,1.077,1.077,0,0,1-.339-.811,1.043,1.043,0,0,1,.333-.827,1.59,1.59,0,0,1,.875-.361Zm-1.358,1.743a.755.755,0,0,0,.483.161,1.468,1.468,0,0,0,.66-.158.884.884,0,0,0,.537-.855v-.519a1.092,1.092,0,0,1-.3.127,2.63,2.63,0,0,1-.365.071l-.39.05a1.5,1.5,0,0,0-.528.147.568.568,0,0,0-.3.536.529.529,0,0,0,.2.44",
    transform: "translate(-777.993 -127.905)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1272",
    "data-name": "Grupo 1272",
    transform: "translate(784.674 130.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1271",
    "data-name": "Grupo 1271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1834",
    "data-name": "Trazado 1834",
    d: "M779.218,132.188a1.417,1.417,0,0,1-1.019-.383,1.282,1.282,0,0,1-.4-.962,1.249,1.249,0,0,1,.4-.985,1.8,1.8,0,0,1,.987-.413l1.029-.129c.109-.013.127-.053.133-.068a.332.332,0,0,0,.023-.158.312.312,0,0,0-.137-.3,1.058,1.058,0,0,0-.558-.116.66.66,0,0,0-.548.191.715.715,0,0,0-.113.348.21.21,0,0,1-.209.185h-.6a.211.211,0,0,1-.21-.216,1.313,1.313,0,0,1,.559-1.162,2.1,2.1,0,0,1,1.138-.311A2.3,2.3,0,0,1,780.9,128a1.092,1.092,0,0,1,.519.983V131.2a.793.793,0,0,0,.081,0c.03,0,.063-.007.1-.014a.215.215,0,0,1,.172.046.21.21,0,0,1,.074.162v.477a.21.21,0,0,1-.151.2,2.235,2.235,0,0,1-.258.06,1.866,1.866,0,0,1-.246.013.735.735,0,0,1-.661-.334.743.743,0,0,1-.037-.066,2.162,2.162,0,0,1-.366.233,1.966,1.966,0,0,1-.909.214m.46-3.938a1.434,1.434,0,0,1,.785.183.731.731,0,0,1,.331.657.768.768,0,0,1-.065.343.547.547,0,0,1-.46.3l-1.029.129a1.4,1.4,0,0,0-.762.311.84.84,0,0,0-.261.67.867.867,0,0,0,.274.659,1,1,0,0,0,.728.266,1.54,1.54,0,0,0,.715-.167,1.723,1.723,0,0,0,.354-.235,1.427,1.427,0,0,1-.169.1,1.3,1.3,0,0,1-1.366-.028.743.743,0,0,1-.283-.6.779.779,0,0,1,.406-.721,1.718,1.718,0,0,1,.6-.171l.391-.051a2.29,2.29,0,0,0,.336-.066.871.871,0,0,0,.246-.1.209.209,0,0,1,.214-.007.212.212,0,0,1,.11.184v.518a1.12,1.12,0,0,1-.238.722.207.207,0,0,1,.114,0,.213.213,0,0,1,.155.174.694.694,0,0,0,.08.273.316.316,0,0,0,.306.138,1.461,1.461,0,0,0,.187-.009l.048-.01v-.081h0a.391.391,0,0,1-.349-.154.488.488,0,0,1-.078-.278v-2.212a.664.664,0,0,0-.317-.624,1.887,1.887,0,0,0-.989-.227,1.678,1.678,0,0,0-.913.246.8.8,0,0,0-.346.6h.2a.948.948,0,0,1,.165-.369,1.05,1.05,0,0,1,.881-.354m.677,1.965-.038.011a2.871,2.871,0,0,1-.395.078l-.389.05a1.261,1.261,0,0,0-.45.121.363.363,0,0,0-.193.353.319.319,0,0,0,.123.274.546.546,0,0,0,.353.116,1.273,1.273,0,0,0,.566-.135.677.677,0,0,0,.422-.667Z",
    transform: "translate(-777.796 -127.707)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1274",
    "data-name": "Grupo 1274",
    transform: "translate(792.533 129.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1273",
    "data-name": "Grupo 1273"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_434",
    "data-name": "Rect\\xE1ngulo 434",
    width: 0.721,
    height: 5.265,
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1276",
    "data-name": "Grupo 1276",
    transform: "translate(792.322 128.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1275",
    "data-name": "Grupo 1275",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1835",
    "data-name": "Trazado 1835",
    d: "M785.912,132.14h-.72a.211.211,0,0,1-.212-.21v-5.266a.211.211,0,0,1,.212-.21h.72a.21.21,0,0,1,.211.21v5.266a.21.21,0,0,1-.211.21m-.51-.42h.3v-4.844h-.3Z",
    transform: "translate(-784.981 -126.455)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1278",
    "data-name": "Grupo 1278",
    transform: "translate(794.876 130.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1277",
    "data-name": "Grupo 1277",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1836",
    "data-name": "Trazado 1836",
    d: "M787.38,128h.612v.545a1.732,1.732,0,0,1,.577-.484,1.548,1.548,0,0,1,.678-.147,1.117,1.117,0,0,1,1.1.571,2.016,2.016,0,0,1,.157.892v2.462h-.656v-2.42a1.33,1.33,0,0,0-.1-.566.633.633,0,0,0-.624-.358,1.276,1.276,0,0,0-.377.046.974.974,0,0,0-.466.316.955.955,0,0,0-.21.392,2.658,2.658,0,0,0-.049.579v2.011h-.644Z",
    transform: "translate(-787.38 -127.911)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1280",
    "data-name": "Grupo 1280",
    transform: "translate(794.665 130.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1279",
    "data-name": "Grupo 1279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1837",
    "data-name": "Trazado 1837",
    d: "M790.522,132.059h-.656a.211.211,0,0,1-.212-.21v-2.42a1.1,1.1,0,0,0-.083-.475.414.414,0,0,0-.433-.241,1.08,1.08,0,0,0-.314.037.748.748,0,0,0-.367.251.731.731,0,0,0-.166.305,2.432,2.432,0,0,0-.043.53v2.011a.21.21,0,0,1-.211.21h-.645a.21.21,0,0,1-.211-.21v-3.84a.21.21,0,0,1,.211-.21h.613a.21.21,0,0,1,.211.21v.043a1.481,1.481,0,0,1,.276-.17,1.742,1.742,0,0,1,.767-.169,1.317,1.317,0,0,1,1.292.687,2.2,2.2,0,0,1,.18.987v2.463a.21.21,0,0,1-.21.21m-.446-.42h.235v-2.252a1.822,1.822,0,0,0-.135-.8.919.919,0,0,0-.917-.455,1.331,1.331,0,0,0-.585.127,1.5,1.5,0,0,0-.5.427.215.215,0,0,1-.234.066.211.211,0,0,1-.141-.2v-.334H787.6v3.418h.225v-1.8a2.828,2.828,0,0,1,.053-.628,1.171,1.171,0,0,1,.254-.48,1.184,1.184,0,0,1,.566-.381,1.447,1.447,0,0,1,.436-.055.835.835,0,0,1,.813.478,1.5,1.5,0,0,1,.125.658Z",
    transform: "translate(-787.182 -127.713)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1282",
    "data-name": "Grupo 1282",
    transform: "translate(799.118 129.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1281",
    "data-name": "Grupo 1281",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1838",
    "data-name": "Trazado 1838",
    d: "M791.885,126.985h.653v1.072h.612v.526h-.612v2.506a.272.272,0,0,0,.136.269.575.575,0,0,0,.251.039l.1,0a1.238,1.238,0,0,0,.125-.013v.513a1.572,1.572,0,0,1-.23.047,2.215,2.215,0,0,1-.26.014.7.7,0,0,1-.614-.231,1.036,1.036,0,0,1-.161-.6v-2.542h-.519v-.526h.519Z",
    transform: "translate(-791.365 -126.985)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1284",
    "data-name": "Grupo 1284",
    transform: "translate(798.907 129.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1283",
    "data-name": "Grupo 1283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1839",
    "data-name": "Trazado 1839",
    d: "M792.672,132.18a.9.9,0,0,1-.787-.321,1.238,1.238,0,0,1-.2-.721v-2.33h-.31a.211.211,0,0,1-.211-.211v-.527a.211.211,0,0,1,.211-.211h.31V127a.21.21,0,0,1,.21-.21h.653a.21.21,0,0,1,.211.21v.861h.4a.211.211,0,0,1,.211.211v.527a.211.211,0,0,1-.211.211h-.4v2.3c0,.012,0,.071.019.08a.838.838,0,0,0,.249.016c.031,0,.066-.005.106-.011a.2.2,0,0,1,.166.05.212.212,0,0,1,.072.159v.513a.213.213,0,0,1-.152.2,1.794,1.794,0,0,1-.265.052,2.377,2.377,0,0,1-.284.016m-1.084-3.794h.309a.211.211,0,0,1,.211.211v2.541a.829.829,0,0,0,.123.48.556.556,0,0,0,.441.142,2.028,2.028,0,0,0,.235-.013l.045-.006v-.119a.764.764,0,0,1-.364-.064.47.47,0,0,1-.248-.455V128.6a.21.21,0,0,1,.21-.211h.4v-.105h-.4a.21.21,0,0,1-.21-.211v-.861h-.232v.861a.211.211,0,0,1-.211.211h-.309Z",
    transform: "translate(-791.167 -126.788)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1286",
    "data-name": "Grupo 1286",
    transform: "translate(801.88 130.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1285",
    "data-name": "Grupo 1285",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1840",
    "data-name": "Trazado 1840",
    d: "M796.55,128.1a1.457,1.457,0,0,1,.58.5,1.7,1.7,0,0,1,.257.677,4.412,4.412,0,0,1,.057.845h-2.792a1.648,1.648,0,0,0,.275.94.91.91,0,0,0,.792.354,1.02,1.02,0,0,0,.8-.335,1.144,1.144,0,0,0,.237-.45h.633a1.3,1.3,0,0,1-.166.472,1.671,1.671,0,0,1-.316.425,1.484,1.484,0,0,1-.723.387,2.164,2.164,0,0,1-.523.057,1.6,1.6,0,0,1-1.207-.522,2.038,2.038,0,0,1-.495-1.46,2.219,2.219,0,0,1,.5-1.5,1.641,1.641,0,0,1,1.3-.577,1.733,1.733,0,0,1,.788.192m.231,1.507a1.664,1.664,0,0,0-.181-.67.927.927,0,0,0-.878-.466.966.966,0,0,0-.739.32,1.21,1.21,0,0,0-.316.815Z",
    transform: "translate(-793.96 -127.911)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1288",
    "data-name": "Grupo 1288",
    transform: "translate(801.669 130.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1287",
    "data-name": "Grupo 1287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1841",
    "data-name": "Trazado 1841",
    d: "M795.675,132.2a1.813,1.813,0,0,1-1.359-.587,2.249,2.249,0,0,1-.554-1.606,2.428,2.428,0,0,1,.55-1.639,1.848,1.848,0,0,1,1.463-.65,1.951,1.951,0,0,1,.882.215,1.668,1.668,0,0,1,.661.569,1.923,1.923,0,0,1,.288.758,4.342,4.342,0,0,1,.06.831.184.184,0,0,1,.006.049.21.21,0,0,1-.211.21h-2.571a1.313,1.313,0,0,0,.217.607.71.71,0,0,0,.623.267.812.812,0,0,0,.643-.265.91.91,0,0,0,.191-.365.209.209,0,0,1,.2-.155h.634a.211.211,0,0,1,.209.235,1.538,1.538,0,0,1-.19.547,1.881,1.881,0,0,1-.356.477,1.7,1.7,0,0,1-.82.44,2.394,2.394,0,0,1-.57.063m.1-4.061a1.431,1.431,0,0,0-1.145.5,2.028,2.028,0,0,0-.447,1.365,1.839,1.839,0,0,0,.439,1.316,1.383,1.383,0,0,0,1.054.457,1.928,1.928,0,0,0,.473-.052,1.265,1.265,0,0,0,.625-.332,1.47,1.47,0,0,0,.279-.376,1.271,1.271,0,0,0,.077-.161h-.209a1.33,1.33,0,0,1-.229.378,1.228,1.228,0,0,1-.959.408,1.113,1.113,0,0,1-.963-.442,1.867,1.867,0,0,1-.314-1.056.213.213,0,0,1,.211-.217h2.579a3.4,3.4,0,0,0-.05-.591,1.564,1.564,0,0,0-.226-.606,1.274,1.274,0,0,0-.5-.425,1.548,1.548,0,0,0-.693-.169m1.019,1.7h-2.115a.211.211,0,0,1-.21-.218,1.422,1.422,0,0,1,.373-.951,1.171,1.171,0,0,1,.893-.387,1.144,1.144,0,0,1,1.061.573,1.9,1.9,0,0,1,.208.754.215.215,0,0,1-.054.162.212.212,0,0,1-.155.068m-1.88-.42h1.637a1.166,1.166,0,0,0-.121-.356.717.717,0,0,0-.7-.36.761.761,0,0,0-.585.253.936.936,0,0,0-.235.462",
    transform: "translate(-793.762 -127.713)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1290",
    "data-name": "Grupo 1290",
    transform: "translate(806.477 130.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1289",
    "data-name": "Grupo 1289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1842",
    "data-name": "Trazado 1842",
    d: "M800.668,128.149a1.8,1.8,0,0,1,.37.366v-.484h.6v3.491a2.585,2.585,0,0,1-.214,1.154,1.539,1.539,0,0,1-1.512.781,1.853,1.853,0,0,1-1.04-.278,1.089,1.089,0,0,1-.472-.869h.657a.722.722,0,0,0,.185.4,1.17,1.17,0,0,0,1.651-.308,3,3,0,0,0,.125-1.1,1.27,1.27,0,0,1-.465.438,1.661,1.661,0,0,1-1.8-.3,1.947,1.947,0,0,1-.465-1.464,2.217,2.217,0,0,1,.469-1.505,1.447,1.447,0,0,1,1.133-.541,1.4,1.4,0,0,1,.787.221m.078.692A.935.935,0,0,0,800,128.5a.919.919,0,0,0-.927.638,2.509,2.509,0,0,0-.132.893,1.59,1.59,0,0,0,.262.987.845.845,0,0,0,.7.339.989.989,0,0,0,.974-.627,2.033,2.033,0,0,0,.156-.827,1.6,1.6,0,0,0-.293-1.058",
    transform: "translate(-798.279 -127.928)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1292",
    "data-name": "Grupo 1292",
    transform: "translate(806.267 130.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1291",
    "data-name": "Grupo 1291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1843",
    "data-name": "Trazado 1843",
    d: "M799.92,133.682a2.062,2.062,0,0,1-1.155-.312,1.291,1.291,0,0,1-.565-1.027.208.208,0,0,1,.21-.228h.656a.21.21,0,0,1,.208.172.531.531,0,0,0,.127.287.761.761,0,0,0,.535.152c.539,0,.7-.227.773-.4a1.522,1.522,0,0,0,.094-.48,1.423,1.423,0,0,1-.142.087,1.756,1.756,0,0,1-.815.168,1.732,1.732,0,0,1-1.232-.5,2.149,2.149,0,0,1-.532-1.617,2.432,2.432,0,0,1,.522-1.642,1.658,1.658,0,0,1,1.292-.614,1.6,1.6,0,0,1,.9.258l.047.033a.211.211,0,0,1,.21-.186h.594a.209.209,0,0,1,.21.211v3.49a2.755,2.755,0,0,1-.236,1.25,1.738,1.738,0,0,1-1.7.9m-1.261-1.146a.8.8,0,0,0,.338.483,1.651,1.651,0,0,0,.923.243,1.335,1.335,0,0,0,1.324-.666,2.4,2.4,0,0,0,.192-1.059v-3.28h-.175v.272a.211.211,0,0,1-.142.2.213.213,0,0,1-.234-.069,1.6,1.6,0,0,0-.325-.321,1.169,1.169,0,0,0-.666-.185,1.235,1.235,0,0,0-.975.468,2.037,2.037,0,0,0-.418,1.367,1.774,1.774,0,0,0,.4,1.312,1.316,1.316,0,0,0,.943.384,1.334,1.334,0,0,0,.618-.119,1.043,1.043,0,0,0,.386-.366.212.212,0,0,1,.235-.086.209.209,0,0,1,.151.2,3.131,3.131,0,0,1-.142,1.188,1.371,1.371,0,0,1-1.992.373.871.871,0,0,1-.2-.336Zm1.261-.957a1.049,1.049,0,0,1-.87-.42,1.791,1.791,0,0,1-.307-1.117,2.746,2.746,0,0,1,.146-.968,1.2,1.2,0,0,1,2.03-.354,1.819,1.819,0,0,1,.342,1.193,2.257,2.257,0,0,1-.174.913,1.2,1.2,0,0,1-1.167.753m.094-2.857a.711.711,0,0,0-.731.5,2.3,2.3,0,0,0-.118.815,1.4,1.4,0,0,0,.218.859.634.634,0,0,0,.538.258.778.778,0,0,0,.781-.5,1.839,1.839,0,0,0,.138-.742,1.427,1.427,0,0,0-.242-.922.727.727,0,0,0-.584-.269",
    transform: "translate(-798.081 -127.73)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1294",
    "data-name": "Grupo 1294",
    transform: "translate(811.383 130.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1293",
    "data-name": "Grupo 1293",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1844",
    "data-name": "Trazado 1844",
    d: "M802.887,128h.612v.663a1.483,1.483,0,0,1,.369-.472.957.957,0,0,1,.678-.278l.061,0,.147.015v.681a.855.855,0,0,0-.106-.015c-.032,0-.067,0-.105,0a.918.918,0,0,0-.748.314,1.087,1.087,0,0,0-.263.722v2.208h-.644Z",
    transform: "translate(-802.887 -127.911)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1296",
    "data-name": "Grupo 1296",
    transform: "translate(811.172 130.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1295",
    "data-name": "Grupo 1295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1845",
    "data-name": "Trazado 1845",
    d: "M803.545,132.059H802.9a.21.21,0,0,1-.211-.21v-3.84a.21.21,0,0,1,.211-.21h.613a.21.21,0,0,1,.211.21v.053l.014-.014a1.166,1.166,0,0,1,.822-.336l.077,0,.153.016a.21.21,0,0,1,.188.209v.681a.21.21,0,0,1-.251.206c-.029-.005-.056-.008-.081-.011s-.057,0-.09,0a.719.719,0,0,0-.588.237.888.888,0,0,0-.213.589v2.208a.209.209,0,0,1-.21.21m-.434-.42h.225v-2a1.3,1.3,0,0,1,.24-.767.206.206,0,0,1-.1.006.211.211,0,0,1-.171-.208v-.452h-.192Zm1.445-3.5a.742.742,0,0,0-.529.22,1.653,1.653,0,0,0-.284.326,1.157,1.157,0,0,1,.812-.285h0Z",
    transform: "translate(-802.689 -127.713)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1298",
    "data-name": "Grupo 1298",
    transform: "translate(814.18 130.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1297",
    "data-name": "Grupo 1297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1846",
    "data-name": "Trazado 1846",
    d: "M807.75,129.513a.351.351,0,0,0,.3-.186.588.588,0,0,0,.043-.248.531.531,0,0,0-.234-.481,1.258,1.258,0,0,0-.671-.149.852.852,0,0,0-.716.274.9.9,0,0,0-.153.45h-.6a1.116,1.116,0,0,1,.461-.99,1.875,1.875,0,0,1,1.025-.278,2.084,2.084,0,0,1,1.1.258.876.876,0,0,1,.419.8v2.212a.279.279,0,0,0,.04.161.2.2,0,0,0,.173.061.816.816,0,0,0,.1-.005q.054,0,.115-.016v.477a1.683,1.683,0,0,1-.23.053,1.6,1.6,0,0,1-.215.012.531.531,0,0,1-.483-.237.892.892,0,0,1-.112-.354,1.635,1.635,0,0,1-.566.448,1.752,1.752,0,0,1-.814.191,1.211,1.211,0,0,1-.872-.325,1.076,1.076,0,0,1-.339-.811,1.043,1.043,0,0,1,.333-.827,1.587,1.587,0,0,1,.875-.361Zm-1.357,1.743a.755.755,0,0,0,.483.161,1.471,1.471,0,0,0,.66-.158.886.886,0,0,0,.538-.855v-.519a1.088,1.088,0,0,1-.3.127,2.574,2.574,0,0,1-.365.071l-.39.05a1.486,1.486,0,0,0-.527.147.569.569,0,0,0-.3.536.53.53,0,0,0,.2.44",
    transform: "translate(-805.515 -127.905)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1300",
    "data-name": "Grupo 1300",
    transform: "translate(813.97 130.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1299",
    "data-name": "Grupo 1299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1847",
    "data-name": "Trazado 1847",
    d: "M806.739,132.188a1.415,1.415,0,0,1-1.018-.383,1.278,1.278,0,0,1-.4-.962,1.249,1.249,0,0,1,.4-.985,1.8,1.8,0,0,1,.987-.413l1.029-.129c.107-.013.126-.053.133-.068a.347.347,0,0,0,.023-.158.314.314,0,0,0-.137-.3,1.062,1.062,0,0,0-.559-.116.662.662,0,0,0-.548.191.7.7,0,0,0-.112.348.211.211,0,0,1-.209.185h-.6a.211.211,0,0,1-.21-.216,1.313,1.313,0,0,1,.559-1.162,2.093,2.093,0,0,1,1.137-.311,2.3,2.3,0,0,1,1.209.288,1.091,1.091,0,0,1,.52.983V131.2a.789.789,0,0,0,.08,0c.031,0,.064-.007.1-.014a.209.209,0,0,1,.247.208v.477a.211.211,0,0,1-.152.2,2.177,2.177,0,0,1-.256.06,1.867,1.867,0,0,1-.246.013.733.733,0,0,1-.661-.334.669.669,0,0,1-.037-.066,2.212,2.212,0,0,1-.367.233,1.963,1.963,0,0,1-.909.214m.46-3.938a1.431,1.431,0,0,1,.784.183.731.731,0,0,1,.332.657.769.769,0,0,1-.065.343.549.549,0,0,1-.46.3l-1.029.129a1.4,1.4,0,0,0-.762.311.841.841,0,0,0-.262.67.868.868,0,0,0,.275.659,1,1,0,0,0,.727.266,1.541,1.541,0,0,0,.716-.167,1.742,1.742,0,0,0,.353-.235,1.353,1.353,0,0,1-.168.1,1.3,1.3,0,0,1-1.366-.028.741.741,0,0,1-.284-.6.78.78,0,0,1,.407-.721,1.718,1.718,0,0,1,.6-.171l.391-.051a2.286,2.286,0,0,0,.336-.066.885.885,0,0,0,.246-.1.209.209,0,0,1,.214-.007.211.211,0,0,1,.11.184v.518a1.12,1.12,0,0,1-.238.722.2.2,0,0,1,.113,0,.211.211,0,0,1,.155.174.712.712,0,0,0,.081.273.314.314,0,0,0,.305.138,1.465,1.465,0,0,0,.187-.009l.048-.01v-.081h0a.39.39,0,0,1-.348-.154.487.487,0,0,1-.078-.278v-2.212a.662.662,0,0,0-.318-.624,1.884,1.884,0,0,0-.989-.227,1.682,1.682,0,0,0-.913.246.8.8,0,0,0-.345.6h.2a.945.945,0,0,1,.165-.369,1.048,1.048,0,0,1,.88-.354m.677,1.965-.037.011a2.826,2.826,0,0,1-.4.078l-.387.05a1.261,1.261,0,0,0-.45.121.363.363,0,0,0-.193.353.319.319,0,0,0,.123.274.545.545,0,0,0,.353.116,1.276,1.276,0,0,0,.566-.135.678.678,0,0,0,.421-.667Z",
    transform: "translate(-805.318 -127.707)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1302",
    "data-name": "Grupo 1302",
    transform: "translate(818.731 130.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1301",
    "data-name": "Grupo 1301",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1848",
    "data-name": "Trazado 1848",
    d: "M812.589,128.2a1.517,1.517,0,0,1,.489,1.086h-.627a1.161,1.161,0,0,0-.263-.59.825.825,0,0,0-.655-.234.9.9,0,0,0-.881.6,2.359,2.359,0,0,0-.171.962,1.82,1.82,0,0,0,.242.971.946.946,0,0,0,1.4.149,1.344,1.344,0,0,0,.326-.67h.627a1.517,1.517,0,0,1-1.638,1.47,1.47,1.47,0,0,1-1.2-.55,2.1,2.1,0,0,1-.448-1.375,2.316,2.316,0,0,1,.491-1.573,1.592,1.592,0,0,1,1.252-.562,1.682,1.682,0,0,1,1.056.315",
    transform: "translate(-809.79 -127.888)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1304",
    "data-name": "Grupo 1304",
    transform: "translate(818.52 130.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1303",
    "data-name": "Grupo 1303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1849",
    "data-name": "Trazado 1849",
    d: "M811.452,132.171a1.674,1.674,0,0,1-1.364-.628,2.317,2.317,0,0,1-.5-1.507,2.525,2.525,0,0,1,.544-1.712,1.794,1.794,0,0,1,1.408-.634,1.887,1.887,0,0,1,1.185.359,1.69,1.69,0,0,1,.564,1.182.228.228,0,0,1,.012.071.209.209,0,0,1-.21.21h-.633a.211.211,0,0,1-.208-.177.954.954,0,0,0-.212-.484.636.636,0,0,0-.5-.163.7.7,0,0,0-.688.476,2.172,2.172,0,0,0-.156.878,1.622,1.622,0,0,0,.212.86.627.627,0,0,0,.589.293.636.636,0,0,0,.484-.179,1.147,1.147,0,0,0,.27-.567.21.21,0,0,1,.206-.167h.627a.212.212,0,0,1,.16.072.208.208,0,0,1,.049.167,1.726,1.726,0,0,1-1.846,1.651m.093-4.061a1.371,1.371,0,0,0-1.091.491,2.119,2.119,0,0,0-.44,1.435,1.889,1.889,0,0,0,.4,1.242,1.261,1.261,0,0,0,1.038.473,1.482,1.482,0,0,0,.966-.306,1.334,1.334,0,0,0,.418-.743h-.21a1.466,1.466,0,0,1-.337.6,1.155,1.155,0,0,1-1.734-.183,2.026,2.026,0,0,1-.275-1.081,2.607,2.607,0,0,1,.189-1.047,1.119,1.119,0,0,1,1.074-.728,1.026,1.026,0,0,1,.815.309,1.294,1.294,0,0,1,.271.516h.214a1.151,1.151,0,0,0-.374-.709,1.481,1.481,0,0,0-.927-.271",
    transform: "translate(-809.592 -127.69)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1306",
    "data-name": "Grupo 1306",
    transform: "translate(823.214 129.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1305",
    "data-name": "Grupo 1305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1850",
    "data-name": "Trazado 1850",
    d: "M814,126.652h.656v.731H814Zm0,1.445h.656v3.82H814Z",
    transform: "translate(-814.002 -126.652)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1308",
    "data-name": "Grupo 1308",
    transform: "translate(823.003 128.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1307",
    "data-name": "Grupo 1307",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1851",
    "data-name": "Trazado 1851",
    d: "M814.671,132.14h-.656a.21.21,0,0,1-.211-.21v-3.821a.21.21,0,0,1,.211-.21h.656a.209.209,0,0,1,.21.21v3.821a.209.209,0,0,1-.21.21m-.446-.42h.235v-3.4h-.235Zm.446-4.113h-.656a.211.211,0,0,1-.211-.211v-.731a.21.21,0,0,1,.211-.21h.656a.209.209,0,0,1,.21.21v.731a.21.21,0,0,1-.21.211m-.446-.422h.235v-.311h-.235Z",
    transform: "translate(-813.804 -126.455)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1310",
    "data-name": "Grupo 1310",
    transform: "translate(825.133 129.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1309",
    "data-name": "Grupo 1309",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1852",
    "data-name": "Trazado 1852",
    d: "M818.848,128.469a1.941,1.941,0,0,1,.509,1.454,2.512,2.512,0,0,1-.448,1.533,1.62,1.62,0,0,1-1.392.6,1.563,1.563,0,0,1-1.249-.535,2.12,2.12,0,0,1-.463-1.437,2.3,2.3,0,0,1,.488-1.54,1.631,1.631,0,0,1,1.309-.573,1.719,1.719,0,0,1,1.247.494m-.4,2.552a2.432,2.432,0,0,0,.236-1.079,1.932,1.932,0,0,0-.17-.874.956.956,0,0,0-.928-.53.913.913,0,0,0-.851.451,2.1,2.1,0,0,0-.266,1.088,1.829,1.829,0,0,0,.266,1.021.931.931,0,0,0,.843.409.877.877,0,0,0,.87-.485m-.083-4.479-.956,1.036h-.495l.656-1.036Z",
    transform: "translate(-815.805 -126.541)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1312",
    "data-name": "Grupo 1312",
    transform: "translate(824.923 128.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1311",
    "data-name": "Grupo 1311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1853",
    "data-name": "Trazado 1853",
    d: "M817.529,132.284a1.773,1.773,0,0,1-1.409-.609,2.334,2.334,0,0,1-.513-1.575,2.509,2.509,0,0,1,.538-1.675,1.779,1.779,0,0,1,1.14-.625h-.36a.209.209,0,0,1-.178-.323l.656-1.036a.21.21,0,0,1,.178-.1h.8a.21.21,0,0,1,.194.127.212.212,0,0,1-.038.227l-.957,1.036a.248.248,0,0,1-.064.047l.1,0a1.928,1.928,0,0,1,1.391.554,2.142,2.142,0,0,1,.574,1.605,2.723,2.723,0,0,1-.49,1.657,1.825,1.825,0,0,1-1.561.691m.085-4.087a1.417,1.417,0,0,0-1.149.5,2.1,2.1,0,0,0-.439,1.4,1.929,1.929,0,0,0,.412,1.3,1.354,1.354,0,0,0,1.09.463,1.41,1.41,0,0,0,1.222-.521,2.313,2.313,0,0,0,.408-1.407,1.752,1.752,0,0,0-.445-1.3,1.508,1.508,0,0,0-1.1-.434m-.308-.819h.02l.568-.614h-.2Zm.282,4.349a1.135,1.135,0,0,1-1.019-.5,2.041,2.041,0,0,1-.3-1.135,2.322,2.322,0,0,1,.295-1.2,1.128,1.128,0,0,1,1.031-.555,1.172,1.172,0,0,1,1.117.645,2.157,2.157,0,0,1,.193.97,2.659,2.659,0,0,1-.258,1.171,1.082,1.082,0,0,1-1.059.6m.008-2.968a.7.7,0,0,0-.67.347,1.92,1.92,0,0,0-.236.981,1.65,1.65,0,0,0,.231.906.733.733,0,0,0,.667.313.672.672,0,0,0,.681-.367,2.236,2.236,0,0,0,.215-.987,1.745,1.745,0,0,0-.148-.779.745.745,0,0,0-.741-.414",
    transform: "translate(-815.607 -126.343)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1314",
    "data-name": "Grupo 1314",
    transform: "translate(830.028 130.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1313",
    "data-name": "Grupo 1313",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1854",
    "data-name": "Trazado 1854",
    d: "M820.4,128h.613v.545a1.713,1.713,0,0,1,.577-.484,1.539,1.539,0,0,1,.677-.147,1.117,1.117,0,0,1,1.1.571,2.016,2.016,0,0,1,.158.892v2.462h-.656v-2.42a1.315,1.315,0,0,0-.1-.566.632.632,0,0,0-.624-.358,1.281,1.281,0,0,0-.377.046.972.972,0,0,0-.465.316.945.945,0,0,0-.211.392,2.653,2.653,0,0,0-.049.579v2.011H820.4Z",
    transform: "translate(-820.403 -127.911)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1316",
    "data-name": "Grupo 1316",
    transform: "translate(829.816 130.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1315",
    "data-name": "Grupo 1315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1855",
    "data-name": "Trazado 1855",
    d: "M823.544,132.059h-.656a.211.211,0,0,1-.212-.21v-2.42a1.107,1.107,0,0,0-.082-.475.416.416,0,0,0-.434-.241,1.072,1.072,0,0,0-.313.037.755.755,0,0,0-.368.251.743.743,0,0,0-.166.305,2.492,2.492,0,0,0-.043.53v2.011a.21.21,0,0,1-.211.21h-.645a.21.21,0,0,1-.211-.21v-3.84a.21.21,0,0,1,.211-.21h.614a.21.21,0,0,1,.21.21v.043a1.485,1.485,0,0,1,.276-.17,1.742,1.742,0,0,1,.768-.169,1.317,1.317,0,0,1,1.292.687,2.2,2.2,0,0,1,.18.987v2.463a.209.209,0,0,1-.21.21m-.446-.42h.236v-2.252a1.839,1.839,0,0,0-.135-.8.921.921,0,0,0-.918-.455,1.323,1.323,0,0,0-.584.127,1.494,1.494,0,0,0-.506.427.215.215,0,0,1-.234.066.211.211,0,0,1-.14-.2v-.334h-.192v3.418h.225v-1.8a2.835,2.835,0,0,1,.053-.628,1.171,1.171,0,0,1,.254-.48,1.189,1.189,0,0,1,.566-.381,1.447,1.447,0,0,1,.436-.055.834.834,0,0,1,.813.478,1.5,1.5,0,0,1,.124.658Z",
    transform: "translate(-820.204 -127.713)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1318",
    "data-name": "Grupo 1318",
    transform: "translate(737.915 136.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1317",
    "data-name": "Grupo 1317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1856",
    "data-name": "Trazado 1856",
    d: "M739.815,134.592a2.8,2.8,0,0,1,.909,1.8h-1.043a1.989,1.989,0,0,0-2.156-1.657,2.325,2.325,0,0,0-1.853.822,3.8,3.8,0,0,0-.7,2.517,3.713,3.713,0,0,0,.637,2.253,2.21,2.21,0,0,0,1.9.864,2,2,0,0,0,1.771-.909,3.521,3.521,0,0,0,.48-1.259H740.8a3.58,3.58,0,0,1-.915,2.093,3.234,3.234,0,0,1-2.51,1.017,3.287,3.287,0,0,1-2.286-.835,5.181,5.181,0,0,1-.3-6.277,3.325,3.325,0,0,1,2.728-1.217,3.174,3.174,0,0,1,2.3.791",
    transform: "translate(-733.87 -133.801)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1320",
    "data-name": "Grupo 1320",
    transform: "translate(737.704 136.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1319",
    "data-name": "Grupo 1319",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1857",
    "data-name": "Trazado 1857",
    d: "M737.387,142.353a3.507,3.507,0,0,1-2.427-.889,5.383,5.383,0,0,1-.326-6.567,3.54,3.54,0,0,1,2.891-1.294,3.4,3.4,0,0,1,2.449.851,3.029,3.029,0,0,1,.968,1.88.21.21,0,0,1-.2.279h-1.046a.21.21,0,0,1-.205-.164,1.777,1.777,0,0,0-1.95-1.492,2.1,2.1,0,0,0-1.693.747,3.618,3.618,0,0,0-.655,2.38,3.523,3.523,0,0,0,.6,2.129,2,2,0,0,0,1.731.778,1.783,1.783,0,0,0,1.6-.815,3.29,3.29,0,0,0,.45-1.184.21.21,0,0,1,.205-.168h1.044a.212.212,0,0,1,.21.233,3.809,3.809,0,0,1-.97,2.212,3.45,3.45,0,0,1-2.665,1.085m.138-8.329a3.1,3.1,0,0,0-2.564,1.139,4.974,4.974,0,0,0,.28,5.989,3.1,3.1,0,0,0,2.146.78,3.011,3.011,0,0,0,2.356-.948,3.342,3.342,0,0,0,.828-1.74h-.632a3.551,3.551,0,0,1-.477,1.167,2.2,2.2,0,0,1-1.945,1,2.416,2.416,0,0,1-2.069-.951,3.929,3.929,0,0,1-.678-2.378,4.006,4.006,0,0,1,.757-2.655,2.536,2.536,0,0,1,2.012-.894,2.388,2.388,0,0,1,1.6.5,2.343,2.343,0,0,1,.721,1.16h.64a2.684,2.684,0,0,0-.814-1.436,2.992,2.992,0,0,0-2.157-.731",
    transform: "translate(-733.672 -133.603)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1322",
    "data-name": "Grupo 1322",
    transform: "translate(746.595 139.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1321",
    "data-name": "Grupo 1321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1858",
    "data-name": "Trazado 1858",
    d: "M745.913,136.181a2.182,2.182,0,0,1,.872.745,2.571,2.571,0,0,1,.384,1.017,6.619,6.619,0,0,1,.087,1.27h-4.193a2.494,2.494,0,0,0,.412,1.41,1.37,1.37,0,0,0,1.19.532,1.533,1.533,0,0,0,1.2-.5,1.726,1.726,0,0,0,.356-.676h.952a1.968,1.968,0,0,1-.25.707,2.547,2.547,0,0,1-.474.639,2.241,2.241,0,0,1-1.085.58,3.261,3.261,0,0,1-.785.086,2.4,2.4,0,0,1-1.812-.782,3.058,3.058,0,0,1-.745-2.193,3.325,3.325,0,0,1,.75-2.255,2.458,2.458,0,0,1,1.955-.866,2.6,2.6,0,0,1,1.183.288m.347,2.262a2.522,2.522,0,0,0-.272-1.006,1.391,1.391,0,0,0-1.317-.7,1.456,1.456,0,0,0-1.11.481,1.823,1.823,0,0,0-.475,1.224Z",
    transform: "translate(-742.024 -135.893)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1324",
    "data-name": "Grupo 1324",
    transform: "translate(746.386 138.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1323",
    "data-name": "Grupo 1323",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1859",
    "data-name": "Trazado 1859",
    d: "M744.594,142.213a2.616,2.616,0,0,1-1.964-.848,3.27,3.27,0,0,1-.8-2.338,3.541,3.541,0,0,1,.8-2.392,2.673,2.673,0,0,1,2.115-.939,2.811,2.811,0,0,1,1.276.311,2.4,2.4,0,0,1,.954.818,2.8,2.8,0,0,1,.416,1.1,6.656,6.656,0,0,1,.088,1.256.178.178,0,0,1,.005.048.215.215,0,0,1-.213.211H743.3a2.131,2.131,0,0,0,.359,1.077,1.162,1.162,0,0,0,1.02.444,1.319,1.319,0,0,0,1.044-.431,1.515,1.515,0,0,0,.309-.592.211.211,0,0,1,.2-.155h.953a.212.212,0,0,1,.209.236,2.2,2.2,0,0,1-.275.782,2.736,2.736,0,0,1-.514.69,2.446,2.446,0,0,1-1.18.633,3.486,3.486,0,0,1-.833.092m.15-6.1a2.239,2.239,0,0,0-1.8.794,3.134,3.134,0,0,0-.7,2.116,2.872,2.872,0,0,0,.685,2.048,2.185,2.185,0,0,0,1.66.717,3.126,3.126,0,0,0,.736-.08,2.051,2.051,0,0,0,.987-.527,2.4,2.4,0,0,0,.438-.589,2.341,2.341,0,0,0,.173-.4h-.538a1.913,1.913,0,0,1-.35.6,1.738,1.738,0,0,1-1.36.575,1.575,1.575,0,0,1-1.361-.618,2.7,2.7,0,0,1-.451-1.528.213.213,0,0,1,.06-.152.208.208,0,0,1,.151-.064h3.98a5.7,5.7,0,0,0-.08-1.016,2.407,2.407,0,0,0-.354-.945,1.987,1.987,0,0,0-.791-.673,2.4,2.4,0,0,0-1.088-.266m1.53,2.55H743.1a.205.205,0,0,1-.15-.065.2.2,0,0,1-.06-.153,2.036,2.036,0,0,1,.531-1.359,1.664,1.664,0,0,1,1.262-.549,1.6,1.6,0,0,1,1.5.807,2.73,2.73,0,0,1,.3,1.09.21.21,0,0,1-.209.23m-2.946-.42h2.708a2.022,2.022,0,0,0-.217-.692,1.189,1.189,0,0,0-1.136-.594,1.244,1.244,0,0,0-.955.415,1.549,1.549,0,0,0-.4.871",
    transform: "translate(-741.828 -135.696)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1326",
    "data-name": "Grupo 1326",
    transform: "translate(753.88 139.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1325",
    "data-name": "Grupo 1325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1860",
    "data-name": "Trazado 1860",
    d: "M748.868,136.023h.92v.818a2.59,2.59,0,0,1,.866-.726,2.313,2.313,0,0,1,1.018-.221,1.676,1.676,0,0,1,1.656.856,3.048,3.048,0,0,1,.236,1.34v3.7h-.985v-3.633a1.975,1.975,0,0,0-.155-.849.946.946,0,0,0-.937-.538,1.893,1.893,0,0,0-.564.069,1.456,1.456,0,0,0-.7.474,1.426,1.426,0,0,0-.314.59,3.981,3.981,0,0,0-.073.869v3.019h-.968Z",
    transform: "translate(-748.868 -135.893)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1328",
    "data-name": "Grupo 1328",
    transform: "translate(753.669 138.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1327",
    "data-name": "Grupo 1327",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1861",
    "data-name": "Trazado 1861",
    d: "M753.577,142.008h-.985a.211.211,0,0,1-.212-.21v-3.632a1.781,1.781,0,0,0-.133-.759.74.74,0,0,0-.748-.418,1.7,1.7,0,0,0-.5.06,1.362,1.362,0,0,0-.874.911,3.77,3.77,0,0,0-.066.82V141.8a.21.21,0,0,1-.211.21h-.969a.21.21,0,0,1-.211-.21v-5.763a.211.211,0,0,1,.211-.211h.921a.21.21,0,0,1,.21.211v.288a2.421,2.421,0,0,1,.564-.386,2.543,2.543,0,0,1,1.109-.242,1.877,1.877,0,0,1,1.845.972,3.2,3.2,0,0,1,.26,1.434v3.7a.21.21,0,0,1-.211.21m-.775-.42h.564V138.1a2.848,2.848,0,0,0-.214-1.244,1.471,1.471,0,0,0-1.469-.741,2.125,2.125,0,0,0-.926.2,2.374,2.374,0,0,0-.794.67.211.211,0,0,1-.375-.133v-.607h-.5v5.342h.547V138.78a4.143,4.143,0,0,1,.079-.918,1.652,1.652,0,0,1,.359-.677,1.67,1.67,0,0,1,.8-.539,2.111,2.111,0,0,1,.625-.079,1.162,1.162,0,0,1,1.127.657,2.2,2.2,0,0,1,.176.942Z",
    transform: "translate(-748.669 -135.696)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1330",
    "data-name": "Grupo 1330",
    transform: "translate(760.249 137.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1329",
    "data-name": "Grupo 1329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1862",
    "data-name": "Trazado 1862",
    d: "M755.63,134.5h.98v1.608h.92v.791h-.92v3.762a.407.407,0,0,0,.2.4.878.878,0,0,0,.377.059c.048,0,.1,0,.151,0s.117-.009.188-.018v.77a2.153,2.153,0,0,1-.347.069,3.183,3.183,0,0,1-.391.022,1.053,1.053,0,0,1-.92-.347,1.542,1.542,0,0,1-.243-.9V136.9h-.779v-.791h.779Z",
    transform: "translate(-754.851 -134.504)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1332",
    "data-name": "Grupo 1332",
    transform: "translate(760.037 137.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1331",
    "data-name": "Grupo 1331",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1863",
    "data-name": "Trazado 1863",
    d: "M756.8,142.188a1.246,1.246,0,0,1-1.092-.436,1.757,1.757,0,0,1-.28-1.022v-3.6h-.57a.21.21,0,0,1-.211-.21v-.791a.21.21,0,0,1,.211-.211h.57v-1.4a.21.21,0,0,1,.21-.21h.979a.21.21,0,0,1,.211.21v1.4h.71a.211.211,0,0,1,.211.211v.791a.21.21,0,0,1-.211.21h-.71v3.551c0,.171.062.2.087.215a.671.671,0,0,0,.283.037c.045,0,.092,0,.142,0s.105-.007.17-.016a.2.2,0,0,1,.166.05.208.208,0,0,1,.072.159v.769a.211.211,0,0,1-.152.2,2.376,2.376,0,0,1-.38.077,3.4,3.4,0,0,1-.416.022m-1.732-5.483h.569a.21.21,0,0,1,.211.211v3.814a1.352,1.352,0,0,0,.2.781.872.872,0,0,0,.747.257,3,3,0,0,0,.366-.02c.054-.006.109-.015.161-.026v-.375a1.243,1.243,0,0,1-.6-.081.6.6,0,0,1-.317-.59v-3.761a.21.21,0,0,1,.21-.211h.71v-.37h-.71a.211.211,0,0,1-.21-.21v-1.4h-.559v1.4a.21.21,0,0,1-.211.21h-.569Z",
    transform: "translate(-754.652 -134.306)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1334",
    "data-name": "Grupo 1334",
    transform: "translate(764.75 139.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1333",
    "data-name": "Grupo 1333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1864",
    "data-name": "Trazado 1864",
    d: "M759.079,136.023H760v1a2.208,2.208,0,0,1,.555-.707,1.433,1.433,0,0,1,1.018-.418c.016,0,.048,0,.091.006s.117.011.221.021v1.022c-.059-.011-.111-.017-.16-.021s-.1-.005-.159-.005a1.386,1.386,0,0,0-1.125.471,1.651,1.651,0,0,0-.393,1.085v3.315h-.968Z",
    transform: "translate(-759.079 -135.893)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1336",
    "data-name": "Grupo 1336",
    transform: "translate(764.539 138.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1335",
    "data-name": "Grupo 1335",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1865",
    "data-name": "Trazado 1865",
    d: "M760.059,142.008h-.968a.21.21,0,0,1-.211-.21v-5.763a.211.211,0,0,1,.211-.211h.92a.21.21,0,0,1,.21.211v.334c.061-.064.127-.13.2-.2a1.647,1.647,0,0,1,1.162-.475c.019,0,.055,0,.107.006s.119.011.226.022a.21.21,0,0,1,.189.209v1.022a.213.213,0,0,1-.076.162.21.21,0,0,1-.173.046c-.049-.01-.095-.015-.137-.019s-.089,0-.141,0a1.171,1.171,0,0,0-.963.395,1.431,1.431,0,0,0-.344.95V141.8a.21.21,0,0,1-.211.21m-.758-.42h.548v-3.1a1.851,1.851,0,0,1,.442-1.219,1.586,1.586,0,0,1,1.286-.546c.037,0,.072,0,.106,0v-.6l-.027,0-.073-.005a1.227,1.227,0,0,0-.874.36,1.968,1.968,0,0,0-.5.631.21.21,0,0,1-.407-.077v-.785h-.5Z",
    transform: "translate(-758.881 -135.696)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1338",
    "data-name": "Grupo 1338",
    transform: "translate(768.826 138.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1337",
    "data-name": "Grupo 1337",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1866",
    "data-name": "Trazado 1866",
    d: "M767.476,136.6a2.907,2.907,0,0,1,.764,2.183,3.759,3.759,0,0,1-.674,2.3,2.426,2.426,0,0,1-2.088.908,2.346,2.346,0,0,1-1.875-.8,3.181,3.181,0,0,1-.7-2.158,3.447,3.447,0,0,1,.732-2.312,2.45,2.45,0,0,1,1.966-.86,2.584,2.584,0,0,1,1.869.742m-.6,3.83a3.65,3.65,0,0,0,.354-1.62,2.908,2.908,0,0,0-.255-1.311,1.435,1.435,0,0,0-1.394-.8,1.37,1.37,0,0,0-1.276.677,3.16,3.16,0,0,0-.4,1.633,2.748,2.748,0,0,0,.4,1.532,1.4,1.4,0,0,0,1.266.613,1.318,1.318,0,0,0,1.306-.728",
    transform: "translate(-762.908 -135.858)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1340",
    "data-name": "Grupo 1340",
    transform: "translate(768.615 138.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1339",
    "data-name": "Grupo 1339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1867",
    "data-name": "Trazado 1867",
    d: "M765.49,142.215a2.565,2.565,0,0,1-2.034-.876,3.407,3.407,0,0,1-.746-2.3,3.666,3.666,0,0,1,.782-2.448,2.66,2.66,0,0,1,2.126-.934,2.8,2.8,0,0,1,2.017.8,3.12,3.12,0,0,1,.827,2.333,3.978,3.978,0,0,1-.714,2.426,2.635,2.635,0,0,1-2.258.994m.128-6.134a2.23,2.23,0,0,0-1.805.786,3.261,3.261,0,0,0-.682,2.175,3,3,0,0,0,.644,2.021,2.129,2.129,0,0,0,1.716.73,2.215,2.215,0,0,0,1.92-.823,3.574,3.574,0,0,0,.632-2.176,2.722,2.722,0,0,0-.7-2.031,2.359,2.359,0,0,0-1.724-.682m-.037,5.3a1.605,1.605,0,0,1-1.442-.708,2.968,2.968,0,0,1-.432-1.647,3.373,3.373,0,0,1,.428-1.74,1.574,1.574,0,0,1,1.457-.78,1.638,1.638,0,0,1,1.582.91,3.135,3.135,0,0,1,.278,1.406,3.88,3.88,0,0,1-.375,1.713,1.52,1.52,0,0,1-1.5.846m.011-4.455a1.161,1.161,0,0,0-1.094.574,2.956,2.956,0,0,0-.37,1.526,2.553,2.553,0,0,0,.365,1.417,1.192,1.192,0,0,0,1.089.517,1.113,1.113,0,0,0,1.117-.61,3.459,3.459,0,0,0,.333-1.529,2.732,2.732,0,0,0-.232-1.216,1.23,1.23,0,0,0-1.207-.68",
    transform: "translate(-762.71 -135.66)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1342",
    "data-name": "Grupo 1342",
    transform: "translate(775.904 138.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1341",
    "data-name": "Grupo 1341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1868",
    "data-name": "Trazado 1868",
    d: "M772.915,138.3a.527.527,0,0,0,.447-.279.868.868,0,0,0,.064-.373.793.793,0,0,0-.352-.722,1.879,1.879,0,0,0-1.006-.224,1.277,1.277,0,0,0-1.075.411,1.372,1.372,0,0,0-.23.675h-.9a1.671,1.671,0,0,1,.69-1.486,2.828,2.828,0,0,1,1.54-.418,3.129,3.129,0,0,1,1.649.387,1.313,1.313,0,0,1,.629,1.206V140.8a.422.422,0,0,0,.063.243.3.3,0,0,0,.261.092c.043,0,.092,0,.145-.008s.112-.013.172-.024v.716a2.742,2.742,0,0,1-.344.08,2.355,2.355,0,0,1-.324.017.8.8,0,0,1-.726-.356,1.369,1.369,0,0,1-.167-.532,2.463,2.463,0,0,1-.85.672,2.619,2.619,0,0,1-1.221.285,1.817,1.817,0,0,1-1.31-.486,1.613,1.613,0,0,1-.508-1.217,1.566,1.566,0,0,1,.5-1.241,2.387,2.387,0,0,1,1.314-.543Zm-2.039,2.617a1.14,1.14,0,0,0,.727.242,2.211,2.211,0,0,0,.989-.236,1.33,1.33,0,0,0,.807-1.284v-.779a1.648,1.648,0,0,1-.456.189,3.874,3.874,0,0,1-.547.108l-.585.076a2.251,2.251,0,0,0-.792.219.857.857,0,0,0-.449.806.794.794,0,0,0,.307.66",
    transform: "translate(-769.558 -135.883)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1344",
    "data-name": "Grupo 1344",
    transform: "translate(775.694 138.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1343",
    "data-name": "Grupo 1343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1869",
    "data-name": "Trazado 1869",
    d: "M771.389,142.2a2.027,2.027,0,0,1-1.455-.545,1.823,1.823,0,0,1-.574-1.369,1.768,1.768,0,0,1,.573-1.4,2.6,2.6,0,0,1,1.425-.6l1.544-.193c.2-.026.256-.1.282-.162a.628.628,0,0,0,.044-.281.583.583,0,0,0-.254-.544,1.687,1.687,0,0,0-.893-.192,1.085,1.085,0,0,0-.907.329,1.163,1.163,0,0,0-.19.574.209.209,0,0,1-.209.184h-.9a.209.209,0,0,1-.211-.215,1.875,1.875,0,0,1,.789-1.66,3.046,3.046,0,0,1,1.652-.45,3.358,3.358,0,0,1,1.76.417,1.522,1.522,0,0,1,.73,1.386v3.319a.249.249,0,0,0,.021.119s.03,0,.091,0a1.073,1.073,0,0,0,.123-.007c.05,0,.1-.012.156-.021a.211.211,0,0,1,.172.046.209.209,0,0,1,.076.161v.716a.21.21,0,0,1-.152.2,2.875,2.875,0,0,1-.375.086,2.549,2.549,0,0,1-.351.018,1,1,0,0,1-.9-.452,1.04,1.04,0,0,1-.1-.216,3.023,3.023,0,0,1-.64.43,2.852,2.852,0,0,1-1.318.309m.692-5.7a2.054,2.054,0,0,1,1.12.258,1,1,0,0,1,.449.9,1.042,1.042,0,0,1-.086.466.728.728,0,0,1-.608.394l-1.547.194a2.2,2.2,0,0,0-1.2.492,1.357,1.357,0,0,0-.429,1.084,1.4,1.4,0,0,0,.444,1.064,1.6,1.6,0,0,0,1.164.428,2.432,2.432,0,0,0,1.125-.261,2.267,2.267,0,0,0,.78-.613.21.21,0,0,1,.375.1,1.175,1.175,0,0,0,.136.45.59.59,0,0,0,.548.257,2.269,2.269,0,0,0,.294-.014,1.559,1.559,0,0,0,.164-.034v-.315c-.278.019-.446-.039-.543-.18a.628.628,0,0,1-.1-.361v-3.319a1.106,1.106,0,0,0-.529-1.026,2.938,2.938,0,0,0-1.539-.357,2.63,2.63,0,0,0-1.428.386,1.354,1.354,0,0,0-.58,1.1h.5a1.379,1.379,0,0,1,.245-.6,1.476,1.476,0,0,1,1.24-.492m-.465,4.875a1.35,1.35,0,0,1-.858-.286,1,1,0,0,1-.385-.826,1.068,1.068,0,0,1,.556-.988,2.436,2.436,0,0,1,.868-.245l.585-.076a3.908,3.908,0,0,0,.521-.1,1.412,1.412,0,0,0,.4-.164.212.212,0,0,1,.325.178v.779a1.532,1.532,0,0,1-.927,1.473,2.424,2.424,0,0,1-1.08.257M773.2,139.2c-.061.022-.123.042-.191.06a3.985,3.985,0,0,1-.578.114l-.584.075a2.073,2.073,0,0,0-.713.2.646.646,0,0,0-.344.621.58.58,0,0,0,.227.495.921.921,0,0,0,.6.2,2.006,2.006,0,0,0,.9-.214,1.127,1.127,0,0,0,.69-1.1Z",
    transform: "translate(-769.36 -135.686)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1346",
    "data-name": "Grupo 1346",
    transform: "translate(783.128 139.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1345",
    "data-name": "Grupo 1345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1870",
    "data-name": "Trazado 1870",
    d: "M776.344,136.023h.957v.818a3.23,3.23,0,0,1,.625-.618,1.873,1.873,0,0,1,1.087-.329,1.716,1.716,0,0,1,1.109.34,1.8,1.8,0,0,1,.43.571,2,2,0,0,1,1.737-.91,1.6,1.6,0,0,1,1.582.84,2.736,2.736,0,0,1,.227,1.217v3.836h-1.006v-4a.933.933,0,0,0-.288-.791,1.137,1.137,0,0,0-.7-.215,1.4,1.4,0,0,0-.983.381,1.688,1.688,0,0,0-.41,1.276v3.352h-.985v-3.762a1.957,1.957,0,0,0-.141-.855.854.854,0,0,0-.823-.4,1.42,1.42,0,0,0-1,.425,2.083,2.083,0,0,0-.449,1.538v3.057h-.969Z",
    transform: "translate(-776.344 -135.893)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1348",
    "data-name": "Grupo 1348",
    transform: "translate(782.918 138.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1347",
    "data-name": "Grupo 1347",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1871",
    "data-name": "Trazado 1871",
    d: "M784.11,142.008H783.1a.211.211,0,0,1-.212-.21v-4a.752.752,0,0,0-.2-.623.928.928,0,0,0-.576-.173,1.184,1.184,0,0,0-.839.327,1.5,1.5,0,0,0-.344,1.121V141.8a.21.21,0,0,1-.211.21h-.984a.211.211,0,0,1-.212-.21v-3.761a1.721,1.721,0,0,0-.116-.759.656.656,0,0,0-.637-.29,1.2,1.2,0,0,0-.853.366,1.907,1.907,0,0,0-.384,1.387V141.8a.209.209,0,0,1-.21.21h-.969a.209.209,0,0,1-.21-.21v-5.763a.21.21,0,0,1,.21-.211h.957a.211.211,0,0,1,.212.211v.271a2.3,2.3,0,0,1,.294-.245,2.094,2.094,0,0,1,1.206-.366,1.922,1.922,0,0,1,1.241.386,1.687,1.687,0,0,1,.323.362,2.188,2.188,0,0,1,.638-.5,2.331,2.331,0,0,1,1.075-.247,1.8,1.8,0,0,1,1.77.956,2.958,2.958,0,0,1,.248,1.31V141.8a.209.209,0,0,1-.21.21m-.8-.42h.585v-3.626a2.556,2.556,0,0,0-.2-1.122,1.4,1.4,0,0,0-1.393-.724,1.918,1.918,0,0,0-.884.2,1.9,1.9,0,0,0-.681.618.212.212,0,0,1-.187.089.209.209,0,0,1-.172-.114,1.575,1.575,0,0,0-.377-.5,1.518,1.518,0,0,0-.975-.292,1.658,1.658,0,0,0-.968.292,2.984,2.984,0,0,0-.579.578.211.211,0,0,1-.375-.133v-.607h-.537v5.342h.547v-2.845a2.248,2.248,0,0,1,.515-1.693,1.633,1.633,0,0,1,1.142-.482,1.053,1.053,0,0,1,1.009.513,2.13,2.13,0,0,1,.165.957v3.55h.563v-3.141a1.885,1.885,0,0,1,.478-1.43,1.611,1.611,0,0,1,1.126-.439,1.35,1.35,0,0,1,.828.257,1.13,1.13,0,0,1,.373.96Z",
    transform: "translate(-776.147 -135.696)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1350",
    "data-name": "Grupo 1350",
    transform: "translate(792.805 139.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1349",
    "data-name": "Grupo 1349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1872",
    "data-name": "Trazado 1872",
    d: "M789.323,136.181a2.19,2.19,0,0,1,.872.745,2.569,2.569,0,0,1,.384,1.017,6.619,6.619,0,0,1,.087,1.27h-4.193a2.5,2.5,0,0,0,.412,1.41,1.369,1.369,0,0,0,1.19.532,1.53,1.53,0,0,0,1.2-.5,1.715,1.715,0,0,0,.357-.676h.952a2.011,2.011,0,0,1-.25.707,2.55,2.55,0,0,1-.474.639,2.245,2.245,0,0,1-1.085.58,3.267,3.267,0,0,1-.785.086,2.406,2.406,0,0,1-1.813-.782,3.062,3.062,0,0,1-.744-2.193,3.32,3.32,0,0,1,.75-2.255,2.458,2.458,0,0,1,1.955-.866,2.6,2.6,0,0,1,1.183.288m.347,2.262a2.526,2.526,0,0,0-.273-1.006,1.391,1.391,0,0,0-1.318-.7,1.455,1.455,0,0,0-1.109.481,1.828,1.828,0,0,0-.475,1.224Z",
    transform: "translate(-785.435 -135.893)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1352",
    "data-name": "Grupo 1352",
    transform: "translate(792.595 138.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1351",
    "data-name": "Grupo 1351",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1873",
    "data-name": "Trazado 1873",
    d: "M788,142.213a2.616,2.616,0,0,1-1.964-.848,3.268,3.268,0,0,1-.8-2.338,3.541,3.541,0,0,1,.8-2.392,2.673,2.673,0,0,1,2.115-.939,2.812,2.812,0,0,1,1.276.311,2.388,2.388,0,0,1,.954.818,2.8,2.8,0,0,1,.416,1.1,6.641,6.641,0,0,1,.088,1.256.233.233,0,0,1,.005.048.21.21,0,0,1-.21.211H786.71a2.131,2.131,0,0,0,.359,1.077,1.162,1.162,0,0,0,1.02.444,1.312,1.312,0,0,0,1.043-.432,1.494,1.494,0,0,0,.31-.591.211.211,0,0,1,.2-.155h.953a.209.209,0,0,1,.158.071.206.206,0,0,1,.051.165,2.2,2.2,0,0,1-.276.782,2.709,2.709,0,0,1-.513.69,2.442,2.442,0,0,1-1.18.633,3.493,3.493,0,0,1-.834.092m.15-6.1a2.238,2.238,0,0,0-1.8.794,3.134,3.134,0,0,0-.7,2.116,2.872,2.872,0,0,0,.685,2.048,2.185,2.185,0,0,0,1.659.717,3.133,3.133,0,0,0,.736-.08,2.05,2.05,0,0,0,.987-.527,2.327,2.327,0,0,0,.436-.589,2.182,2.182,0,0,0,.174-.4H789.8a1.912,1.912,0,0,1-.35.6,1.74,1.74,0,0,1-1.36.575,1.574,1.574,0,0,1-1.362-.618,2.7,2.7,0,0,1-.451-1.528.211.211,0,0,1,.211-.216h3.98a5.688,5.688,0,0,0-.08-1.016,2.406,2.406,0,0,0-.354-.945,1.987,1.987,0,0,0-.791-.673,2.4,2.4,0,0,0-1.088-.266m1.53,2.55h-3.175a.208.208,0,0,1-.151-.065.2.2,0,0,1-.058-.153,2.036,2.036,0,0,1,.531-1.359,1.664,1.664,0,0,1,1.263-.549,1.6,1.6,0,0,1,1.5.807,2.732,2.732,0,0,1,.3,1.09.209.209,0,0,1-.053.162.212.212,0,0,1-.155.068m-2.946-.42h2.708a2.038,2.038,0,0,0-.217-.692,1.189,1.189,0,0,0-1.136-.594,1.242,1.242,0,0,0-.955.415,1.549,1.549,0,0,0-.4.871",
    transform: "translate(-785.238 -135.696)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1354",
    "data-name": "Grupo 1354",
    transform: "translate(800.115 139.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1353",
    "data-name": "Grupo 1353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1874",
    "data-name": "Trazado 1874",
    d: "M792.3,136.023h.92v1a2.213,2.213,0,0,1,.556-.707,1.429,1.429,0,0,1,1.017-.418c.017,0,.048,0,.092.006l.22.021v1.022c-.057-.011-.111-.017-.16-.021s-.1-.005-.158-.005a1.385,1.385,0,0,0-1.125.471,1.645,1.645,0,0,0-.393,1.085v3.315H792.3Z",
    transform: "translate(-792.302 -135.893)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1356",
    "data-name": "Grupo 1356",
    transform: "translate(799.904 138.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1355",
    "data-name": "Grupo 1355",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1875",
    "data-name": "Trazado 1875",
    d: "M793.283,142.008h-.969a.21.21,0,0,1-.211-.21v-5.763a.211.211,0,0,1,.211-.211h.921a.211.211,0,0,1,.21.211v.334c.061-.064.127-.13.2-.2a1.647,1.647,0,0,1,1.162-.475c.02,0,.056,0,.106.006s.12.011.227.022a.209.209,0,0,1,.188.209v1.022a.213.213,0,0,1-.076.162.21.21,0,0,1-.174.046c-.049-.01-.094-.015-.136-.019s-.089,0-.143,0a1.174,1.174,0,0,0-.963.395,1.436,1.436,0,0,0-.344.95V141.8a.209.209,0,0,1-.21.21m-.758-.42h.548v-3.1a1.85,1.85,0,0,1,.441-1.219,1.587,1.587,0,0,1,1.286-.546c.038,0,.073,0,.107,0v-.6l-.028,0c-.034,0-.06-.005-.073-.005a1.229,1.229,0,0,0-.874.36,1.969,1.969,0,0,0-.5.631.21.21,0,0,1-.407-.077v-.785h-.5Z",
    transform: "translate(-792.104 -135.696)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1358",
    "data-name": "Grupo 1358",
    transform: "translate(804.586 136.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1357",
    "data-name": "Grupo 1357",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1876",
    "data-name": "Trazado 1876",
    d: "M796.5,134h.985v1.1H796.5Zm0,2.168h.985v5.735H796.5Z",
    transform: "translate(-796.502 -134.004)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1360",
    "data-name": "Grupo 1360",
    transform: "translate(804.375 136.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1359",
    "data-name": "Grupo 1359",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1877",
    "data-name": "Trazado 1877",
    d: "M797.5,142.13h-.985a.21.21,0,0,1-.211-.21v-5.735a.21.21,0,0,1,.211-.211h.985a.21.21,0,0,1,.21.211v5.735a.21.21,0,0,1-.21.21m-.775-.42h.563v-5.315h-.563Zm.775-6.385h-.985a.211.211,0,0,1-.211-.211v-1.1a.211.211,0,0,1,.211-.211h.985a.211.211,0,0,1,.21.211v1.1a.211.211,0,0,1-.21.211m-.775-.422h.563v-.677h-.563Z",
    transform: "translate(-796.304 -133.806)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1362",
    "data-name": "Grupo 1362",
    transform: "translate(807.467 138.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1361",
    "data-name": "Grupo 1361",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1878",
    "data-name": "Trazado 1878",
    d: "M803.407,136.332a2.266,2.266,0,0,1,.734,1.631H803.2a1.741,1.741,0,0,0-.393-.886,1.239,1.239,0,0,0-.985-.352,1.36,1.36,0,0,0-1.323.9,3.56,3.56,0,0,0-.259,1.446,2.727,2.727,0,0,0,.365,1.456,1.421,1.421,0,0,0,2.108.225,2.022,2.022,0,0,0,.486-1.006h.941a2.277,2.277,0,0,1-2.458,2.207,2.206,2.206,0,0,1-1.8-.826,3.16,3.16,0,0,1-.672-2.063,3.473,3.473,0,0,1,.737-2.362,2.382,2.382,0,0,1,1.878-.845,2.513,2.513,0,0,1,1.584.474",
    transform: "translate(-799.209 -135.858)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1364",
    "data-name": "Grupo 1364",
    transform: "translate(807.257 138.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1363",
    "data-name": "Grupo 1363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1879",
    "data-name": "Trazado 1879",
    d: "M801.7,142.178a2.416,2.416,0,0,1-1.966-.9,3.377,3.377,0,0,1-.72-2.2,3.691,3.691,0,0,1,.789-2.5,2.6,2.6,0,0,1,2.036-.918,2.73,2.73,0,0,1,1.714.518,2.443,2.443,0,0,1,.809,1.726.2.2,0,0,1,.013.071.21.21,0,0,1-.211.21h-.947a.209.209,0,0,1-.208-.177,1.55,1.55,0,0,0-.344-.78,1.051,1.051,0,0,0-.826-.281,1.156,1.156,0,0,0-1.13.778,3.391,3.391,0,0,0-.241,1.36,2.526,2.526,0,0,0,.333,1.345,1.212,1.212,0,0,0,1.776.189,1.818,1.818,0,0,0,.434-.9.21.21,0,0,1,.206-.167h.942a.213.213,0,0,1,.159.072.208.208,0,0,1,.049.167,2.484,2.484,0,0,1-2.667,2.388m.139-6.1a2.162,2.162,0,0,0-1.719.773,3.291,3.291,0,0,0-.685,2.224,2.96,2.96,0,0,0,.626,1.93,1.986,1.986,0,0,0,1.639.749,2.325,2.325,0,0,0,1.518-.483,2.177,2.177,0,0,0,.691-1.3h-.526a2.135,2.135,0,0,1-.5.941,1.631,1.631,0,0,1-2.438-.26,2.94,2.94,0,0,1-.4-1.567,3.793,3.793,0,0,1,.277-1.531,1.56,1.56,0,0,1,1.516-1.028,1.445,1.445,0,0,1,1.143.425,1.888,1.888,0,0,1,.407.813h.529a1.918,1.918,0,0,0-.624-1.254,2.323,2.323,0,0,0-1.455-.429",
    transform: "translate(-799.011 -135.66)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1366",
    "data-name": "Grupo 1366",
    transform: "translate(813.927 138.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1365",
    "data-name": "Grupo 1365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1880",
    "data-name": "Trazado 1880",
    d: "M808.635,138.3a.527.527,0,0,0,.447-.279.869.869,0,0,0,.064-.373.791.791,0,0,0-.352-.722,1.876,1.876,0,0,0-1.006-.224,1.274,1.274,0,0,0-1.074.411,1.361,1.361,0,0,0-.231.675h-.9a1.673,1.673,0,0,1,.69-1.486,2.83,2.83,0,0,1,1.54-.418,3.137,3.137,0,0,1,1.65.387,1.315,1.315,0,0,1,.628,1.206V140.8a.423.423,0,0,0,.063.243.3.3,0,0,0,.261.092c.043,0,.092,0,.146-.008s.111-.013.171-.024v.716a2.745,2.745,0,0,1-.344.08,2.343,2.343,0,0,1-.324.017.8.8,0,0,1-.726-.356,1.367,1.367,0,0,1-.167-.532,2.453,2.453,0,0,1-.851.672,2.617,2.617,0,0,1-1.22.285,1.818,1.818,0,0,1-1.311-.486,1.613,1.613,0,0,1-.508-1.217,1.566,1.566,0,0,1,.5-1.241,2.386,2.386,0,0,1,1.314-.543Zm-2.04,2.617a1.142,1.142,0,0,0,.727.242,2.208,2.208,0,0,0,.989-.236,1.331,1.331,0,0,0,.808-1.284v-.779a1.67,1.67,0,0,1-.457.189,3.846,3.846,0,0,1-.547.108l-.585.076a2.251,2.251,0,0,0-.792.219.857.857,0,0,0-.449.806.8.8,0,0,0,.307.66",
    transform: "translate(-805.277 -135.883)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1368",
    "data-name": "Grupo 1368",
    transform: "translate(813.717 138.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1367",
    "data-name": "Grupo 1367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1881",
    "data-name": "Trazado 1881",
    d: "M807.108,142.2a2.028,2.028,0,0,1-1.455-.545,1.822,1.822,0,0,1-.573-1.369,1.77,1.77,0,0,1,.572-1.4,2.6,2.6,0,0,1,1.425-.6l1.545-.193c.2-.026.255-.1.282-.162a.627.627,0,0,0,.044-.281.583.583,0,0,0-.254-.544,1.687,1.687,0,0,0-.893-.192,1.086,1.086,0,0,0-.907.329,1.152,1.152,0,0,0-.188.574.211.211,0,0,1-.21.184h-.9a.209.209,0,0,1-.211-.215,1.872,1.872,0,0,1,.79-1.66,3.04,3.04,0,0,1,1.651-.45,3.356,3.356,0,0,1,1.76.417,1.522,1.522,0,0,1,.73,1.386v3.319a.25.25,0,0,0,.021.119s.03,0,.091,0a1.073,1.073,0,0,0,.123-.007c.05,0,.1-.012.158-.021a.211.211,0,0,1,.247.207v.716a.21.21,0,0,1-.152.2,2.88,2.88,0,0,1-.375.086,2.54,2.54,0,0,1-.351.018,1,1,0,0,1-.9-.452,1.046,1.046,0,0,1-.1-.216,3.02,3.02,0,0,1-.64.43,2.851,2.851,0,0,1-1.318.309m.692-5.7a2.055,2.055,0,0,1,1.12.258,1,1,0,0,1,.449.9,1.042,1.042,0,0,1-.086.466.728.728,0,0,1-.608.394l-1.547.194a2.2,2.2,0,0,0-1.2.492,1.357,1.357,0,0,0-.429,1.084,1.4,1.4,0,0,0,.444,1.064,1.6,1.6,0,0,0,1.165.428,2.43,2.43,0,0,0,1.125-.261,2.282,2.282,0,0,0,.78-.613.21.21,0,0,1,.375.1,1.213,1.213,0,0,0,.136.45.589.589,0,0,0,.548.257,2.27,2.27,0,0,0,.294-.014,1.512,1.512,0,0,0,.164-.034v-.315c-.278.019-.446-.039-.542-.18a.629.629,0,0,1-.1-.361v-3.319a1.107,1.107,0,0,0-.529-1.026,2.939,2.939,0,0,0-1.539-.357,2.629,2.629,0,0,0-1.427.386,1.353,1.353,0,0,0-.579,1.1h.5a1.371,1.371,0,0,1,.245-.6,1.477,1.477,0,0,1,1.24-.492m-.465,4.875a1.346,1.346,0,0,1-.857-.286,1,1,0,0,1-.386-.826,1.068,1.068,0,0,1,.556-.988,2.435,2.435,0,0,1,.868-.245l.585-.076a3.906,3.906,0,0,0,.521-.1,1.479,1.479,0,0,0,.4-.163.211.211,0,0,1,.325.177v.779a1.531,1.531,0,0,1-.926,1.473,2.431,2.431,0,0,1-1.082.257m1.586-2.177c-.061.022-.123.042-.19.06a3.985,3.985,0,0,1-.578.114l-.583.075a2.073,2.073,0,0,0-.714.2.645.645,0,0,0-.343.621.582.582,0,0,0,.226.495.923.923,0,0,0,.6.2,2.015,2.015,0,0,0,.9-.214,1.126,1.126,0,0,0,.689-1.1Z",
    transform: "translate(-805.08 -135.686)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1370",
    "data-name": "Grupo 1370",
    transform: "translate(821.15 139.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1369",
    "data-name": "Grupo 1369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1882",
    "data-name": "Trazado 1882",
    d: "M812.063,136.023h.92v.818a2.583,2.583,0,0,1,.868-.726,2.308,2.308,0,0,1,1.017-.221,1.675,1.675,0,0,1,1.656.856,3.031,3.031,0,0,1,.237,1.34v3.7h-.986v-3.633a1.978,1.978,0,0,0-.154-.849.946.946,0,0,0-.937-.538,1.9,1.9,0,0,0-.565.069,1.461,1.461,0,0,0-.7.474,1.411,1.411,0,0,0-.313.59,3.917,3.917,0,0,0-.073.869v3.019h-.969Z",
    transform: "translate(-812.063 -135.893)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1372",
    "data-name": "Grupo 1372",
    transform: "translate(820.94 138.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1371",
    "data-name": "Grupo 1371",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1883",
    "data-name": "Trazado 1883",
    d: "M816.774,142.008h-.985a.211.211,0,0,1-.212-.21v-3.632a1.8,1.8,0,0,0-.133-.759.739.739,0,0,0-.748-.418,1.7,1.7,0,0,0-.5.06,1.247,1.247,0,0,0-.6.409,1.218,1.218,0,0,0-.269.5,3.762,3.762,0,0,0-.067.82V141.8a.209.209,0,0,1-.21.21h-.97a.21.21,0,0,1-.21-.21v-5.763a.211.211,0,0,1,.21-.211H813a.211.211,0,0,1,.21.211v.288a2.4,2.4,0,0,1,.564-.386,2.535,2.535,0,0,1,1.108-.242,1.881,1.881,0,0,1,1.846.971,3.211,3.211,0,0,1,.259,1.435v3.7a.209.209,0,0,1-.21.21m-.775-.42h.564V138.1a2.864,2.864,0,0,0-.214-1.244,1.474,1.474,0,0,0-1.47-.741,2.117,2.117,0,0,0-.925.2,2.378,2.378,0,0,0-.794.67.211.211,0,0,1-.375-.133v-.607h-.5v5.342h.547V138.78a4.082,4.082,0,0,1,.079-.918,1.637,1.637,0,0,1,.358-.677,1.668,1.668,0,0,1,.8-.539,2.107,2.107,0,0,1,.625-.079,1.161,1.161,0,0,1,1.126.657,2.16,2.16,0,0,1,.177.942Z",
    transform: "translate(-811.866 -135.696)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1374",
    "data-name": "Grupo 1374",
    transform: "translate(827.837 138.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1373",
    "data-name": "Grupo 1373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1884",
    "data-name": "Trazado 1884",
    d: "M821.7,138.3a.526.526,0,0,0,.447-.279.852.852,0,0,0,.065-.373.793.793,0,0,0-.352-.722,1.881,1.881,0,0,0-1.007-.224,1.276,1.276,0,0,0-1.074.411,1.361,1.361,0,0,0-.23.675h-.9a1.673,1.673,0,0,1,.691-1.486,2.828,2.828,0,0,1,1.54-.418,3.135,3.135,0,0,1,1.649.387,1.315,1.315,0,0,1,.629,1.206V140.8a.423.423,0,0,0,.063.243.3.3,0,0,0,.261.092c.043,0,.092,0,.145-.008s.111-.013.173-.024v.716a2.8,2.8,0,0,1-.344.08,2.357,2.357,0,0,1-.324.017.8.8,0,0,1-.727-.356,1.368,1.368,0,0,1-.166-.532,2.463,2.463,0,0,1-.851.672,2.619,2.619,0,0,1-1.221.285,1.817,1.817,0,0,1-1.31-.486,1.613,1.613,0,0,1-.508-1.217,1.566,1.566,0,0,1,.5-1.241,2.386,2.386,0,0,1,1.314-.543Zm-2.038,2.617a1.137,1.137,0,0,0,.726.242,2.212,2.212,0,0,0,.99-.236,1.33,1.33,0,0,0,.807-1.284v-.779a1.655,1.655,0,0,1-.457.189,3.833,3.833,0,0,1-.546.108l-.586.076a2.251,2.251,0,0,0-.791.219.857.857,0,0,0-.449.806.794.794,0,0,0,.307.66",
    transform: "translate(-818.345 -135.883)",
    fill: "#786621"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1376",
    "data-name": "Grupo 1376",
    transform: "translate(827.625 138.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1375",
    "data-name": "Grupo 1375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1885",
    "data-name": "Trazado 1885",
    d: "M820.175,142.2a2.027,2.027,0,0,1-1.455-.545,1.822,1.822,0,0,1-.574-1.369,1.771,1.771,0,0,1,.572-1.4,2.6,2.6,0,0,1,1.426-.6l1.544-.193c.2-.026.255-.1.283-.162a.649.649,0,0,0,.044-.281.583.583,0,0,0-.254-.544,1.691,1.691,0,0,0-.894-.192,1.084,1.084,0,0,0-.906.329,1.164,1.164,0,0,0-.189.574.21.21,0,0,1-.209.184h-.9a.216.216,0,0,1-.151-.063.212.212,0,0,1-.059-.152,1.873,1.873,0,0,1,.789-1.66,3.044,3.044,0,0,1,1.652-.45,3.351,3.351,0,0,1,1.758.417,1.52,1.52,0,0,1,.73,1.386v3.319a.25.25,0,0,0,.022.119s.03,0,.089,0a1.076,1.076,0,0,0,.125-.007c.05,0,.1-.012.156-.021a.211.211,0,0,1,.172.046.206.206,0,0,1,.075.161v.716a.211.211,0,0,1-.151.2,2.84,2.84,0,0,1-.375.086,2.549,2.549,0,0,1-.351.018,1,1,0,0,1-.9-.452,1.043,1.043,0,0,1-.1-.216,3.029,3.029,0,0,1-.641.43,2.847,2.847,0,0,1-1.317.309m.691-5.7a2.059,2.059,0,0,1,1.121.258,1,1,0,0,1,.449.9,1.031,1.031,0,0,1-.087.466.724.724,0,0,1-.608.394l-1.546.194a2.2,2.2,0,0,0-1.2.492,1.357,1.357,0,0,0-.429,1.084,1.4,1.4,0,0,0,.444,1.064,1.6,1.6,0,0,0,1.164.428,2.432,2.432,0,0,0,1.125-.261,2.253,2.253,0,0,0,.779-.613.211.211,0,0,1,.22-.076.208.208,0,0,1,.154.174,1.19,1.19,0,0,0,.137.45.589.589,0,0,0,.548.257,2.268,2.268,0,0,0,.294-.014,1.559,1.559,0,0,0,.164-.034v-.315c-.277.02-.447-.039-.543-.18a.626.626,0,0,1-.1-.361v-3.319a1.108,1.108,0,0,0-.529-1.026,2.939,2.939,0,0,0-1.539-.357,2.63,2.63,0,0,0-1.428.386,1.354,1.354,0,0,0-.58,1.1h.5a1.36,1.36,0,0,1,.245-.6,1.475,1.475,0,0,1,1.239-.492m-.465,4.875a1.346,1.346,0,0,1-.857-.286,1,1,0,0,1-.385-.826,1.068,1.068,0,0,1,.556-.988,2.422,2.422,0,0,1,.868-.245l.585-.076a3.941,3.941,0,0,0,.521-.1,1.445,1.445,0,0,0,.4-.164.212.212,0,0,1,.325.178v.779a1.533,1.533,0,0,1-.926,1.473,2.436,2.436,0,0,1-1.083.257m1.587-2.177c-.061.022-.124.042-.191.06a4.027,4.027,0,0,1-.579.114l-.583.075a2.066,2.066,0,0,0-.713.2.646.646,0,0,0-.344.621.58.58,0,0,0,.227.495.921.921,0,0,0,.6.2,2.008,2.008,0,0,0,.9-.214,1.127,1.127,0,0,0,.69-1.1Z",
    transform: "translate(-818.146 -135.686)",
    fill: "#786621"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "_79a59c01-a709-42ea-ab16-b2683bf8abfa",
    "data-name": "79a59c01-a709-42ea-ab16-b2683bf8abfa",
    width: 170,
    height: 61,
    transform: "translate(1029.188 78.491)",
    fill: "url(#pattern-2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPuntos);
export default __webpack_public_path__ + "static/media/img_puntos.1f45b87b7695548a7c1a89225c4af2e8.svg";
export { ForwardRef as ReactComponent };